var Fs = Object.defineProperty;
var qs = (e, t, i) => t in e ? Fs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var st = (e, t, i) => (qs(e, typeof t != "symbol" ? t + "" : t, i), i);
import { defineComponent as pe, h as ua, getCurrentInstance as ma, inject as Gs, onMounted as dt, onUnmounted as Tn, shallowRef as An, ref as H, computed as W, onBeforeMount as Ks, watch as gi, Fragment as _t, createVNode as U, Text as Hs, openBlock as G, createElementBlock as Z, createElementVNode as D, toDisplayString as R, unref as p, withModifiers as Qe, createBlock as Ve, createCommentVNode as ke, withCtx as ne, createTextVNode as Pe, withDirectives as Ws, vShow as Js, normalizeClass as et, Comment as Zs, cloneVNode as Ys, renderSlot as mi, Transition as Ta, renderList as xn, createSlots as Oi } from "vue";
import { DcfTextInput as rt, DcfNotification as ji, DcfButton as Ue, DcfCheckbox as Oe, DcfModal as Xs, DcfIcon as Qs, DcfTile as eo } from "@miele/dcf-components-vue";
/*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ye = typeof window < "u";
let xe, wt;
if (process.env.NODE_ENV !== "production") {
  const e = Ye && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (xe = (t) => {
    e.mark(t);
  }, wt = (t, i, a) => {
    e.measure(t, i, a), e.clearMarks(i), e.clearMarks(a);
  });
}
const to = /\{([0-9a-zA-Z]+)\}/g;
function pa(e, ...t) {
  return t.length === 1 && ee(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(to, (i, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const tt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), io = (e, t, i) => ao({ l: e, k: t, s: i }), ao = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), je = (e) => typeof e == "number" && isFinite(e), no = (e) => Dn(e) === "[object Date]", xt = (e) => Dn(e) === "[object RegExp]", _i = (e) => J(e) && Object.keys(e).length === 0, _e = Object.assign;
let Aa;
const Ze = () => Aa || (Aa = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function xa(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const so = Object.prototype.hasOwnProperty;
function hi(e, t) {
  return so.call(e, t);
}
const fe = Array.isArray, re = (e) => typeof e == "function", N = (e) => typeof e == "string", se = (e) => typeof e == "boolean", ee = (e) => e !== null && typeof e == "object", oo = (e) => ee(e) && re(e.then) && re(e.catch), In = Object.prototype.toString, Dn = (e) => In.call(e), J = (e) => {
  if (!ee(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, ro = (e) => e == null ? "" : fe(e) || J(e) && e.toString === In ? JSON.stringify(e, null, 2) : String(e);
function lo(e, t = "") {
  return e.reduce((i, a, n) => n === 0 ? i + a : i + t + a, "");
}
const Ia = 2;
function co(e, t = 0, i = e.length) {
  const a = e.split(/\r?\n/);
  let n = 0;
  const s = [];
  for (let o = 0; o < a.length; o++)
    if (n += a[o].length + 1, n >= t) {
      for (let r = o - Ia; r <= o + Ia || i > n; r++) {
        if (r < 0 || r >= a.length)
          continue;
        const l = r + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${a[r]}`);
        const u = a[r].length;
        if (r === o) {
          const c = t - (n - u) + 1, m = Math.max(1, i > n ? u - c : i - t);
          s.push("   |  " + " ".repeat(c) + "^".repeat(m));
        } else if (r > o) {
          if (i > n) {
            const c = Math.max(Math.min(i - n, u), 1);
            s.push("   |  " + "^".repeat(c));
          }
          n += u + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Ei(e) {
  let t = e;
  return () => ++t;
}
function it(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Da = {};
function Nn(e) {
  Da[e] || (Da[e] = !0, it(e));
}
function uo() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(i, a) {
      const n = e.get(i);
      n && n.push(a) || e.set(i, [a]);
    },
    off(i, a) {
      const n = e.get(i);
      n && n.splice(n.indexOf(a) >>> 0, 1);
    },
    emit(i, a) {
      (e.get(i) || []).slice().map((n) => n(a)), (e.get("*") || []).slice().map((n) => n(i, a));
    }
  };
}
const oi = (e) => !ee(e) || fe(e);
function pi(e, t) {
  if (oi(e) || oi(t))
    throw new Error("Invalid value");
  const i = [{ src: e, des: t }];
  for (; i.length; ) {
    const { src: a, des: n } = i.pop();
    Object.keys(a).forEach((s) => {
      oi(a[s]) || oi(n[s]) ? n[s] = a[s] : i.push({ src: a[s], des: n[s] });
    });
  }
}
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function mo(e, t, i) {
  return { line: e, column: t, offset: i };
}
function vi(e, t, i) {
  const a = { start: e, end: t };
  return i != null && (a.source = i), a;
}
const po = /\{([0-9a-zA-Z]+)\}/g;
function On(e, ...t) {
  return t.length === 1 && go(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(po, (i, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const Un = Object.assign, Na = (e) => typeof e == "string", go = (e) => e !== null && typeof e == "object";
function $n(e, t = "") {
  return e.reduce((i, a, n) => n === 0 ? i + a : i + t + a, "");
}
const Si = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, ho = {
  [Si.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function vo(e, t, ...i) {
  const a = On(ho[e] || "", ...i || []), n = { message: String(a), code: e };
  return t && (n.location = t), n;
}
const V = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, fo = {
  // tokenizer error messages
  [V.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [V.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [V.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [V.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [V.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [V.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [V.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [V.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [V.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [V.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [V.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [V.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [V.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [V.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [V.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [V.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Nt(e, t, i = {}) {
  const { domain: a, messages: n, args: s } = i, o = On((n || fo)[e] || "", ...s || []), r = new SyntaxError(String(o));
  return r.code = e, t && (r.location = t), r.domain = a, r;
}
function ko(e) {
  throw e;
}
const bo = /<\/?[\w\s="/.':;#-\/]+>/, wo = (e) => bo.test(e), He = " ", yo = "\r", Se = `
`, Mo = String.fromCharCode(8232), zo = String.fromCharCode(8233);
function jo(e) {
  const t = e;
  let i = 0, a = 1, n = 1, s = 0;
  const o = (M) => t[M] === yo && t[M + 1] === Se, r = (M) => t[M] === Se, l = (M) => t[M] === zo, u = (M) => t[M] === Mo, c = (M) => o(M) || r(M) || l(M) || u(M), m = () => i, d = () => a, v = () => n, w = () => s, S = (M) => o(M) || l(M) || u(M) ? Se : t[M], j = () => S(i), E = () => S(i + s);
  function A() {
    return s = 0, c(i) && (a++, n = 0), o(i) && i++, i++, n++, t[i];
  }
  function f() {
    return o(i + s) && s++, s++, t[i + s];
  }
  function b() {
    i = 0, a = 1, n = 1, s = 0;
  }
  function P(M = 0) {
    s = M;
  }
  function k() {
    const M = i + s;
    for (; M !== i; )
      A();
    s = 0;
  }
  return {
    index: m,
    line: d,
    column: v,
    peekOffset: w,
    charAt: S,
    currentChar: j,
    currentPeek: E,
    next: A,
    peek: f,
    reset: b,
    resetPeek: P,
    skipToPeek: k
  };
}
const ot = void 0, _o = ".", Oa = "'", Eo = "tokenizer";
function So(e, t = {}) {
  const i = t.location !== !1, a = jo(e), n = () => a.index(), s = () => mo(a.line(), a.column(), a.index()), o = s(), r = n(), l = {
    currentType: 14,
    offset: r,
    startLoc: o,
    endLoc: o,
    lastType: 14,
    lastOffset: r,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => l, { onError: c } = t;
  function m(g, h, T, ...B) {
    const de = u();
    if (h.column += T, h.offset += T, c) {
      const ae = i ? vi(de.startLoc, h) : null, te = Nt(g, ae, {
        domain: Eo,
        args: B
      });
      c(te);
    }
  }
  function d(g, h, T) {
    g.endLoc = s(), g.currentType = h;
    const B = { type: h };
    return i && (B.loc = vi(g.startLoc, g.endLoc)), T != null && (B.value = T), B;
  }
  const v = (g) => d(
    g,
    14
    /* TokenTypes.EOF */
  );
  function w(g, h) {
    return g.currentChar() === h ? (g.next(), h) : (m(V.EXPECTED_TOKEN, s(), 0, h), "");
  }
  function S(g) {
    let h = "";
    for (; g.currentPeek() === He || g.currentPeek() === Se; )
      h += g.currentPeek(), g.peek();
    return h;
  }
  function j(g) {
    const h = S(g);
    return g.skipToPeek(), h;
  }
  function E(g) {
    if (g === ot)
      return !1;
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h === 95;
  }
  function A(g) {
    if (g === ot)
      return !1;
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57;
  }
  function f(g, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    S(g);
    const B = E(g.currentPeek());
    return g.resetPeek(), B;
  }
  function b(g, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    S(g);
    const B = g.currentPeek() === "-" ? g.peek() : g.currentPeek(), de = A(B);
    return g.resetPeek(), de;
  }
  function P(g, h) {
    const { currentType: T } = h;
    if (T !== 2)
      return !1;
    S(g);
    const B = g.currentPeek() === Oa;
    return g.resetPeek(), B;
  }
  function k(g, h) {
    const { currentType: T } = h;
    if (T !== 8)
      return !1;
    S(g);
    const B = g.currentPeek() === ".";
    return g.resetPeek(), B;
  }
  function M(g, h) {
    const { currentType: T } = h;
    if (T !== 9)
      return !1;
    S(g);
    const B = E(g.currentPeek());
    return g.resetPeek(), B;
  }
  function _(g, h) {
    const { currentType: T } = h;
    if (!(T === 8 || T === 12))
      return !1;
    S(g);
    const B = g.currentPeek() === ":";
    return g.resetPeek(), B;
  }
  function C(g, h) {
    const { currentType: T } = h;
    if (T !== 10)
      return !1;
    const B = () => {
      const ae = g.currentPeek();
      return ae === "{" ? E(g.peek()) : ae === "@" || ae === "%" || ae === "|" || ae === ":" || ae === "." || ae === He || !ae ? !1 : ae === Se ? (g.peek(), B()) : y(g, !1);
    }, de = B();
    return g.resetPeek(), de;
  }
  function $(g) {
    S(g);
    const h = g.currentPeek() === "|";
    return g.resetPeek(), h;
  }
  function F(g) {
    const h = S(g), T = g.currentPeek() === "%" && g.peek() === "{";
    return g.resetPeek(), {
      isModulo: T,
      hasSpace: h.length > 0
    };
  }
  function y(g, h = !0) {
    const T = (de = !1, ae = "", te = !1) => {
      const z = g.currentPeek();
      return z === "{" ? ae === "%" ? !1 : de : z === "@" || !z ? ae === "%" ? !0 : de : z === "%" ? (g.peek(), T(de, "%", !0)) : z === "|" ? ae === "%" || te ? !0 : !(ae === He || ae === Se) : z === He ? (g.peek(), T(!0, He, te)) : z === Se ? (g.peek(), T(!0, Se, te)) : !0;
    }, B = T();
    return h && g.resetPeek(), B;
  }
  function L(g, h) {
    const T = g.currentChar();
    return T === ot ? ot : h(T) ? (g.next(), T) : null;
  }
  function O(g) {
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h >= 48 && h <= 57 || // 0-9
    h === 95 || // _
    h === 36;
  }
  function K(g) {
    return L(g, O);
  }
  function q(g) {
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h >= 48 && h <= 57 || // 0-9
    h === 95 || // _
    h === 36 || // $
    h === 45;
  }
  function Y(g) {
    return L(g, q);
  }
  function ie(g) {
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57;
  }
  function ce(g) {
    return L(g, ie);
  }
  function oe(g) {
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57 || // 0-9
    h >= 65 && h <= 70 || // A-F
    h >= 97 && h <= 102;
  }
  function ze(g) {
    return L(g, oe);
  }
  function ge(g) {
    let h = "", T = "";
    for (; h = ce(g); )
      T += h;
    return T;
  }
  function Ee(g) {
    j(g);
    const h = g.currentChar();
    return h !== "%" && m(V.EXPECTED_TOKEN, s(), 0, h), g.next(), "%";
  }
  function De(g) {
    let h = "";
    for (; ; ) {
      const T = g.currentChar();
      if (T === "{" || T === "}" || T === "@" || T === "|" || !T)
        break;
      if (T === "%")
        if (y(g))
          h += T, g.next();
        else
          break;
      else if (T === He || T === Se)
        if (y(g))
          h += T, g.next();
        else {
          if ($(g))
            break;
          h += T, g.next();
        }
      else
        h += T, g.next();
    }
    return h;
  }
  function at(g) {
    j(g);
    let h = "", T = "";
    for (; h = Y(g); )
      T += h;
    return g.currentChar() === ot && m(V.UNTERMINATED_CLOSING_BRACE, s(), 0), T;
  }
  function Ge(g) {
    j(g);
    let h = "";
    return g.currentChar() === "-" ? (g.next(), h += `-${ge(g)}`) : h += ge(g), g.currentChar() === ot && m(V.UNTERMINATED_CLOSING_BRACE, s(), 0), h;
  }
  function Ke(g) {
    return g !== Oa && g !== Se;
  }
  function ni(g) {
    j(g), w(g, "'");
    let h = "", T = "";
    for (; h = L(g, Ke); )
      h === "\\" ? T += Vt(g) : T += h;
    const B = g.currentChar();
    return B === Se || B === ot ? (m(V.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), B === Se && (g.next(), w(g, "'")), T) : (w(g, "'"), T);
  }
  function Vt(g) {
    const h = g.currentChar();
    switch (h) {
      case "\\":
      case "'":
        return g.next(), `\\${h}`;
      case "u":
        return Et(g, h, 4);
      case "U":
        return Et(g, h, 6);
      default:
        return m(V.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, h), "";
    }
  }
  function Et(g, h, T) {
    w(g, h);
    let B = "";
    for (let de = 0; de < T; de++) {
      const ae = ze(g);
      if (!ae) {
        m(V.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${h}${B}${g.currentChar()}`);
        break;
      }
      B += ae;
    }
    return `\\${h}${B}`;
  }
  function Ft(g) {
    return g !== "{" && g !== "}" && g !== He && g !== Se;
  }
  function qt(g) {
    j(g);
    let h = "", T = "";
    for (; h = L(g, Ft); )
      T += h;
    return T;
  }
  function Gt(g) {
    let h = "", T = "";
    for (; h = K(g); )
      T += h;
    return T;
  }
  function I(g) {
    const h = (T) => {
      const B = g.currentChar();
      return B === "{" || B === "%" || B === "@" || B === "|" || B === "(" || B === ")" || !B || B === He ? T : (T += B, g.next(), h(T));
    };
    return h("");
  }
  function X(g) {
    j(g);
    const h = w(
      g,
      "|"
      /* TokenChars.Pipe */
    );
    return j(g), h;
  }
  function Kt(g, h) {
    let T = null;
    switch (g.currentChar()) {
      case "{":
        return h.braceNest >= 1 && m(V.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), g.next(), T = d(
          h,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), j(g), h.braceNest++, T;
      case "}":
        return h.braceNest > 0 && h.currentType === 2 && m(V.EMPTY_PLACEHOLDER, s(), 0), g.next(), T = d(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), h.braceNest--, h.braceNest > 0 && j(g), h.inLinked && h.braceNest === 0 && (h.inLinked = !1), T;
      case "@":
        return h.braceNest > 0 && m(V.UNTERMINATED_CLOSING_BRACE, s(), 0), T = pt(g, h) || v(h), h.braceNest = 0, T;
      default: {
        let de = !0, ae = !0, te = !0;
        if ($(g))
          return h.braceNest > 0 && m(V.UNTERMINATED_CLOSING_BRACE, s(), 0), T = d(h, 1, X(g)), h.braceNest = 0, h.inLinked = !1, T;
        if (h.braceNest > 0 && (h.currentType === 5 || h.currentType === 6 || h.currentType === 7))
          return m(V.UNTERMINATED_CLOSING_BRACE, s(), 0), h.braceNest = 0, Ht(g, h);
        if (de = f(g, h))
          return T = d(h, 5, at(g)), j(g), T;
        if (ae = b(g, h))
          return T = d(h, 6, Ge(g)), j(g), T;
        if (te = P(g, h))
          return T = d(h, 7, ni(g)), j(g), T;
        if (!de && !ae && !te)
          return T = d(h, 13, qt(g)), m(V.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, T.value), j(g), T;
        break;
      }
    }
    return T;
  }
  function pt(g, h) {
    const { currentType: T } = h;
    let B = null;
    const de = g.currentChar();
    switch ((T === 8 || T === 9 || T === 12 || T === 10) && (de === Se || de === He) && m(V.INVALID_LINKED_FORMAT, s(), 0), de) {
      case "@":
        return g.next(), B = d(
          h,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), h.inLinked = !0, B;
      case ".":
        return j(g), g.next(), d(
          h,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return j(g), g.next(), d(
          h,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return $(g) ? (B = d(h, 1, X(g)), h.braceNest = 0, h.inLinked = !1, B) : k(g, h) || _(g, h) ? (j(g), pt(g, h)) : M(g, h) ? (j(g), d(h, 12, Gt(g))) : C(g, h) ? (j(g), de === "{" ? Kt(g, h) || B : d(h, 11, I(g))) : (T === 8 && m(V.INVALID_LINKED_FORMAT, s(), 0), h.braceNest = 0, h.inLinked = !1, Ht(g, h));
    }
  }
  function Ht(g, h) {
    let T = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (h.braceNest > 0)
      return Kt(g, h) || v(h);
    if (h.inLinked)
      return pt(g, h) || v(h);
    switch (g.currentChar()) {
      case "{":
        return Kt(g, h) || v(h);
      case "}":
        return m(V.UNBALANCED_CLOSING_BRACE, s(), 0), g.next(), d(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return pt(g, h) || v(h);
      default: {
        if ($(g))
          return T = d(h, 1, X(g)), h.braceNest = 0, h.inLinked = !1, T;
        const { isModulo: de, hasSpace: ae } = F(g);
        if (de)
          return ae ? d(h, 0, De(g)) : d(h, 4, Ee(g));
        if (y(g))
          return d(h, 0, De(g));
        break;
      }
    }
    return T;
  }
  function Ni() {
    const { currentType: g, offset: h, startLoc: T, endLoc: B } = l;
    return l.lastType = g, l.lastOffset = h, l.lastStartLoc = T, l.lastEndLoc = B, l.offset = n(), l.startLoc = s(), a.currentChar() === ot ? d(
      l,
      14
      /* TokenTypes.EOF */
    ) : Ht(a, l);
  }
  return {
    nextToken: Ni,
    currentOffset: n,
    currentPosition: s,
    context: u
  };
}
const Lo = "parser", Co = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Po(e, t, i) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || i, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function To(e = {}) {
  const t = e.location !== !1, { onError: i, onWarn: a } = e;
  function n(f, b, P, k, ...M) {
    const _ = f.currentPosition();
    if (_.offset += k, _.column += k, i) {
      const C = t ? vi(P, _) : null, $ = Nt(b, C, {
        domain: Lo,
        args: M
      });
      i($);
    }
  }
  function s(f, b, P, k, ...M) {
    const _ = f.currentPosition();
    if (_.offset += k, _.column += k, a) {
      const C = t ? vi(P, _) : null;
      a(vo(b, C, M));
    }
  }
  function o(f, b, P) {
    const k = { type: f };
    return t && (k.start = b, k.end = b, k.loc = { start: P, end: P }), k;
  }
  function r(f, b, P, k) {
    k && (f.type = k), t && (f.end = b, f.loc && (f.loc.end = P));
  }
  function l(f, b) {
    const P = f.context(), k = o(3, P.offset, P.startLoc);
    return k.value = b, r(k, f.currentOffset(), f.currentPosition()), k;
  }
  function u(f, b) {
    const P = f.context(), { lastOffset: k, lastStartLoc: M } = P, _ = o(5, k, M);
    return _.index = parseInt(b, 10), f.nextToken(), r(_, f.currentOffset(), f.currentPosition()), _;
  }
  function c(f, b, P) {
    const k = f.context(), { lastOffset: M, lastStartLoc: _ } = k, C = o(4, M, _);
    return C.key = b, P === !0 && (C.modulo = !0), f.nextToken(), r(C, f.currentOffset(), f.currentPosition()), C;
  }
  function m(f, b) {
    const P = f.context(), { lastOffset: k, lastStartLoc: M } = P, _ = o(9, k, M);
    return _.value = b.replace(Co, Po), f.nextToken(), r(_, f.currentOffset(), f.currentPosition()), _;
  }
  function d(f) {
    const b = f.nextToken(), P = f.context(), { lastOffset: k, lastStartLoc: M } = P, _ = o(8, k, M);
    return b.type !== 12 ? (n(f, V.UNEXPECTED_EMPTY_LINKED_MODIFIER, P.lastStartLoc, 0), _.value = "", r(_, k, M), {
      nextConsumeToken: b,
      node: _
    }) : (b.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, Re(b)), _.value = b.value || "", r(_, f.currentOffset(), f.currentPosition()), {
      node: _
    });
  }
  function v(f, b) {
    const P = f.context(), k = o(7, P.offset, P.startLoc);
    return k.value = b, r(k, f.currentOffset(), f.currentPosition()), k;
  }
  function w(f) {
    const b = f.context(), P = o(6, b.offset, b.startLoc);
    let k = f.nextToken();
    if (k.type === 9) {
      const M = d(f);
      P.modifier = M.node, k = M.nextConsumeToken || f.nextToken();
    }
    switch (k.type !== 10 && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(k)), k = f.nextToken(), k.type === 2 && (k = f.nextToken()), k.type) {
      case 11:
        k.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(k)), P.key = v(f, k.value || "");
        break;
      case 5:
        k.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(k)), P.key = c(f, k.value || "");
        break;
      case 6:
        k.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(k)), P.key = u(f, k.value || "");
        break;
      case 7:
        k.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(k)), P.key = m(f, k.value || "");
        break;
      default: {
        n(f, V.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const M = f.context(), _ = o(7, M.offset, M.startLoc);
        return _.value = "", r(_, M.offset, M.startLoc), P.key = _, r(P, M.offset, M.startLoc), {
          nextConsumeToken: k,
          node: P
        };
      }
    }
    return r(P, f.currentOffset(), f.currentPosition()), {
      node: P
    };
  }
  function S(f) {
    const b = f.context(), P = b.currentType === 1 ? f.currentOffset() : b.offset, k = b.currentType === 1 ? b.endLoc : b.startLoc, M = o(2, P, k);
    M.items = [];
    let _ = null, C = null;
    do {
      const y = _ || f.nextToken();
      switch (_ = null, y.type) {
        case 0:
          y.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(y)), M.items.push(l(f, y.value || ""));
          break;
        case 6:
          y.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(y)), M.items.push(u(f, y.value || ""));
          break;
        case 4:
          C = !0;
          break;
        case 5:
          y.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(y)), M.items.push(c(f, y.value || "", !!C)), C && (s(f, Si.USE_MODULO_SYNTAX, b.lastStartLoc, 0, Re(y)), C = null);
          break;
        case 7:
          y.value == null && n(f, V.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Re(y)), M.items.push(m(f, y.value || ""));
          break;
        case 8: {
          const L = w(f);
          M.items.push(L.node), _ = L.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 14 && b.currentType !== 1);
    const $ = b.currentType === 1 ? b.lastOffset : f.currentOffset(), F = b.currentType === 1 ? b.lastEndLoc : f.currentPosition();
    return r(M, $, F), M;
  }
  function j(f, b, P, k) {
    const M = f.context();
    let _ = k.items.length === 0;
    const C = o(1, b, P);
    C.cases = [], C.cases.push(k);
    do {
      const $ = S(f);
      _ || (_ = $.items.length === 0), C.cases.push($);
    } while (M.currentType !== 14);
    return _ && n(f, V.MUST_HAVE_MESSAGES_IN_PLURAL, P, 0), r(C, f.currentOffset(), f.currentPosition()), C;
  }
  function E(f) {
    const b = f.context(), { offset: P, startLoc: k } = b, M = S(f);
    return b.currentType === 14 ? M : j(f, P, k, M);
  }
  function A(f) {
    const b = So(f, Un({}, e)), P = b.context(), k = o(0, P.offset, P.startLoc);
    return t && k.loc && (k.loc.source = f), k.body = E(b), e.onCacheKey && (k.cacheKey = e.onCacheKey(f)), P.currentType !== 14 && n(b, V.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, f[P.offset] || ""), r(k, b.currentOffset(), b.currentPosition()), k;
  }
  return { parse: A };
}
function Re(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Ao(e, t = {}) {
  const i = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => i, helper: (s) => (i.helpers.add(s), s) };
}
function Ua(e, t) {
  for (let i = 0; i < e.length; i++)
    ga(e[i], t);
}
function ga(e, t) {
  switch (e.type) {
    case 1:
      Ua(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Ua(e.items, t);
      break;
    case 6: {
      ga(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function xo(e, t = {}) {
  const i = Ao(e);
  i.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && ga(e.body, i);
  const a = i.context();
  e.helpers = Array.from(a.helpers);
}
function Io(e) {
  const t = e.body;
  return t.type === 2 ? $a(t) : t.cases.forEach((i) => $a(i)), e;
}
function $a(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let i = 0; i < e.items.length; i++) {
      const a = e.items[i];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = $n(t);
      for (let i = 0; i < e.items.length; i++) {
        const a = e.items[i];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const Do = "minifier";
function Ct(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Ct(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, i = t.cases;
      for (let a = 0; a < i.length; a++)
        Ct(i[a]);
      t.c = i, delete t.cases;
      break;
    }
    case 2: {
      const t = e, i = t.items;
      for (let a = 0; a < i.length; a++)
        Ct(i[a]);
      t.i = i, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Ct(t.key), t.k = t.key, delete t.key, t.modifier && (Ct(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw Nt(V.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: Do,
        args: [e.type]
      });
  }
  delete e.type;
}
const No = "parser";
function Oo(e, t) {
  const { sourceMap: i, filename: a, breakLineCode: n, needIndent: s } = t, o = t.location !== !1, r = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: n,
    needIndent: s,
    indentLevel: 0
  };
  o && e.loc && (r.source = e.loc.source);
  const l = () => r;
  function u(j, E) {
    r.code += j;
  }
  function c(j, E = !0) {
    const A = E ? n : "";
    u(s ? A + "  ".repeat(j) : A);
  }
  function m(j = !0) {
    const E = ++r.indentLevel;
    j && c(E);
  }
  function d(j = !0) {
    const E = --r.indentLevel;
    j && c(E);
  }
  function v() {
    c(r.indentLevel);
  }
  return {
    context: l,
    push: u,
    indent: m,
    deindent: d,
    newline: v,
    helper: (j) => `_${j}`,
    needIndent: () => r.needIndent
  };
}
function Uo(e, t) {
  const { helper: i } = e;
  e.push(`${i(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), It(e, t.key), t.modifier ? (e.push(", "), It(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function $o(e, t) {
  const { helper: i, needIndent: a } = e;
  e.push(`${i(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const n = t.items.length;
  for (let s = 0; s < n && (It(e, t.items[s]), s !== n - 1); s++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function Bo(e, t) {
  const { helper: i, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${i(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const n = t.cases.length;
    for (let s = 0; s < n && (It(e, t.cases[s]), s !== n - 1); s++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function Ro(e, t) {
  t.body ? It(e, t.body) : e.push("null");
}
function It(e, t) {
  const { helper: i } = e;
  switch (t.type) {
    case 0:
      Ro(e, t);
      break;
    case 1:
      Bo(e, t);
      break;
    case 2:
      $o(e, t);
      break;
    case 6:
      Uo(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${i(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${i(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${i(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${i(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Nt(V.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: No,
        args: [t.type]
      });
  }
}
const Vo = (e, t = {}) => {
  const i = Na(t.mode) ? t.mode : "normal", a = Na(t.filename) ? t.filename : "message.intl", n = !!t.sourceMap, s = t.breakLineCode != null ? t.breakLineCode : i === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : i !== "arrow", r = e.helpers || [], l = Oo(e, {
    mode: i,
    filename: a,
    sourceMap: n,
    breakLineCode: s,
    needIndent: o
  });
  l.push(i === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(o), r.length > 0 && (l.push(`const { ${$n(r.map((m) => `${m}: _${m}`), ", ")} } = ctx`), l.newline()), l.push("return "), It(l, e), l.deindent(o), l.push("}"), delete e.helpers;
  const { code: u, map: c } = l.context();
  return {
    ast: e,
    code: u,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Fo(e, t = {}) {
  const i = Un({}, t), a = !!i.jit, n = !!i.minify, s = i.optimize == null ? !0 : i.optimize, r = To(i).parse(e);
  return a ? (s && Io(r), n && Ct(r), { ast: r, code: "" }) : (xo(r, i), Vo(r, i));
}
/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function qo() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ze().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const ut = [];
ut[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ut[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ut[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ut[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ut[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ut[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ut[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Go = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Ko(e) {
  return Go.test(e);
}
function Ho(e) {
  const t = e.charCodeAt(0), i = e.charCodeAt(e.length - 1);
  return t === i && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Wo(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Jo(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Ko(t) ? Ho(t) : "*" + t;
}
function Zo(e) {
  const t = [];
  let i = -1, a = 0, n = 0, s, o, r, l, u, c, m;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = r : o += r;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), n++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (n > 0)
      n--, a = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (n = 0, o === void 0 || (o = Jo(o), o === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function v() {
    const w = e[i + 1];
    if (a === 5 && w === "'" || a === 6 && w === '"')
      return i++, r = "\\" + w, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (i++, s = e[i], !(s === "\\" && v())) {
      if (l = Wo(s), m = ut[a], u = m[l] || m.l || 8, u === 8 || (a = u[0], u[1] !== void 0 && (c = d[u[1]], c && (r = s, c() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const Ba = /* @__PURE__ */ new Map();
function Yo(e, t) {
  return ee(e) ? e[t] : null;
}
function Xo(e, t) {
  if (!ee(e))
    return null;
  let i = Ba.get(t);
  if (i || (i = Zo(t), i && Ba.set(t, i)), !i)
    return null;
  const a = i.length;
  let n = e, s = 0;
  for (; s < a; ) {
    const o = n[i[s]];
    if (o === void 0 || re(n))
      return null;
    n = o, s++;
  }
  return n;
}
const Qo = (e) => e, er = (e) => "", tr = "text", ir = (e) => e.length === 0 ? "" : lo(e), ar = ro;
function Ra(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function nr(e) {
  const t = je(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (je(e.named.count) || je(e.named.n)) ? je(e.named.count) ? e.named.count : je(e.named.n) ? e.named.n : t : t;
}
function sr(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function or(e = {}) {
  const t = e.locale, i = nr(e), a = ee(e.pluralRules) && N(t) && re(e.pluralRules[t]) ? e.pluralRules[t] : Ra, n = ee(e.pluralRules) && N(t) && re(e.pluralRules[t]) ? Ra : void 0, s = (E) => E[a(i, E.length, n)], o = e.list || [], r = (E) => o[E], l = e.named || {};
  je(e.pluralIndex) && sr(i, l);
  const u = (E) => l[E];
  function c(E) {
    const A = re(e.messages) ? e.messages(E) : ee(e.messages) ? e.messages[E] : !1;
    return A || (e.parent ? e.parent.message(E) : er);
  }
  const m = (E) => e.modifiers ? e.modifiers[E] : Qo, d = J(e.processor) && re(e.processor.normalize) ? e.processor.normalize : ir, v = J(e.processor) && re(e.processor.interpolate) ? e.processor.interpolate : ar, w = J(e.processor) && N(e.processor.type) ? e.processor.type : tr, j = {
    list: r,
    named: u,
    plural: s,
    linked: (E, ...A) => {
      const [f, b] = A;
      let P = "text", k = "";
      A.length === 1 ? ee(f) ? (k = f.modifier || k, P = f.type || P) : N(f) && (k = f || k) : A.length === 2 && (N(f) && (k = f || k), N(b) && (P = b || P));
      const M = c(E)(j), _ = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        P === "vnode" && fe(M) && k ? M[0] : M
      );
      return k ? m(k)(_, P) : _;
    },
    message: c,
    type: w,
    interpolate: v,
    normalize: d,
    values: _e({}, o, l)
  };
  return j;
}
let Xt = null;
function rr(e) {
  Xt = e;
}
function lr(e, t, i) {
  Xt && Xt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: i
  });
}
const cr = /* @__PURE__ */ dr(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function dr(e) {
  return (t) => Xt && Xt.emit(e, t);
}
const Bn = Si.__EXTEND_POINT__, ht = Ei(Bn), Le = {
  NOT_FOUND_KEY: Bn,
  // 2
  FALLBACK_TO_TRANSLATE: ht(),
  // 3
  CANNOT_FORMAT_NUMBER: ht(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: ht(),
  // 5
  CANNOT_FORMAT_DATE: ht(),
  // 6
  FALLBACK_TO_DATE_FORMAT: ht(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: ht(),
  // 8
  __EXTEND_POINT__: ht()
  // 9
}, ur = {
  [Le.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Le.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Le.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Le.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function yt(e, ...t) {
  return pa(ur[e], ...t);
}
const Rn = V.__EXTEND_POINT__, vt = Ei(Rn), be = {
  INVALID_ARGUMENT: Rn,
  // 17
  INVALID_DATE_ARGUMENT: vt(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: vt(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: vt(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: vt(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: vt(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: vt(),
  // 23
  __EXTEND_POINT__: vt()
  // 24
};
function qe(e) {
  return Nt(e, null, process.env.NODE_ENV !== "production" ? { messages: mr } : void 0);
}
const mr = {
  [be.INVALID_ARGUMENT]: "Invalid arguments",
  [be.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [be.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [be.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [be.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [be.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [be.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function ha(e, t) {
  return t.locale != null ? Va(t.locale) : Va(e.locale);
}
let Ui;
function Va(e) {
  if (N(e))
    return e;
  if (re(e)) {
    if (e.resolvedOnce && Ui != null)
      return Ui;
    if (e.constructor.name === "Function") {
      const t = e();
      if (oo(t))
        throw qe(be.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ui = t;
    } else
      throw qe(be.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw qe(be.NOT_SUPPORT_LOCALE_TYPE);
}
function pr(e, t, i) {
  return [.../* @__PURE__ */ new Set([
    i,
    ...fe(t) ? t : ee(t) ? Object.keys(t) : N(t) ? [t] : [i]
  ])];
}
function Vn(e, t, i) {
  const a = N(i) ? i : Qt, n = e;
  n.__localeChainCache || (n.__localeChainCache = /* @__PURE__ */ new Map());
  let s = n.__localeChainCache.get(a);
  if (!s) {
    s = [];
    let o = [i];
    for (; fe(o); )
      o = Fa(s, o, t);
    const r = fe(t) || !J(t) ? t : t.default ? t.default : null;
    o = N(r) ? [r] : r, fe(o) && Fa(s, o, !1), n.__localeChainCache.set(a, s);
  }
  return s;
}
function Fa(e, t, i) {
  let a = !0;
  for (let n = 0; n < t.length && se(a); n++) {
    const s = t[n];
    N(s) && (a = gr(e, t[n], i));
  }
  return a;
}
function gr(e, t, i) {
  let a;
  const n = t.split("-");
  do {
    const s = n.join("-");
    a = hr(e, s, i), n.splice(-1, 1);
  } while (n.length && a === !0);
  return a;
}
function hr(e, t, i) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const n = t.replace(/!/g, "");
    e.push(n), (fe(i) || J(i)) && i[n] && (a = i[n]);
  }
  return a;
}
const vr = "9.13.1", Li = -1, Qt = "en-US", fi = "", qa = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function fr() {
  return {
    upper: (e, t) => t === "text" && N(e) ? e.toUpperCase() : t === "vnode" && ee(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && N(e) ? e.toLowerCase() : t === "vnode" && ee(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && N(e) ? qa(e) : t === "vnode" && ee(e) && "__v_isVNode" in e ? qa(e.children) : e
  };
}
let Fn;
function Ga(e) {
  Fn = e;
}
let qn;
function kr(e) {
  qn = e;
}
let Gn;
function br(e) {
  Gn = e;
}
let Kn = null;
const wr = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Kn = e;
}, yr = /* @__NO_SIDE_EFFECTS__ */ () => Kn;
let Hn = null;
const Ka = (e) => {
  Hn = e;
}, Mr = () => Hn;
let Ha = 0;
function zr(e = {}) {
  const t = re(e.onWarn) ? e.onWarn : it, i = N(e.version) ? e.version : vr, a = N(e.locale) || re(e.locale) ? e.locale : Qt, n = re(a) ? Qt : a, s = fe(e.fallbackLocale) || J(e.fallbackLocale) || N(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : n, o = J(e.messages) ? e.messages : { [n]: {} }, r = J(e.datetimeFormats) ? e.datetimeFormats : { [n]: {} }, l = J(e.numberFormats) ? e.numberFormats : { [n]: {} }, u = _e({}, e.modifiers || {}, fr()), c = e.pluralRules || {}, m = re(e.missing) ? e.missing : null, d = se(e.missingWarn) || xt(e.missingWarn) ? e.missingWarn : !0, v = se(e.fallbackWarn) || xt(e.fallbackWarn) ? e.fallbackWarn : !0, w = !!e.fallbackFormat, S = !!e.unresolving, j = re(e.postTranslation) ? e.postTranslation : null, E = J(e.processor) ? e.processor : null, A = se(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, f = !!e.escapeParameter, b = re(e.messageCompiler) ? e.messageCompiler : Fn;
  process.env.NODE_ENV !== "production" && re(e.messageCompiler) && Nn(yt(Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const P = re(e.messageResolver) ? e.messageResolver : qn || Yo, k = re(e.localeFallbacker) ? e.localeFallbacker : Gn || pr, M = ee(e.fallbackContext) ? e.fallbackContext : void 0, _ = e, C = ee(_.__datetimeFormatters) ? _.__datetimeFormatters : /* @__PURE__ */ new Map(), $ = ee(_.__numberFormatters) ? _.__numberFormatters : /* @__PURE__ */ new Map(), F = ee(_.__meta) ? _.__meta : {};
  Ha++;
  const y = {
    version: i,
    cid: Ha,
    locale: a,
    fallbackLocale: s,
    messages: o,
    modifiers: u,
    pluralRules: c,
    missing: m,
    missingWarn: d,
    fallbackWarn: v,
    fallbackFormat: w,
    unresolving: S,
    postTranslation: j,
    processor: E,
    warnHtmlMessage: A,
    escapeParameter: f,
    messageCompiler: b,
    messageResolver: P,
    localeFallbacker: k,
    fallbackContext: M,
    onWarn: t,
    __meta: F
  };
  return y.datetimeFormats = r, y.numberFormats = l, y.__datetimeFormatters = C, y.__numberFormatters = $, process.env.NODE_ENV !== "production" && (y.__v_emitter = _.__v_emitter != null ? _.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && lr(y, i, F), y;
}
function Ci(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Wn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function va(e, t, i, a, n) {
  const { missing: s, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const r = e.__v_emitter;
    r && r.emit("missing", {
      locale: i,
      key: t,
      type: n,
      groupId: `${n}:${t}`
    });
  }
  if (s !== null) {
    const r = s(e, i, t, n);
    return N(r) ? r : t;
  } else
    return process.env.NODE_ENV !== "production" && Wn(a, t) && o(yt(Le.NOT_FOUND_KEY, { key: t, locale: i })), t;
}
function Wt(e, t, i) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, i, t);
}
function Jn(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function jr(e, t) {
  const i = t.indexOf(e);
  if (i === -1)
    return !1;
  for (let a = i + 1; a < t.length; a++)
    if (Jn(e, t[a]))
      return !0;
  return !1;
}
function $i(e) {
  return (i) => _r(i, e);
}
function _r(e, t) {
  const i = t.b || t.body;
  if ((i.t || i.type) === 1) {
    const a = i, n = a.c || a.cases;
    return e.plural(n.reduce((s, o) => [
      ...s,
      Wa(e, o)
    ], []));
  } else
    return Wa(e, i);
}
function Wa(e, t) {
  const i = t.s || t.static;
  if (i)
    return e.type === "text" ? i : e.normalize([i]);
  {
    const a = (t.i || t.items).reduce((n, s) => [...n, Yi(e, s)], []);
    return e.normalize(a);
  }
}
function Yi(e, t) {
  const i = t.t || t.type;
  switch (i) {
    case 3: {
      const a = t;
      return a.v || a.value;
    }
    case 9: {
      const a = t;
      return a.v || a.value;
    }
    case 4: {
      const a = t;
      return e.interpolate(e.named(a.k || a.key));
    }
    case 5: {
      const a = t;
      return e.interpolate(e.list(a.i != null ? a.i : a.index));
    }
    case 6: {
      const a = t, n = a.m || a.modifier;
      return e.linked(Yi(e, a.k || a.key), n ? Yi(e, n) : void 0, e.type);
    }
    case 7: {
      const a = t;
      return a.v || a.value;
    }
    case 8: {
      const a = t;
      return a.v || a.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${i}`);
  }
}
const Er = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Zn(e, t) {
  t && wo(e) && it(pa(Er, { source: e }));
}
const Yn = (e) => e;
let Pt = /* @__PURE__ */ Object.create(null);
function Xn(e) {
  e.code === Si.USE_MODULO_SYNTAX && it(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
const Mt = (e) => ee(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function Qn(e, t = {}) {
  let i = !1;
  const a = t.onError || ko;
  return t.onError = (n) => {
    i = !0, a(n);
  }, { ...Fo(e, t), detectError: i };
}
const Sr = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!N(e))
    throw qe(be.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (t.onWarn = Xn);
  {
    const i = se(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Zn(e, i);
    const n = (t.onCacheKey || Yn)(e), s = Pt[n];
    if (s)
      return s;
    const { code: o, detectError: r } = Qn(e, t), l = new Function(`return ${o}`)();
    return r ? l : Pt[n] = l;
  }
};
function Lr(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = Xn), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && N(e)) {
    const i = se(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Zn(e, i);
    const n = (t.onCacheKey || Yn)(e), s = Pt[n];
    if (s)
      return s;
    const { ast: o, detectError: r } = Qn(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = $i(o);
    return r ? l : Pt[n] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Mt(e))
      return it(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const i = e.cacheKey;
    if (i) {
      const a = Pt[i];
      return a || (Pt[i] = $i(e));
    } else
      return $i(e);
  }
}
const Ja = () => "", Ne = (e) => re(e);
function Za(e, ...t) {
  const { fallbackFormat: i, postTranslation: a, unresolving: n, messageCompiler: s, fallbackLocale: o, messages: r } = e, [l, u] = Xi(...t), c = se(u.missingWarn) ? u.missingWarn : e.missingWarn, m = se(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, d = se(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, v = !!u.resolvedMessage, w = N(u.default) || se(u.default) ? se(u.default) ? s ? l : () => l : u.default : i ? s ? l : () => l : "", S = i || w !== "", j = ha(e, u);
  d && Cr(u);
  let [E, A, f] = v ? [
    l,
    j,
    r[j] || {}
  ] : es(e, l, j, o, m, c), b = E, P = l;
  if (!v && !(N(b) || Mt(b) || Ne(b)) && S && (b = w, P = b), !v && (!(N(b) || Mt(b) || Ne(b)) || !N(A)))
    return n ? Li : l;
  if (process.env.NODE_ENV !== "production" && N(b) && e.messageCompiler == null)
    return it(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let k = !1;
  const M = () => {
    k = !0;
  }, _ = Ne(b) ? b : ts(e, l, A, b, P, M);
  if (k)
    return b;
  const C = xr(e, A, f, u), $ = or(C), F = Pr(e, _, $), y = a ? a(F, l) : F;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const L = {
      timestamp: Date.now(),
      key: N(l) ? l : Ne(b) ? b.key : "",
      locale: A || (Ne(b) ? b.locale : ""),
      format: N(b) ? b : Ne(b) ? b.source : "",
      message: y
    };
    L.meta = _e({}, e.__meta, /* @__PURE__ */ yr() || {}), cr(L);
  }
  return y;
}
function Cr(e) {
  fe(e.list) ? e.list = e.list.map((t) => N(t) ? xa(t) : t) : ee(e.named) && Object.keys(e.named).forEach((t) => {
    N(e.named[t]) && (e.named[t] = xa(e.named[t]));
  });
}
function es(e, t, i, a, n, s) {
  const { messages: o, onWarn: r, messageResolver: l, localeFallbacker: u } = e, c = u(e, a, i);
  let m = {}, d, v = null, w = i, S = null;
  const j = "translate";
  for (let E = 0; E < c.length; E++) {
    if (d = S = c[E], process.env.NODE_ENV !== "production" && i !== d && !Jn(i, d) && Ci(n, t) && r(yt(Le.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    })), process.env.NODE_ENV !== "production" && i !== d) {
      const P = e.__v_emitter;
      P && P.emit("fallback", {
        type: j,
        key: t,
        from: w,
        to: S,
        groupId: `${j}:${t}`
      });
    }
    m = o[d] || {};
    let A = null, f, b;
    if (process.env.NODE_ENV !== "production" && Ye && (A = window.performance.now(), f = "intlify-message-resolve-start", b = "intlify-message-resolve-end", xe && xe(f)), (v = l(m, t)) === null && (v = m[t]), process.env.NODE_ENV !== "production" && Ye) {
      const P = window.performance.now(), k = e.__v_emitter;
      k && A && v && k.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: v,
        time: P - A,
        groupId: `${j}:${t}`
      }), f && b && xe && wt && (xe(b), wt("intlify message resolve", f, b));
    }
    if (N(v) || Mt(v) || Ne(v))
      break;
    if (!jr(d, c)) {
      const P = va(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        s,
        j
      );
      P !== t && (v = P);
    }
    w = S;
  }
  return [v, d, m];
}
function ts(e, t, i, a, n, s) {
  const { messageCompiler: o, warnHtmlMessage: r } = e;
  if (Ne(a)) {
    const d = a;
    return d.locale = d.locale || i, d.key = d.key || t, d;
  }
  if (o == null) {
    const d = () => a;
    return d.locale = i, d.key = t, d;
  }
  let l = null, u, c;
  process.env.NODE_ENV !== "production" && Ye && (l = window.performance.now(), u = "intlify-message-compilation-start", c = "intlify-message-compilation-end", xe && xe(u));
  const m = o(a, Tr(e, i, n, a, r, s));
  if (process.env.NODE_ENV !== "production" && Ye) {
    const d = window.performance.now(), v = e.__v_emitter;
    v && l && v.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: d - l,
      groupId: `translate:${t}`
    }), u && c && xe && wt && (xe(c), wt("intlify message compilation", u, c));
  }
  return m.locale = i, m.key = t, m.source = a, m;
}
function Pr(e, t, i) {
  let a = null, n, s;
  process.env.NODE_ENV !== "production" && Ye && (a = window.performance.now(), n = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", xe && xe(n));
  const o = t(i);
  if (process.env.NODE_ENV !== "production" && Ye) {
    const r = window.performance.now(), l = e.__v_emitter;
    l && a && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: r - a,
      groupId: `translate:${t.key}`
    }), n && s && xe && wt && (xe(s), wt("intlify message evaluation", n, s));
  }
  return o;
}
function Xi(...e) {
  const [t, i, a] = e, n = {};
  if (!N(t) && !je(t) && !Ne(t) && !Mt(t))
    throw qe(be.INVALID_ARGUMENT);
  const s = je(t) ? String(t) : (Ne(t), t);
  return je(i) ? n.plural = i : N(i) ? n.default = i : J(i) && !_i(i) ? n.named = i : fe(i) && (n.list = i), je(a) ? n.plural = a : N(a) ? n.default = a : J(a) && _e(n, a), [s, n];
}
function Tr(e, t, i, a, n, s) {
  return {
    locale: t,
    key: i,
    warnHtmlMessage: n,
    onError: (o) => {
      if (s && s(o), process.env.NODE_ENV !== "production") {
        const r = Ar(a), l = `Message compilation error: ${o.message}`, u = o.location && r && co(r, o.location.start.offset, o.location.end.offset), c = e.__v_emitter;
        c && r && c.emit("compile-error", {
          message: r,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${i}`
        }), console.error(u ? `${l}
${u}` : l);
      } else
        throw o;
    },
    onCacheKey: (o) => io(t, i, o)
  };
}
function Ar(e) {
  if (N(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function xr(e, t, i, a) {
  const { modifiers: n, pluralRules: s, messageResolver: o, fallbackLocale: r, fallbackWarn: l, missingWarn: u, fallbackContext: c } = e, d = {
    locale: t,
    modifiers: n,
    pluralRules: s,
    messages: (v) => {
      let w = o(i, v);
      if (w == null && c) {
        const [, , S] = es(c, v, t, r, l, u);
        w = o(S, v);
      }
      if (N(w) || Mt(w)) {
        let S = !1;
        const E = ts(e, v, t, w, v, () => {
          S = !0;
        });
        return S ? Ja : E;
      } else
        return Ne(w) ? w : Ja;
    }
  };
  return e.processor && (d.processor = e.processor), a.list && (d.list = a.list), a.named && (d.named = a.named), je(a.plural) && (d.pluralIndex = a.plural), d;
}
const Ya = typeof Intl < "u", is = {
  dateTimeFormat: Ya && typeof Intl.DateTimeFormat < "u",
  numberFormat: Ya && typeof Intl.NumberFormat < "u"
};
function Xa(e, ...t) {
  const { datetimeFormats: i, unresolving: a, fallbackLocale: n, onWarn: s, localeFallbacker: o } = e, { __datetimeFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !is.dateTimeFormat)
    return s(yt(Le.CANNOT_FORMAT_DATE)), fi;
  const [l, u, c, m] = Qi(...t), d = se(c.missingWarn) ? c.missingWarn : e.missingWarn, v = se(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, w = !!c.part, S = ha(e, c), j = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    n,
    S
  );
  if (!N(l) || l === "")
    return new Intl.DateTimeFormat(S, m).format(u);
  let E = {}, A, f = null, b = S, P = null;
  const k = "datetime format";
  for (let C = 0; C < j.length; C++) {
    if (A = P = j[C], process.env.NODE_ENV !== "production" && S !== A && Ci(v, l) && s(yt(Le.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: A
    })), process.env.NODE_ENV !== "production" && S !== A) {
      const $ = e.__v_emitter;
      $ && $.emit("fallback", {
        type: k,
        key: l,
        from: b,
        to: P,
        groupId: `${k}:${l}`
      });
    }
    if (E = i[A] || {}, f = E[l], J(f))
      break;
    va(e, l, A, d, k), b = P;
  }
  if (!J(f) || !N(A))
    return a ? Li : l;
  let M = `${A}__${l}`;
  _i(m) || (M = `${M}__${JSON.stringify(m)}`);
  let _ = r.get(M);
  return _ || (_ = new Intl.DateTimeFormat(A, _e({}, f, m)), r.set(M, _)), w ? _.formatToParts(u) : _.format(u);
}
const as = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Qi(...e) {
  const [t, i, a, n] = e, s = {};
  let o = {}, r;
  if (N(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw qe(be.INVALID_ISO_DATE_ARGUMENT);
    const u = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    r = new Date(u);
    try {
      r.toISOString();
    } catch {
      throw qe(be.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (no(t)) {
    if (isNaN(t.getTime()))
      throw qe(be.INVALID_DATE_ARGUMENT);
    r = t;
  } else if (je(t))
    r = t;
  else
    throw qe(be.INVALID_ARGUMENT);
  return N(i) ? s.key = i : J(i) && Object.keys(i).forEach((l) => {
    as.includes(l) ? o[l] = i[l] : s[l] = i[l];
  }), N(a) ? s.locale = a : J(a) && (o = a), J(n) && (o = n), [s.key || "", r, s, o];
}
function Qa(e, t, i) {
  const a = e;
  for (const n in i) {
    const s = `${t}__${n}`;
    a.__datetimeFormatters.has(s) && a.__datetimeFormatters.delete(s);
  }
}
function en(e, ...t) {
  const { numberFormats: i, unresolving: a, fallbackLocale: n, onWarn: s, localeFallbacker: o } = e, { __numberFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !is.numberFormat)
    return s(yt(Le.CANNOT_FORMAT_NUMBER)), fi;
  const [l, u, c, m] = ea(...t), d = se(c.missingWarn) ? c.missingWarn : e.missingWarn, v = se(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, w = !!c.part, S = ha(e, c), j = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    n,
    S
  );
  if (!N(l) || l === "")
    return new Intl.NumberFormat(S, m).format(u);
  let E = {}, A, f = null, b = S, P = null;
  const k = "number format";
  for (let C = 0; C < j.length; C++) {
    if (A = P = j[C], process.env.NODE_ENV !== "production" && S !== A && Ci(v, l) && s(yt(Le.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: A
    })), process.env.NODE_ENV !== "production" && S !== A) {
      const $ = e.__v_emitter;
      $ && $.emit("fallback", {
        type: k,
        key: l,
        from: b,
        to: P,
        groupId: `${k}:${l}`
      });
    }
    if (E = i[A] || {}, f = E[l], J(f))
      break;
    va(e, l, A, d, k), b = P;
  }
  if (!J(f) || !N(A))
    return a ? Li : l;
  let M = `${A}__${l}`;
  _i(m) || (M = `${M}__${JSON.stringify(m)}`);
  let _ = r.get(M);
  return _ || (_ = new Intl.NumberFormat(A, _e({}, f, m)), r.set(M, _)), w ? _.formatToParts(u) : _.format(u);
}
const ns = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function ea(...e) {
  const [t, i, a, n] = e, s = {};
  let o = {};
  if (!je(t))
    throw qe(be.INVALID_ARGUMENT);
  const r = t;
  return N(i) ? s.key = i : J(i) && Object.keys(i).forEach((l) => {
    ns.includes(l) ? o[l] = i[l] : s[l] = i[l];
  }), N(a) ? s.locale = a : J(a) && (o = a), J(n) && (o = n), [s.key || "", r, s, o];
}
function tn(e, t, i) {
  const a = e;
  for (const n in i) {
    const s = `${t}__${n}`;
    a.__numberFormatters.has(s) && a.__numberFormatters.delete(s);
  }
}
qo();
/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ir = "9.13.1";
function Dr() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ze().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ze().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ze().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ss = Le.__EXTEND_POINT__, We = Ei(ss), Ae = {
  FALLBACK_TO_ROOT: ss,
  // 9
  NOT_SUPPORTED_PRESERVE: We(),
  // 10
  NOT_SUPPORTED_FORMATTER: We(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: We(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: We(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: We(),
  // 14
  NOT_FOUND_PARENT_SCOPE: We(),
  // 15
  IGNORE_OBJ_FLATTEN: We(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: We(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: We()
  // 18
}, Nr = {
  [Ae.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ae.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Ae.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Ae.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Ae.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Ae.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Ae.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ae.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Ae.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [Ae.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function ki(e, ...t) {
  return pa(Nr[e], ...t);
}
const os = be.__EXTEND_POINT__, Te = Ei(os), me = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: os,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: Te(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Te(),
  // 26
  NOT_INSTALLED: Te(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: Te(),
  // 28
  // directive module errors
  REQUIRED_VALUE: Te(),
  // 29
  INVALID_VALUE: Te(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Te(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: Te(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: Te(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Te(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Te(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Te(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Te(),
  // 37
  // for enhancement
  __EXTEND_POINT__: Te()
  // 38
};
function lt(e, ...t) {
  return Nt(e, null, process.env.NODE_ENV !== "production" ? { messages: Or, args: t } : void 0);
}
const Or = {
  [me.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [me.INVALID_ARGUMENT]: "Invalid argument",
  [me.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [me.NOT_INSTALLED]: "Need to install with `app.use` function",
  [me.UNEXPECTED_ERROR]: "Unexpected error",
  [me.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [me.REQUIRED_VALUE]: "Required in value: {0}",
  [me.INVALID_VALUE]: "Invalid value",
  [me.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [me.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [me.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [me.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [me.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [me.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, ta = /* @__PURE__ */ tt("__translateVNode"), ia = /* @__PURE__ */ tt("__datetimeParts"), aa = /* @__PURE__ */ tt("__numberParts"), na = /* @__PURE__ */ tt("__enableEmitter"), sa = /* @__PURE__ */ tt("__disableEmitter"), Ur = tt("__setPluralRules"), rs = /* @__PURE__ */ tt("__injectWithOption"), oa = /* @__PURE__ */ tt("__dispose");
function ei(e) {
  if (!ee(e))
    return e;
  for (const t in e)
    if (hi(e, t))
      if (!t.includes("."))
        ee(e[t]) && ei(e[t]);
      else {
        const i = t.split("."), a = i.length - 1;
        let n = e, s = !1;
        for (let o = 0; o < a; o++) {
          if (i[o] in n || (n[i[o]] = {}), !ee(n[i[o]])) {
            process.env.NODE_ENV !== "production" && it(ki(Ae.IGNORE_OBJ_FLATTEN, {
              key: i[o]
            })), s = !0;
            break;
          }
          n = n[i[o]];
        }
        s || (n[i[a]] = e[t], delete e[t]), ee(n[i[a]]) && ei(n[i[a]]);
      }
  return e;
}
function fa(e, t) {
  const { messages: i, __i18n: a, messageResolver: n, flatJson: s } = t, o = J(i) ? i : fe(a) ? {} : { [e]: {} };
  if (fe(a) && a.forEach((r) => {
    if ("locale" in r && "resource" in r) {
      const { locale: l, resource: u } = r;
      l ? (o[l] = o[l] || {}, pi(u, o[l])) : pi(u, o);
    } else
      N(r) && pi(JSON.parse(r), o);
  }), n == null && s)
    for (const r in o)
      hi(o, r) && ei(o[r]);
  return o;
}
function ls(e) {
  return e.type;
}
function $r(e, t, i) {
  let a = ee(t.messages) ? t.messages : {};
  "__i18nGlobal" in i && (a = fa(e.locale.value, {
    messages: a,
    __i18n: i.__i18nGlobal
  }));
  const n = Object.keys(a);
  n.length && n.forEach((s) => {
    e.mergeLocaleMessage(s, a[s]);
  });
  {
    if (ee(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (ee(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function an(e) {
  return U(Hs, null, e, 0);
}
const nn = "__INTLIFY_META__", sn = () => [], Br = () => !1;
let on = 0;
function rn(e) {
  return (t, i, a, n) => e(i, a, ma() || void 0, n);
}
const Rr = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ma();
  let t = null;
  return e && (t = ls(e)[nn]) ? { [nn]: t } : null;
};
function Vr(e = {}, t) {
  const { __root: i, __injectWithOption: a } = e, n = i === void 0, s = e.flatJson, o = Ye ? H : An, r = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && r && Nn(ki(Ae.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = se(e.inheritLocale) ? e.inheritLocale : !0;
  const u = o(
    // prettier-ignore
    i && l ? i.locale.value : N(e.locale) ? e.locale : Qt
  ), c = o(
    // prettier-ignore
    i && l ? i.fallbackLocale.value : N(e.fallbackLocale) || fe(e.fallbackLocale) || J(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : u.value
  ), m = o(fa(u.value, e)), d = o(J(e.datetimeFormats) ? e.datetimeFormats : { [u.value]: {} }), v = o(J(e.numberFormats) ? e.numberFormats : { [u.value]: {} });
  let w = i ? i.missingWarn : se(e.missingWarn) || xt(e.missingWarn) ? e.missingWarn : !0, S = i ? i.fallbackWarn : se(e.fallbackWarn) || xt(e.fallbackWarn) ? e.fallbackWarn : !0, j = i ? i.fallbackRoot : se(e.fallbackRoot) ? e.fallbackRoot : !0, E = !!e.fallbackFormat, A = re(e.missing) ? e.missing : null, f = re(e.missing) ? rn(e.missing) : null, b = re(e.postTranslation) ? e.postTranslation : null, P = i ? i.warnHtmlMessage : se(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, k = !!e.escapeParameter;
  const M = i ? i.modifiers : J(e.modifiers) ? e.modifiers : {};
  let _ = e.pluralRules || i && i.pluralRules, C;
  C = (() => {
    n && Ka(null);
    const z = {
      version: Ir,
      locale: u.value,
      fallbackLocale: c.value,
      messages: m.value,
      modifiers: M,
      pluralRules: _,
      missing: f === null ? void 0 : f,
      missingWarn: w,
      fallbackWarn: S,
      fallbackFormat: E,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: P,
      escapeParameter: k,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    z.datetimeFormats = d.value, z.numberFormats = v.value, z.__datetimeFormatters = J(C) ? C.__datetimeFormatters : void 0, z.__numberFormatters = J(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (z.__v_emitter = J(C) ? C.__v_emitter : void 0);
    const x = zr(z);
    return n && Ka(x), x;
  })(), Wt(C, u.value, c.value);
  function F() {
    return [
      u.value,
      c.value,
      m.value,
      d.value,
      v.value
    ];
  }
  const y = W({
    get: () => u.value,
    set: (z) => {
      u.value = z, C.locale = u.value;
    }
  }), L = W({
    get: () => c.value,
    set: (z) => {
      c.value = z, C.fallbackLocale = c.value, Wt(C, u.value, z);
    }
  }), O = W(() => m.value), K = /* @__PURE__ */ W(() => d.value), q = /* @__PURE__ */ W(() => v.value);
  function Y() {
    return re(b) ? b : null;
  }
  function ie(z) {
    b = z, C.postTranslation = z;
  }
  function ce() {
    return A;
  }
  function oe(z) {
    z !== null && (f = rn(z)), A = z, C.missing = f;
  }
  function ze(z, x) {
    return z !== "translate" || !x.resolvedMessage;
  }
  const ge = (z, x, Q, he, nt, si) => {
    F();
    let St;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (C.fallbackContext = i ? Mr() : void 0), St = z(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, n || (C.fallbackContext = void 0);
    }
    if (Q !== "translate exists" && // for not `te` (e.g `t`)
    je(St) && St === Li || Q === "translate exists" && !St) {
      const [gt, Vs] = x();
      if (process.env.NODE_ENV !== "production" && i && N(gt) && ze(Q, Vs) && (j && (Ci(S, gt) || Wn(w, gt)) && it(ki(Ae.FALLBACK_TO_ROOT, {
        key: gt,
        type: Q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Pa } = C;
        Pa && j && Pa.emit("fallback", {
          type: Q,
          key: gt,
          to: "global",
          groupId: `${Q}:${gt}`
        });
      }
      return i && j ? he(i) : nt(gt);
    } else {
      if (si(St))
        return St;
      throw lt(me.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ee(...z) {
    return ge((x) => Reflect.apply(Za, null, [x, ...z]), () => Xi(...z), "translate", (x) => Reflect.apply(x.t, x, [...z]), (x) => x, (x) => N(x));
  }
  function De(...z) {
    const [x, Q, he] = z;
    if (he && !ee(he))
      throw lt(me.INVALID_ARGUMENT);
    return Ee(x, Q, _e({ resolvedMessage: !0 }, he || {}));
  }
  function at(...z) {
    return ge((x) => Reflect.apply(Xa, null, [x, ...z]), () => Qi(...z), "datetime format", (x) => Reflect.apply(x.d, x, [...z]), () => fi, (x) => N(x));
  }
  function Ge(...z) {
    return ge((x) => Reflect.apply(en, null, [x, ...z]), () => ea(...z), "number format", (x) => Reflect.apply(x.n, x, [...z]), () => fi, (x) => N(x));
  }
  function Ke(z) {
    return z.map((x) => N(x) || je(x) || se(x) ? an(String(x)) : x);
  }
  const Vt = {
    normalize: Ke,
    interpolate: (z) => z,
    type: "vnode"
  };
  function Et(...z) {
    return ge(
      (x) => {
        let Q;
        const he = x;
        try {
          he.processor = Vt, Q = Reflect.apply(Za, null, [he, ...z]);
        } finally {
          he.processor = null;
        }
        return Q;
      },
      () => Xi(...z),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[ta](...z),
      (x) => [an(x)],
      (x) => fe(x)
    );
  }
  function Ft(...z) {
    return ge(
      (x) => Reflect.apply(en, null, [x, ...z]),
      () => ea(...z),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[aa](...z),
      sn,
      (x) => N(x) || fe(x)
    );
  }
  function qt(...z) {
    return ge(
      (x) => Reflect.apply(Xa, null, [x, ...z]),
      () => Qi(...z),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x) => x[ia](...z),
      sn,
      (x) => N(x) || fe(x)
    );
  }
  function Gt(z) {
    _ = z, C.pluralRules = _;
  }
  function I(z, x) {
    return ge(() => {
      if (!z)
        return !1;
      const Q = N(x) ? x : u.value, he = pt(Q), nt = C.messageResolver(he, z);
      return r ? nt != null : Mt(nt) || Ne(nt) || N(nt);
    }, () => [z], "translate exists", (Q) => Reflect.apply(Q.te, Q, [z, x]), Br, (Q) => se(Q));
  }
  function X(z) {
    let x = null;
    const Q = Vn(C, c.value, u.value);
    for (let he = 0; he < Q.length; he++) {
      const nt = m.value[Q[he]] || {}, si = C.messageResolver(nt, z);
      if (si != null) {
        x = si;
        break;
      }
    }
    return x;
  }
  function Kt(z) {
    const x = X(z);
    return x ?? (i ? i.tm(z) || {} : {});
  }
  function pt(z) {
    return m.value[z] || {};
  }
  function Ht(z, x) {
    if (s) {
      const Q = { [z]: x };
      for (const he in Q)
        hi(Q, he) && ei(Q[he]);
      x = Q[z];
    }
    m.value[z] = x, C.messages = m.value;
  }
  function Ni(z, x) {
    m.value[z] = m.value[z] || {};
    const Q = { [z]: x };
    if (s)
      for (const he in Q)
        hi(Q, he) && ei(Q[he]);
    x = Q[z], pi(x, m.value[z]), C.messages = m.value;
  }
  function g(z) {
    return d.value[z] || {};
  }
  function h(z, x) {
    d.value[z] = x, C.datetimeFormats = d.value, Qa(C, z, x);
  }
  function T(z, x) {
    d.value[z] = _e(d.value[z] || {}, x), C.datetimeFormats = d.value, Qa(C, z, x);
  }
  function B(z) {
    return v.value[z] || {};
  }
  function de(z, x) {
    v.value[z] = x, C.numberFormats = v.value, tn(C, z, x);
  }
  function ae(z, x) {
    v.value[z] = _e(v.value[z] || {}, x), C.numberFormats = v.value, tn(C, z, x);
  }
  on++, i && Ye && (gi(i.locale, (z) => {
    l && (u.value = z, C.locale = z, Wt(C, u.value, c.value));
  }), gi(i.fallbackLocale, (z) => {
    l && (c.value = z, C.fallbackLocale = z, Wt(C, u.value, c.value));
  }));
  const te = {
    id: on,
    locale: y,
    fallbackLocale: L,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(z) {
      l = z, z && i && (u.value = i.locale.value, c.value = i.fallbackLocale.value, Wt(C, u.value, c.value));
    },
    get availableLocales() {
      return Object.keys(m.value).sort();
    },
    messages: O,
    get modifiers() {
      return M;
    },
    get pluralRules() {
      return _ || {};
    },
    get isGlobal() {
      return n;
    },
    get missingWarn() {
      return w;
    },
    set missingWarn(z) {
      w = z, C.missingWarn = w;
    },
    get fallbackWarn() {
      return S;
    },
    set fallbackWarn(z) {
      S = z, C.fallbackWarn = S;
    },
    get fallbackRoot() {
      return j;
    },
    set fallbackRoot(z) {
      j = z;
    },
    get fallbackFormat() {
      return E;
    },
    set fallbackFormat(z) {
      E = z, C.fallbackFormat = E;
    },
    get warnHtmlMessage() {
      return P;
    },
    set warnHtmlMessage(z) {
      P = z, C.warnHtmlMessage = z;
    },
    get escapeParameter() {
      return k;
    },
    set escapeParameter(z) {
      k = z, C.escapeParameter = z;
    },
    t: Ee,
    getLocaleMessage: pt,
    setLocaleMessage: Ht,
    mergeLocaleMessage: Ni,
    getPostTranslationHandler: Y,
    setPostTranslationHandler: ie,
    getMissingHandler: ce,
    setMissingHandler: oe,
    [Ur]: Gt
  };
  return te.datetimeFormats = K, te.numberFormats = q, te.rt = De, te.te = I, te.tm = Kt, te.d = at, te.n = Ge, te.getDateTimeFormat = g, te.setDateTimeFormat = h, te.mergeDateTimeFormat = T, te.getNumberFormat = B, te.setNumberFormat = de, te.mergeNumberFormat = ae, te[rs] = a, te[ta] = Et, te[ia] = qt, te[aa] = Ft, process.env.NODE_ENV !== "production" && (te[na] = (z) => {
    C.__v_emitter = z;
  }, te[sa] = () => {
    C.__v_emitter = void 0;
  }), te;
}
const ka = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Fr({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, n) => [
    ...a,
    // prettier-ignore
    ...n.type === _t ? n.children : [n]
  ], []) : t.reduce((i, a) => {
    const n = e[a];
    return n && (i[a] = n()), i;
  }, {});
}
function cs(e) {
  return _t;
}
_e({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => je(e) || !isNaN(e)
  }
}, ka);
function qr(e) {
  return fe(e) && !N(e[0]);
}
function ds(e, t, i, a) {
  const { slots: n, attrs: s } = t;
  return () => {
    const o = { part: !0 };
    let r = {};
    e.locale && (o.locale = e.locale), N(e.format) ? o.key = e.format : ee(e.format) && (N(e.format.key) && (o.key = e.format.key), r = Object.keys(e.format).reduce((d, v) => i.includes(v) ? _e({}, d, { [v]: e.format[v] }) : d, {}));
    const l = a(e.value, o, r);
    let u = [o.key];
    fe(l) ? u = l.map((d, v) => {
      const w = n[d.type], S = w ? w({ [d.type]: d.value, index: v, parts: l }) : [d.value];
      return qr(S) && (S[0].key = `${d.type}-${v}`), S;
    }) : N(l) && (u = [l]);
    const c = _e({}, s), m = N(e.tag) || ee(e.tag) ? e.tag : cs();
    return ua(m, c, u);
  };
}
_e({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ka);
_e({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ka);
function ln(e, t) {
}
const Gr = /* @__PURE__ */ tt("global-vue-i18n");
function Pi(e = {}) {
  const t = ma();
  if (t == null)
    throw lt(me.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw lt(me.NOT_INSTALLED);
  const i = Kr(t), a = Wr(i), n = ls(t), s = Hr(e, n);
  if (__VUE_I18N_LEGACY_API__ && i.mode === "legacy" && !e.__useComponent) {
    if (!i.allowComposition)
      throw lt(me.NOT_AVAILABLE_IN_LEGACY_MODE);
    return Xr(t, s, a, e);
  }
  if (s === "global")
    return $r(a, e, n), a;
  if (s === "parent") {
    let l = Jr(i, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && it(ki(Ae.NOT_FOUND_PARENT_SCOPE)), l = a), l;
  }
  const o = i;
  let r = o.__getInstance(t);
  if (r == null) {
    const l = _e({}, e);
    "__i18n" in n && (l.__i18n = n.__i18n), a && (l.__root = a), r = Vr(l), o.__composerExtend && (r[oa] = o.__composerExtend(r)), Yr(o, t, r), o.__setInstance(t, r);
  }
  return r;
}
function Kr(e) {
  {
    const t = Gs(e.isCE ? Gr : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw lt(e.isCE ? me.NOT_INSTALLED_WITH_PROVIDE : me.UNEXPECTED_ERROR);
    return t;
  }
}
function Hr(e, t) {
  return _i(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Wr(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Jr(e, t, i = !1) {
  let a = null;
  const n = t.root;
  let s = Zr(t, i);
  for (; s != null; ) {
    const o = e;
    if (e.mode === "composition")
      a = o.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const r = o.__getInstance(s);
      r != null && (a = r.__composer, i && a && !a[rs] && (a = null));
    }
    if (a != null || n === s)
      break;
    s = s.parent;
  }
  return a;
}
function Zr(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Yr(e, t, i) {
  let a = null;
  dt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = i, a = uo();
      const n = i;
      n[na] && n[na](a), a.on("*", ln);
    }
  }, t), Tn(() => {
    const n = i;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", ln), n[sa] && n[sa](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const s = n[oa];
    s && (s(), delete n[oa]);
  }, t);
}
function Xr(e, t, i, a = {}) {
  const n = t === "local", s = An(null);
  if (n && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw lt(me.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const o = se(a.inheritLocale) ? a.inheritLocale : !N(a.locale), r = H(
    // prettier-ignore
    !n || o ? i.locale.value : N(a.locale) ? a.locale : Qt
  ), l = H(
    // prettier-ignore
    !n || o ? i.fallbackLocale.value : N(a.fallbackLocale) || fe(a.fallbackLocale) || J(a.fallbackLocale) || a.fallbackLocale === !1 ? a.fallbackLocale : r.value
  ), u = H(fa(r.value, a)), c = H(J(a.datetimeFormats) ? a.datetimeFormats : { [r.value]: {} }), m = H(J(a.numberFormats) ? a.numberFormats : { [r.value]: {} }), d = n ? i.missingWarn : se(a.missingWarn) || xt(a.missingWarn) ? a.missingWarn : !0, v = n ? i.fallbackWarn : se(a.fallbackWarn) || xt(a.fallbackWarn) ? a.fallbackWarn : !0, w = n ? i.fallbackRoot : se(a.fallbackRoot) ? a.fallbackRoot : !0, S = !!a.fallbackFormat, j = re(a.missing) ? a.missing : null, E = re(a.postTranslation) ? a.postTranslation : null, A = n ? i.warnHtmlMessage : se(a.warnHtmlMessage) ? a.warnHtmlMessage : !0, f = !!a.escapeParameter, b = n ? i.modifiers : J(a.modifiers) ? a.modifiers : {}, P = a.pluralRules || n && i.pluralRules;
  function k() {
    return [
      r.value,
      l.value,
      u.value,
      c.value,
      m.value
    ];
  }
  const M = W({
    get: () => s.value ? s.value.locale.value : r.value,
    set: (I) => {
      s.value && (s.value.locale.value = I), r.value = I;
    }
  }), _ = W({
    get: () => s.value ? s.value.fallbackLocale.value : l.value,
    set: (I) => {
      s.value && (s.value.fallbackLocale.value = I), l.value = I;
    }
  }), C = W(() => s.value ? s.value.messages.value : u.value), $ = W(() => c.value), F = W(() => m.value);
  function y() {
    return s.value ? s.value.getPostTranslationHandler() : E;
  }
  function L(I) {
    s.value && s.value.setPostTranslationHandler(I);
  }
  function O() {
    return s.value ? s.value.getMissingHandler() : j;
  }
  function K(I) {
    s.value && s.value.setMissingHandler(I);
  }
  function q(I) {
    return k(), I();
  }
  function Y(...I) {
    return s.value ? q(() => Reflect.apply(s.value.t, null, [...I])) : q(() => "");
  }
  function ie(...I) {
    return s.value ? Reflect.apply(s.value.rt, null, [...I]) : "";
  }
  function ce(...I) {
    return s.value ? q(() => Reflect.apply(s.value.d, null, [...I])) : q(() => "");
  }
  function oe(...I) {
    return s.value ? q(() => Reflect.apply(s.value.n, null, [...I])) : q(() => "");
  }
  function ze(I) {
    return s.value ? s.value.tm(I) : {};
  }
  function ge(I, X) {
    return s.value ? s.value.te(I, X) : !1;
  }
  function Ee(I) {
    return s.value ? s.value.getLocaleMessage(I) : {};
  }
  function De(I, X) {
    s.value && (s.value.setLocaleMessage(I, X), u.value[I] = X);
  }
  function at(I, X) {
    s.value && s.value.mergeLocaleMessage(I, X);
  }
  function Ge(I) {
    return s.value ? s.value.getDateTimeFormat(I) : {};
  }
  function Ke(I, X) {
    s.value && (s.value.setDateTimeFormat(I, X), c.value[I] = X);
  }
  function ni(I, X) {
    s.value && s.value.mergeDateTimeFormat(I, X);
  }
  function Vt(I) {
    return s.value ? s.value.getNumberFormat(I) : {};
  }
  function Et(I, X) {
    s.value && (s.value.setNumberFormat(I, X), m.value[I] = X);
  }
  function Ft(I, X) {
    s.value && s.value.mergeNumberFormat(I, X);
  }
  const qt = {
    get id() {
      return s.value ? s.value.id : -1;
    },
    locale: M,
    fallbackLocale: _,
    messages: C,
    datetimeFormats: $,
    numberFormats: F,
    get inheritLocale() {
      return s.value ? s.value.inheritLocale : o;
    },
    set inheritLocale(I) {
      s.value && (s.value.inheritLocale = I);
    },
    get availableLocales() {
      return s.value ? s.value.availableLocales : Object.keys(u.value);
    },
    get modifiers() {
      return s.value ? s.value.modifiers : b;
    },
    get pluralRules() {
      return s.value ? s.value.pluralRules : P;
    },
    get isGlobal() {
      return s.value ? s.value.isGlobal : !1;
    },
    get missingWarn() {
      return s.value ? s.value.missingWarn : d;
    },
    set missingWarn(I) {
      s.value && (s.value.missingWarn = I);
    },
    get fallbackWarn() {
      return s.value ? s.value.fallbackWarn : v;
    },
    set fallbackWarn(I) {
      s.value && (s.value.missingWarn = I);
    },
    get fallbackRoot() {
      return s.value ? s.value.fallbackRoot : w;
    },
    set fallbackRoot(I) {
      s.value && (s.value.fallbackRoot = I);
    },
    get fallbackFormat() {
      return s.value ? s.value.fallbackFormat : S;
    },
    set fallbackFormat(I) {
      s.value && (s.value.fallbackFormat = I);
    },
    get warnHtmlMessage() {
      return s.value ? s.value.warnHtmlMessage : A;
    },
    set warnHtmlMessage(I) {
      s.value && (s.value.warnHtmlMessage = I);
    },
    get escapeParameter() {
      return s.value ? s.value.escapeParameter : f;
    },
    set escapeParameter(I) {
      s.value && (s.value.escapeParameter = I);
    },
    t: Y,
    getPostTranslationHandler: y,
    setPostTranslationHandler: L,
    getMissingHandler: O,
    setMissingHandler: K,
    rt: ie,
    d: ce,
    n: oe,
    tm: ze,
    te: ge,
    getLocaleMessage: Ee,
    setLocaleMessage: De,
    mergeLocaleMessage: at,
    getDateTimeFormat: Ge,
    setDateTimeFormat: Ke,
    mergeDateTimeFormat: ni,
    getNumberFormat: Vt,
    setNumberFormat: Et,
    mergeNumberFormat: Ft
  };
  function Gt(I) {
    I.locale.value = r.value, I.fallbackLocale.value = l.value, Object.keys(u.value).forEach((X) => {
      I.mergeLocaleMessage(X, u.value[X]);
    }), Object.keys(c.value).forEach((X) => {
      I.mergeDateTimeFormat(X, c.value[X]);
    }), Object.keys(m.value).forEach((X) => {
      I.mergeNumberFormat(X, m.value[X]);
    }), I.escapeParameter = f, I.fallbackFormat = S, I.fallbackRoot = w, I.fallbackWarn = v, I.missingWarn = d, I.warnHtmlMessage = A;
  }
  return Ks(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw lt(me.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const I = s.value = e.proxy.$i18n.__composer;
    t === "global" ? (r.value = I.locale.value, l.value = I.fallbackLocale.value, u.value = I.messages.value, c.value = I.datetimeFormats.value, m.value = I.numberFormats.value) : n && Gt(I);
  }), qt;
}
Dr();
__INTLIFY_JIT_COMPILATION__ ? Ga(Lr) : Ga(Sr);
kr(Xo);
br(Vn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ze();
  e.__INTLIFY__ = !0, rr(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Qr = {
  waitMessage: "Er der næsten. "
}, el = {
  buttonLabel: "Gemme",
  buttonLabelClose: "Tæt",
  confirmEmailMessage: "Bekræft din e-mail-adresse",
  copy: "For at opdatere din e-mailadresse skal du tilføje den nye nedenfor:",
  errorMessageCopy: "Noget gik galt. ",
  errorMessageHeadline: "Fejl",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekræft din emailadresse",
  inputEmailPlaceholder: "Email adresse",
  invalidEmailMessage: "E-mail ikke gyldig!",
  rememberMeLabel: "Husk mig",
  successMessageCopy: "Din e-mailadresse er blevet opdateret.",
  successMessageHeadline: "E-mail-adresse opdateret"
}, tl = {
  closeButtonLabel: "Tæt",
  confirmPasswordLabel: "Bekræft kodeord",
  currentPasswordLabel: "Nuværende kodeord",
  newPasswordLabel: "nyt kodeord",
  passwordMismatchError: "Adgangskoden passer ikke",
  passwordUpdateErrorTitle: "Fejl",
  passwordUpdateSuccessTitle: "Adgangskode opdateret",
  samePasswordError: "Denne adgangskode blev brugt tidligere. Indsend venligst en ny adgangskode",
  subtitle: "For at ændre din adgangskode skal du udfylde felterne nedenfor:",
  submitButtonLabel: "Indsend",
  successfulChangeLabel: "Din adgangskode er blevet opdateret",
  title: "Adgangskodeændring"
}, il = {
  invalidEmail: "Forkert e-mail",
  invalidPassword: "Forkert kodeord",
  sap_206002: "Din konto afventer bekræftelse. Jeg er bange for, at vi ikke kan lade dig fortsætte i øjeblikket. ",
  sap_206006: "Det ser ud til, at den e-mailadresse, du har indsendt, afventer bekræftelse",
  sap_400003: "Denne e-mail findes allerede, brug venligst en anden e-mailadresse!",
  sap_400028: "Den indsendte e-mailadresse afventer bekræftelse",
  sap_400050: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_400097: "Det ser ud til, at du får adgang til vores tjenester fra en usikker/ikke-understøttet browser. ",
  sap_401030: "Denne adgangskode blev brugt tidligere. Indsend venligst en ny adgangskode",
  sap_403005: "Vi har ikke en konto tilknyttet denne e-mailadresse. Tjek venligst din e-mail og prøv igen",
  sap_403011: "Sessionen er udløbet. ",
  sap_403012: "Sessionen er udløbet. ",
  sap_403013: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_403035: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_403041: "Vi har ikke en konto tilknyttet denne e-mailadresse. Tjek venligst din e-mail og prøv igen",
  sap_403042: "E-mail",
  sap_403043: "E-mail",
  sap_403047: "E-mail",
  sap_403100: "Der er for nylig anmodet om en anmodning om opdatering af adgangskode. Fortæl os venligst, indtil anmodningen er behandlet",
  sap_403025: "Linket til nulstilling af adgangskode er ugyldigt. Send venligst anmodning om glemt adgangskode igen for at modtage et nyt nulstillingslink.",
  sapErrorTitle: "Fejl ved behandling af anmodning",
  sessionExpired: "Sessionen er udløbet",
  tooWeakPassword: "Adgangskoden skal indeholde mindst {minLength} tegn og {minCharGroups} af følgende: stort bogstav, lille bogstav, tal, specialsymbol | Adgangskoden skal indeholde mindst {minLength} tegn",
  unexpectedDescription: "Hvis problemet fortsætter, bedes du kontakte os via kontaktformularen med detaljer.",
  unexpectedTitle: "Der opstod en uventet fejl",
  unknownDescription: "Der opstod en uventet fejl. ",
  unknownTitle: "Åh åh!"
}, al = {
  subtitle: "Indstil din nye adgangskode.",
  title: "Glemt din adgangskode?"
}, nl = {
  headMetaDescription: "Kunde login side",
  headTitle: "Log ind med din e-mail og adgangskode:",
  subtitle: "Log ind eller opret en konto for at få alle Mieles funktioner.",
  title: "Log ind på din konto",
  error: {
    invalidEmailPasswordDescription: "Kombinationen af ​​e-mailadresse og adgangskode er ikke gyldig.",
    invalidEmailPasswordTitle: "Ugyldige legitimationsoplysninger",
    missingConcentTitle: "Konto afventer registrering",
    noAccountDescription: "Der er ingen konto knyttet til denne e-mailadresse.",
    noAccountTitle: "Ingen konto registreret"
  },
  extraConsentScene: {
    continue: "Blive ved",
    privacyStatementCheckboxLabel: "Jeg har noteret mig {0}.",
    privacyStatementName: "fortrolighedserklæring",
    privacyStatementTitle: "Vores privatlivspolitik er ændret",
    termsOfUseCheckboxLabel: "Jeg accepterer {0}.",
    termsOfUseName: "vilkår for brug",
    termsOfUseTitle: "Vores vilkår for brug er ændret",
    title: "Profil færdiggørelse"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tilbage til Login",
    submitButtonLabel: "Indsend",
    successDescription: "Tjek venligst din e-mail, du vil snart modtage oplysningerne på din konto for at starte med processen til nulstilling af adgangskode.",
    successTitle: "Din anmodning er modtaget.",
    title: "Indtast venligst din e-mailadresse for at nulstille din adgangskode:"
  },
  loginModalScene: {
    copy: "Log ind eller opret en konto for at få alle Mieles funktioner.",
    title: "Log ind på din konto"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Glemt min adgangskode",
    invalidEmailMessage: "E-mail ikke gyldig!",
    loginButtonLabel: "Log på",
    passwordInputLabel: "Adgangskode",
    rememberMeLabel: "Husk mig",
    title: "Log ind med din e-mail og adgangskode:"
  }
}, sl = {
  accessibility: {
    close: "Tæt"
  }
}, ol = {
  tooShort: "For kort",
  medium: "Middel",
  strong: "Stærk",
  tooWeak: "For svag",
  veryStrong: "Meget stærk",
  weak: "Svag"
}, rl = {
  showPasswordText: "Vis",
  hidePasswordText: "Skjul"
}, ll = {
  registerButtonLabel: "Tilmeld",
  registerTitle: "Har du ikke en konto?",
  whyRegister: {
    list: [
      "Adgang til eksklusive fordele fra Miele Club",
      "Registrer apparater, spor ordrer, få adgang til manualer",
      "Modtag personlige tilbud og kampagner",
      "Se alle dine ordrer, garantier, begivenheder og tjenester"
    ],
    title: "Hvorfor registrere?"
  },
  closeButtonLabel: "Tæt",
  passwordMismatchError: "Adgangskoderne stemmer ikke overens",
  passwordUpdateErrorTitle: "Fejl ved opdatering af adgangskode",
  passwordUpdateSuccessTitle: "Adgangskode opdateret",
  successfulChangeLabel: "Din adgangskode er blevet opdateret"
}, cl = {
  title: "Marketingpræferencer",
  description: "Sæt kryds nedenfor for eksklusive tilbud, nyheder, begivenheder og hvordan du får mest muligt ud af dit apparat.",
  submit: "Gemme",
  levelOne: {
    shortText: 'Ja, jeg ønsker at modtage markedsføringskommunikation fra Miele A/S og Miele & Cie. KG ("Miele"), som er tilpasset mine personlige interesser via e-mail, sms, post og via Miele-apps (hvis relevant)',
    text: `Ja, jeg ønsker at modtage markedsføringskommunikation fra Miele A/S og Miele & Cie. KG ("Miele"), som er tilpasset mine personlige interesser via e-mail, sms, post og via Miele-apps (hvis relevant) med oplysninger om produkter, tilbud og nyheder fra Mieles produktsortiment og om Miele-events kundeundersøgelser, produktvurderinger, anmeldelser og opskrifter. Til dette formål kan Miele bruge mine kontaktoplysninger (titel, navn, e-mailadresse, mobiltelefonnummer og postadresse) og tilpasse kommunikationen baseret på min købs-, service-, begivenhedshistorik, klik- og åbningsadfærd for nyhedsbrevet samt kundeværdi, som nærmere beskrevet i vores privatlivspolitik. Jeg kan til enhver tid tilbagekalde mit samtykke uden at angive årsager med virkning for fremtiden (f.eks. ved at sende en besked til  info{'@'}miele.dk ,kontaktoplysningerne i impressum eller ved at klikke på afmeldingslinket i e-mails).`,
    link: {
      title: "Databeskyttelse",
      ref: "https://www.miele.dk/c/databeskyttelse-14.htm"
    }
  },
  levelTwo: {
    text: "Ud over mit grundlæggende samtykke giver jeg også tilladelse til, at Miele kan behandle data fra min brug af Miele-apps og mine besøg på Mieles hjemmeside (www.miele.dk), herunder brugeradfærd på Mieles websteder efter klik på det tilknyttede nyhedsbrev, for at supplere min brugerprofil til personliggjort reklamekommunikation, forudsat jeg har givet separat samtykke i appen eller på webstedet til databehandling. Jeg kan til enhver tid tilbagekalde mit samtykke uden begrundelse med virkning for fremtiden. Yderligere detaljer i Mieles databeskyttelsespolitik.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Ud over mit grundlæggende samtykke giver jeg også tilladelse til, at Miele må behandle data fra mine tilsluttede Miele-produkter (data om brug af produktet og status) for at supplere min brugerprofil med henblik på personliggjort annoncering. Jeg kan finde flere oplysninger om behandlingen af produktdata i privatlivspolitikken for Miele{'@'}Home-systemet. Jeg kan til enhver tid tilbagekalde mit samtykke uden begrundelse med virkning for fremtiden. Se Mieles databeskyttelsespolitik for yderligere informationer.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jeg accepterer vilkårene for brug.",
    link: {
      title: "Se vilkår for brug*",
      ref: "https://www.miele.dk/c/brugsbetingelser-304.htm"
    }
  }
}, dl = {
  headline: "Miele Club",
  why: {
    title: "Gratis medlemskab - Eksklusive tilbud for medlemmer.",
    reasons: [
      "Velkomstgave 10 % rabat",
      "Fødselsdagsoverraskelse",
      "Eksklusive tilbud",
      "Invitationer til events og oplevelser"
    ]
  },
  birthDateTitle: "Må vi sende dig en fødselsdagsgave?",
  birthDateLabel: "Din fødselsdato (frivilligt)",
  birthDateValidation: {
    requirementMsg: "Indtast venligst dette datoformat: DD/MM/YYYY",
    errorMsg: "Ugyldig dato"
  },
  joinClubLabel: "Ja, jeg vil gerne blive medlem af Miele Club.",
  termsAndCondition: {
    description: "Jeg accepterer Miele Club {termsAndConditionLink} og bekræfter, at jeg har læst og forstået informationen om {privacyLink} for Miele Club.",
    termsAndConditionLink: {
      title: "Vilkår for deltagelse og brug",
      ref: "https://www.miele.dk/c/betingelser-og-vilkar-13.htm"
    },
    privacyLink: {
      title: "Databeskyttelse",
      ref: "https://www.miele.dk/c/databeskyttelse-14.htm"
    }
  },
  newsletter: {
    description: "Ja, jeg ønsker at modtage Miele Club-reklamer fra Miele A/S (“Miele”), der er skræddersyet til mine personlige interesser, via e-mail og post med specialtilbud, oplysninger, invitationer til begivenheder og kundeundersøgelser om Mieles produkter og tjenester. Til dette formål kan Miele bruge mine kontaktoplysninger (titel, navn, e-mail og postadresse) og tilpasse kommunikationen på baggrund af min købs- og nyhedsbrevsadfærd, samt min Miele Club-status, som beskrevet nærmere i {privacyLink}. Jeg kan til enhver tid tilbagekalde mit samtykke med fremtidig virkning (fx ved at sende en uformel besked til info{'@'}miele.dk, kontaktoplysningerne angivet i aftrykket eller ved at trykke på afmeldingslinket i e-mails). Den kontraktlige Miele Club {termsAndConditionLink} forbliver upåvirket af dette, indtil medlemskabet opsiges.",
    shortDescription: "Ja, jeg ønsker at modtage Miele Club-reklamer fra Miele A/S (“Miele”), der er skræddersyet til mine personlige interesser, via e-mail og post",
    privacyLink: {
      title: "Datasikkerhed",
      href: "https://www.miele.dk/c/databeskyttelse-14.htm"
    },
    termsAndConditionLink: {
      title: "kommunikation",
      href: "https://www.miele.dk/c/betingelser-og-vilkar-13.htm"
    },
    supportEmail: "info{'@'}miele.dk"
  },
  selectAllConsents: {
    description: "For at blive medlem af Miele Club skal du acceptere alle vilkår og betingelser *"
  }
}, ul = "vis hele erklæringen", ml = "vis mindre", pl = {
  auth: Qr,
  changeEmailScene: el,
  changePasswordScene: tl,
  errors: il,
  forgotPassword: al,
  login: nl,
  modal: sl,
  passwordStrength: ol,
  passwordHelper: rl,
  register: ll,
  "marketing-consent": {
    title: "Marketingpræferencer",
    description: "Sæt kryds nedenfor for eksklusive tilbud, nyheder, begivenheder og hvordan du får mest muligt ud af dit apparat.",
    submit: "Gemme",
    newsletter: {
      text: "Jeg giver samtykke til, at Miele A/S (“Miele”) sender mig information om produkter og innovationer fra Mieles sortiment og om Mieles arrangementer, kundeundersøgelser, vurderinger og anmeldelser af produkter og opskrifter via e-mail, Miele-apps og SMS, og at Miele til dette formål behandler de kontaktoplysninger, jeg har oplyst (titel, navn, e-mailadresse, mobiltelefonnummer og postnummer) og om de Miele-produkter, jeg har købt og vil købe i fremtiden, så vidt det er relevant, jeg har angivet.",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    personalisation: {
      text: "Jeg accepterer, at Miele må behandle oplysninger om de tjenester, jeg har brugt, og teknikeropgaver, jeg har udført, samt arrangementer, jeg har deltaget i, med henblik på forbedret personalisering.",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Ud over den udvidede personalisering accepterer jeg, at Miele også må behandle data fra brugen af ​​Miele-appen og mine besøg på Mieles hjemmesider (www.miele.co.uk) for at supplere min brugerprofil, forudsat at jeg har givet særskilt samtykke ",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jeg kan til enhver tid tilbagekalde mit samtykke uden at angive grunde med virkning for fremtiden.  ",
      link: {
        title: "databeskyttelsespolitik.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jeg accepterer vilkårene for brug.",
      link: {
        title: "Se vilkår for brug*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: cl,
  mieleClub: dl,
  readMore: ul,
  readLess: ml
}, gl = {
  waitMessage: "Fast geschafft..."
}, hl = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätige deine E-Mail-Adresse",
  copy: "Ändere deine E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuche es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "Bestätige deine E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Deine E-Mail-Adresse wurde erfolgreich geändert",
  successMessageHeadline: "E-Mail-Address aktualisiert"
}, vl = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, fl = {
  invalidEmail: "Ungültige E-Mail Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail existiert bereits, bitte verwenden Sie eine andere E-Mail Adresse!",
  sap_400028: "Die E-Mail-Adresse steht noch aus und muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die eingegebene E-Mail-Adresse ist nicht registriert.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: 'Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte senden Sie die Anfrage "Passwort vergessen" erneut, um einen neuen Link zum Zurücksetzen zu erhalten.',
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und {minCharGroups} der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, kl = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, bl = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich an in Ihrem Benutzerkonto, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail Adresse und Passwort eingeben:"
  }
}, wl = {
  accessibility: {
    close: "Schliessen"
  }
}, yl = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, Ml = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, zl = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Exklusive Miele Club Vorteile",
      "Geräteregistrierung, Sendeverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, jl = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
  submit: "Speichern",
  levelOne: {
    shortText: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Gesellschaft m.b.H. sowie der Miele & Cie. KG (“Miele”) per E-Mail, SMS, Post und über die Miele Apps (soweit genutzt) erhalten",
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Gesellschaft m.b.H. sowie der Miele & Cie. KG (“Miele”) per E-Mail, SMS, Post und über die Miele Apps (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletterklick- und -öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.at, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutzhinweisen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.at), einschließlich an Newsletterklicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele-Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele-Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu",
    link: {
      title: "Nutzungsbedingungen ansehen*",
      ref: "https://www.miele.at/c/nutzungsbedingungen-304.htm"
    }
  }
}, _l = {
  headline: "Miele Club",
  birthDateTitle: "Dürfen wir Ihnen ein Geburtstagsgeschenk senden?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt auf Zubehör und Reinigungsprodukte",
      "Geburtstagsüberraschung",
      "Exklusive Angebote",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat: DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.at/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.at, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.at/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.at/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.at"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, El = "vollständige Erklärung anzeigen", Sl = "vollständige Erklärung ausblenden", Ll = {
  auth: gl,
  changeEmailScene: hl,
  changePasswordScene: vl,
  errors: fl,
  forgotPassword: kl,
  login: bl,
  modal: wl,
  passwordStrength: yl,
  passwordHelper: Ml,
  register: zl,
  "marketing-consent": {
    title: "Marketing-Präferenzen",
    description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
    submit: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Gesellschaft m.b.H. ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungen und Rezensionen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.at) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    highlightedText: {
      text: "Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Meinen Widerruf kann ich zu jedem späteren Zeitpunkt ohne Angaben von Gründen schriftlich (Miele Gesellschaft m.b.H., Mielestraße 1, A-5071 Wals) oder per E-Mail (info{'@'}miele.at) erklären. Zudem befindet sich in jeder E-Mail an mich ein Abmeldelink, mit dem ich meinen Widerruf ebenfalls erklären kann. Weitere Informationen, wie Miele mit Ihren Daten umgeht finden Sie in den Datenschutzbestimmungen.",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "https://www.miele.at/c/nutzungsbedingungen-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: jl,
  mieleClub: _l,
  readMore: El,
  readLess: Sl
}, Cl = {
  waitMessage: "Fast geschafft. Bitte warten…"
}, Pl = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätigen Sie Ihre E-Mail-Adresse",
  copy: "Um Ihre E-Mail-Adresse zu aktualisieren, fügen Sie bitte die neue unten ein:",
  errorMessageCopy: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  errorMessageHeadline: "Fehlersadlinen",
  headline: "Profilangaben",
  inputEmailConfirmPlaceholder: "Bestätigen Sie Ihre E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail nicht gültig!",
  rememberMeLabel: "Angemeldet bleiben",
  successMessageCopy: "Ihre E-Mail-Adresse wurde erfolgreich aktualisiert.",
  successMessageHeadline: "E-Mail-Adresse aktualisiert"
}, Tl = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen ",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Passwort stimmt nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde bereits verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um Ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Absenden",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, Al = {
  invalidEmail: "Falsche E-Mail-Adresse",
  invalidPassword: "Falsches Passwort",
  sap_206002: "Ihr Konto wartet noch auf Bestätigung. Leider können wir Sie momentan nicht weiterleiten. Bitte kontaktieren Sie uns für weitere Informationen.",
  sap_206006: "Die angegebene E-Mail-Adresse wartet noch auf Bestätigung.",
  sap_400003: "Diese E-Mail-Adresse existiert bereits. Bitte verwenden Sie eine andere E-Mail-Adresse.",
  sap_400028: "Die angegebene E-Mail-Adresse wartet noch auf Bestätigung.",
  sap_400050: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_400097: "Es scheint, als ob Sie unsere Dienste von einem unsicheren/nicht unterstützten Browser aus aufrufen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde bereits verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Wir haben kein Konto mit dieser E-Mail-Adresse gefunden. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Sitzung abgelaufen. Bitte aktualisieren Sie den Browser und melden Sie sich erneut an.",
  sap_403012: "Sitzung abgelaufen. Bitte aktualisieren Sie den Browser und melden Sie sich erneut an.",
  sap_403013: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_403035: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_403041: "Wir haben kein Konto mit dieser E-Mail-Adresse gefunden. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403043: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403047: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403100: "Eine Änderung des Passworts wurde kürzlich angefordert. Bitte haben Sie Geduld, bis die Anfrage bearbeitet wurde.",
  sap_403025: "Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte setzen Sie Ihr Passwort erneut zurück, um einen neuen Link zu erhalten.",
  sapErrorTitle: "Fehler bei der Verarbeitung der Anfrage",
  sessionExpired: "Sitzung abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und mindestens {minCharGroups} der folgenden Zeichen enthalten: Grossbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular mit Details.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten",
  unknownDescription: "Unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  unknownTitle: "Oh Oh!"
}, xl = {
  subtitle: "Legen Sie Ihr neues Passwort fest.",
  title: "Passwort vergessen?"
}, Il = {
  headMetaDescription: "Kunden-Anmeldeseite",
  headTitle: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:",
  subtitle: "Melden Sie sich an oder erstellen Sie ein Konto, um alle Funktionen von Miele nutzen zu können.",
  title: "Melden Sie sich bei Ihrem Konto an",
  error: {
    invalidEmailPasswordDescription: "Die Kombination aus E-Mail-Adresse und Passwort ist nicht gültig.",
    invalidEmailPasswordTitle: "Ungültige Anmeldedaten",
    missingConcentTitle: "Konto wartet auf Registrierung",
    noAccountDescription: "Es gibt kein Konto, das mit dieser E-Mail-Adresse verknüpft ist.",
    noAccountTitle: "Kein Konto registriert"
  },
  extraConsentScene: {
    continue: "Weiter",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzerklärung",
    privacyStatementTitle: "Unsere Datenschutzerklärung wurde aktualisiert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen wurden aktualisiert",
    title: "Profil vervollständigen"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Absenden",
    successDescription: "Bitte überprüfen Sie Ihre E-Mail. Sie erhalten in Kürze Informationen zu Ihrem Konto, um den Prozess zur Zurücksetzung des Passworts zu starten.",
    successTitle: "Wir haben Ihre Anfrage erhalten.",
    title: "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen:"
  },
  loginModalScene: {
    copy: "Melden Sie sich an oder erstellen Sie ein Konto, um alle Funktionen von Miele nutzen zu können.",
    title: "Melden Sie sich bei Ihrem Konto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail nicht gültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Angemeldet bleiben",
    title: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:"
  }
}, Dl = {
  accessibility: {
    close: "Schliessen"
  }
}, Nl = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, Ol = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Ausblenden"
}, Ul = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben noch kein Konto?",
  whyRegister: {
    list: [
      "Zugang zu exklusiven Vorteilen des Miele Clubs",
      "Registrierung von Geräten, Auftragsverfolgung, Zugriff auf Gebrauchsanweisungen",
      "Personalisierte Angebote und Promotionen",
      "Alle Ihre Bestellungen, Garantien, Events und Dienstleistungen einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler beim Aktualisieren des Passworts",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, $l = {
  title: "Marketingpräferenzen",
  description: "Interessieren Sie sich für exklusive Angebote, Produktneuheiten, Events, Kundenbefragungen und weiteren nützlichen Informationen aus der Miele-Welt?",
  submit: "Speichern",
  levelOne: {
    text: "Ich bin damit einverstanden, dass die Miele AG («Miele») mir Informationen und Angebote zu Produkten und Dienstleistungen sowie Einladungen zu Events und Kundenbefragungen per E-Mail (Newsletter), Miele Apps, Post und SMS sendet. Um die kommerzielle Kommunikation bestmöglich auf Ihre Bedürfnisse abzustimmen, verarbeitet Miele die folgende Personendaten und führen dabei ein sogenanntes Profiling durch (d.h. eine automatisierte Bearbeitung von Personendaten, um persönliche Aspekte zu analysieren oder Prognosen zu treffen): Kontaktdaten, Gerätedaten, Daten aus Kundenbefragungen/Surveys, Kaufhistorie und Newsletter-Klicks, beanspruchte Dienstleistungen, Technikereinsätze und Event-Teilnahmen, Nutzungsverhalten Miele App und Webseiten. Weitere Details finden Sie in den ",
    link: {
      title: "Datenschutzhinweisen.",
      ref: "https://www.miele.ch/de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen darüber, wie Miele mit Ihren Daten umgeht, finden Sie in der ",
    link: {
      title: "Miele Datenschutzerklärung.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu.",
    link: {
      title: "Nutzungsbedingungen anzeigen.",
      ref: "https://www.miele.ch/de/c/nutzungsbedingungen-304.htm"
    }
  }
}, Bl = {
  headline: "Miele Club",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt",
      "Geburtstagsüberraschung",
      "Exklusive Angebote und Events",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateTitle: "Möchten Sie eine Geburtstagsüberraschung erhalten?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat: DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ja, ich habe die Miele Club {termsAndConditionLink} gelesen und akzeptiere sie.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.ch/de/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Ja, ich habe die Miele Club {privacyLink} gelesen und akzeptiere sie. Die Bearbeitung gemäss Datenschutzbestimmungen umfasst insbesondere das Profiling gestützt auf das Kundenverhalten und die Nutzung der Kundenprofile für Marketing und weitere Zwecke.",
    privacyLink: {
      title: "Datenschutzbestimmungen",
      href: "https://www.miele.ch/de/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen"
  }
}, Rl = "vollständige Erklärung anzeigen", Vl = "vollständige Erklärung ausblenden", Fl = {
  auth: Cl,
  changeEmailScene: Pl,
  changePasswordScene: Tl,
  errors: Al,
  forgotPassword: xl,
  login: Il,
  modal: Dl,
  passwordStrength: Nl,
  passwordHelper: Ol,
  register: Ul,
  "marketing-consent": {
    title: "Marketingpräferenzen",
    description: "Interessieren Sie sich für exklusive Angebote, Produktneuheiten, Events, Kundenbefragungen und weiteren nützlichen Informationen aus der Miele-Welt?",
    submit: "Speichern",
    newsletter: {
      text: "Ich bin damit einverstanden, dass die Miele AG («Miele») mir Informationen und Angebote zu Produkten und Dienstleistungen sowie Einladungen zu Events und Kundenbefragungen per E-Mail (Newsletter), Miele Apps, Post und SMS sendet. Um die kommerzielle Kommunikation bestmöglich auf Ihre Bedürfnisse abzustimmen, verarbeitet Miele die folgende Personendaten und führen dabei ein sogenanntes Profiling durch (d.h. eine automatisierte Bearbeitung von Personendaten, um persönliche Aspekte zu analysieren oder Prognosen zu treffen): Kontaktdaten, Gerätedaten, Daten aus Kundenbefragungen/Surveys, Kaufhistorie und Newsletter-Klicks, beanspruchte Dienstleistungen, Technikereinsätze und Event-Teilnahmen, Nutzungsverhalten Miele App und Webseiten. ",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführten Technikereinsätze sowie über von mir besuchte Events zum Zweck der erweiterten Personalisierung verarbeitet.",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur erweiterten Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meinen Besuchen der Miele Webseiten (www.miele.ch)  verarbeitet, um mein Benutzerprofil zu ergänzen, sofern ich der Verarbeitung dieser Daten separat zugestimmt habe. Weitere Einzelheiten finden Sie in der Miele Datenschutzerklärung.",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    highlightedText: {
      text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen darüber, wie Miele mit Ihren Daten umgeht, finden Sie in der ",
      link: {
        title: "Miele Datenschutzerklärung.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu.",
      link: {
        title: "Nutzungsbedingungen anzeigen*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: $l,
  mieleClub: Bl,
  readMore: Rl,
  readLess: Vl
}, ql = {
  waitMessage: "Fast geschafft..."
}, Gl = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schließen",
  confirmEmailMessage: "E-Mail-Adresse bestätigen",
  copy: "Ändern Sie Ihre E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuchen Sie es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt.",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "E-Mail-Adresse bestätigen",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Ihre E-Mail-Adresse wurde erfolgreich geändert.",
  successMessageHeadline: "E-Mail-Adresse aktualisiert"
}, Kl = {
  closeButtonLabel: "Schließen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein.",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um Ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert.",
  title: "Passwort ändern"
}, Hl = {
  invalidEmail: "Ungültige E-Mail-Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail-Adresse existiert bereits. Bitte verwenden Sie eine andere E-Mail-Adresse!",
  sap_400028: "Die E-Mail-Adresse muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: "Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte setzen Sie Ihr Passwort erneut zurück, um einen neuen Link zu erhalten.",
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens 8 Zeichen lang sein und 3 der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, Wl = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, Jl = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail-Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail-Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert.",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich in Ihrem Benutzerkonto an, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail-Adresse",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail-Adresse und Passwort eingeben:"
  }
}, Zl = {
  accessibility: {
    close: "Schließen"
  }
}, Yl = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, Xl = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, Ql = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Exklusive myMiele Club Vorteile",
      "Geräteregistrierung, Sendungsverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schließen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein.",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert."
}, ec = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
  submit: "Speichern",
  levelOne: {
    shortText: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Vertriebsgesellschaft Deutschland KG sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps (soweit genutzt) erhalten",
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Vertriebsgesellschaft Deutschland KG sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele Sortiment und zu Miele Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletter-Klick- und -Öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.de, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutzhinweise",
      ref: "https://www.miele.de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele Webseiten (www.miele.de), einschließlich an Newsletter-Klicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.de/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu.",
    link: {
      title: "Nutzungsbedingungen ansehen*",
      ref: "https://www.miele.de/c/nutzungsbedingungen-304.htm"
    }
  }
}, tc = {
  headline: "Miele Club",
  birthDateTitle: "Können wir Ihnen ein Geburtstagsgeschenk schicken?",
  birthDateLabel: "Geburtstag (optional)",
  why: {
    title: "Mitgliedschaft",
    reasons: [
      "Mitgliedskonto mit Informationen zu Ihren Geräten",
      "Transaktionen und persönlichen Daten"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Geben Sie dieses Datumsformat ein: MM/DD/YYYY",
    errorMsg: "Ungültiges Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.de/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutz",
      ref: "https://www.miele.de/c/agb-13.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.de, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.de/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.de/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.de"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, ic = "vollständige Erklärung anzeigen", ac = "vollständige Erklärung ausblenden", nc = {
  auth: ql,
  changeEmailScene: Gl,
  changePasswordScene: Kl,
  errors: Hl,
  forgotPassword: Wl,
  login: Jl,
  modal: Zl,
  passwordStrength: Yl,
  passwordHelper: Xl,
  register: Ql,
  "marketing-consent": {
    title: "Marketingeinwilligung",
    description: "",
    submit: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Vertriebsgesellschaft Deutschland KG ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungen, -rezensionen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele Webseiten (www.miele.de) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    highlightedText: {
      text: "Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Meinen Widerruf kann ich zu jedem späteren Zeitpunkt ohne Angaben von Gründen schriftlich (Miele Vertriebsgesellschaft Deutschland KG, Carl-Miele-Straße 29, 33332 Gütersloh ) oder per E-Mail (info{'@'}miele.de) erklären. Zudem befindet sich in jeder E-Mail an mich ein Abmeldelink, mit dem ich meinen Widerruf ebenfalls erklären kann. Weitere Informationen, wie Miele mit Ihren Daten umgeht finden Sie in den Datenschutzbestimmungen.",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu.",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "https://www.miele.de/c/nutzungsbedingungen-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: ec,
  mieleClub: tc,
  readMore: ic,
  readLess: ac
}, sc = {
  waitMessage: "Fast geschafft..."
}, oc = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätige deine E-Mail-Adresse",
  copy: "Ändere deine E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuche es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "Bestätige deine E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Deine E-Mail-Adresse wurde erfolgreich geändert",
  successMessageHeadline: "E-Mail-Address aktualisiert"
}, rc = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, lc = {
  invalidEmail: "Ungültige E-Mail Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail existiert bereits, bitte verwenden Sie eine andere E-Mail Adresse!",
  sap_400028: "Die E-Mail-Adresse steht noch aus und muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: "Paroles atiestatīšanas saite nav derīga. Lūdzu, vēlreiz nosūtiet aizmirstās paroles pieprasījumu, lai saņemtu jaunu atiestatīšanas saiti.",
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und {minCharGroups} der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, cc = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, dc = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich an in Ihrem Benutzerkonto, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail Adresse und Passwort eingeben:"
  }
}, uc = {
  accessibility: {
    close: "Schliessen"
  }
}, mc = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, pc = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, gc = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Geräteregistrierung, Sendeverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, hc = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können",
  submit: "Speichern",
  levelOne: {
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele s.à r.l. sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletterklick- und -öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an privacy{'@'}miele.lu, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutzhinweisen",
      ref: "https://www.miele.lu/de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.lu), einschließlich an Newsletterklicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele-Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.lu/de/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele-Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ich stimme den",
    link: {
      title: "Nutzungsbestimmungen  zu.",
      ref: "https://www.miele.lu/de/c/agb-13.htm"
    }
  }
}, vc = {
  headline: "Miele Club",
  birthDateTitle: "Dürfen wir Ihnen ein Geburtstagsgeschenk senden?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt auf Zubehör und Reinigungsprodukte",
      "Geburtstagsüberraschung",
      "Exklusive Angebote",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat : DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.lu/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutz",
      ref: "https://www.miele.lu/c/agb-13.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.lu, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.lu/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.lu/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.lu"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, fc = "vollständige Erklärung anzeigen", kc = "vollständige Erklärung ausblenden", bc = {
  auth: sc,
  changeEmailScene: oc,
  changePasswordScene: rc,
  errors: lc,
  forgotPassword: cc,
  login: dc,
  modal: uc,
  passwordStrength: mc,
  passwordHelper: pc,
  register: gc,
  "marketing-consent": {
    title: "Marketing-Präferenzen",
    submit: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können",
    description: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Gesellschaft m.b.H. ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.lu) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen zum Umgang mit Ihren Daten bei Miele finden Sie in der Miele ",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: hc,
  mieleClub: vc,
  readMore: fc,
  readLess: kc
}, wc = {
  waitMessage: "Nearly there. Hang tight ..."
}, yc = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Mc = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, zc = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "The email address you entered is not registered.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occurred",
  unknownDescription: "Unexpected error occurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, jc = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, _c = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Ec = {
  accessibility: {
    close: "Close"
  }
}, Sc = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, Lc = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, Cc = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, Pc = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'Yes, I would like to receive promotional communications from Miele Co Ltd. and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post and via the Miele apps (if used)',
    text: `Yes, I would like to receive promotional communications from Miele Co Ltd. and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post and via the Miele apps (if used) with information on products, offers and innovations from the Miele product range and on Miele events as well as customer surveys, product rating and review requests and recipes. For this purpose, Miele may use my contact information (title, name, email address, mobile phone number and postal address) and design the communication based on my purchase, service, event history, newsletter click and open behavior as well as customer value, as described in detail in our privacy policy. I can revoke my consent at any time without giving reasons with effect for the future (e.g. by sending an informal message to info{'@'}miele.co.uk, the contact details given in the imprint or by clicking on the unsubscribe link in emails).`,
    link: {
      title: "See data protection policy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  levelTwo: {
    text: "In addition to my basic consent, I agree that Miele may also process data from the use of the Miele app and my visits to Miele websites (www.miele.co.uk), including user behavior on the Miele websites after linked newsletter clicks, to supplement my user profile for personalized advertising communications, provided that my separate consent in the app or on the website releases the data processing. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "See data protection policy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  levelThree: {
    text: "In addition to my basic consent, I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "#"
    }
  }
}, Tc = {
  headline: "Miele Club",
  birthDateTitle: "Would you like to receive a birthday surprise?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Free membership - Exclusive offers for members.",
    reasons: [
      "£ 10 Welcome voucher",
      "Birthday surprise",
      "Special sale offers",
      "Invites to exclusive events & experiences"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Please enter this date format: DD/MM/YYYY",
    errorMsg: "Incorrect date"
  },
  joinClubLabel: "Yes, I would like to join the Miele Club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post",
    description: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post including special offers, information, event invitations and customer surveys on our products and services. To do this, Miele may use my contact details (title, name, e-mail and postal address) and personalise the communications based on my purchasing behaviour, how I interact with the newsletter and my status as a customer, as described in more detail in our {privacyLink}. I may withdraw my consent with effect for the future at any time (for example, by sending an e-mail to info{'@'}miele.co.uk, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). Contractual Club {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Club privacy notice",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "communications",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, Ac = "show full statement", xc = "hide full statement", Ic = {
  auth: wc,
  changeEmailScene: yc,
  changePasswordScene: Mc,
  errors: zc,
  forgotPassword: jc,
  login: _c,
  modal: Ec,
  passwordStrength: Sc,
  passwordHelper: Lc,
  register: Cc,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Pc,
  mieleClub: Tc,
  readMore: Ac,
  readLess: xc
}, Dc = {
  waitMessage: "Nearly there. Hang tight ..."
}, Nc = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Oc = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, Uc = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "No account found with this email address. Please check the email address or create a new account.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, $c = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, Bc = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Rc = {
  accessibility: {
    close: "Close"
  }
}, Vc = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, Fc = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, qc = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, Gc = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'By checking this box, I acknowledge and agree that (i) I am a U.S. resident, (ii) at least 18 years of age and that (iii) Miele, Incorporated or any of its affiliates ("Miele") may collect and process personal information about and from me',
    text: 'By checking this box, I acknowledge and agree that (i) I am a U.S. resident, (ii) at least 18 years of age and that (iii) Miele, Incorporated or any of its affiliates ("Miele") may collect and process personal information about and from me (e.g. name, email address, phone number, postal code, purchase history, receipt and read confirmations via Miele newsletters) and track my use of the Miele apps and Miele websites for the purposes listed in the Miele privacy policy, which includes a notice at collection for California residents (together, the “Privacy Policy”), and I have read and accept the terms of the Privacy Policy. I further acknowledge and agree that among other purposes listed in the privacy policy, Miele may send me information about the Miele product assortment and events as well as customer surveys, product ratings and reviews, and recipes as newsletters or otherwise via email. I understand that I may revoke my consent at any time with or without reason through the methods mentioned in the privacy policy.',
    link: {
      title: "See data protection policy",
      ref: "https://www.mieleusa.com/c/privacy-policy-14.htm"
    }
  },
  levelTwo: {
    text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  levelThree: {
    text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  highlightedText: {
    text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
    link: {
      title: "data protection policy.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "#"
    }
  }
}, Kc = {
  headline: "Miele Club",
  birthDateTitle: "Can we send you a birthday gift?",
  birthDateLabel: "Birthday (optional)",
  why: {
    title: "Membership",
    reasons: [
      "Birthday surprise",
      "Exclusive offers and campaigns",
      "Welcome gift",
      "VIP offers and experiences",
      "Attractive savings",
      "Club news"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Use format like MM/DD/YYYY",
    errorMsg: "Invalid date"
  },
  joinClubLabel: "Yes, I want to join the Miele club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.mieleusa.com/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.mieleusa.com/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}mieleusa.com, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.mieleusa.com/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.mieleusa.com/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}mieleusa.com"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, Hc = "show full statement", Wc = "hide full statement", Jc = {
  auth: Dc,
  changeEmailScene: Nc,
  changePasswordScene: Oc,
  errors: Uc,
  forgotPassword: $c,
  login: Bc,
  modal: Rc,
  passwordStrength: Vc,
  passwordHelper: Fc,
  register: qc,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "https://www.mieleusa.com/c/privacy-policy-14.htm"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Gc,
  mieleClub: Kc,
  readMore: Hc,
  readLess: Wc
}, Zc = {
  waitMessage: "Casi listo. Espere un momento..."
}, Yc = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Cerrar",
  confirmEmailMessage: "Confirme su dirección de correo electrónico",
  copy: "Para actualizar su dirección de correo electrónico, por favor agregue la nueva dirección debajo:",
  errorMessageCopy: "Algo salió mal. Inténtelo de nuevo.",
  errorMessageHeadline: "Error",
  headline: "Detalles del perfil",
  inputEmailConfirmPlaceholder: "Confirme su dirección de correo electrónico",
  inputEmailPlaceholder: "Dirección de correo electrónico",
  invalidEmailMessage: "¡El correo electrónico no es válido!",
  rememberMeLabel: "Recuérdame",
  successMessageCopy: "Su dirección de correo electrónico se ha actualizado correctamente.",
  successMessageHeadline: "Dirección de correo electrónico actualizada"
}, Xc = {
  closeButtonLabel: "Cerrar",
  confirmPasswordLabel: "Confirmar contraseña",
  currentPasswordLabel: "Contraseña actual",
  newPasswordLabel: "Nueva contraseña",
  passwordMismatchError: "La contraseña no coincide",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  samePasswordError: "Esta contraseña fue utilizada anteriormente, por favor envíe una nueva contraseña",
  subtitle: "Para cambiar su contraseña, por favor complete los campos a continuación:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente",
  title: "Cambio de contraseña"
}, Qc = {
  invalidEmail: "Correo electrónico incorrecto",
  invalidPassword: "Contraseña incorrecta",
  sap_206002: "Su cuenta está pendiente de verificación, lamentablemente no podemos permitir que proceda en este momento. Por favor contáctenos para más detalles.",
  sap_206006: "Parece que la dirección de correo electrónico que proporcionó está pendiente de verificación",
  sap_400003: "¡Esta dirección de correo electrónico ya existe, por favor use una dirección de correo electrónico diferente!",
  sap_400028: "La dirección de correo electrónico enviada está pendiente de verificación",
  sap_400050: "Lo siento, no podemos validar sus credenciales en este momento.",
  sap_400097: "Parece que está accediendo a nuestros servicios desde un navegador inseguro/no compatible. Por favor, intente de nuevo con otro navegador.",
  sap_401030: "Esta contraseña fue utilizada previamente, por favor envíe una nueva contraseña",
  sap_403005: "No tenemos una cuenta asociada a esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403011: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403012: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403013: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403035: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403041: "No tenemos una cuenta asociada con esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403042: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403043: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403047: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403100: "Recientemente se solicitó una actualización de la contraseña, por favor espere a que la solicitud sea procesada",
  sap_403025: "El enlace de restablecimiento de contraseña no es válido, envíe nuevamente la solicitud de contraseña olvidada para recibir un nuevo enlace de restablecimiento.",
  sapErrorTitle: "Error procesando la solicitud",
  sessionExpired: "La sesión ha expirado",
  tooWeakPassword: "La contraseña debe contener al menos {minLength} caracteres y {minCharGroups} de los siguientes: letra mayúscula, letra minúscula, número, símbolo especial | La contraseña debe contener al menos {minLength} caracteres",
  unexpectedDescription: "Si el problema persiste, comuníquese con nosotros a través del formulario de contacto con los detalles.",
  unexpectedTitle: "Ha ocurrido un error inesperado",
  unknownDescription: "Error inesperado. Por favor, inténtelo de nuevo.",
  unknownTitle: "¡Uh Oh!"
}, ed = {
  subtitle: "Establecer su nueva contraseña.",
  title: "¿Olvidó su contraseña?"
}, td = {
  headMetaDescription: "Página de inicio de sesión del cliente",
  headTitle: "Inicie sesión con su correo electrónico y contraseña:",
  subtitle: "Inicie sesión o cree una cuenta para obtener todas las características de Miele.",
  title: "Inicie sesión en su cuenta",
  error: {
    invalidEmailPasswordDescription: "La combinación de dirección de correo electrónico y contraseña no es válida.",
    invalidEmailPasswordTitle: "Credenciales inválidas",
    missingConcentTitle: "Cuenta pendiente de registro",
    noAccountDescription: "No hay ninguna cuenta asociada a esta dirección de correo electrónico.",
    noAccountTitle: "Ninguna cuenta registrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "He tomado nota de la {0}.",
    privacyStatementName: "declaración de privacidad",
    privacyStatementTitle: "Nuestra política de privacidad ha cambiado",
    termsOfUseCheckboxLabel: "Acepto los {0}.",
    termsOfUseName: "términos de uso",
    termsOfUseTitle: "Nuestros Términos de Uso han cambiado",
    title: "Completar perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volver al inicio de sesión",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, revise su correo electrónico, pronto recibirá la información de su cuenta para comenzar con el proceso de restablecimiento de contraseña.",
    successTitle: "Hemos recibido su solicitud.",
    title: "Por favor ingrese su dirección de correo electrónico para restablecer su contraseña:"
  },
  loginModalScene: {
    copy: "Inicie sesión o cree una cuenta para obtener todas las funciones de Miele.",
    title: "Iniciar sesión en su cuenta"
  },
  loginScene: {
    emailInputLabel: "Correo electrónico",
    forgotPwdButtonLabel: "Olvidé mi contraseña",
    invalidEmailMessage: "¡El correo electrónico no es válido!",
    loginButtonLabel: "Ingresar",
    passwordInputLabel: "Contraseña",
    rememberMeLabel: "Recordarme",
    title: "Inicie sesión con su correo electrónico y contraseña:"
  }
}, id = {
  accessibility: {
    close: "Cerrar"
  }
}, ad = {
  tooShort: "Demasiado corta",
  medium: "Media",
  strong: "Fuerte",
  tooWeak: "Muy débil",
  veryStrong: "Muy fuerte",
  weak: "Débil"
}, nd = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Ocultar"
}, sd = {
  registerButtonLabel: "Registrar",
  registerTitle: "¿No tiene una cuenta?",
  whyRegister: {
    list: {
      0: "Acceso a beneficios exclusivos del Club Miele",
      1: "Registrar electrodomésticos, hacer seguimiento de pedidos, acceder a manuales",
      2: "Recibir ofertas y promociones personalizadas",
      3: "Ver todos sus pedidos, garantías, eventos y servicios"
    },
    title: "¿Por qué registrarse?"
  },
  closeButtonLabel: "Cerrar",
  passwordMismatchError: "Las contraseñas no coinciden",
  passwordUpdateErrorTitle: "Error al actualizar la contraseña",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente"
}, od = {
  title: "Preferencias de marketing",
  description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
  submit: "Guardar",
  levelOne: {
    shortText: 'Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo)',
    text: `Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo) con información sobre productos, ofertas e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, solicitudes de valoración y reseñas de productos y recetas. Para este fin, Miele puede utilizar mi información de contacto (título, nombre, dirección de correo electrónico, número de teléfono móvil y dirección postal) y diseñar la comunicación basándose en mi compra, servicio, historial de eventos, comportamiento de clics y apertura de boletines, así como en el valor del cliente, tal y como se describe detalladamente en nuestra política de privacidad. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro (por ejemplo, enviando un mensaje informal a info{'@'}miele.es, a los datos de contacto que figuran en el pie de página o haciendo clic en el enlace para darse de baja en los correos electrónicos).`,
    link: {
      title: "Protección de datos",
      ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    }
  },
  levelTwo: {
    text: "Además de mi consentimiento básico, acepto que Miele también pueda procesar datos procedentes del uso de la app de Miele y de mis visitas a los sitios web de Miele (www.miele.es), incluido el comportamiento del usuario en los sitios web de Miele después de hacer clic en el boletín vinculado, para complementar mi perfil de usuario para comunicaciones publicitarias personalizadas, siempre que mi consentimiento por separado en la app o en el sitio web libere el procesamiento de datos. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Además de mi consentimiento básico, acepto que Miele también procese datos de mis aparatos Miele conectados (datos sobre el uso y el estado de los aparatos) para complementar mi perfil de usuario para publicidad personalizada. Puedo encontrar más información sobre el tratamiento de los datos de los aparatos en la política de privacidad sobre el sistema Miele{'@'}Home. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sí, estoy de acuerdo con los términos de uso.",
    link: {
      title: "Ver términos de uso",
      ref: "https://www.miele.es/c/condiciones-de-uso-304.htm"
    }
  }
}, rd = {
  headline: "Miele Club",
  why: {
    title: "Formar parte del Miele Club es gratuito - Ventajas exclusivas para socios.",
    reasons: [
      "Regalo de bienvenida: 10% de descuento en Accesorios y Consumibles para tu próxima compra con el cupón de Bienvenida. Consulta las condiciones en www.miele.es/e/miele-club",
      "Regalo de cumpleaños",
      "Promociones especiales",
      "Invitaciones a eventos y experiencias exclusivas"
    ]
  },
  birthDateTitle: "¿Te gustaría recibir una sorpresa de cumpleaños?",
  birthDateLabel: "Fecha de nacimiento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduce la fecha con este formato: DD/MM/AAAA",
    errorMsg: "Fecha incorrecta"
  },
  joinClubLabel: "Sí, me gustaría unirme al Club Miele",
  termsAndCondition: {
    description: "Acepto las {termsAndConditionLink} y confirmo que he leído y comprendido la {privacyLink}",
    termsAndConditionLink: {
      title: "Condiciones de participación y uso del Club Miele",
      ref: "https://www.miele.es/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    privacyLink: {
      title: "Privacidad del Miele Club",
      ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal",
    description: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal con promociones especiales, información de producto, invitaciones a eventos y encuestas sobre los productos y servicios de Miele. Con este fin, Miele puede usar mis datos de contacto (tratamiento, nombre, correo electrónico y dirección postal) y diseñar comunicaciones basadas en mi comportamiento de compra y en mis pedidos, tal y como se describe con más detalle en nuestro Aviso {privacyLink}. Puedo revocar mi consentimiento en cualquier momento con efecto futuro (p. ej. con un mensaje a info{'@'}miele.es , a los datos postales incluidos en el Aviso legal o haciendo clic en el enlace de darse de baja de los correos electrónicos). La comunicación contractual del Miele Club {termsAndConditionLink} no se verá afectada por ello hasta que se cancele la membresía.",
    privacyLink: {
      title: "Privacidad del Miele Club",
      href: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicación contractual del Miele Club ",
      href: "https://www.miele.es/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    supportEmail: "info{'@'}miele.es"
  },
  selectAllConsents: {
    description: "Para unirse al Miele Club, debe aceptar todos los términos y condiciones *"
  }
}, ld = "mostrar declaración completa", cd = "ocultar declaración completa", dd = {
  auth: Zc,
  changeEmailScene: Yc,
  changePasswordScene: Xc,
  errors: Qc,
  forgotPassword: ed,
  login: td,
  modal: id,
  passwordStrength: ad,
  passwordHelper: nd,
  register: sd,
  "marketing-consent": {
    title: "Preferencias de marketing",
    description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
    submit: "Guardar",
    newsletter: {
      text: 'Acepto que MIELE S.A.U ("Miele") me envíe información sobre productos e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, reseñas de productos y recetas por correo electrónico, las aplicaciones de Miele y SMS, y que Miele procese los datos de contacto que he proporcionado (título, nombre, dirección de correo electrónico, número de teléfono móvil y código postal) y los productos de Miele que he comprado hasta la fecha y que compraré en el futuro , así como los intereses que he indicado para este fin. Asimismo, acepto que Miele procese las confirmaciones de recepción y lectura recibidas a través del boletín informativo y la información sobre los enlaces en los que he hecho clic, así como mi comportamiento de usuario relacionado en el sitio web vinculado con fines de personalización. Lo mismo se aplica a los mensajes push in-app, en la medida en que se utilicen las aplicaciones de Miele. ',
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    personalisation: {
      text: "Estoy de acuerdo en que Miele pueda procesar información sobre los servicios que he utilizado y las asignaciones de técnicos que he llevado a cabo, así como los eventos a los que he asistido, con el fin de mejorar la personalización. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Además de la personalización extendida, estoy de acuerdo en que Miele también pueda procesar los datos del uso de la aplicación de Miele y mis visitas a los sitios web de Miele (www.miele.co.uk) para completar mi perfil de usuario, siempre y cuando haya dado mi consentimiento por separado para el procesamiento de estos datos. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    highlightedText: {
      text: "Puedo revocar mi consentimiento en cualquier momento sin dar razones con efectos para el futuro. Para obtener más información sobre cómo Miele maneja sus datos, consulte la ",
      link: {
        title: "política de protección de datos de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sí, estoy de acuerdo con los términos de uso.",
      link: {
        title: "Ver términos de uso",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: od,
  mieleClub: rd,
  readMore: ld,
  readLess: cd
}, ud = {
  waitMessage: "Casi listo. Espere un momento..."
}, md = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Cerrar",
  confirmEmailMessage: "Confirme su dirección de correo electrónico",
  copy: "Para actualizar su dirección de correo electrónico, por favor agregue la nueva dirección debajo:",
  errorMessageCopy: "Algo salió mal. Inténtelo de nuevo.",
  errorMessageHeadline: "Error",
  headline: "Detalles del perfil",
  inputEmailConfirmPlaceholder: "Confirme su dirección de correo electrónico",
  inputEmailPlaceholder: "Dirección de correo electrónico",
  invalidEmailMessage: "¡El correo electrónico no es válido!",
  rememberMeLabel: "Recuérdame",
  successMessageCopy: "Su dirección de correo electrónico se ha actualizado correctamente.",
  successMessageHeadline: "Dirección de correo electrónico actualizada"
}, pd = {
  closeButtonLabel: "Cerrar",
  confirmPasswordLabel: "Confirmar contraseña",
  currentPasswordLabel: "Contraseña actual",
  newPasswordLabel: "Nueva contraseña",
  passwordMismatchError: "La contraseña no coincide",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  samePasswordError: "Esta contraseña fue utilizada anteriormente, por favor envíe una nueva contraseña",
  subtitle: "Para cambiar su contraseña, por favor complete los campos a continuación:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente",
  title: "Cambio de contraseña"
}, gd = {
  invalidEmail: "Correo electrónico incorrecto",
  invalidPassword: "Contraseña incorrecta",
  sap_206002: "Su cuenta está pendiente de verificación, lamentablemente no podemos permitir que proceda en este momento. Por favor contáctenos para más detalles.",
  sap_206006: "Parece que la dirección de correo electrónico que proporcionó está pendiente de verificación",
  sap_400003: "¡Esta dirección de correo electrónico ya existe, por favor use una dirección de correo electrónico diferente!",
  sap_400028: "La dirección de correo electrónico enviada está pendiente de verificación",
  sap_400050: "Lo siento, no podemos validar sus credenciales en este momento.",
  sap_400097: "Parece que está accediendo a nuestros servicios desde un navegador inseguro/no compatible. Por favor, intente de nuevo con otro navegador.",
  sap_401030: "Esta contraseña fue utilizada previamente, por favor envíe una nueva contraseña",
  sap_403005: "No tenemos una cuenta asociada a esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403011: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403012: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403013: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403035: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403041: "No tenemos una cuenta asociada con esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403042: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403043: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403047: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403100: "Recientemente se solicitó una actualización de la contraseña, por favor espere a que la solicitud sea procesada",
  sap_403025: "El enlace de restablecimiento de contraseña no es válido, envíe nuevamente la solicitud de contraseña olvidada para recibir un nuevo enlace de restablecimiento.",
  sapErrorTitle: "Error procesando la solicitud",
  sessionExpired: "La sesión ha expirado",
  tooWeakPassword: "La contraseña debe contener al menos {minLength} caracteres y {minCharGroups} de los siguientes: letra mayúscula, letra minúscula, número, símbolo especial | La contraseña debe contener al menos {minLength} caracteres",
  unexpectedDescription: "Si el problema persiste, comuníquese con nosotros a través del formulario de contacto con los detalles.",
  unexpectedTitle: "Ha ocurrido un error inesperado",
  unknownDescription: "Error inesperado. Por favor, inténtelo de nuevo.",
  unknownTitle: "¡Uh Oh!"
}, hd = {
  subtitle: "Establecer su nueva contraseña.",
  title: "¿Olvidó su contraseña?"
}, vd = {
  headMetaDescription: "Página de inicio de sesión del cliente",
  headTitle: "Inicie sesión con su correo electrónico y contraseña:",
  subtitle: "Inicie sesión o cree una cuenta para obtener todas las características de Miele.",
  title: "Inicie sesión en su cuenta",
  error: {
    invalidEmailPasswordDescription: "La combinación de dirección de correo electrónico y contraseña no es válida.",
    invalidEmailPasswordTitle: "Credenciales inválidas",
    missingConcentTitle: "Cuenta pendiente de registro",
    noAccountDescription: "No hay ninguna cuenta asociada a esta dirección de correo electrónico.",
    noAccountTitle: "Ninguna cuenta registrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "He tomado nota de la {0}.",
    privacyStatementName: "declaración de privacidad",
    privacyStatementTitle: "Nuestra política de privacidad ha cambiado",
    termsOfUseCheckboxLabel: "Acepto los {0}.",
    termsOfUseName: "términos de uso",
    termsOfUseTitle: "Nuestros Términos de Uso han cambiado",
    title: "Completar perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volver al inicio de sesión",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, revise su correo electrónico, pronto recibirá la información de su cuenta para comenzar con el proceso de restablecimiento de contraseña.",
    successTitle: "Hemos recibido su solicitud.",
    title: "Por favor ingrese su dirección de correo electrónico para restablecer su contraseña:"
  },
  loginModalScene: {
    copy: "Inicie sesión o cree una cuenta para obtener todas las funciones de Miele.",
    title: "Iniciar sesión en su cuenta"
  },
  loginScene: {
    emailInputLabel: "Correo electrónico",
    forgotPwdButtonLabel: "Olvidé mi contraseña",
    invalidEmailMessage: "¡El correo electrónico no es válido!",
    loginButtonLabel: "Ingresar",
    passwordInputLabel: "Contraseña",
    rememberMeLabel: "Recordarme",
    title: "Inicie sesión con su correo electrónico y contraseña:"
  }
}, fd = {
  accessibility: {
    close: "Cerrar"
  }
}, kd = {
  tooShort: "Demasiado corta",
  medium: "Media",
  strong: "Fuerte",
  tooWeak: "Muy débil",
  veryStrong: "Muy fuerte",
  weak: "Débil"
}, bd = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Ocultar"
}, wd = {
  registerButtonLabel: "Registrar",
  registerTitle: "¿No tiene una cuenta?",
  whyRegister: {
    list: {
      0: "Acceso a beneficios exclusivos del Club Miele",
      1: "Registrar electrodomésticos, hacer seguimiento de pedidos, acceder a manuales",
      2: "Recibir ofertas y promociones personalizadas",
      3: "Ver todos sus pedidos, garantías, eventos y servicios"
    },
    title: "¿Por qué registrarse?"
  },
  closeButtonLabel: "Cerrar",
  passwordMismatchError: "Las contraseñas no coinciden",
  passwordUpdateErrorTitle: "Error al actualizar la contraseña",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente"
}, yd = {
  title: "Preferencias de marketing",
  description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
  submit: "Guardar",
  levelOne: {
    shortText: 'Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo)',
    text: `Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo) con información sobre productos, ofertas e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, solicitudes de valoración y reseñas de productos y recetas. Para este fin, Miele puede utilizar mi información de contacto (título, nombre, dirección de correo electrónico, número de teléfono móvil y dirección postal) y diseñar la comunicación basándose en mi compra, servicio, historial de eventos, comportamiento de clics y apertura de boletines, así como en el valor del cliente, tal y como se describe detalladamente en nuestra política de privacidad. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro (por ejemplo, enviando un mensaje informal a info{'@'}miele.com.mx, a los datos de contacto que figuran en el pie de página o haciendo clic en el enlace para darse de baja en los correos electrónicos).`,
    link: {
      title: "Protección de datos",
      ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    }
  },
  levelTwo: {
    text: "Además de mi consentimiento básico, acepto que Miele también pueda procesar datos procedentes del uso de la app de Miele y de mis visitas a los sitios web de Miele (www.miele.com.mx), incluido el comportamiento del usuario en los sitios web de Miele después de hacer clic en el boletín vinculado, para complementar mi perfil de usuario para comunicaciones publicitarias personalizadas, siempre que mi consentimiento por separado en la app o en el sitio web libere el procesamiento de datos. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Además de mi consentimiento básico, acepto que Miele también procese datos de mis aparatos Miele conectados (datos sobre el uso y el estado de los aparatos) para complementar mi perfil de usuario para publicidad personalizada. Puedo encontrar más información sobre el tratamiento de los datos de los aparatos en la política de privacidad sobre el sistema Miele{'@'}Home. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sí, estoy de acuerdo con los términos de uso.",
    link: {
      title: "Ver términos de uso",
      ref: "https://www.miele.com.mx/c/condiciones-de-uso-304.htm"
    }
  }
}, Md = {
  headline: "Miele Club",
  why: {
    title: "Formar parte del Miele Club es gratuito - Ventajas exclusivas para socios.",
    reasons: [
      "Regalo de bienvenida: 10% de descuento en Accesorios y Consumibles para tu próxima compra con el cupón de Bienvenida. Consulta las condiciones en www.miele.com.mx/e/miele-club",
      "Regalo de cumpleaños",
      "Promociones especiales",
      "Invitaciones a eventos y experiencias exclusivas"
    ]
  },
  birthDateTitle: "¿Te gustaría recibir una sorpresa de cumpleaños?",
  birthDateLabel: "Fecha de nacimiento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduce la fecha con este formato: DD/MM/AAAA",
    errorMsg: "Fecha incorrecta"
  },
  joinClubLabel: "Sí, me gustaría unirme al Club Miele",
  termsAndCondition: {
    description: "Acepto las {termsAndConditionLink} y confirmo que he leído y comprendido la {privacyLink}",
    termsAndConditionLink: {
      title: "Condiciones de participación y uso del Club Miele",
      ref: "https://www.miele.com.mx/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    privacyLink: {
      title: "Privacidad del Miele Club",
      ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal",
    description: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal con promociones especiales, información de producto, invitaciones a eventos y encuestas sobre los productos y servicios de Miele. Con este fin, Miele puede usar mis datos de contacto (tratamiento, nombre, correo electrónico y dirección postal) y diseñar comunicaciones basadas en mi comportamiento de compra y en mis pedidos, tal y como se describe con más detalle en nuestro Aviso {privacyLink}. Puedo revocar mi consentimiento en cualquier momento con efecto futuro (p. ej. con un mensaje a info{'@'}miele.com.mx , a los datos postales incluidos en el Aviso legal o haciendo clic en el enlace de darse de baja de los correos electrónicos). La comunicación contractual del Miele Club {termsAndConditionLink} no se verá afectada por ello hasta que se cancele la membresía.",
    privacyLink: {
      title: "Privacidad del Miele Club",
      href: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicación contractual del Miele Club ",
      href: "https://www.miele.com.mx/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    supportEmail: "info{'@'}miele.com.mx"
  },
  selectAllConsents: {
    description: "Para unirse al Miele Club, debe aceptar todos los términos y condiciones *"
  }
}, zd = "mostrar declaración completa", jd = "ocultar declaración completa", _d = {
  auth: ud,
  changeEmailScene: md,
  changePasswordScene: pd,
  errors: gd,
  forgotPassword: hd,
  login: vd,
  modal: fd,
  passwordStrength: kd,
  passwordHelper: bd,
  register: wd,
  "marketing-consent": {
    title: "Preferencias de marketing",
    description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
    submit: "Guardar",
    newsletter: {
      text: 'Acepto que MIELE S.A.U ("Miele") me envíe información sobre productos e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, reseñas de productos y recetas por correo electrónico, las aplicaciones de Miele y SMS, y que Miele procese los datos de contacto que he proporcionado (título, nombre, dirección de correo electrónico, número de teléfono móvil y código postal) y los productos de Miele que he comprado hasta la fecha y que compraré en el futuro , así como los intereses que he indicado para este fin. Asimismo, acepto que Miele procese las confirmaciones de recepción y lectura recibidas a través del boletín informativo y la información sobre los enlaces en los que he hecho clic, así como mi comportamiento de usuario relacionado en el sitio web vinculado con fines de personalización. Lo mismo se aplica a los mensajes push in-app, en la medida en que se utilicen las aplicaciones de Miele. ',
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    personalisation: {
      text: "Estoy de acuerdo en que Miele pueda procesar información sobre los servicios que he utilizado y las asignaciones de técnicos que he llevado a cabo, así como los eventos a los que he asistido, con el fin de mejorar la personalización. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Además de la personalización extendida, estoy de acuerdo en que Miele también pueda procesar los datos del uso de la aplicación de Miele y mis visitas a los sitios web de Miele (www.miele.co.uk) para completar mi perfil de usuario, siempre y cuando haya dado mi consentimiento por separado para el procesamiento de estos datos. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    highlightedText: {
      text: "Puedo revocar mi consentimiento en cualquier momento sin dar razones con efectos para el futuro. Para obtener más información sobre cómo Miele maneja sus datos, consulte la ",
      link: {
        title: "política de protección de datos de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sí, estoy de acuerdo con los términos de uso.",
      link: {
        title: "Ver términos de uso",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: yd,
  mieleClub: Md,
  readMore: zd,
  readLess: jd
}, Ed = {
  waitMessage: "Lähes siellä. "
}, Sd = {
  buttonLabel: "Tallentaa",
  buttonLabelClose: "kiinni",
  confirmEmailMessage: "Vahvista sähköpostiosoitteesi",
  copy: "Päivitä sähköpostiosoitteesi lisäämällä uusi alle:",
  errorMessageCopy: "Jotain meni pieleen. ",
  errorMessageHeadline: "Virhe",
  headline: "Profiilin tiedot",
  inputEmailConfirmPlaceholder: "Vahvista sähköpostiosoitteesi",
  inputEmailPlaceholder: "Sähköpostiosoite",
  invalidEmailMessage: "Sähköposti ei kelpaa!",
  rememberMeLabel: "Muista minut",
  successMessageCopy: "Sähköpostiosoitteesi päivitys onnistui.",
  successMessageHeadline: "Sähköpostiosoite päivitetty"
}, Ld = {
  closeButtonLabel: "kiinni",
  confirmPasswordLabel: "Vahvista salasana",
  currentPasswordLabel: "Nykyinen salasana",
  newPasswordLabel: "uusi salasana",
  passwordMismatchError: "Salasana ei täsmää",
  passwordUpdateErrorTitle: "Virhe",
  passwordUpdateSuccessTitle: "Salasana päivitetty",
  samePasswordError: "Tätä salasanaa käytettiin aiemmin, lähetä uusi salasana",
  subtitle: "Jos haluat vaihtaa salasanasi, täytä alla olevat kentät:",
  submitButtonLabel: "Lähetä",
  successfulChangeLabel: "Salasanasi on päivitetty onnistuneesti",
  title: "Salasanan vaihto"
}, Cd = {
  invalidEmail: "väärä sähköposti",
  invalidPassword: "Väärä salasana",
  sap_206002: "Tilisi odottaa vahvistusta. Emme valitettavasti voi antaa sinun jatkaa tällä hetkellä. ",
  sap_206006: "Näyttää siltä, ​​että lähettämäsi sähköpostiosoite odottaa vahvistusta",
  sap_400003: "Tämä sähköpostiosoite on jo olemassa, käytä toista sähköpostiosoitetta!",
  sap_400028: "Lähetetty sähköpostiosoite odottaa vahvistusta",
  sap_400050: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_400097: "Näyttää siltä, ​​että käytät palveluitamme suojaamattomasta/tukemattomasta selaimesta. ",
  sap_401030: "Tätä salasanaa käytettiin aiemmin, lähetä uusi salasana",
  sap_403005: "Meillä ei ole tähän sähköpostiosoitteeseen liittyvää tiliä. Tarkista sähköpostisi ja yritä uudelleen",
  sap_403011: "Istunto päättyi. ",
  sap_403012: "Istunto päättyi. ",
  sap_403013: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_403035: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_403041: "Meillä ei ole tähän sähköpostiosoitteeseen liittyvää tiliä. Tarkista sähköpostisi ja yritä uudelleen",
  sap_403042: "Sähköposti",
  sap_403043: "Sähköposti",
  sap_403047: "Sähköposti",
  sap_403100: "Salasanan päivityspyyntöä on pyydetty äskettäin, ole hyvä ja kerro meille, kunnes pyyntö on käsitelty",
  sap_403025: "Salasanan palautuslinkki on virheellinen, lähetä unohtunut salasana -pyyntö uudelleen saadaksesi uuden palautuslinkin.",
  sapErrorTitle: "Virhe pyynnön käsittelyssä",
  sessionExpired: "Istunto päättyi",
  tooWeakPassword: "Salasanan tulee sisältää vähintään {minLength} merkkiä ja {minCharGroups} seuraavista: iso kirjain, pieni kirjain, numero, erikoissymboli | Salasanan tulee sisältää vähintään {minLength} merkkiä",
  unexpectedDescription: "Jos ongelma jatkuu, ota meihin yhteyttä yhteydenottolomakkeella ja kerro tarkemmat tiedot.",
  unexpectedTitle: "Tapahtui odottamaton virhe",
  unknownDescription: "Tapahtui odottamaton virhe. ",
  unknownTitle: "Voi ei!"
}, Pd = {
  subtitle: "Aseta uusi salasanasi.",
  title: "Unohditko salasanasi?"
}, Td = {
  headMetaDescription: "Asiakkaan kirjautumissivu",
  headTitle: "Kirjaudu sisään sähköpostiosoitteellasi ja salasanallasi:",
  subtitle: "Kirjaudu sisään tai luo tili saadaksesi kaikki Mielen ominaisuudet.",
  title: "Kirjaudu tilillesi",
  error: {
    invalidEmailPasswordDescription: "Sähköpostiosoitteen ja salasanan yhdistelmä ei kelpaa.",
    invalidEmailPasswordTitle: "Virheelliset kirjautumistiedot",
    missingConcentTitle: "Tili odottaa rekisteröintiä",
    noAccountDescription: "Tähän sähköpostiosoitteeseen ei ole liitetty tiliä.",
    noAccountTitle: "Tiliä ei ole rekisteröity"
  },
  extraConsentScene: {
    continue: "Jatkaa",
    privacyStatementCheckboxLabel: "Olen pannut merkille {0}.",
    privacyStatementName: "Tietosuojalausunto",
    privacyStatementTitle: "Tietosuojakäytäntömme on muuttunut",
    termsOfUseCheckboxLabel: "Hyväksyn {0}.",
    termsOfUseName: "käyttöehdot",
    termsOfUseTitle: "Käyttöehtomme ovat muuttuneet",
    title: "Profiilin viimeistely"
  },
  forgotPasswordScene: {
    backButtonLabel: "Takaisin sisäänkirjautumiseen",
    submitButtonLabel: "Lähetä",
    successDescription: "Tarkista sähköpostisi, saat pian tilillesi tiedot, jotta voit aloittaa salasanan vaihtoprosessin.",
    successTitle: "Pyyntösi on vastaanotettu.",
    title: "Anna sähköpostiosoitteesi vaihtaaksesi salasanasi:"
  },
  loginModalScene: {
    copy: "Kirjaudu sisään tai luo tili saadaksesi kaikki Mielen ominaisuudet.",
    title: "Kirjaudu tilillesi"
  },
  loginScene: {
    emailInputLabel: "Sähköposti",
    forgotPwdButtonLabel: "Unohdin salasanani",
    invalidEmailMessage: "Sähköposti ei kelpaa!",
    loginButtonLabel: "Kirjaudu sisään",
    passwordInputLabel: "Salasana",
    rememberMeLabel: "Muista minut",
    title: "Kirjaudu sisään sähköpostiosoitteellasi ja salasanallasi:"
  }
}, Ad = {
  accessibility: {
    close: "kiinni"
  }
}, xd = {
  tooShort: "Liian lyhyt",
  medium: "Keskivahva",
  strong: "Vahva",
  tooWeak: "Liian heikko",
  veryStrong: "Erittäin vahva",
  weak: "Heikko"
}, Id = {
  showPasswordText: "Näytä",
  hidePasswordText: "Piilota"
}, Dd = {
  registerButtonLabel: "rekisteröidy",
  registerTitle: "Eikö sinulla ole tiliä?",
  whyRegister: {
    list: [
      "Pääsy Miele Clubin eksklusiivisiin etuihin",
      "Rekisteröi laitteita, seuraa tilauksia, käytä käsikirjoja",
      "Vastaanota henkilökohtaisia ​​tarjouksia ja kampanjoita",
      "Katso kaikki tilauksesi, takuusi, tapahtumasi ja palvelusi"
    ],
    title: "Miksi rekisteröityä?"
  },
  closeButtonLabel: "kiinni",
  passwordMismatchError: "salasanat eivät täsmää",
  passwordUpdateErrorTitle: "Salasanan päivitysvirhe",
  passwordUpdateSuccessTitle: "Salasana päivitetty",
  successfulChangeLabel: "Salasanasi on päivitetty onnistuneesti"
}, Nd = {
  title: "Markkinointiasetukset",
  description: "Rasti alla nähdäksesi eksklusiiviset tarjoukset, uutiset, tapahtumat ja miten saat kaiken irti laitteestasi.",
  submit: "Tallentaa",
  levelOne: {
    shortText: 'Kyllä, haluan vastaanottaa Miele Oy:ltä ja Miele & Cie. KG:lta ("Miele") sähköpostitse, tekstiviesteinä, postitse ja Miele-sovelluksen kautta (jos käytössä) henkilökohtaisten kiinnostukseni mukaan räätälöityä mainosviestintää',
    text: `Kyllä, haluan vastaanottaa Miele Oy:ltä ja Miele & Cie. KG:lta ("Miele") sähköpostitse, tekstiviesteinä, postitse ja Miele-sovelluksen kautta (jos käytössä) henkilökohtaisten kiinnostukseni mukaan räätälöityä mainosviestintää, jossa on tietoa Miele-tuotevalikoiman tuotteista, tarjouksista ja innovaatioista, Miele-tapahtumista sekä asiakaskyselyistä, tuotearviointi- ja -arvostelupyynnöoistä sekä resepteistä. Tätä tarkoitusta varten Miele voi käyttää yhteystietojani (titteli, nimi, sähköpostiosoite, matkapuhelinnumero ja postiosoite) ja suunnitella viestinnän osto-, palvelu- ja tapahtumahistoriani, uutiskirjeen klikkaus- ja avauskäyttäytymiseni sekä asiakasarvoni perusteella, kuten Mielen tietosuojaselosteessa on yksityiskohtaisesti kuvattu. Voin milloin vain syytä ilmoittamatta peruuttaa suostumukseni tulevaisuutta koskevin vaikutuksin(esim. lähettämällä epävirallisen viestin osoitteeseen asiakaspalvelu{'@'}miele.fi , klikkauksella annettuihin yhteystietoihin tai klikkaamalla sähköpostiviestien tilauksen peruutuslinkkiä).`,
    link: {
      title: "Tietosuoja",
      ref: "https://www.miele.fi/c/tietosuoja-14.htm"
    }
  },
  levelTwo: {
    text: "Antamani perussuostumuksen lisäksi hyväksyn, että Miele voi myös käsitellä Miele-sovelluksen käytöstäni ja Miele-sivustoilla (www.miele.fi) tekemistäni käynneistä saatuja tietoja, mukaan lukien käyttäjän käyttäytyminen Miele-sivustoilla linkitetyn uutiskirjeen napsautuksen jälkeen, täydentääkseen käyttäjäprofiiliani yksilöllistä mainosviestintää varten edellyttäen, että sovelluksessa tai verkkosivustolla antamani erillinen suostumus antaa suostumuksen tietojen käsittelyn. Voin milloin vain syytä ilmoittamatta peruuttaa suostumukseni tulevaisuutta koskevin vaikutuksin. Lisätietoja Mielen tietosuojaselosteessa.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Perussuostumukseni lisäksi suostun siihen, että Miele voi myös käsitellä yhdistetyistä Miele-laitteistani saatuja tietoja (tietoja laitteen käytöstä ja sen tilasta) käyttäjäprofiilini täydentämiseksi henkilökohtaista mainontaa varten. Voin saada lisätietoja laitetietojen käsittelystä Miele{'@'}Home-järjestelmän tietosuojaselosteesta. Voin milloin vain syytä ilmoittamatta peruuttaa suostumuksenitulevaisuutta koskevin vaikutuksin.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Kyllä, hyväksyn käyttöehdot.",
    link: {
      title: "Katso käyttöehdot*",
      ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    }
  }
}, Od = {
  headline: "Miele Club",
  birthDateTitle: "Voimmeko lähettää sinulle syntymäpäivälahjan?",
  birthDateLabel: "Syntymäaika (vapaaehtoinen)",
  why: {
    title: "Maksuton jäsenyys - Eksklusiivisia tarjouksia jäsenille.",
    reasons: [
      "Saat tervetuliaislahjana 10 % alennuksen",
      "Syntymäpäiväyllätys",
      "Eksklusiiviset tarjoukset",
      "Kutsut tapahtumiin ja elämyksiin "
    ]
  },
  birthDateValidation: {
    requirementMsg: "Anna päivämäärä tässä muodossa: PP/KK/VVVV",
    errorMsg: "Virheellinen päivämäärä"
  },
  joinClubLabel: "Kyllä, haluaisin liittyä Miele Clubiin.",
  termsAndCondition: {
    description: "Hyväksyn Miele Clubin {termsAndConditionLink} ja vahvistan, että olen lukenut ja ymmärtänyt Miele Clubin {privacyLink} koskevat tiedot.",
    termsAndConditionLink: {
      title: "osallistumis- ja käyttöehdot",
      ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    },
    privacyLink: {
      title: "tietosuojaa",
      ref: "https://www.miele.fi/c/tietosuoja-14.htm"
    }
  },
  newsletter: {
    description: "Kyllä, haluan saada Miele Oy:ltä (“Miele”) henkilökohtaisten kiinnostuksen kohteideni mukaisesti räätälöityä klubimainosviestintää sähköpostitse ja postitse, kuten erikoistarjouksia, tiedotteita, kutsuja tapahtumiin sekä asiakaskyselyjä Mielen tarjoamista tuotteista ja palveluista. Miele saa käyttää tähän tarkoitukseen yhteystietojani (titteli , nimi, sähköposti- ja postiosoite) ja muokata viestejä osto- ja uutiskirjekäyttäytymiseni ja jäsenluokkani perusteella Miele Clubin {privacyLink} kuvatulla tavalla. Voin milloin vain syytä ilmoittamatta perua suostumukseni tulevaisuutta koskevin vaikutuksin (esim. epämuodollisella sähköpostiviestillä osoitteeseen asiakaspalvelu{'@'}miele.fi, ottamalla yhteyttä verkkosivuiltamme löytyvien yhteystitetojen kautta tai napsauttamalla sähköpostiviestin Peru tilaus -linkkiä. Muu Miele Clubin jäsen- ja {termsAndConditionLink} perustuva klubiviestintä jatkuu tästä huolimatta Miele Clubista eroamiseen asti.",
    shortDescription: "Kyllä, haluan saada Miele Oy:ltä (“Miele”) henkilökohtaisten kiinnostuksen kohteideni mukaisesti räätälöityä klubimainosviestintää sähköpostitse ja postitse",
    privacyLink: {
      title: "tietosuojakäytännössä",
      href: "https://www.miele.fi/c/tietosuoja-14.htm"
    },
    termsAndConditionLink: {
      title: "käyttöehtoihin",
      href: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    },
    supportEmail: "info{'@'}miele.fi"
  },
  selectAllConsents: {
    description: "Liittyäksesi Miele Clubiin sinun täytyy hyväksyä kaikki ehdot *"
  }
}, Ud = "näytä koko lausunto", $d = "piilota koko lausunto", Bd = {
  auth: Ed,
  changeEmailScene: Sd,
  changePasswordScene: Ld,
  errors: Cd,
  forgotPassword: Pd,
  login: Td,
  modal: Ad,
  passwordStrength: xd,
  passwordHelper: Id,
  register: Dd,
  "marketing-consent": {
    title: "Markkinointiasetukset",
    description: "Rasti alla nähdäksesi eksklusiiviset tarjoukset, uutiset, tapahtumat ja miten saat kaiken irti laitteestasi.",
    submit: "Tallentaa",
    newsletter: {
      text: "Hyväksyn, että Miele Oy (“Miele”) lähettää minulle sähköpostitse, Miele-sovellusten ja tekstiviestien välityksellä tietoa Miele-valikoiman tuotteista ja uutuuksista, Miele-tapahtumista, asiakaskyselyistä, tuotearvioinnit ja arvostelut sekä ruokaresepteistä. Tätä tarkoitusta varten Miele käyttää antamiani yhteystietoja (nimi, sähköpostiosoite, puhelinnumero ja osoite). Tähän sisältyvät myös Miele-tuotteet, joita olen ostanut aiemmin tai aion ostaa tulevaisuudessa, sekä ilmoittamani erilaiset kiinnostuksen kohteet.",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    personalisation: {
      text: "Hyväksyn, että Miele voi käsitellä tietoja käyttämistäni palveluista ja suorittamistani teknikkotehtävistä sekä tapahtumista, joihin olen osallistunut henkilökohtaistamisen tehostamiseksi.",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Laajennetun personoinnin lisäksi hyväksyn, että Miele voi käsitellä myös Miele-sovelluksen käytöstä ja Mielen verkkosivuilla (www.miele.co.uk) käynneistäni saatuja tietoja käyttäjäprofiilini täydentämiseksi edellyttäen, että olen siihen erikseen suostunut. ",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    highlightedText: {
      text: "Voin peruuttaa suostumukseni milloin tahansa ilmoittamatta tulevaisuutta koskevia syitä.  ",
      link: {
        title: "tietosuojakäytäntö.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Kyllä, hyväksyn käyttöehdot.",
      link: {
        title: "Katso käyttöehdot.",
        ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: Nd,
  mieleClub: Od,
  readMore: Ud,
  readLess: $d
}, Rd = {
  waitMessage: "Presque là. Tenez bon ..."
}, Vd = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmer votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez saisir la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "Adresse e-mail non valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, Fd = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Erreur",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a déjà été utilisé auparavant. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous : ",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, qd = {
  invalidEmail: "Adresse e-mail incorrecte",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification. Malheureusement, nous ne pouvons pas vous autoriser à continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semblerait que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cet e-mail existe déjà, veuillez utiliser une adresse e-mail différente !",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semblerait que vous accédiez à nos services à partir d'un navigateur non sécurisé/ non-supporté. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé précédemment, veuillez saisir un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403042: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment effectuée, veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : une lettre majuscule, une lettre minuscule, un chiffre, un symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact en nous fournissant les détails.",
  unexpectedTitle: "Une erreur imprévue est survenue",
  unknownDescription: "Erreur imprévue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, Gd = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, Kd = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "En attente d'enregistrement du compte",
    noAccountDescription: "Il n'y a aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "politique de confidentialité",
    privacyStatementTitle: "Notre politique de confidentialité a été modifiée",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la page de connexion",
    submitButtonLabel: "Envoyer",
    successDescription: "Veuillez consulter votre messagerie, vous recevrez bientôt les informations concernant votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour profiter de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Connexion",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, Hd = {
  accessibility: {
    close: "Fermer"
  }
}, Wd = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, Jd = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, Zd = {
  registerButtonLabel: "S'enregistrer",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: {
      0: "Accès aux avantages exclusifs du Club Miele",
      1: "Enregistrer les appareils, suivre les commandes, accéder aux manuels",
      2: "Recevoir des offres et promotions personnalisées",
      3: "Voir toutes vos commandes, garanties, événements et services"
    },
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour de mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Préférences de marketing"
}, Yd = {
  title: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
  submit: "Enregistrer",
  description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des invitations à des évenements, des conseils pour profiter pleinement de vos appareils.",
  levelOne: {
    text: `Oui, je souhaite recevoir des communications promotionnelles de Miele SAS. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi qu'avec des enquêtes auprès des clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et concevoir la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet immédiat (par exemple, en envoyant un message informel à rgpd{'@'}miele.fr, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les newsletter).`,
    shortText: 'Oui, je souhaite recevoir des communications promotionnelles de Miele SAS. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications Miele (si utilisées)',
    link: {
      title: "Politique de protection des données",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'appli Miele et de mes visites sur les sites Internet de Miele (www.miele.fr), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement séparé dans l'appli ou sur le site Internet libère le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet immédiat.",
    link: {
      title: "Pour plus de détails, voir la politique de protection des données de Miele.",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir.",
    link: {
      title: "Pour plus de détails, voir la politique de protection des données de Miele.",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement pour le traitement de mes données personnelles à tout moment. Pour plus d'informations sur la gestion de vos données personnelles par Miele, veuillez consulter la politique de confidentialité de Miele",
    link: {
      title: "politique de confidentialité",
      ref: "https://www.miele.fr/c/politique-de-confidentialite-14.htm"
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation*",
      ref: "https://www.miele.fr/c/agb-13.htm"
    }
  }
}, Xd = {
  headline: "Miele Club",
  why: {
    title: "Adhésion gratuite - Offres exclusives pour les membres.",
    reasons: [
      "Offre de bienvenue de -15%",
      "Surprise pour votre anniversaire",
      "Offres spéciales membres",
      "Invitations à nos evenements exclusifs"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: " Protection des données",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.fr, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.fr"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, Qd = "afficher la déclaration complète", eu = "masquer la déclaration complète", tu = {
  auth: Rd,
  changeEmailScene: Vd,
  changePasswordScene: Fd,
  errors: qd,
  forgotPassword: Gd,
  login: Kd,
  modal: Hd,
  passwordStrength: Wd,
  passwordHelper: Jd,
  register: Zd,
  "marketing-consent": {
    title: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
    description: "Enregistrer",
    submit: `Je suis d'accord que Miele Co Ltd. ("Miele") peut m'envoyer des informations sur les produits et les innovations de la gamme de produits Miele, ainsi que des sondages auprès des clients, et des recettes par courrier électronique, les applications Miele et SMS et que Miele peut traiter les coordonnées que j'ai fournies (titre, nom, adresse e-mail, numéro de téléphone portable et code postal) et les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir ainsi que les intérêts que j'ai indiqués à cette fin. Je suis également d'accord que Miele peut également traiter les confirmations de réception et de lecture reçues par le biais de la newsletter et des informations sur les liens sur lesquels j'ai cliqué, ainsi que sur mon comportement d'utilisateur associé sur le site web lié à des fins de personnalisation. Il en va de même pour les messages push in-app, dans la mesure où les applications Miele sont utilisées.`,
    newsletter: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "Je suis d'accord que Miele puisse traiter des informations sur les services que j'ai utilisés, les affectations de techniciens que j'ai effectuées, ainsi que des événements auxquels j'ai participé, afin d'améliorer la personnalisation."
      }
    },
    personalisation: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "En plus de la personnalisation étendue, je suis d'accord que Miele puisse également traiter les données d'utilisation de l'application Miele et de mes visites sur les sites web de Miele (www.miele.co.uk) pour compléter mon profil utilisateur, à condition que j'ai donné mon consentement séparément pour le traitement de ces données."
      }
    },
    extendedPersonalisation: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "Je peux révoquer mon consentement à tout moment sans donner de raisons pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez vous référer à la "
      }
    },
    highlightedText: {
      text: "politique de protection des données de Miele.",
      link: {
        title: "#",
        ref: "Oui, j'accepte les conditions d'utilisation."
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: "https://www.miele.fr/c/agb-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: Yd,
  mieleClub: Xd,
  readMore: Qd,
  readLess: eu
}, iu = {
  waitMessage: "Nous y sommes presque. Veuillez attendre encore un peu..."
}, au = {
  buttonLabel: "Sauvegarder",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmez votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez ajouter la nouvelle adresse ci-dessous :",
  errorMessageCopy: "Un problème s'est produit. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du compte",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "L'adresse e-mail n'est pas valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Mise à jour de l'adresse e-mail"
}, nu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a été utilisé précédemment, veuillez soumettre un nouveau mot de passe",
  subtitle: "Pour modifier votre mot de passe, veuillez remplir les champs ci-dessous :",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, su = {
  invalidEmail: "Email incorrect",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification, je crains que nous ne puissions pas vous permettre de continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semble que l'adresse électronique que vous avez fournie soit en attente de vérification.",
  sap_400003: "Cet email existe déjà, veuillez utiliser une autre adresse email.",
  sap_400028: "L'adresse électronique soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_400097: "Il semble que vous accédiez à nos services à partir d'un navigateur non sécurisé/non pris en charge. Veuillez réessayer avec un autre navigateur. ",
  sap_401030: "Ce mot de passe a été utilisé précédemment, veuillez soumettre un nouveau mot de passe.",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403011: "La session a expiré. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre adresse e-mail et réessayer.",
  sap_403042: "La combinaison de l'adresse électronique et du mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez « Mot de passe oublié » si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison email et mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison email et mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour du mot de passe a été récemment introduite. Veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur dans le traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : lettre majuscule, lettre minuscule, chiffre, symbole spécial. | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact.",
  unexpectedTitle: "Une erreur inattendue s'est produite",
  unknownDescription: "Une erreur inattendue s'est produite. Veuillez réessayer.",
  unknownTitle: "Oh là là !"
}, ou = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, ru = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connexion à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "Compte en attente d'enregistrement",
    noAccountDescription: "Aucun compte n'est associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance des {0}.",
    privacyStatementName: "Protection des données",
    privacyStatementTitle: "Notre politique de protection des données a changé",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "Conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le compte"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la connexion",
    submitButtonLabel: "Soumettre",
    successDescription: "Veuillez vérifier votre e-mail, vous recevrez bientôt les informations sur votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
    title: "Connexion à votre compte"
  },
  loginScene: {
    emailInputLabel: "Adresse e-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Se connecter",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, lu = {
  accessibility: {
    close: "Fermer"
  }
}, cu = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Forte",
  tooWeak: "Trop faible",
  veryStrong: "Très forte",
  weak: "Faible"
}, du = {
  showPasswordText: "Montrer",
  hidePasswordText: "Cacher"
}, uu = {
  registerButtonLabel: "S'inscrire",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: [
      "Vue d'ensemble pratique de toutes vos commandes et réservations d'événements",
      "Vue d'ensemble de tous vos appareils avec accessoires et modes d’emploi",
      "Un aperçu de toutes vos réparations et garanties"
    ],
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour du mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès"
}, mu = {
  title: "Préférences marketing",
  description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des informations, des conseils sur les produits et bien plus encore.",
  submit: "Sauvegarder",
  levelOne: {
    shortText: 'Oui, je souhaite recevoir des communications promotionnelles de Miele Belgique S.A. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications Miele (si utilisées)',
    text: `Oui, je souhaite recevoir des communications promotionnelles de Miele Belgique S.A. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi que des enquêtes clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et élaborer la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir (par exemple, en envoyant un email à privacy{'@'}miele.be , aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les emails).`,
    link: {
      title: "Politique de confidentialité",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'application Miele et de mes visites sur les sites Internet de Miele (www.miele.be), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement distinct dans l'application ou sur le site Internet autorise le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la politique de protection des données de Miele. ",
    link: {
      title: "politique de protection des données de Miele.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation*",
      ref: "#"
    }
  }
}, pu = {
  headline: "Miele Club",
  why: {
    title: "Adhésion",
    reasons: [
      "Surprise d'anniversaire",
      "Offres et campagnes exclusives",
      "Cadeau de bienvenue",
      "Offres et expériences VIP",
      "Des économies attractives",
      "Actualités du club"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.be/fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: "Protection des données",
      ref: "https://www.miele.be/fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.be, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.be/fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.be/fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.be"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, gu = "afficher la déclaration complète", hu = "masquer la déclaration complète", vu = {
  auth: iu,
  changeEmailScene: au,
  changePasswordScene: nu,
  errors: su,
  forgotPassword: ou,
  login: ru,
  modal: lu,
  passwordStrength: cu,
  passwordHelper: du,
  register: uu,
  "marketing-consent": {
    title: "Préférences marketing",
    description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des informations, des événements et des conseils pour tirer le meilleur parti de votre appareil.",
    submit: "Sauvegarder",
    newsletter: {
      text: "J'accepte que Miele Belgique S.A. (Miele) m'envoie des informations sur les produits et les nouveautés de l'assortiment Miele, les événements, les enquêtes clients et des recettes par e-mail, via l'application Miele et par SMS. J'accepte également que Miele traite à cette fin les coordonnées que j'ai fournies (civilité, nom, adresse e-mail, numéro de téléphone et code postal), les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir, ainsi que les centres d'intérêts que j'ai spécifiés. De plus, j'accepte que Miele traite, à des fins de personnalisation, les accusés de réception et de lecture reçus via la newsletter, ainsi que les informations concernant les liens sur lesquels j'ai cliqué et mon comportement d'utilisateur connexe sur le site web. Il en va de même pour les notifications push in-app, dans la mesure où les applications Miele sont utilisées.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    personalisation: {
      text: "J’accepte que Miele traite, à des fins de personnalisation avancée, des informations sur les services que j’ai utilisés et les interventions de techniciens effectuées, ainsi que sur les événements auxquels j’ai participé. ",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation avancée, j’accepte que Miele traite également les données issues de l’utilisation de l’App Miele et de mes visites sur le sites Internet de Miele (www.miele.be) afin de compléter mon profil d’utilisateur, dans la mesure où j’ai donné mon consentement spécifique au traitement de ces données.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la politique de protection des données de Miele. ",
      link: {
        title: "politique de protection des données de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation.",
        ref: "https://www.miele.be/fr/c/cgv-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: mu,
  mieleClub: pu,
  readMore: gu,
  readLess: hu
}, fu = {
  waitMessage: "Presque là. Patientez…"
}, ku = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmez votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez ajouter la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "E-mail non valide !",
  rememberMeLabel: "Rester connecté",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, bu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a déjà été utilisé auparavant. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous :",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, wu = {
  invalidEmail: "E-mail incorrect",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification, nous ne pouvons malheureusement pas vous laisser continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semble que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cette adresse e-mail existe déjà, veuillez utiliser une adresse e-mail différente.",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification.",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semble que vous accédiez à nos services à partir d'un navigateur non sécurisé/non pris en charge. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé, veuillez soumettre un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_403035: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403042: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403043: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403047: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment demandée, veuillez patienter jusqu'à ce que la demande soit traitée",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : lettre majuscule, lettre minuscule, chiffre, symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact avec les détails.",
  unexpectedTitle: "Une erreur inattendue s'est produite",
  unknownDescription: "Erreur inattendue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, yu = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Mot de passe oublié ?"
}, Mu = {
  headMetaDescription: "Page de connexion client",
  headTitle: "Connectez-vous avec votre e-mail et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités de Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Identifiants invalides",
    missingConcentTitle: "Compte en attente d'inscription",
    noAccountDescription: "Aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "déclaration de confidentialité",
    privacyStatementTitle: "Notre déclaration de confidentialité a été mise à jour",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été mises à jour",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la connexion",
    submitButtonLabel: "Soumettre",
    successDescription: "Veuillez vérifier votre e-mail, vous recevrez bientôt les informations sur votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mot de passe oublié",
    invalidEmailMessage: "E-mail non valide !",
    loginButtonLabel: "Se connecter",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Rester connecté",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, zu = {
  accessibility: {
    close: "Fermer"
  }
}, ju = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, _u = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, Eu = {
  registerButtonLabel: "S'inscrire",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: [
      "Accès à des avantages exclusifs du Club Mieleb",
      "Enregistrement des appareils, suivi des commandes, accès aux manuels",
      "Recevoir des offres et des promotions personnalisées",
      "Voir toutes vos commandes, garanties, événements et services"
    ],
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour du mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès"
}, Su = {
  title: "Préférences marketing",
  description: "Vous êtes intéressé(e) par des offres exclusives, des nouveautés produits, des événements, des enquêtes clients et d’autres informations utiles sur l’univers Miele ?",
  submit: "Enregistrer",
  levelOne: {
    text: "J’accepte que Miele AG (“Miele”) m’envoie des informations et des offres sur ses produits et services ainsi que des invitations pour participer à des événements et à des enquêtes clients par e-mail (newsletter), courrier, SMS ou via les applications Miele. Afin d’adapter au mieux la communication commerciale à vos besoins, Miele traite les données personnelles suivantes et procède à un profilage (c’est-à-dire un traitement automatisé des données personnelles afin d’analyser des aspects personnels ou de faire des prévisions) : données de contact, données des appareils, données issues de sondages ou d’enquêtes clients, historique des achats et clics sur la newsletter, prestations de service demandées, interventions de techniciens et participations à des événements, comportement d’utilisation de l’application Miele et des pages Internet. Vous trouverez plus de détails dans la ",
    link: {
      title: "Déclaration de confidentialité.",
      ref: "https://www.miele.ch/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement à tout moment et sans donner de raisons, avec effet pour l’avenir. Pour plus d’informations sur la manière dont Miele traite vos données, veuillez consulter ",
    link: {
      title: "la politique de protection des données de Miele.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation.",
      ref: "https://www.miele.ch/fr/c/conditions-d-utilisation-304.htm"
    }
  }
}, Lu = {
  headline: "Club Miele",
  why: {
    title: "Avantages exclusifs pour les membres - Communication personnelle du club.",
    reasons: [
      "Cadeau de bienvenue -10%",
      "Surprise d'anniversaire",
      "Offres et événements exclusives",
      "Conseils sur l'utilisation des appareils"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "Oui, j’ai lu et j’accepte les {termsAndConditionLink} au Club Miele.",
    termsAndConditionLink: {
      title: "conditions de participation",
      ref: "https://www.miele.ch/fr/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Oui, j’ai lu et j’accepte la {privacyLink} du Club Miele. Conformément à la Déclaration de confidentialité, le traitement comprend notamment le profilage basé sur le comportement des clients et l’utilisation des profils clients à des fins de marketing et à d'autres fins.",
    privacyLink: {
      title: "Déclaration de confidentialité",
      href: "https://www.miele.ch/fr/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Pour adhérer au Miele Club, vous devez accepter l'ensemble des conditions générales."
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, Cu = "afficher la déclaration complète", Pu = "masquer la déclaration complète", Tu = {
  auth: fu,
  changeEmailScene: ku,
  changePasswordScene: bu,
  errors: wu,
  forgotPassword: yu,
  login: Mu,
  modal: zu,
  passwordStrength: ju,
  passwordHelper: _u,
  register: Eu,
  "marketing-consent": {
    title: "Préférences marketing",
    description: "Vous êtes intéressé(e) par des offres exclusives, des nouveautés produits, des événements, des enquêtes clients et d’autres informations utiles sur l’univers Miele ?",
    submit: "Enregistrer",
    newsletter: {
      text: "J’accepte que Miele AG (“Miele”) m’envoie des informations et des offres sur ses produits et services ainsi que des invitations pour participer à des événements et à des enquêtes clients par e-mail (newsletter), courrier, SMS ou via les applications Miele. Afin d’adapter au mieux la communication commerciale à vos besoins, Miele traite les données personnelles suivantes et procède à un profilage (c’est-à-dire un traitement automatisé des données personnelles afin d’analyser des aspects personnels ou de faire des prévisions) : données de contact, données des appareils, données issues de sondages ou d’enquêtes clients, historique des achats et clics sur la newsletter, prestations de service demandées, interventions de techniciens et participations à des événements, comportement d’utilisation de l’application Miele et des pages Internet.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: "#"
      }
    },
    personalisation: {
      text: "Je consens à ce que Miele traite les informations relatives aux services que j’ai utilisés, aux interventions de technicien auxquelles j’ai eu recours ainsi qu’aux événements auxquels j’ai participé, dans le but d’améliorer la personnalisation.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation étendue, je consens également à ce que Miele traite les données issues de l’utilisation de l’app Miele et de mes consultations des sites Internet de Miele (www.miele.ch) pour compléter mon profil d’utilisateur, dans la mesure où j’ai consenti séparément au traitement de ces données. Pour plus de détails, voir la politique de protection des données de Miele.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: ""
      }
    },
    highlightedText: {
      text: "Je peux révoquer mon consentement à tout moment et sans donner de raisons, avec effet pour l’avenir. Pour plus d’informations sur la manière dont Miele traite vos données, veuillez consulter ",
      link: {
        title: "la politique de protection des données de Miele.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Su,
  mieleClub: Lu,
  readMore: Cu,
  readLess: Pu
}, Au = {
  waitMessage: "Presque là. Tenez bon ..."
}, xu = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmer votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez saisir la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "Adresse e-mail non valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, Iu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Erreur",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a été utilisé précédemment. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous : ",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, Du = {
  invalidEmail: "Adresse e-mail incorrecte",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification. Malheureusement, nous ne pouvons pas vous autoriser à continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semblerait que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cet e-mail existe déjà, veuillez utiliser une adresse e-mail différente !",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semblerait que vous accédiez à nos services à partir d'un navigateur non sécurisé/ non-supporté. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé précédemment, veuillez saisir un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403042: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment effectuée, veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : une lettre majuscule, une lettre minuscule, un chiffre, un symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact en nous fournissant les détails.",
  unexpectedTitle: "Une erreur imprévue est survenue",
  unknownDescription: "Erreur imprévue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, Nu = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, Ou = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "En attente d'enregistrement du compte",
    noAccountDescription: "Il n'y a aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "politique de confidentialité",
    privacyStatementTitle: "Notre politique de confidentialité a été modifiée",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la page de connexion",
    submitButtonLabel: "Envoyer",
    successDescription: "Veuillez consulter votre messagerie, vous recevrez bientôt les informations concernant votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour profiter de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Connexion",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, Uu = {
  accessibility: {
    close: "Fermer"
  }
}, $u = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, Bu = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, Ru = {
  registerButtonLabel: "S'enregistrer",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: {
      1: "Enregistrer les appareils, suivre les commandes, accéder aux manuels",
      2: "Recevoir des offres et promotions personnalisées",
      3: "Voir toutes vos commandes, garanties, événements et services"
    },
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour de mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour."
}, Vu = {
  title: "Préférences de marketing",
  description: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
  submit: "Enregistrer",
  levelOne: {
    text: "Oui, je souhaite recevoir des communications promotionnelles de Miele s.à r.l. et Miele & Cie. KG (« Miele ») adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi que des enquêtes clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et élaborer la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir (par exemple, en envoyant un e-mail à privacy{'@'}miele.lu, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les e-mails).",
    link: {
      title: "Politique de confidentialité",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'application Miele et de mes visites sur les sites Internet de Miele (www.miele.lu), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement distinct dans l'application ou sur le site Internet autorise le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "Protection des données",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus de détails, voir la politique de Protection des données de Miele.",
    link: {
      title: "Système Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "J'ai lu et j'accepte les",
    link: {
      title: "Conditions d'utilisation",
      ref: "https://www.miele.lu/fr/c/cgv-13.htm"
    }
  }
}, Fu = {
  headline: "Miele Club",
  why: {
    title: "Adhésion gratuite - Offres exclusives pour les membres.",
    reasons: [
      "Offre de bienvenue de -15%",
      "Surprise pour votre anniversaire",
      "Offres spéciales membres",
      "Invitations à nos evenements exclusifs"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.lu/fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: " Protection des données",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.lu, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.lu/fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.lu"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, qu = "afficher la déclaration complète", Gu = "masquer la déclaration complète", Ku = {
  auth: Au,
  changeEmailScene: xu,
  changePasswordScene: Iu,
  errors: Du,
  forgotPassword: Nu,
  login: Ou,
  modal: Uu,
  passwordStrength: $u,
  passwordHelper: Bu,
  register: Ru,
  "marketing-consent": {
    title: "Préférences de marketing",
    submit: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
    description: "Enregistrer",
    newsletter: {
      text: `Je suis d'accord que Miele Co Ltd. ("Miele") peut m'envoyer des informations sur les produits et les innovations de la gamme de produits Miele, ainsi que des sondages auprès des clients, et des recettes par courrier électronique, les applications Miele et SMS et que Miele peut traiter les coordonnées que j'ai fournies (titre, nom, adresse e-mail, numéro de téléphone portable et code postal) et les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir ainsi que les intérêts que j'ai indiqués à cette fin. Je suis également d'accord que Miele peut également traiter les confirmations de réception et de lecture reçues par le biais de la newsletter et des informations sur les liens sur lesquels j'ai cliqué, ainsi que sur mon comportement d'utilisateur associé sur le site web lié à des fins de personnalisation. Il en va de même pour les messages push in-app, dans la mesure où les applications Miele sont utilisées.`,
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    personalisation: {
      text: "Je suis d'accord que Miele puisse traiter des informations sur les services que j'ai utilisés, les affectations de techniciens que j'ai effectuées, ainsi que des événements auxquels j'ai participé, afin d'améliorer la personnalisation.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation étendue, je suis d'accord que Miele puisse également traiter les données d'utilisation de l'application Miele et de mes visites sur les sites web de Miele (www.miele.lu) pour compléter mon profil utilisateur, à condition que j'ai donné mon consentement séparément pour le traitement de ces données.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    highlightedText: {
      text: " Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la page ",
      link: {
        title: "Politique de protection des données",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Vu,
  mieleClub: Fu,
  readMore: qu,
  readLess: Gu
}, Hu = {
  waitMessage: "Quasi arrivati. Resistete..."
}, Wu = {
  buttonLabel: "Salva",
  buttonLabelClose: "Chiudi",
  confirmEmailMessage: "Conferma il tuo indirizzo email",
  copy: "Per aggiornare il tuo indirizzo email, inserisci quello nuovo qui sotto:",
  errorMessageCopy: "Qualcosa è andato storto. Riprova.",
  errorMessageHeadline: "Errore",
  headline: "Dettagli profilo",
  inputEmailConfirmPlaceholder: "Conferma il tuo indirizzo email",
  inputEmailPlaceholder: "Indirizzo email",
  invalidEmailMessage: "Indirizzo email non valido!",
  rememberMeLabel: "Ricordami",
  successMessageCopy: "Il tuo indirizzo email è stato aggiornato con successo.",
  successMessageHeadline: "Indirizzo email aggiornato"
}, Ju = {
  closeButtonLabel: "Chiudi",
  confirmPasswordLabel: "Conferma Password",
  currentPasswordLabel: "Password attuale",
  newPasswordLabel: "Nuova Password",
  passwordMismatchError: "La password non corrisponde",
  passwordUpdateErrorTitle: "Errore",
  passwordUpdateSuccessTitle: "Password aggiornata",
  samePasswordError: "Questa password è stata utilizzata in precedenza, invia una nuova password",
  subtitle: "Per cambiare la password, compila i campi qui sotto:",
  submitButtonLabel: "Invia",
  successfulChangeLabel: "La tua password è stata aggiornata con successo",
  title: "Cambio password"
}, Zu = {
  invalidEmail: "Email non corretta",
  invalidPassword: "Password errata",
  sap_206002: "Il tuo account è in attesa di verifica, mi dispiace ma al momento non possiamo permetterti di procedere. Contattaci per maggiori dettagli.",
  sap_206006: "Sembra che l'indirizzo email che hai inviato sia in attesa di verifica",
  sap_400003: "Questo indirizzo email esiste già, per favore utilizza un altro indirizzo email!",
  sap_400028: "L'indirizzo email inviato è in attesa di verifica",
  sap_400050: "Mi dispiace, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_400097: "Sembra che tu stia accedendo ai nostri servizi da un browser non protetto/non supportato. Riprova con un altro browser.",
  sap_401030: "Questa password è stata utilizzata in precedenza, per favore inserisci una nuova password",
  sap_403005: "Non abbiamo un account associato a questo indirizzo email, per favore controlla la tua email e riprova.",
  sap_403011: "Sessione scaduta. Si prega di ricaricare il browser e accedere nuovamente.",
  sap_403012: "Sessione scaduta. Si prega di ricaricare il browser e accedere nuovamente.",
  sap_403013: "Spiacenti, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_403035: "Spiacenti, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_403041: "Non abbiamo un account associato a questo indirizzo email, per favore controlla la tua email e riprova.",
  sap_403042: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403043: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403047: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403100: "È stata richiesta di recente una modifica della password, per favore attendi finché la richiesta viene elaborata.",
  sap_403025: "Il link per la reimpostazione della password non è valido. Invia nuovamente la richiesta di password dimenticata per ricevere un nuovo link per la reimpostazione.",
  sapErrorTitle: "Errore elaborazione richiesta",
  sessionExpired: "Sessione scaduta",
  tooWeakPassword: "La password deve contenere almeno {minLength} caratteri e {minCharGroups} dei seguenti elementi: lettera maiuscola, lettera minuscola, numero, simbolo speciale | La password deve contenere almeno {minLength} caratteri",
  unexpectedDescription: "Se il problema persiste, contattaci attraverso il modulo di contatto fornendoci i dettagli necessari.",
  unexpectedTitle: "Si è verificato un errore imprevisto",
  unknownDescription: "Errore imprevisto. Riprova per favore.",
  unknownTitle: "Oops!"
}, Yu = {
  subtitle: "Imposta la tua nuova password.",
  title: "Hai dimenticato la password?"
}, Xu = {
  headMetaDescription: "Pagina di login del cliente",
  headTitle: "Accedi con la tua e-mail e password:",
  subtitle: "Accedi o crea un account per accedere a tutte le funzioni Miele.",
  title: "Accedi al tuo account",
  error: {
    invalidEmailPasswordDescription: "La combinazione di indirizzo e-mail e password non è valida.",
    invalidEmailPasswordTitle: "Credenziali non valide",
    missingConcentTitle: "Account in attesa di registrazione",
    noAccountDescription: "Non esiste alcun account associato a questo indirizzo e-mail.",
    noAccountTitle: "Nessun account registrato"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Ho preso visione dell'{0}.",
    privacyStatementName: "informativa sulla privacy",
    privacyStatementTitle: "La nostra politica sulla privacy è cambiata",
    termsOfUseCheckboxLabel: "Accetto i {0}.",
    termsOfUseName: "termini di utilizzo",
    termsOfUseTitle: "I nostri termini di utilizzo sono cambiati",
    title: "Completamento profilo"
  },
  forgotPasswordScene: {
    backButtonLabel: "Torna al Login",
    submitButtonLabel: "Invia",
    successDescription: "Controlla la tua e-mail, riceverai presto le istruzioni sul tuo account per iniziare il processo di reset della password.",
    successTitle: "Abbiamo ricevuto la tua richiesta.",
    title: "Inserisci il tuo indirizzo email per reimpostare la password:"
  },
  loginModalScene: {
    copy: "Accedi o crea un account per usufruire di tutte le funzionalità Miele.",
    title: "Accedi al tuo account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Ho dimenticato la password",
    invalidEmailMessage: "E-mail non valida!",
    loginButtonLabel: "Accedi",
    passwordInputLabel: "Password",
    rememberMeLabel: "Ricordami",
    title: "Accedi con il tuo indirizzo email e la password:"
  }
}, Qu = {
  accessibility: {
    close: "Chiudi"
  }
}, em = {
  tooShort: "Troppo corta",
  medium: "Media",
  strong: "Forte",
  tooWeak: "Troppo debole",
  veryStrong: "Molto forte",
  weak: "Debole"
}, tm = {
  showPasswordText: "Mostra",
  hidePasswordText: "Nascondi"
}, im = {
  registerButtonLabel: "registrati",
  registerTitle: "Non hai ancora un account?",
  whyRegister: {
    list: {
      0: "Accesso a vantaggi esclusivi del Miele Club",
      1: "Registra i tuoi elettrodomestici, traccia gli ordini, accedi ai manuali",
      2: "Ricevi offerte e promozioni personalizzate",
      3: "Visualizza tutti i tuoi ordini, garanzie, eventi e servizi"
    },
    title: "Perché registrarsi?"
  },
  closeButtonLabel: "Chiudi",
  passwordMismatchError: "Le password non corrispondono",
  passwordUpdateErrorTitle: "Errore durante l'aggiornamento della password",
  passwordUpdateSuccessTitle: "Password aggiornata",
  successfulChangeLabel: "La tua password è stata aggiornata con successo"
}, am = {
  title: "Preferenze di marketing",
  description: "Spunta la casella qui sotto per ricevere offerte esclusive, notizie, consigli sui prodotti e altro ancora",
  submit: "Salva",
  levelOne: {
    shortText: 'Sì, desidero ricevere comunicazioni promozionali da Miele Italia S.r.l. e Miele & Cie. KG ("Miele"), personalizzate in base ai miei interessi personali, via e-mail, SMS, posta e tramite le app Miele (se utilizzate)',
    text: `Sì, desidero ricevere comunicazioni promozionali da Miele Italia S.r.l. e Miele & Cie. KG ("Miele"), personalizzate in base ai miei interessi personali, via e-mail, SMS, posta e tramite le app Miele (se utilizzate) con informazioni su prodotti, offerte e innovazioni della gamma di prodotti Miele e su eventi Miele, nonché sondaggi tra i clienti, richieste di valutazione e recensione dei prodotti e ricette. A tal fine, Miele può utilizzare i miei dati di contatto (titolo, nome, indirizzo e-mail, numero di cellulare e indirizzo postale) e progettare la comunicazione in base ai miei acquisti, ai servizi, alla cronologia degli eventi, al comportamento di clic e apertura della newsletter e al valore del cliente, come descritto in dettaglio nella nostra informativa sulla privacy. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro (ad esempio, inviando un messaggio informale a contact{'@'}miele-support.it, ai dettagli di contatto indicati nell'imprinting o facendo clic sul link di annullamento dell'iscrizione nelle e-mail).`,
    link: {
      title: "Privacy",
      ref: "https://www.miele.it/c/privacy-14.htm"
    }
  },
  levelTwo: {
    text: "Oltre al mio consenso di base, accetto che Miele possa trattare anche i dati derivanti dall'utilizzo dell'app Miele e dalle mie visite ai siti web Miele (www.miele.it), compreso il comportamento dell'utente sui siti web Miele dopo i clic sulla newsletter collegata, per integrare il mio profilo utente per comunicazioni pubblicitarie personalizzate, a condizione che il mio consenso separato nell'app o sul sito web autorizzi il trattamento dei dati. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro. Ulteriori dettagli nella politica di protezione dei dati di Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Oltre al mio consenso di base, accetto che Miele possa elaborare anche i dati dei miei elettrodomestici Miele collegati (dati sull'utilizzo e sullo stato degli elettrodomestici) per integrare il mio profilo utente per la pubblicità personalizzata. Posso trovare ulteriori informazioni sul trattamento dei dati degli elettrodomestici nell'informativa sulla privacy del sistema Miele{'@'}Home. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro. Ulteriori dettagli nella politica di protezione dei dati di Miele.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Possono revocare il mio consenso in qualsiasi momento senza dover fornire delle motivazioni e con effetto futuro. Per maggiori informazioni su come Miele gestisce i tuoi dati, si prega di consultare la ",
    link: {
      title: "politica di protezione dei dati di Miele.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Sì, acconsento ai termini d'uso.",
    link: {
      title: "Vedi i termini d'uso.",
      ref: "https://www.miele.it/c/condizioni-di-utilizzo-304.htm"
    }
  }
}, nm = {
  headline: "Miele Club",
  why: {
    title: "Vantaggi esclusivi e comunicazioni personalizzate per i membri.",
    reasons: [
      "Regalo di benvenuto",
      "Sorpresa di compleanno",
      "Offerte ed eventi esclusivi",
      "Consiglio sull'utilizzo di elettrodomestici, detersivi e accessori"
    ]
  },
  birthDateTitle: "Vuoi ricevere una sorpresa di compleanno?",
  birthDateValidation: {
    requirementMsg: "Si prega di inserire il seguente formato per la data: GG/MM/AAAA",
    errorMsg: "Data incorretta"
  },
  joinClubLabel: "Si, voglio iscrivermi al Miele Club.",
  termsAndCondition: {
    description: "Accetto le {termsAndConditionLink} del Miele Club e prendo atto dei {privacyLink} relativi al Miele Club.",
    termsAndConditionLink: {
      title: "Condizioni di partecipazione",
      ref: "https://www.miele.it/c/condizioni-generali-di-vendita-13.htm#p7207"
    },
    privacyLink: {
      title: "Regolamenti sulla protezione dei dati",
      ref: "https://www.miele.it/c/privacy-14.htm"
    }
  },
  newsletter: {
    description: `Sì, desidero ricevere comunicazioni promozionali personalizzate in base ai miei interessi personali da parte di Miele Italia S.r.l. ("Miele") via email e per posta con offerte speciali, informazioni, inviti a eventi e sondaggi sui nostri prodotti e servizi. A tal fine, Miele puó utilizzare i miei dati di contatto (titolo, nome, e-mail e indirizzo postale) e strutturare la comunicazione in base al mio comportamento di acquisto e in materia di newsletter, nonché al mio valore di cliente, come descritto piú dettagliatamente nella nostra informativa sui  {privacyLink}. Posso revocare il mio consenso per il futuro in qualsiasi momento, inviando un messaggio a contact{'@'}miele-support.it, ai recapiti indicati nell´impressum o cliccando sul link di annullamento dell´iscrizione nelle email. Le condizioni generali di {termsAndConditionLink} rimangono inalterate fino alla cancellazione dell´iscrizione.`,
    shortDescription: 'Sì, desidero ricevere comunicazioni promozionali personalizzate in base ai miei interessi personali da parte di Miele Italia S.r.l. ("Miele") via email e per posta',
    privacyLink: {
      title: "Regolamenti sulla protezione dei dati",
      href: "https://www.miele.it/c/privacy-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicazione di Miele Club",
      href: "https://www.miele.it/c/condizioni-generali-di-vendita-13.htm#p7207"
    },
    supportEmail: "contact{'@'}miele-support.it"
  },
  selectAllConsents: {
    description: "Per unirti al Miele Club, devi accettare tutti i termini e condizioni *"
  },
  birthDateLabel: "Inserisci la tua data di nascita (facoltativo)"
}, sm = "mostra la dichiarazione completa", om = "nascondi l'intera dichiarazione", rm = {
  auth: Hu,
  changeEmailScene: Wu,
  changePasswordScene: Ju,
  errors: Zu,
  forgotPassword: Yu,
  login: Xu,
  modal: Qu,
  passwordStrength: em,
  passwordHelper: tm,
  register: im,
  "marketing-consent": {
    title: "Preferenze di marketing",
    description: "Seleziona le caselle qui sotto per ricevere offerte esclusive, novità, eventi e informazioni su come ottenere il massimo dal tuo elettrodomestico.",
    submit: "Salva",
    newsletter: {
      text: 'Accetto che Miele Co Ltd. ("Miele") possa inviarmi informazioni sui prodotti e le innovazioni dalla gamma di prodotti Miele e su eventi Miele, nonché sondaggi sui clienti e ricette tramite e-mail, le app Miele e SMS e che Miele possa trattare i dettagli di contatto che ho fornito (titolo, nome, indirizzo email, numero di telefono mobile e codice postale) e i prodotti Miele che ho acquistato fino ad oggi e acquisterò in futuro, nonché gli interessi che ho indicato a tale scopo. Inoltre, acconsento a che Miele possa trattare i comprovanti di ricezione e lettura ricevuti tramite il newsletter e le informazioni sui link su cui ho cliccato nonché il mio comportamento utente correlato al sito Web collegato ai fini della personalizzazione. Lo stesso si applica alle notifiche push in-app, nella misura in cui vengono utilizzate le app Miele.',
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    personalisation: {
      text: "Acconsento che Miele possa elaborare le informazioni sui servizi utilizzati, le assegnazioni tecniche effettuate e gli eventi a cui ho partecipato, al fine di migliorare la personalizzazione.",
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Inoltre alla personalizzazione estesa, acconsento che Miele possa elaborare anche i dati relativi all'uso dell'app Miele e le visite ai siti web Miele (www.miele.co.uk) per integrare il mio profilo utente, a condizione che abbia precedentemente acconsentito al trattamento di questi dati.",
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Possono revocare il mio consenso in qualsiasi momento senza dover fornire delle motivazioni e con effetto futuro. Per maggiori informazioni su come Miele gestisce i tuoi dati, si prega di consultare la ",
      link: {
        title: "politica di protezione dei dati di Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sì, acconsento ai termini d'uso.",
      link: {
        title: "Vedi i termini d'uso*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: am,
  mieleClub: nm,
  readMore: sm,
  readLess: om
}, lm = {
  waitMessage: "Quasi pronto. Attendere…"
}, cm = {
  buttonLabel: "Salva",
  buttonLabelClose: "Chiudere",
  confirmEmailMessage: "Confermate il vostro indirizzo e-mail",
  copy: "Per aggiornare il vostro indirizzo e-mail, inserite il nuovo qui sotto:",
  errorMessageCopy: "Qualcosa è andato storto. Riprovate.",
  errorMessageHeadline: "Errore",
  headline: "Dettagli del profilo",
  inputEmailConfirmPlaceholder: "Conferma il vostro indirizzo e-mail",
  inputEmailPlaceholder: "Indirizzo e-mail",
  invalidEmailMessage: "E-mail non valida!",
  rememberMeLabel: "Resta connesso",
  successMessageCopy: "Il vostro indirizzo e-mail è stato aggiornato con successo.",
  successMessageHeadline: "Indirizzo e-mail aggiornato"
}, dm = {
  closeButtonLabel: "Chiudere",
  confirmPasswordLabel: "Conferma password",
  currentPasswordLabel: "Password attuale",
  newPasswordLabel: "Nuova password",
  passwordMismatchError: "La password non corrisponde",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password aggiornata",
  samePasswordError: "Questa password è stata utilizzata in precedenza, si prega di inserirne una nuova",
  subtitle: "Per cambiare la password, compila i campi qui sotto:",
  submitButtonLabel: "Invia",
  successfulChangeLabel: "La password è stata aggiornata con successo",
  title: "Cambia password"
}, um = {
  invalidEmail: "E-mail non corretta",
  invalidPassword: "Password errata",
  sap_206002: "Il account è in attesa di verifica, non possiamo lasciarti procedere al momento. Contattaci per maggiori dettagli.",
  sap_206006: "L'indirizzo e-mail inviato è in attesa di verifica",
  sap_400003: "Questo indirizzo e-mail esiste già, si prega di utilizzare un indirizzo e-mail diverso.",
  sap_400028: "L'indirizzo e-mail inviato è in attesa di verifica",
  sap_400050: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_400097: "Sembra che si stia accedendo ai nostri servizi da un browser non sicuro/non supportato. Si prega di riprovare con un altro browser.",
  sap_401030: "Questa password è stata utilizzata in precedenza, si prega di inviare una nuova password",
  sap_403005: "Non abbiamo un account associato a questo indirizzo e-mail, si prega di controllare la e-mail e riprovare.",
  sap_403011: "Sessione scaduta. Si prega di ricaricare il browser e accedere di nuovo.",
  sap_403012: "Sessione scaduta. Si prega di ricaricare il browser e accedere di nuovo.",
  sap_403013: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_403035: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_403041: "Non abbiamo un account associato a questo indirizzo e-mail, si prega di controllare la e-mail e riprovare.",
  sap_403042: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403043: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403047: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403100: "È stata richiesta di recente un'aggiornamento della password, si prega di attendere fino a quando la richiesta viene elaborata",
  sap_403025: "Il link per la reimpostazione della password non è valido. Invia nuovamente la richiesta di password dimenticata per ricevere un nuovo link per la reimpostazione.",
  sapErrorTitle: "Errore durante l'elaborazione della richiesta",
  sessionExpired: "Sessione scaduta",
  tooWeakPassword: "La password deve contenere almeno {minLength} caratteri e {minCharGroups} dei seguenti: lettera maiuscola, lettera minuscola, numero, simbolo speciale | La password deve contenere almeno {minLength} caratteri",
  unexpectedDescription: "Se il problema persiste, contattaci tramite il modulo di contatto fornendo i dettagli.",
  unexpectedTitle: "Si è verificato un errore imprevisto",
  unknownDescription: "Si è verificato un errore imprevisto. Si prega di riprovare.",
  unknownTitle: "Ops!"
}, mm = {
  subtitle: "Imposta la nuova password.",
  title: "Hai dimenticato la password?"
}, pm = {
  headMetaDescription: "Pagina di accesso cliente",
  headTitle: "Accedi con il e-mail e la password:",
  subtitle: "Accedi o crea un account per usufruire di tutte le funzionalità di Miele.",
  title: "Accedi",
  error: {
    invalidEmailPasswordDescription: "La combinazione di indirizzo e-mail e password non è valida.",
    invalidEmailPasswordTitle: "Credenziali non valide",
    missingConcentTitle: "Account in attesa di registrazione",
    noAccountDescription: "Non è presente alcun account associato a questo indirizzo e-mail.",
    noAccountTitle: "Nessun account registrato"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Ho preso visione della {0}.",
    privacyStatementName: "informativa sulla privacy",
    privacyStatementTitle: "La nostra informativa sulla privacy è stata aggiornata",
    termsOfUseCheckboxLabel: "Accetto i {0}.",
    termsOfUseName: "condizioni di utilizzo",
    termsOfUseTitle: "I nostri condizioni di utilizzo sono stati aggiornati",
    title: "Completamento del profilo"
  },
  forgotPasswordScene: {
    backButtonLabel: "Torna al login",
    submitButtonLabel: "Invia",
    successDescription: "Controlla la e-mail, riceverai presto le informazioni su account per iniziare il processo di reimpostazione della password.",
    successTitle: "La richiesta è stata ricevuta.",
    title: "Inserisci il indirizzo e-mail per reimpostare la password:"
  },
  loginModalScene: {
    copy: "Accedi o crea un account per usufruire di tutte le funzionalità di Miele.",
    title: "Accedi "
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Password dimenticata",
    invalidEmailMessage: "E-mail non valida!",
    loginButtonLabel: "Accedi",
    passwordInputLabel: "Password",
    rememberMeLabel: "Resta connesso",
    title: "Accedi con il e-mail e la password:"
  }
}, gm = {
  accessibility: {
    close: "Chiudere"
  }
}, hm = {
  tooShort: "Troppo corta",
  medium: "Media",
  strong: "Forte",
  tooWeak: "Troppo debole",
  veryStrong: "Molto forte",
  weak: "Debole"
}, vm = {
  showPasswordText: "Mostra",
  hidePasswordText: "Nascondi"
}, fm = {
  registerButtonLabel: "registrati",
  registerTitle: "Non hai un account?",
  whyRegister: {
    list: [
      "Accesso a vantaggi esclusivi del Club Miele",
      "Registra elettrodomestici, traccia ordini, accedi ai manuali ",
      "Ricevi offerte e promozioni personalizzate",
      "Visualizza tutti i tuoi ordini, garanzie, eventi e servizi  "
    ],
    title: "Perché registrarsi?"
  },
  closeButtonLabel: "Chiudere",
  passwordMismatchError: "Le password non corrispondono",
  passwordUpdateErrorTitle: "Errore di aggiornamento della password",
  passwordUpdateSuccessTitle: "Password aggiornata",
  successfulChangeLabel: "La password è stata aggiornata con successo"
}, km = {
  title: "Preferenze di marketing",
  description: "Le interessano offerte esclusive, nuovi prodotti, eventi, sondaggi tra i clienti e altre informazioni utili dal mondo Miele?",
  submit: "Salva",
  levelOne: {
    text: "Acconsento all’invio da parte di Miele AG («Miele») di informazioni e offerte su prodotti e servizi, nonché di inviti a eventi e sondaggi tra i clienti tramite e-mail (newsletter), app Miele, posta e SMS. Al fine di adattare al meglio le comunicazioni commerciali alle sue esigenze, Miele tratta i seguenti dati personali ed effettua la cosiddetta profilazione (ossia il trattamento automatizzato di dati personali al fine di analizzare aspetti personali o fare previsioni): dati di contatto, dati relativi agli apparecchi, dati provenienti da sondaggi dei clienti, cronologia degli acquisti e clic sulla newsletter, servizi utilizzati, interventi di tecnici e partecipazione a eventi, comportamento di utilizzo dell’app Miele e del sito web. Ulteriori dettagli sono disponibili nell’ ",
    link: {
      title: "Informativa sulla privacy.",
      ref: "https://www.miele.ch/it/c/tutela-della-privacy-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Posso revocare il mio consenso in qualsiasi momento, senza indicarne i motivi, con effetto nel futuro. Per ulteriori informazioni sul trattamento dei dati da parte di Miele, si prega di consultare ",
    link: {
      title: "l’informativa sulla privacy di Miele.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sì, accetto i condizioni di utilizzo.",
    link: {
      title: "Vedi i condizioni di Utilizzo.",
      ref: "https://www.miele.ch/it/c/condizioni-di-utilizzo-304.htm"
    }
  }
}, bm = {
  headline: "Miele Club",
  why: {
    title: "Vantaggi esclusivi per i soci - Comunicazione personale del club.",
    reasons: [
      "10% Regalo di benvenuto",
      "Sorpresa di compleanno",
      "Offerte e eventi esclusive",
      "Consigli sull'uso dei apparecchi"
    ]
  },
  birthDateTitle: "Volete ricevere una sorpresa di compleanno?",
  birthDateValidation: {
    requirementMsg: "Si prega di inserire il seguente formato per la data: GG/MM/AAAA",
    errorMsg: "Data incorretta"
  },
  joinClubLabel: "Si, voglio iscrivermi al Miele Club.",
  termsAndCondition: {
    description: "Sì, ho letto e accetto le {termsAndConditionLink} al Miele Club.",
    termsAndConditionLink: {
      title: "Condizioni di partecipazione",
      ref: "https://www.miele.ch/it/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Sì, ho letto e accetto l’ {privacyLink} del Miele Club. Il trattamento in conformità alle disposizioni sulla protezione dei dati comprende, in particolare, la profilazione basata sul comportamento dei clienti e l’utilizzo dei profili dei clienti per scopi di marketing e di altro tipo.",
    privacyLink: {
      title: "Informativa sulla privacy",
      href: "https://www.miele.ch/it/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Per aderire al Miele Club, é necessario accettare le condizioni di utilizzo e partecipazione al Miele Club"
  },
  birthDateLabel: "Data di nascita (facoltativo)"
}, wm = "mostra l'intera dichiarazione", ym = "nascondi l'intera dichiarazione", Mm = {
  auth: lm,
  changeEmailScene: cm,
  changePasswordScene: dm,
  errors: um,
  forgotPassword: mm,
  login: pm,
  modal: gm,
  passwordStrength: hm,
  passwordHelper: vm,
  register: fm,
  "marketing-consent": {
    title: "Preferenze di marketing",
    description: "Le interessano offerte esclusive, nuovi prodotti, eventi, sondaggi tra i clienti e altre informazioni utili dal mondo Miele?",
    submit: "Salva",
    newsletter: {
      text: "Acconsento all’invio da parte di Miele AG («Miele») di informazioni e offerte su prodotti e servizi, nonché di inviti a eventi e sondaggi tra i clienti tramite e-mail (newsletter), app Miele, posta e SMS. Al fine di adattare al meglio le comunicazioni commerciali alle sue esigenze, Miele tratta i seguenti dati personali ed effettua la cosiddetta profilazione (ossia il trattamento automatizzato di dati personali al fine di analizzare aspetti personali o fare previsioni): dati di contatto, dati relativi agli apparecchi, dati provenienti da sondaggi dei clienti, cronologia degli acquisti e clic sulla newsletter, servizi utilizzati, interventi di tecnici e partecipazione a eventi, comportamento di utilizzo dell’app Miele e del sito web. ",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    personalisation: {
      text: "Acconsento al trattamento da parte di Miele delle informazioni relative ai servizi da me utilizzati, agli incarichi tecnici da me svolti e agli eventi a cui ho partecipato ai fini di una maggiore personalizzazione.",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Oltre che ai fini di personalizzazione, accetto che Miele possa trattare anche i dati derivanti dall’uso dell’app Miele e dalle mie visite ai siti web Miele (www.miele.ch) per integrare il mio profilo utente, a condizione che io abbia acconsentito separatamente al trattamento di questi dati. Ulteriori dettagli nell’informativa sulla privacy di Miele.",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    highlightedText: {
      text: "Posso revocare il mio consenso in qualsiasi momento, senza indicarne i motivi, con effetto nel futuro. Per ulteriori informazioni sul trattamento dei dati da parte di Miele, si prega di consultare ",
      link: {
        title: "l’informativa sulla privacy di Miele.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Sì, accetto i condizioni di utilizzo.",
      link: {
        title: "Vedi i condizioni di Utilizzo*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: km,
  mieleClub: bm,
  readMore: wm,
  readLess: ym
}, zm = {
  waitMessage: "Bijna daar. "
}, jm = {
  buttonLabel: "Opslaan",
  buttonLabelClose: "Sluit",
  confirmEmailMessage: "Bevestig uw e-mailadres",
  copy: "Voeg je nieuwe e-mailadres hieronder toe om het te wijzigen.",
  errorMessageCopy: "Er is iets fout gegaan. ",
  errorMessageHeadline: "Fout",
  headline: "profiel details",
  inputEmailConfirmPlaceholder: "Bevestig je e-mailadres",
  inputEmailPlaceholder: "E-mailadres",
  invalidEmailMessage: "E-mail niet geldig!",
  rememberMeLabel: "Onthoud me",
  successMessageCopy: "Uw e-mailadres is succesvol bijgewerkt.",
  successMessageHeadline: "E-mailadres bijgewerkt"
}, _m = {
  closeButtonLabel: "Sluit",
  confirmPasswordLabel: "bevestig wachtwoord",
  currentPasswordLabel: "huidig ​​wachtwoord",
  newPasswordLabel: "nieuw paswoord",
  passwordMismatchError: "Wachtwoord komt niet overeen",
  passwordUpdateErrorTitle: "Fout",
  passwordUpdateSuccessTitle: "wachtwoord bijgewerkt",
  samePasswordError: "Dit wachtwoord werd eerder gebruikt, geef een nieuw wachtwoord op",
  subtitle: "Vul onderstaande velden in om uw wachtwoord te wijzigen:",
  submitButtonLabel: "Indienen",
  successfulChangeLabel: "je wachtwoord is succesvol geupdate",
  title: "Wachtwoord verandering"
}, Em = {
  invalidEmail: "incorrecte Email",
  invalidPassword: "Verkeerd wachtwoord",
  sap_206002: "Uw account is in afwachting van verificatie. Ik ben bang dat we u op dit moment niet verder kunnen laten gaan. ",
  sap_206006: "Het lijkt erop dat het e-mailadres dat je hebt opgegeven in afwachting is van verificatie",
  sap_400003: "Dit e-mailadres bestaat al, gebruik een ander e-mailadres!",
  sap_400028: "Het ingediende e-mailadres is in afwachting van verificatie",
  sap_400050: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_400097: "Het lijkt erop dat u onze services opent vanuit een onveilige/niet-ondersteunde browser. ",
  sap_401030: "Dit wachtwoord is eerder gebruikt, gelieve een nieuw wachtwoord in te dienen",
  sap_403005: "We hebben geen account gekoppeld aan dit e-mailadres, controleer uw e-mail en probeer het opnieuw",
  sap_403011: "Sessie verlopen. ",
  sap_403012: "Sessie verlopen. ",
  sap_403013: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_403035: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_403041: "We hebben geen account gekoppeld aan dit e-mailadres, controleer uw e-mail en probeer het opnieuw",
  sap_403042: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres of selecteer 'Wachtwoord vergeten' als u het opnieuw wilt instellen.",
  sap_403043: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres of selecteer 'Wachtwoord vergeten' als u het opnieuw wilt instellen.",
  sap_403047: "Het ingevulde email adres is niet geregistreerd",
  sap_403100: "Er is onlangs een verzoek om wachtwoordupdate aangevraagd, neem contact met ons op totdat het verzoek is verwerkt",
  sap_403025: "De link om het wachtwoord opnieuw in te stellen is ongeldig. Stuur het verzoek om een nieuw wachtwoord te ontvangen opnieuw, om een nieuwe link te ontvangen.",
  sapErrorTitle: "Fout bij verwerken van verzoek",
  sessionExpired: "Sessie verlopen",
  tooWeakPassword: "Het wachtwoord moet minimaal {minLength} tekens bevatten en {minCharGroups} van de volgende tekens: hoofdletter, kleine letter, cijfer of speciaal symbool. | Het wachtwoord moet minimaal {minLength} tekens bevatten.",
  unexpectedDescription: "Als het probleem aanhoudt, neem dan contact met ons op via het contactformulier met details.",
  unexpectedTitle: "Er is een onverwachte fout opgetreden",
  unknownDescription: "Er is een onverwachte fout opgetreden. ",
  unknownTitle: "Oh Oh!"
}, Sm = {
  subtitle: "Stel jouw nieuwe wachtwoord in.",
  title: "Je wachtwoord vergeten?"
}, Lm = {
  headMetaDescription: "Inlogpagina van de klant",
  headTitle: "Log in met jouw e-mailadres en wachtwoord:",
  subtitle: "Log in of maak een account aan om alle functies van Miele te gebruiken.",
  title: "Log in op jouw account",
  error: {
    invalidEmailPasswordDescription: "De combinatie van e-mailadres en wachtwoord is niet geldig.",
    invalidEmailPasswordTitle: "Ongeldige inloggegevens",
    missingConcentTitle: "Account in afwachting van registratie",
    noAccountDescription: "Er is geen account gekoppeld aan dit e-mailadres.",
    noAccountTitle: "Geen account geregistreerd"
  },
  extraConsentScene: {
    continue: "Doorgaan",
    privacyStatementCheckboxLabel: "Ik heb kennis genomen van de {0}.",
    privacyStatementName: "privacy verklaring",
    privacyStatementTitle: "Ons privacybeleid is gewijzigd",
    termsOfUseCheckboxLabel: "Ik ga akkoord met de {0}.",
    termsOfUseName: "gebruiksvoorwaarden",
    termsOfUseTitle: "Onze Gebruiksvoorwaarden zijn gewijzigd",
    title: "Profiel voltooiing"
  },
  forgotPasswordScene: {
    backButtonLabel: "Terug naar Inloggen",
    submitButtonLabel: "Indienen",
    successDescription: "Controleer jouw e-mail, je ontvangt binnenkort de informatie over jouw account om te beginnen met het wachtwoordherstelproces.",
    successTitle: "Je verzoek is ontvangen.",
    title: "Voer jouw e-mailadres in om jouw wachtwoord opnieuw in te stellen:"
  },
  loginModalScene: {
    copy: "Log in of maak een account aan om alle functies van Miele te gebruiken.",
    title: "Log in op jouw account"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Ik ben mijn wachtwoord vergeten",
    invalidEmailMessage: "E-mail niet geldig!",
    loginButtonLabel: "Log in",
    passwordInputLabel: "Wachtwoord",
    rememberMeLabel: "Onthoud me",
    title: "Log in met jouw e-mailadres en wachtwoord:"
  }
}, Cm = {
  accessibility: {
    close: "Sluit"
  }
}, Pm = {
  tooShort: "Te kort",
  medium: "Gemiddeld",
  strong: "Sterk",
  tooWeak: "Te zwak",
  veryStrong: "Heel sterk",
  weak: "Zwak"
}, Tm = {
  showPasswordText: "Weergeven",
  hidePasswordText: "Verbergen"
}, Am = {
  registerButtonLabel: "registreren",
  registerTitle: "Heb je geen account?",
  whyRegister: {
    list: [
      "Altijd op de hoogte van leuke evenementen",
      "Maak bestellen nog eenvoudiger",
      "Ontvang relevante informatie over jouw apparaten",
      "Alle bestellingen, garantiebewijzen en services bij elkaar"
    ],
    title: "Waarom registreren?"
  },
  closeButtonLabel: "Sluit",
  passwordMismatchError: "de wachtwoorden komen niet overeen",
  passwordUpdateErrorTitle: "Fout bij bijwerken van wachtwoord",
  passwordUpdateSuccessTitle: "wachtwoord bijgewerkt",
  successfulChangeLabel: "je wachtwoord is succesvol geupdate"
}, xm = {
  title: "Marketingvoorkeuren",
  description: "Heb je interesse in de nieuwste Miele producten, wil je deelnemen aan exclusieve Miele evenementen of kook je graag? Schrijf je dan in voor de Miele nieuwsbrief. Om de inhoud beter op je behoeften af te stemmen, maken wij gebruik van personalisering.",
  submit: "Opslaan",
  levelOne: {
    shortText: "Ja, ik wil graag marketingcommunicatie van Miele Nederland B.V. en Miele & Cie. KG (“Miele”), afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele apps, (indien gebruikt)",
    text: "Ja, ik wil graag marketingcommunicatie van Miele Nederland B.V. en Miele & Cie. KG (“Miele”), afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele apps, (indien gebruikt) met informatie over producten, aanbiedingen en innovaties uit het Miele productassortiment, evenementen, klantenenquêtes, aanvragen voor productbeoordelingen en -recensies en recepten. Hiervoor kan Miele mijn contactgegevens (titel, naam, e-mailadres, mobiele telefoonnummer en adresgegevens) gebruiken en de communicatie vormgeven op basis van mijn aankoop-, service-, evenementgeschiedenis, klik- en opengedrag van de nieuwsbrief en klantwaarde, zoals in detail beschreven in ons privacybeleid. Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen intrekken met werking voor de toekomst (bijv. door te klikken op de afmeldlink in e-mails of een informeel bericht te sturen naar nieuwsbrief{'@'}miele.nl).",
    link: {
      title: "Privacybeleid",
      ref: "https://www.miele.nl/c/privacybeleid-14.htm"
    }
  },
  levelTwo: {
    text: "Ik ga ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele app en mijn bezoeken aan Miele website (www.miele.nl), inclusief gebruikersgedrag op de Miele websites na gekoppelde nieuwsbriefklikken, mag verwerken om mijn gebruikersprofiel voor gepersonaliseerde reclamecommunicatie aan te vullen, mits mijn afzonderlijke toestemming in de app of op de website de gegevensverwerking vrijgeeft.  Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen met werking voor de toekomst intrekken. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Ik ga ermee akkoord dat Miele ook gegevens van mijn aangesloten Miele apparaten mag verwerken (gegevens over het gebruik en de status van apparaten) om mijn gebruikersprofiel aan te vullen voor gepersonaliseerde reclame. Meer informatie over de verwerking van apparaatgegevens vind je in het privacybeleid over het Miele{'@'}Home-systeem. Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen intrekken met werking voor de toekomst. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Ik kan mijn toestemming voor de verwerking van mijn persoonsgegevens op ieder moment intrekken. Meer informatie over hoe Miele met je persoonsgegevens omgaat, kun je vinden in het Miele",
    link: {
      title: "privacybeleid",
      ref: "https://www.miele.nl/c/privacybeleid-14.htm"
    }
  },
  termsOfUse: {
    text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
    link: {
      title: "Zie gebruiksvoorwaarden*",
      ref: "https://www.miele.nl/c/agb-13.htm"
    }
  }
}, Im = {
  headline: "Miele Club",
  birthDateTitle: "Mogen wij u een verjaardagscadeau sturen?",
  birthDateLabel: "Verjaardag (optioneel)",
  why: {
    title: "Lidmaatschap",
    reasons: [
      "Verjaardag verrassing",
      "Exclusieve aanbiedingen en campagnes",
      "Welkomstgeschenk",
      "VIP-aanbiedingen en ervaringen",
      "Aantrekkelijke besparingen",
      "Clubnieuws"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Gebruik een formaat zoals DD/MM/JJJJ",
    errorMsg: "Ongeldige datum"
  },
  joinClubLabel: "Ja, ik wil lid worden van de Miele-club.",
  termsAndCondition: {
    description: "Door Miele Club-lid te worden, gaat u akkoord met de {termsAndConditionLink} van Miele Club.",
    termsAndConditionLink: {
      title: "voorwaarden",
      ref: "https://www.miele.nl/c/agb-13.htm"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Ja, ik wil Miele Club-lid worden en Miele Club-communicatie (welkomstgeschenk, verjaardagsverrassing, statusupgrade, Miele Club-nieuws) via e-mail ontvangen.",
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    privacyLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.nl"
  },
  selectAllConsents: {
    description: "Om lid te worden van de Miele Club, moet je akkoord gaan met alle voorwaarden *"
  }
}, Dm = "volledige verklaring tonen", Nm = "verklaring minder tonen", Om = {
  auth: zm,
  changeEmailScene: jm,
  changePasswordScene: _m,
  errors: Em,
  forgotPassword: Sm,
  login: Lm,
  modal: Cm,
  passwordStrength: Pm,
  passwordHelper: Tm,
  register: Am,
  "marketing-consent": {
    title: "Marketingvoorkeuren",
    description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, evenementen en hoe u het meeste uit uw apparaat kunt halen.",
    submit: "Opslaan",
    newsletter: {
      text: 'Ik ga ermee akkoord dat Miele Nederland B.V. ("Miele") mij informatie over producten en nieuwe ontwikkelingen uit het Miele assortiment, evenementen, klantenquêtes, productbeoordelingen, reviews en recepten via e-mail, de Miele apps en sms toestuurt.',
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    personalisation: {
      text: "Ik ga ermee akkoord dat Miele informatie over de diensten die ik heb gebruikt en de opdrachten van technici die ik heb uitgevoerd, evenals evenementen die ik heb bijgewoond, mag verwerken met het oog op een betere personalisatie.",
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Naast de uitgebreide personalisatie ga ik ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele-app en mijn bezoeken aan de Miele-websites (www.miele.co.uk) mag verwerken om mijn gebruikersprofiel aan te vullen, op voorwaarde dat ik afzonderlijk toestemming heb gegeven ",
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    highlightedText: {
      text: "Ik kan mijn toestemming te allen tijde intrekken zonder opgaaf van redenen voor de toekomst.  ",
      link: {
        title: "gegevensbeschermingsbeleid.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
      link: {
        title: "Zie gebruiksvoorwaarden*",
        ref: "https://www.miele.nl/c/agb-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: xm,
  mieleClub: Im,
  readMore: Dm,
  readLess: Nm
}, Um = {
  waitMessage: "We zijn er bijna. Nog even geduld..."
}, $m = {
  buttonLabel: "Opslaan",
  buttonLabelClose: "Sluiten",
  confirmEmailMessage: "Bevestig uw e-mailadres",
  copy: "Als u uw e-mailadres wil aanpassen, voeg dan hieronder het nieuwe toe:",
  errorMessageCopy: "Er is iets misgegaan. Probeer het later opnieuw.",
  errorMessageHeadline: "Fout",
  headline: "Accountgegevens",
  inputEmailConfirmPlaceholder: "Bevestig uw e-mailadres",
  inputEmailPlaceholder: "E-mailadres",
  invalidEmailMessage: "E-mail niet geldig!",
  rememberMeLabel: "Onthoud mij",
  successMessageCopy: "Uw e-mailadres is succesvol bijgewerkt.",
  successMessageHeadline: "E-mailadres bijgewerkt"
}, Bm = {
  closeButtonLabel: "Sluiten",
  confirmPasswordLabel: "Bevestig wachtwoord",
  currentPasswordLabel: "Huidig wachtwoord",
  newPasswordLabel: "Nieuw wachtwoord",
  passwordMismatchError: "Wachtwoord komt niet overeen",
  passwordUpdateErrorTitle: "Fout",
  passwordUpdateSuccessTitle: "Wachtwoord bijgewerkt",
  samePasswordError: "Dit wachtwoord werd eerder gebruikt, geef een nieuw wachtwoord op",
  subtitle: "Vul de onderstaande velden in om uw wachtwoord te wijzigen:",
  submitButtonLabel: "Verzenden",
  successfulChangeLabel: "Uw wachtwoord is succesvol bijgewerkt",
  title: "Wachtwoord wijzigen"
}, Rm = {
  invalidEmail: "Onjuiste e-mail",
  invalidPassword: "Verkeerd wachtwoord",
  sap_206002: "Uw account moet nog geverifieerd worden, we kunnen u op dit moment niet verder laten gaan. Neem contact met ons op voor meer informatie.",
  sap_206006: "Het lijkt erop dat het e-mailadres dat u hebt opgegeven nog moet worden geverifieerd.",
  sap_400003: "Dit e-mailadres bestaat al, gebruik een ander e-mailadres.",
  sap_400028: "Het opgegeven e-mailadres moet nog worden geverifieerd.",
  sap_400050: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_400097: "Het lijkt erop dat u onze services benadert via een onveilige/onondersteunde browser. Probeer het opnieuw met een andere browser. ",
  sap_401030: "Dit wachtwoord werd al eerder gebruikt. Geef een nieuw wachtwoord op.",
  sap_403005: "Er is geen account gekoppeld aan dit e-mailadres. Controleer uw e-mailadres en probeer het opnieuw.",
  sap_403011: "Sessie verlopen. Laad de browser opnieuw en meld u opnieuw aan.",
  sap_403012: "Sessie verlopen. Laad de browser opnieuw en meld u opnieuw aan.",
  sap_403013: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_403035: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_403041: "Er is geen account gekoppeld aan dit e-mailadres. Controleer uw e-mailadres en probeer het opnieuw.",
  sap_403042: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres dat aan het account is gekoppeld of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403043: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres van het account of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403047: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres van het account of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403100: "Er werd onlangs een verzoek ingediend om het wachtwoord bij te werken. Blijf bij ons totdat het verzoek is verwerkt.",
  sap_403025: "De link om het wachtwoord opnieuw in te stellen is ongeldig. Stuur het verzoek om een nieuw wachtwoord te ontvangen opnieuw, om een nieuwe link te ontvangen.",
  sapErrorTitle: "Fout bij het verwerken van het verzoek",
  sessionExpired: "Sessie verlopen",
  tooWeakPassword: "Wachtwoord moet ten minste {minLength} tekens en {minCharGroups} van het volgende bevatten: hoofdletter, kleine letter, cijfer of speciaal symbool.. | Wachtwoord moet ten minste {minLength} tekens",
  unexpectedDescription: "Als het probleem zich blijft voordoen, neem dan contact met ons op via het contactformulier.",
  unexpectedTitle: "Er is een onverwachte fout opgetreden",
  unknownDescription: "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
  unknownTitle: "Uh Oh!"
}, Vm = {
  subtitle: "Stel uw nieuw wachtwoord in.",
  title: "Wachtwoord vergeten?"
}, Fm = {
  headMetaDescription: "Inlogpagina voor klanten",
  headTitle: "Meld u aan met uw e-mailadres en wachtwoord:",
  subtitle: "Meld u aan of maak een account aan om alle functies van Miele te gebruiken.",
  title: "Inloggen op uw account",
  error: {
    invalidEmailPasswordDescription: "De combinatie van e-mailadres en wachtwoord is ongeldig.",
    invalidEmailPasswordTitle: "Ongeldige gegevens",
    missingConcentTitle: "Account in afwachting van registratie",
    noAccountDescription: "Er is geen account gekoppeld aan dit e-mailadres.",
    noAccountTitle: "Geen account geregistreerd"
  },
  extraConsentScene: {
    continue: "Doorgaan",
    privacyStatementCheckboxLabel: "Ik heb kennis genomen van de {0}.",
    privacyStatementName: "Privacyverklaring",
    privacyStatementTitle: "Ons privacybeleid is gewijzigd",
    termsOfUseCheckboxLabel: "Ik ga akkoord met de {0}.",
    termsOfUseName: "Gebruiksvoorwaarden",
    termsOfUseTitle: "Onze gebruiksvoorwaarden zijn gewijzigd",
    title: "Account voltooien"
  },
  forgotPasswordScene: {
    backButtonLabel: "Terug naar aanmelden",
    submitButtonLabel: "Verzenden",
    successDescription: "Controleer uw e-mail, u ontvangt binnenkort de informatie over uw account om te beginnen met het resetten van uw wachtwoord.",
    successTitle: "Uw verzoek is ontvangen.",
    title: "Voer uw e-mailadres in om uw wachtwoord opnieuw in te stellen:"
  },
  loginModalScene: {
    copy: "Meld u aan of maak een account aan om alle Miele-functies te gebruiken.",
    title: "Aanmelden op uw account"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mijn wachtwoord vergeten",
    invalidEmailMessage: "E-mail niet geldig!",
    loginButtonLabel: "Aanmelden  ",
    passwordInputLabel: "Wachtwoord",
    rememberMeLabel: "Onthoud mij",
    title: "Meld u aan met uw e-mailadres en wachtwoord:"
  }
}, qm = {
  accessibility: {
    close: "Sluiten"
  }
}, Gm = {
  tooShort: "Te kort",
  medium: "Gemiddeld",
  strong: "Sterk",
  tooWeak: "Te Zwak",
  veryStrong: "Zeer sterk",
  weak: "Zwak"
}, Km = {
  showPasswordText: "Tonen",
  hidePasswordText: "Verbergen"
}, Hm = {
  registerButtonLabel: "Registreren",
  registerTitle: "Hebt u nog geen account?",
  whyRegister: {
    list: [
      "Handig overzicht van al uw bestellingen en eventboekingen",
      "Overzicht van al uw toestellen met accessoires en gebruiksaanwijzingen",
      "Zicht op al uw herstellingen en garanties"
    ],
    title: "Waarom registreren?"
  },
  closeButtonLabel: "Sluiten",
  passwordMismatchError: "De wachtwoorden komen niet overeen",
  passwordUpdateErrorTitle: "Fout bij het bijwerken van het wachtwoord",
  passwordUpdateSuccessTitle: "Wachtwoord bijgewerkt",
  successfulChangeLabel: "Uw wachtwoord werd succesvol bijgewerkt"
}, Wm = {
  title: "Marketingvoorkeuren",
  description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, productadvies en meer",
  submit: "Opslaan",
  levelOne: {
    shortText: 'Ja, ik wil graag promotionele informatie van Miele België NV en Miele & Cie. KG ("Miele") afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele-apps (indien gebruikt) ontvangen',
    text: `Ja, ik wil graag promotionele informatie van Miele België NV en Miele & Cie. KG ("Miele") afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele-apps (indien gebruikt) ontvangen met informatie over producten, aanbiedingen en innovaties uit het Miele-productassortiment en over Miele-evenementen, evenals klantenenquêtes, aanvragen voor productbeoordelingen en recensies en recepten. Hiervoor kan Miele mijn contactgegevens (titel, naam, e-mailadres, mobiel telefoonnummer en postadres) gebruiken en de communicatie vormgeven op basis van mijn aankoop-, service-, evenementgeschiedenis, klik- en opengedrag van de nieuwsbrief en klantwaarde, zoals in detail beschreven in ons privacybeleid. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen intrekken met werking voor de toekomst (bijv. door een informeel bericht te sturen naar privacy{'@'}miele.be, de contactgegevens in het impressum of door te klikken op de afmeldlink in e-mails).`,
    link: {
      title: "Privacybeleid",
      ref: "https://www.miele.be/nl/c/privacybeleid-14.htm"
    }
  },
  levelTwo: {
    text: "Naast mijn basistoestemming ga ik ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele-app en mijn bezoeken aan Miele-websites (www.miele.be), inclusief gebruikersgedrag op de Miele-websites na gekoppelde nieuwsbriefklikken, mag verwerken om mijn gebruikersprofiel voor gepersonaliseerde promotionele communicatie aan te vullen, mits mijn afzonderlijke toestemming in de app of op de website de gegevensverwerking vrijgeeft. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen met werking voor de toekomst intrekken. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Naast mijn basistoestemming ga ik ermee akkoord dat Miele ook gegevens van mijn aangesloten Miele-toestellen mag verwerken (gegevens over het gebruik en de status van toestellen) om mijn gebruikersprofiel aan te vullen voor gepersonaliseerde reclame. Meer informatie over de verwerking van toestelgegevens vind ik in het privacybeleid over het Miele{'@'}Home-systeem. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen intrekken met werking voor de toekomst. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "U kunt op ieder moment de toestemming voor de verwerking van uw persoonsgegevens intrekken. Meer informatie over hoe Miele met uw persoonsgegevens omgaat, kunt u vinden in het Miele",
    link: {
      title: "privacybeleid.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
    link: {
      title: "Bekijk de gebruiksvoorwaarden.",
      ref: "https://www.miele.be/nl/c/algemene-voorwaarden-13.htm"
    }
  }
}, Jm = {
  headline: "Miele Club",
  birthDateTitle: "Mogen wij u een verjaardagscadeau sturen?",
  birthDateLabel: "Verjaardag (optioneel)",
  why: {
    title: "Lidmaatschap",
    reasons: [
      "Verjaardag verrassing",
      "Exclusieve aanbiedingen en campagnes",
      "Welkomstgeschenk",
      "VIP-aanbiedingen en ervaringen",
      "Aantrekkelijke besparingen",
      "Clubnieuws"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Gebruik een formaat zoals DD/MM/JJJJ",
    errorMsg: "Ongeldige datum"
  },
  joinClubLabel: "Ja, ik wil lid worden van de Miele-club.",
  termsAndCondition: {
    description: "Ik accepteer de Miele Club {termsAndConditionLink} en bevestig dat ik de {privacyLink}-informatie voor de Miele Club heb gelezen.",
    termsAndConditionLink: {
      title: "Voorwaarden voor deelname en gebruik",
      ref: "https://www.miele.be/nl/c/cgv-13.htm"
    },
    privacyLink: {
      title: "Gegevensbescherming",
      ref: "https://www.miele.be/nl/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Ja, ik wil graag Club-advertentiecommunicatie ontvangen van Miele SAS (« Miele »), afgestemd op mijn persoonlijke interesses, per e-mail en post voor speciale aanbiedingen, informatie, uitnodigingen voor evenementen en klantenenquêtes over onze producten en diensten. Om dit te doen, geef ik Miele toestemming om mijn contactgegevens (titel, naam, e-mail, telefoon en postadres) te gebruiken en de communicatie aan te passen op basis van mijn koopgedrag en mijn gedrag met betrekking tot nieuwsbrieven, zoals gedetailleerder beschreven in {privacyLink} . Ik kan mijn toestemming op elk moment in de toekomst intrekken (bijvoorbeeld door een eenvoudige e-mail te sturen naar info{'@'}miele.fr, naar de contactgegevens vermeld in de wettelijke kennisgevingen of door op de afmeldlink in de e-mails te klikken). De contractuele communicatie van de Club {termsAndConditionLink} blijft onaangetast totdat het lidmaatschap wordt beëindigd.",
    shortDescription: "Ja, ik wil graag per e-mail en per post Club-advertentiecommunicatie ontvangen van Miele SAS (« Miele »), afgestemd op mijn persoonlijke interesses",
    privacyLink: {
      title: "Gegevensbescherming van Miele Club",
      href: "https://www.miele.be/nl/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubcommunicatie",
      href: "https://www.miele.be/nl/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.be"
  },
  selectAllConsents: {
    description: "Om lid te worden van de Miele Club, moet je akkoord gaan met alle voorwaarden *"
  }
}, Zm = "volledige verklaring tonen", Ym = "verklaring minder tonen", Xm = {
  auth: Um,
  changeEmailScene: $m,
  changePasswordScene: Bm,
  errors: Rm,
  forgotPassword: Vm,
  login: Fm,
  modal: qm,
  passwordStrength: Gm,
  passwordHelper: Km,
  register: Hm,
  "marketing-consent": {
    title: "Marketingvoorkeuren",
    description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, evenementen en hoe u het meeste uit uw toestel kunt halen.",
    submit: "Opslaan",
    newsletter: {
      text: "Ik ga ermee akkoord dat Miele België NV (‘Miele’) mij informatie over producten en nieuwe ontwikkelingen uit het Miele assortiment, evenementen, klantenenquêtes en recepten via e-mail, de Miele apps en sms toestuurt. Ook ga ik ermee akkoord dat Miele voor dit doeleinde de door mij verstrekte contactgegevens (aanspreking, naam, e-mailadres, telefoonnummer en postcode), de tot nu toe en in de toekomst door mij aangeschafte Miele producten en de door mij aangegeven interesses verwerkt. Daarnaast ga ik ermee akkoord dat Miele via de nieuwsbrief ontvangen ontvangst- en leesbevestigingen, informatie over de links waarop ik heb geklikt en mijn daaraan verbonden gebruikersgedrag op de website verwerkt met als doel betere personalisering. Hetzelfde geldt voor de in-app-pushberichten, voor zover de Miele apps worden gebruikt.",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    personalisation: {
      text: "Ik ga ermee akkoord dat Miele voor de uitgebreide personalisering informatie verwerkt over de door mij aangekochte diensten en herstellingsaanvragen en over evenementen waaraan ik heb deelgenomen. ",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Naast de uitgebreide personalisering ga ik ermee akkoord dat Miele gegevens uit het gebruik van de Miele app en uit mijn bezoeken aan de Miele website (www.miele.be) verwerkt om mijn profiel aan te vullen, voor zover ik heb toegestemd met de verwerking van deze gegevens.",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    highlightedText: {
      text: "U kunt op ieder moment de toestemming voor de verwerking van uw persoonsgegevens intrekken. Meer informatie over hoe Miele met uw persoonsgegevens omgaat, kunt u vinden in het Miele",
      link: {
        title: "privacybeleid.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
      link: {
        title: "Bekijk de gebruiksvoorwaarden*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Wm,
  mieleClub: Jm,
  readMore: Zm,
  readLess: Ym
}, Qm = {
  waitMessage: "Nesten der. "
}, ep = {
  buttonLabel: "Lagre",
  buttonLabelClose: "Lukk",
  confirmEmailMessage: "Bekreft e-postadressen din",
  copy: "For å oppdatere e-postadressen din, vennligst legg til den nye nedenfor:",
  errorMessageCopy: "Noe gikk galt. ",
  errorMessageHeadline: "Feil",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekreft din e-postadresse",
  inputEmailPlaceholder: "Epostadresse",
  invalidEmailMessage: "E-post ikke gyldig!",
  rememberMeLabel: "Husk meg",
  successMessageCopy: "E-postadressen din ble oppdatert.",
  successMessageHeadline: "E-postadresse oppdatert"
}, tp = {
  closeButtonLabel: "Lukk",
  confirmPasswordLabel: "bekreft passord",
  currentPasswordLabel: "Nåværende passord",
  newPasswordLabel: "Nytt passord",
  passwordMismatchError: "Passordet stemmer ikke",
  passwordUpdateErrorTitle: "Feil",
  passwordUpdateSuccessTitle: "Passord oppdatert",
  samePasswordError: "Dette passordet ble brukt tidligere, vennligst send inn et nytt passord",
  subtitle: "For å endre passordet ditt, fyll ut feltene nedenfor:",
  submitButtonLabel: "Sende inn",
  successfulChangeLabel: "Passordet ditt har blitt oppdatert",
  title: "Endring av passord"
}, ip = {
  invalidEmail: "ukorrekt email",
  invalidPassword: "Feil passord",
  sap_206002: "Kontoen din venter på bekreftelse. Jeg er redd vi ikke kan la deg fortsette for øyeblikket. ",
  sap_206006: "Det ser ut til at e-postadressen du sendte inn venter på bekreftelse",
  sap_400003: "Denne e-postadressen finnes allerede, vennligst bruk en annen e-postadresse!",
  sap_400028: "E-postadressen som er sendt inn venter på bekreftelse",
  sap_400050: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_400097: "Det ser ut til at du får tilgang til tjenestene våre fra en usikker/ustøttet nettleser. ",
  sap_401030: "Dette passordet ble brukt tidligere, vennligst send inn et nytt passord",
  sap_403005: "Vi har ikke en konto knyttet til denne e-postadressen, vennligst sjekk e-posten din og prøv igjen",
  sap_403011: "Sesjon utløpt. ",
  sap_403012: "Sesjon utløpt. ",
  sap_403013: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_403035: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_403041: "Vi har ikke en konto knyttet til denne e-postadressen, vennligst sjekk e-posten din og prøv igjen",
  sap_403042: "E-post",
  sap_403043: "E-post",
  sap_403047: "E-post",
  sap_403100: "En forespørsel om passordoppdatering er nylig forespurt, vennligst informer med oss ​​til forespørselen er behandlet",
  sap_403025: "Link for tilbakestilling av passord er ugyldig. Send forespørsel om glemt passord igjen for å motta en ny tilbakestillingslenke.",
  sapErrorTitle: "Feil under behandling av forespørsel",
  sessionExpired: "Sesjon utløpt",
  tooWeakPassword: "Passord må inneholde minst {minLength} tegn og {minCharGroups} av følgende: stor bokstav, liten bokstav, tall, spesialsymbol | Passord må inneholde minst {minLength} tegn",
  unexpectedDescription: "Hvis problemet vedvarer, ta kontakt med oss ​​via kontaktskjemaet med detaljer.",
  unexpectedTitle: "Det oppstod en uventet feil",
  unknownDescription: "Det oppstod en uventet feil. ",
  unknownTitle: "UH oh!"
}, ap = {
  subtitle: "Angi ditt nye passord.",
  title: "Glemt passordet?"
}, np = {
  headMetaDescription: "Kundepåloggingsside",
  headTitle: "Logg inn med e-post og passord:",
  subtitle: "Logg på eller opprett en konto for å få alle Miele-funksjonene.",
  title: "Logg inn på kontoen din",
  error: {
    invalidEmailPasswordDescription: "Kombinasjonen av e-postadresse og passord er ikke gyldig.",
    invalidEmailPasswordTitle: "Ugyldige legitimasjon",
    missingConcentTitle: "Konto venter på registrering",
    noAccountDescription: "Det er ingen konto knyttet til denne e-postadressen.",
    noAccountTitle: "Ingen konto registrert"
  },
  extraConsentScene: {
    continue: "Fortsette",
    privacyStatementCheckboxLabel: "Jeg har lagt merke til {0}.",
    privacyStatementName: "Personvernerklæring",
    privacyStatementTitle: "Våre retningslinjer for personvern er endret",
    termsOfUseCheckboxLabel: "Jeg godtar {0}.",
    termsOfUseName: "vilkår for bruk",
    termsOfUseTitle: "Våre vilkår for bruk er endret",
    title: "Fullføring av profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tilbake til innlogging",
    submitButtonLabel: "Sende inn",
    successDescription: "Vennligst sjekk e-posten din, du vil snart motta informasjonen på kontoen din for å starte med prosessen for tilbakestilling av passord.",
    successTitle: "Din forespørsel er mottatt.",
    title: "Vennligst skriv inn e-postadressen din for å tilbakestille passordet ditt:"
  },
  loginModalScene: {
    copy: "Logg på eller opprett en konto for å få alle Miele-funksjonene.",
    title: "Logg inn på kontoen din"
  },
  loginScene: {
    emailInputLabel: "E-post",
    forgotPwdButtonLabel: "Glemte passordet mitt",
    invalidEmailMessage: "E-post ikke gyldig!",
    loginButtonLabel: "Logg Inn",
    passwordInputLabel: "Passord",
    rememberMeLabel: "Husk meg",
    title: "Logg inn med e-post og passord:"
  }
}, sp = {
  accessibility: {
    close: "Lukk"
  }
}, op = {
  tooShort: "For kort",
  medium: "Middels",
  strong: "Sterk",
  tooWeak: "For svak",
  veryStrong: "Veldig sterk",
  weak: "Svak"
}, rp = {
  showPasswordText: "Vis",
  hidePasswordText: "Skjul"
}, lp = {
  registerButtonLabel: "registrere",
  registerTitle: "Har du ikke en konto?",
  whyRegister: {
    list: [
      "Tilgang til eksklusive fordeler fra Miele Club",
      "Registrere apparater, spore bestillinger, få tilgang til manualer",
      "Motta personlige tilbud og kampanjer",
      "Se alle dine bestillinger, garantier, arrangementer og tjenester"
    ],
    title: "Hvorfor registrere seg?"
  },
  closeButtonLabel: "Lukk",
  passwordMismatchError: "Passordene stemmer ikke",
  passwordUpdateErrorTitle: "Feil ved oppdatering av passord",
  passwordUpdateSuccessTitle: "Passord oppdatert",
  successfulChangeLabel: "Passordet ditt har blitt oppdatert"
}, cp = {
  title: "Markedsføringspreferanser",
  description: "Klikk nedenfor for å få eksklusive tilbud, nyheter, produktrådgivning m.m.",
  submit: "Lagre",
  levelOne: {
    shortText: 'Ja, jeg ønsker å motta markedsføringskommunikasjon fra Miele A/S og Miele & Cie. KG ("Miele") tilpasset mine personlige interesser via e-post, SMS, post og via Miele Apper (hvis brukt)',
    text: `Ja, jeg ønsker å motta markedsføringskommunikasjon fra Miele A/S og Miele & Cie. KG ("Miele") tilpasset mine personlige interesser via e-post, SMS, post og via Miele Apper (hvis brukt) med informasjon om produkter, tilbud og nyheter fra Mieles produktsortiment og om Miele-arrangementer/eventer, samt kundeundersøkelser, forespørsler om produktvurderinger og -anmeldelser og oppskrifter. Til dette formålet kan Miele bruke min kontaktinformasjon (navn, e-postadresse, mobiltelefonnummer og postadresse) og utforme kommunikasjonen basert på mine kjøp, tjenester, arrangementshistorikk, klikk- og åpningsatferd for nyhetsbrev samt kundeverdi, som beskrevet i detalj i vår personvernerklæring. Jeg kan når som helst trekke tilbake samtykket mitt uten å oppgi noen grunn med virkning for fremtiden (f.eks. ved å sende en uformell melding til info{'@'}miele.no, kontaktopplysningene som er oppgitt i imprintet eller ved å klikke på avmeldingslenken i e-postmeldinger).`,
    link: {
      title: "Personvern",
      ref: "https://www.miele.no/c/personvern-14.htm"
    }
  },
  levelTwo: {
    text: "I tillegg til mitt grunnleggende samtykke aksepterer jeg at Miele også kan behandle data fra bruken av Miele Appen og mine besøk på Mieles nettsider (www.miele.no), inkludert brukeratferd på Mieles nettsider etter klikk på lenkede nyhetsbrev, for å supplere min brukerprofil for personlig tilpasset reklamekommunikasjon, forutsatt at jeg har gitt et eget samtykke til databehandlingen i appen eller på nettsiden. Jeg kan når som helst trekke tilbake mitt samtykke uten å oppgi noen grunn med virkning for fremtiden. Mer informasjon finnes i Mieles personvernerklæring.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "I tillegg til mitt grunnleggende samtykke tillater jeg også at Miele kan behandle data fra mine tilkoblede Miele-produkter (data om bruk av produktet og -status) for å supplere min brukerprofil for personlig tilpasset reklame. Jeg finner mer informasjon om behandling av produktdata i personvernerklæringen til Miele{'@'}home-systemet. Jeg kan når som helst trekke tilbake mitt samtykke uten å oppgi noen grunn med virkning for fremtiden. Mer informasjon finnes i Mieles personvernerklæring.",
    link: {
      title: "Miele{'@'}home-systemet",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jeg godtar vilkårene for bruk.",
    link: {
      title: "Se vilkårene for bruk*",
      ref: "https://www.miele.no/c/vilkar-for-bruk-304.htm"
    }
  }
}, dp = {
  headline: "Miele Club",
  birthDateTitle: "Kan vi sende deg en bursdagsgave?",
  birthDateLabel: "Fødselsdato (frivillig)",
  why: {
    title: "Medlemskap uten kostnad - Eksklusive medlemstilbud.",
    reasons: [
      "Velkomstgave 10 % rabatt",
      "Bursdagsoverraskelse",
      "Eksklusive tilbud ",
      "Invitasjoner til eventer og opplevelser"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Skriv datoen i dette formatet: DD/MM/ÅÅÅÅ",
    errorMsg: "Ugyldig dato"
  },
  joinClubLabel: "Ja, jeg vil gjerne bli medlem av Miele Club.",
  termsAndCondition: {
    description: "Jeg samtykker til {termsAndConditionLink} til Miele Club, og bekrefter at jeg har lest og forstått Miele Clubs {privacyLink}.",
    termsAndConditionLink: {
      title: "medlems- og bruksvilkårene",
      ref: "https://www.miele.no/c/vilkar-og-betingelser-13.htm"
    },
    privacyLink: {
      title: "personvernerklæring",
      ref: "https://www.miele.no/c/personvern-14.htm"
    }
  },
  newsletter: {
    description: "Ja, jeg ønsker å motta Miele Club reklamekommunikasjon som er tilpasset mine personlige interesser fra selskapet Miele A/S («Miele») per e-post og post. Den omfatter spesialtilbud, informasjon, invitasjoner til eventer og kundeundersøkelser om våre produkter og tjenesteytelser. Miele kan i den forbindelse benytte mine kontaktopplysninger (navn, e-postadresse og postadresse) og tilpasse kommunikasjonen basert på min kjøps- og nyhetsbrevatferd, samt min kundeverdi, slik det er beskrevet mer i detalj i Miele Clubs {privacyLink}. Jeg kan til enhver tid trekke tilbake mitt samtykke med fremtidig virkning (for eksempel i en uformell melding til info{'@'}miele.no, kontaktopplysningene som er angitt i vårt impressum eller ved å klikke på avmeldingslenken i e-poster). Den avtalefestede {termsAndConditionLink} forblir upåvirket av dette frem til medlemskapet sies opp.",
    shortDescription: "Ja, jeg ønsker å motta Miele Club reklamekommunikasjon som er tilpasset mine personlige interesser fra selskapet Miele A/S («Miele») per e-post og post",
    privacyLink: {
      title: "personvernerklæring",
      href: "https://www.miele.no/c/personvern-14.htm"
    },
    termsAndConditionLink: {
      title: "klubbkommunikasjonen",
      href: "https://www.miele.no/c/vilkar-og-betingelser-13.htm"
    },
    supportEmail: "info{'@'}miele.no"
  },
  selectAllConsents: {
    description: "For å bli medlem av Miele Klubben, må du godta alle vilkår og betingelser *"
  }
}, up = "vis mer", mp = "vis mindre", pp = {
  auth: Qm,
  changeEmailScene: ep,
  changePasswordScene: tp,
  errors: ip,
  forgotPassword: ap,
  login: np,
  modal: sp,
  passwordStrength: op,
  passwordHelper: rp,
  register: lp,
  "marketing-consent": {
    title: "Markedsføringspreferanser",
    description: "Kryss av nedenfor for eksklusive tilbud, nyheter, arrangementer og hvordan du får mest mulig ut av apparatet ditt.",
    submit: "Lagre",
    newsletter: {
      text: "Jeg samtykker i at Miele AS («Miele») kan sende meg informasjon om produkter og nyheter fra Mieles sortiment og om Mieles arrangementer, kundeundersøkelser, produktvurderinger and anmeldelser og oppskrifter via e-post, Miele-apper og SMS. Til dette formålet vil Miele benytte kontaktinformasjonen (navn, e-postadresse, mobilnummer og adresse) jeg har oppgitt.",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    personalisation: {
      text: "Jeg godtar at Miele kan behandle informasjon om tjenestene jeg har brukt og teknikeroppdrag jeg har utført, samt arrangementer jeg har deltatt på, med det formål å forbedre personlig tilpasning.",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "I tillegg til den utvidede personaliseringen godtar jeg at Miele også kan behandle data fra bruken av Miele-appen og mine besøk på Mieles nettsteder (www.miele.co.uk) for å supplere brukerprofilen min, forutsatt at jeg har samtykket separat. ",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jeg kan tilbakekalle mitt samtykke når som helst uten å oppgi grunner med virkning for fremtiden.  ",
      link: {
        title: "retningslinjer for databeskyttelse.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jeg godtar vilkårene for bruk.",
      link: {
        title: "Se vilkårene for bruk*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: cp,
  mieleClub: dp,
  readMore: up,
  readLess: mp
}, gp = {
  waitMessage: "Quase lá. "
}, hp = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Fechar",
  confirmEmailMessage: "Confirme seu endereço de e-mail",
  copy: "Para atualizar seu endereço de e-mail, adicione o novo abaixo:",
  errorMessageCopy: "Ocorreu um erro.",
  errorMessageHeadline: "Erro",
  headline: "Detalhes de perfil",
  inputEmailConfirmPlaceholder: "Confirme seu endereço de e-mail",
  inputEmailPlaceholder: "Endereço de email",
  invalidEmailMessage: "Email inválido!",
  rememberMeLabel: "Lembre de mim",
  successMessageCopy: "O seu endereço de e-mail foi atualizado com sucesso.",
  successMessageHeadline: "Endereço de email atualizado"
}, vp = {
  closeButtonLabel: "Fechar",
  confirmPasswordLabel: "Confirme a sua palavra-passe",
  currentPasswordLabel: "Senha atual",
  newPasswordLabel: "Nova Senha",
  passwordMismatchError: "Senha não corresponde",
  passwordUpdateErrorTitle: "Erro",
  passwordUpdateSuccessTitle: "palavra-passe atualizada",
  samePasswordError: "Esta palavra-passe foi utilizada anteriormente, envie uma nova palavra-passe",
  subtitle: "Para alterar a sua palavra-passe, por favor preencha os campos abaixo:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "A sua palavra-passe foi atualizada com sucesso",
  title: "Mudança de palavra-passe"
}, fp = {
  invalidEmail: "e-mail incorreto",
  invalidPassword: "Senha incorreta",
  sap_206002: "A sua conta está com verificação pendente. Infelizmente, não podemos permitir que você continue no momento.",
  sap_206006: "Parece que o endereço de e-mail que você enviou está com verificação pendente",
  sap_400003: "Este e-mail já existe, por favor, use um endereço de e-mail diferente!",
  sap_400028: "O endereço de e-mail enviado está com verificação pendente",
  sap_400050: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_400097: "Parece que você está acedendo aos nossos serviços através de um navegador inseguro/sem suporte.",
  sap_401030: "Esta palavra-passe foi usada anteriormente, por favor, envie uma nova palavra-passe",
  sap_403005: "Não temos uma conta associada a este endereço de e-mail, verifique o seu e-mail e tente novamente",
  sap_403011: "Sessão expirada.",
  sap_403012: "Sessão expirada.",
  sap_403013: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_403035: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_403041: "Não temos uma conta associada a este endereço de e-mail, verifique o seu e-mail e tente novamente",
  sap_403042: "E-mail",
  sap_403043: "E-mail",
  sap_403047: "E-mail",
  sap_403100: "Uma solicitação de atualização de palavra-passe foi solicitada recentemente, por favor, fique connosco até que a solicitação seja processada",
  sap_403025: "Link de redefinição de palavra-passe inválido.",
  sapErrorTitle: "Solicitação de processamento de erro",
  sessionExpired: "Sessão expirada",
  tooWeakPassword: "A palavra-passe deve conter pelo menos {minLength} caracteres e {minCharGroups} dos seguintes: letra maiúscula, letra minúscula, número, símbolo especial | A palavra-passe deve conter pelo menos {minLength} caracteres",
  unexpectedDescription: "Se o problema persistir, entre em contacto connosco através do formulário de contacto com detalhes.",
  unexpectedTitle: "Ocorreu um erro inesperado",
  unknownDescription: "Ocorreu um erro inesperado.",
  unknownTitle: "Oh não!"
}, kp = {
  subtitle: "Defina a sua nova palavra-passe.",
  title: "Esqueceu a sua palavra-passe?"
}, bp = {
  headMetaDescription: "página de login do cliente",
  headTitle: "Faça login com o seu e-mail e palavra-passe:",
  subtitle: "Inicie sessão ou crie uma conta para obter todas as funcionalidades Miele.",
  title: "Faça login na sua conta",
  error: {
    invalidEmailPasswordDescription: "A combinação de endereço de e-mail e palavra-passe não é válida.",
    invalidEmailPasswordTitle: "Credenciais inválidas",
    missingConcentTitle: "Registro pendente de conta",
    noAccountDescription: "Não há nenhuma conta associada a este endereço de e-mail.",
    noAccountTitle: "Nenhuma conta cadastrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "Tomei nota do {0}.",
    privacyStatementName: "declaração de privacidade",
    privacyStatementTitle: "Nossa Política de Privacidade mudou",
    termsOfUseCheckboxLabel: "Eu concordo com os {0}.",
    termsOfUseName: "termos de uso",
    termsOfUseTitle: "Os nossos Termos de Uso mudaram",
    title: "Conclusão do perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volte ao login",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, verifique o seu e-mail, você receberá em breve as informações da sua conta para iniciar o processo de redefinição de palavra-passe.",
    successTitle: "O seu pedido foi recebido.",
    title: "Digite o seu endereço de e-mail para redefinir a sua palavra-passe:"
  },
  loginModalScene: {
    copy: "Inicie sessão ou crie uma conta para obter todas as funcionalidades Miele.",
    title: "Faça login na sua conta"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Esqueci-me da palavra-passe",
    invalidEmailMessage: "Email inválido!",
    loginButtonLabel: "Iniciar sessão",
    passwordInputLabel: "Palavra-passe",
    rememberMeLabel: "Lembre-se de mim",
    title: "Faça login com o seu e-mail e palavra-passe:"
  }
}, wp = {
  accessibility: {
    close: "Fechar"
  }
}, yp = {
  tooShort: "Muito curta",
  medium: "Média",
  strong: "Forte",
  tooWeak: "Muito fraco",
  veryStrong: "Muito forte",
  weak: "Fraco"
}, Mp = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Esconder"
}, zp = {
  registerButtonLabel: "registo",
  registerTitle: "Não tem uma conta?",
  whyRegister: {
    list: [
      "Acesso a vantagens exclusivas do Miele Club",
      "Registe eletrodomésticos, rastreie pedidos, aceda a manuais",
      "Receba ofertas e promoções personalizadas",
      "Veja todos os seus pedidos, garantias, eventos e serviços"
    ],
    title: "Vantagens do registo"
  },
  closeButtonLabel: "Fechar",
  passwordMismatchError: "As palavras-passe não combinam",
  passwordUpdateErrorTitle: "Erro de atualização de palavra-passe",
  passwordUpdateSuccessTitle: "palavra-passe atualizada",
  successfulChangeLabel: "A sua palavra-passe foi atualizada com sucesso"
}, jp = {
  title: "Preferências de marketing",
  description: "Assinale abaixo para obter promoções exclusivas, notícias, conselhos sobre produtos e muito mais.",
  submit: "Salvar",
  levelOne: {
    shortText: 'Sim, gostaria de receber comunicações promocionais da Miele Portuguesa, Lda e da Miele & Cie. KG ("Miele") adaptadas aos meus interesses pessoais por e-mail, SMS, correio e através das aplicações da Miele (se utilizadas)',
    text: `Sim, gostaria de receber comunicações promocionais da Miele Portuguesa, Lda e da Miele & Cie. KG ("Miele") adaptadas aos meus interesses pessoais por e-mail, SMS, correio e através das aplicações da Miele (se utilizadas) com informações sobre produtos, ofertas e inovações dos produtos Miele e sobre eventos Miele, bem como inquéritos a clientes, pedidos de classificação e avaliação de produtos e receitas. Para tal, a Miele pode utilizar os meus dados de contacto (forma de tratamento, nome, endereço de correio eletrónico, número de telemóvel e morada) e conceber a comunicação com base na minha compra, serviço, histórico de eventos, comportamento de clique e abertura da newsletters, bem como no valor do cliente, conforme descrito em detalhe na nossa política de privacidade. Posso revogar o meu consentimento a qualquer momento, sem necessidade de indicar os motivos, com efeito futuro (por exemplo, ao enviar uma mensagem informal para info{'@'}miele.pt, para os dados de contacto indicados na ficha técnica ou ao clicar na ligação de cancelamento da subscrição nos e-mails).`,
    link: {
      title: "Proteção de dados",
      ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    }
  },
  levelTwo: {
    text: "Para além do meu consentimento básico, concordo que a Miele também pode processar dados da utilização da aplicação Miele e das minhas visitas aos sites da Miele (www.miele.pt), incluindo o comportamento do utilizador nos sites da Miele após cliques na newsletter, para complementar o meu perfil de utilizador para comunicações publicitárias personalizadas, desde que o meu consentimento separado na aplicação ou no site autorize o processamento de dados. Posso revogar o meu consentimento a qualquer momento, sem indicação dos motivos, com efeito futuro. Para obter mais informações, consulte a política de proteção de dados da Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Para além do meu consentimento básico, concordo que a Miele também pode processar dados dos meus aparelhos Miele ligados em rede (dados sobre a utilização e estado dos aparelhos) para complementar o meu perfil de utilizador para publicidade personalizada. Para obter mais informações sobre o processamento de dados a partir de aparelhos, consulte a política de privacidade do sistema Miele{'@'}home. Posso revogar o meu consentimento em qualquer momento, sem necessidade de justificação, com efeito futuro. Para obter mais informações, consulte a política de proteção de dados da Miele.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Posso revogar o meu consentimento a qualquer momento sem apresentar motivos com efeitos para o futuro.",
    link: {
      title: "política de proteção de dados.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sim, eu concordo com os termos de uso.",
    link: {
      title: "Consulte os Termos de Uso*",
      ref: ""
    }
  }
}, _p = {
  headline: "Miele Club",
  why: {
    title: "Adesão gratuit - Vantagens e ofertas exclusivas para membros.",
    reasons: [
      "Voucher de boas-vindas com 10 % de desconto em acessórios e consumíveis na sua próxima compra. Consulte as condições em www.miele.pt/e/miele-club",
      "Surpresa de aniversário",
      "Ofertas e promoções exclusivas",
      "Convites para eventos e experiências exclusivas"
    ]
  },
  birthDateTitle: "Gostaria de receber uma surpresa de aniversário?",
  birthDateLabel: "Data de nascimento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduza a data no seguinte formato: DD/MM/AAAA",
    errorMsg: "Data incorrecta"
  },
  joinClubLabel: "Sim, gostaria de aderir ao Miele Club",
  termsAndCondition: {
    description: "Concordo com os {termsAndConditionLink} e confirmo que li a informação sobre a {privacyLink} do Clube Miele.",
    termsAndConditionLink: {
      title: "Termos e Condições de Participação e Utilização",
      ref: "https://www.miele.pt/c/condicoes-gerais-13.htm#p7613"
    },
    privacyLink: {
      title: "Regulamentos de proteção de dados",
      ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sim, gostaria de receber comunicações sobre o Miele Club adaptadas aos meus interesses pessoais pela Miele Portuguesa («Miele») por e-mail e correio",
    description: "Sim, gostaria de receber comunicações sobre o Miele Club adaptadas aos meus interesses pessoais pela Miele Portuguesa («Miele») por e-mail e correio com promoções especiais, informações de produto, convites para eventos e inquéritos sobre os produtos e serviços da Miele. Para tal, a Miele pode utilizar os meus dados de contacto (forma de tratamento, nome, e-mail e endereço postal) e criar comunicações com base no meu comportamento de compra e de abertura de newsletters e encomendas, tal como descrito com mais detalhe na nossa {privacyLink}. Posso revogar em qualquer altura o meu consentimento com efeito futuro (por ex., com uma mensagem para info{'@'}miele.pt, para os dados de contacto indicados na ficha técnica, ou ao clicar na ligação de cancelamento da subscrição nos e-mails). A comunicação contratual do {termsAndConditionLink} mantém-se inalterada até ao cancelamento da adesão.",
    privacyLink: {
      title: "Política de privacidade",
      href: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    },
    termsAndConditionLink: {
      title: "Miele Club",
      href: "https://www.miele.pt/c/condicoes-gerais-13.htm#p7613"
    },
    supportEmail: "info{'@'}miele.pt"
  },
  selectAllConsents: {
    description: "Para aderir ao Clube Miele, deve aceitar todos os termos e condições *"
  }
}, Ep = "mostrar declaração completa", Sp = "ocultar declaração completa", Lp = {
  auth: gp,
  changeEmailScene: hp,
  changePasswordScene: vp,
  errors: fp,
  forgotPassword: kp,
  login: bp,
  modal: wp,
  passwordStrength: yp,
  passwordHelper: Mp,
  register: zp,
  "marketing-consent": {
    title: "Preferências de marketing",
    description: "Marque abaixo para ofertas exclusivas, notícias, eventos e como obter o máximo do seu eletrodoméstico.",
    submit: "Salvar",
    newsletter: {
      text: 'Concordo que a Miele Portuguesa ("Miele") me envie informações sobre produtos e inovações da gama de produtos Miele e sobre eventos Miele, bem como inquéritos a clientes, avaliações e críticas a produtos e receitas por e-mail, aplicações Miele e SMS e que a Miele possa processar os dados de contacto que indiquei (título, nome, endereço de e-mail, número de telemóvel e código postal) e os produtos Miele que comprei até à data e que irei comprar no futuro bem como os interesses que indiquei para este fim. Concordo ainda que a Miele possa também processar as confirmações de receção e leitura recebidas através da newsletter e informações sobre os links em que cliquei, bem como o meu comportamento de utilizador no site ligado para fins de personalização. O mesmo se aplica às mensagens push in-app, desde que sejam utilizadas as aplicações Miele. ',
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    personalisation: {
      text: "Concordo que a Miele processe informações sobre os serviços que utilizei e as tarefas técnicas que realizei, bem como eventos em que participei, para fins de personalização aprimorada.",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Além da personalização alargada, concordo que a Miele também possa processar dados da utilização da aplicação Miele e das minhas visitas aos sites da Miele (www.miele.co.uk) para complementar o meu perfil de utilizador, desde que eu tenha consentido separadamente ",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    highlightedText: {
      text: "Posso revogar o meu consentimento a qualquer momento sem apresentar motivos com efeitos para o futuro.  ",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    termsOfUse: {
      text: "Sim, eu concordo com os termos de uso.",
      link: {
        title: "Consulte os Termos de Uso*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: jp,
  mieleClub: _p,
  readMore: Ep,
  readLess: Sp
}, Cp = {
  waitMessage: "Nästan där. "
}, Pp = {
  buttonLabel: "Spara",
  buttonLabelClose: "Stänga",
  confirmEmailMessage: "Bekräfta din e-postadress",
  copy: "För att uppdatera din e-postadress, lägg till den nya nedan:",
  errorMessageCopy: "Något gick fel. ",
  errorMessageHeadline: "Fel",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekräfta Din E-postadress",
  inputEmailPlaceholder: "E-postadress",
  invalidEmailMessage: "E-post inte giltig!",
  rememberMeLabel: "Kom ihåg mig",
  successMessageCopy: "Din e-postadress har uppdaterats.",
  successMessageHeadline: "E-postadress uppdaterad"
}, Tp = {
  closeButtonLabel: "Stänga",
  confirmPasswordLabel: "Bekräfta lösenord",
  currentPasswordLabel: "Nuvarande lösenord",
  newPasswordLabel: "nytt lösenord",
  passwordMismatchError: "Lösenordet matchar inte",
  passwordUpdateErrorTitle: "Fel",
  passwordUpdateSuccessTitle: "lösenord uppdaterat",
  samePasswordError: "Detta lösenord användes tidigare, vänligen skicka in ett nytt lösenord",
  subtitle: "För att ändra ditt lösenord, fyll i fälten nedan:",
  submitButtonLabel: "Skicka in",
  successfulChangeLabel: "Ditt lösenord har uppdaterats",
  title: "Lösenordsändring"
}, Ap = {
  invalidEmail: "Felaktig e-post",
  invalidPassword: "Fel lösenord",
  sap_206002: "Ditt konto väntar på verifiering, jag är rädd att vi inte kan låta dig fortsätta just nu. ",
  sap_206006: "Det verkar som att e-postadressen du skickade in väntar på verifiering",
  sap_400003: "Denna e-postadress finns redan, använd en annan e-postadress!",
  sap_400028: "Den skickade e-postadressen väntar på verifiering",
  sap_400050: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_400097: "Det verkar som att du använder våra tjänster från en osäker/inte stödd webbläsare. ",
  sap_401030: "Detta lösenord användes tidigare, vänligen skicka in ett nytt lösenord",
  sap_403005: "Vi har inget konto kopplat till den här e-postadressen, kontrollera din e-post och försök igen",
  sap_403011: "Sessionen löpte. ",
  sap_403012: "Sessionen löpte. ",
  sap_403013: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_403035: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_403041: "Vi har inget konto kopplat till den här e-postadressen, kontrollera din e-post och försök igen",
  sap_403042: "E-post",
  sap_403043: "E-post",
  sap_403047: "E-post",
  sap_403100: "En begäran om lösenordsuppdatering har nyligen begärts, vänligen kontakta oss tills begäran har behandlats",
  sap_403025: "Återställ lösenordslänken är ogiltig, skicka förfrågan om glömt lösenord igen för att få en ny återställningslänk.",
  sapErrorTitle: "Fel vid behandling av begäran",
  sessionExpired: "Sessionen löpte",
  tooWeakPassword: "Lösenordet måste innehålla minst {minLength} tecken och {minCharGroups} av följande tecken: stor bokstav, liten bokstav, siffra, specialsymbol | Lösenordet måste innehålla minst {minLength} tecken",
  unexpectedDescription: "Om problemet kvarstår vänligen kontakta oss via kontaktformuläret med information.",
  unexpectedTitle: "Ett oväntat fel inträffade",
  unknownDescription: "Oväntat fel uppstod. ",
  unknownTitle: "Hoppsan!"
}, xp = {
  subtitle: "Ställ in ditt nya lösenord.",
  title: "Glömt ditt lösenord?"
}, Ip = {
  headMetaDescription: "Kundinloggningssida",
  headTitle: "Logga in med din e-postadress och ditt lösenord:",
  subtitle: "Logga in eller skapa ett konto för att få alla Mieles funktioner.",
  title: "Logga in på ditt konto",
  error: {
    invalidEmailPasswordDescription: "Kombinationen av e-postadress och lösenord är inte giltig.",
    invalidEmailPasswordTitle: "Ogiltiga uppgifter",
    missingConcentTitle: "Konto väntar på registrering",
    noAccountDescription: "Det finns inget konto kopplat till den här e-postadressen.",
    noAccountTitle: "Inget konto registrerat"
  },
  extraConsentScene: {
    continue: "Fortsätta",
    privacyStatementCheckboxLabel: "Jag har noterat {0}.",
    privacyStatementName: "sekretesspolicy",
    privacyStatementTitle: "Vår integritetspolicy har ändrats",
    termsOfUseCheckboxLabel: "Jag godkänner {0}.",
    termsOfUseName: "villkor",
    termsOfUseTitle: "Våra användarvillkor har ändrats",
    title: "Profilkomplettering"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tillbaka till login",
    submitButtonLabel: "Skicka in",
    successDescription: "Vänligen kontrollera din e-post, du kommer snart att få information om ditt konto för att börja med processen för återställning av lösenord.",
    successTitle: "Din förfrågan har mottagits.",
    title: "Ange din e-postadress för att återställa ditt lösenord:"
  },
  loginModalScene: {
    copy: "Logga in eller skapa ett konto för att få alla Mieles funktioner.",
    title: "Logga in på ditt konto"
  },
  loginScene: {
    emailInputLabel: "E-post",
    forgotPwdButtonLabel: "Glömde mitt lösenord",
    invalidEmailMessage: "E-post inte giltig!",
    loginButtonLabel: "Logga in",
    passwordInputLabel: "Lösenord",
    rememberMeLabel: "Kom ihåg mig",
    title: "Logga in med din e-postadress och ditt lösenord:"
  }
}, Dp = {
  accessibility: {
    close: "Stänga"
  }
}, Np = {
  tooShort: "För kort",
  medium: "Medel",
  strong: "Stark",
  tooWeak: "För svag",
  veryStrong: "Väldigt stark",
  weak: "Svag"
}, Op = {
  showPasswordText: "Visa",
  hidePasswordText: "Dölj"
}, Up = {
  registerButtonLabel: "Registrera",
  registerTitle: "Har du inget konto?",
  whyRegister: {
    list: [
      "Tillgång till exklusiva förmåner från Miele Club",
      "Registrera apparater, spåra beställningar, få tillgång till manualer",
      "Få personliga erbjudanden och kampanjer",
      "Se alla dina beställningar, garantier, evenemang och tjänster"
    ],
    title: "Varför registrera sig?"
  },
  closeButtonLabel: "Stänga",
  passwordMismatchError: "Lösenorden stämmer inte överens",
  passwordUpdateErrorTitle: "Lösenordsuppdateringsfel",
  passwordUpdateSuccessTitle: "lösenord uppdaterat",
  successfulChangeLabel: "Ditt lösenord har uppdaterats"
}, $p = {
  title: "Marknadsföringspreferenser",
  description: "Markera nedan för exklusiva erbjudanden, nyheter, evenemang och hur du får ut det mesta av din apparat.",
  submit: "Spara",
  levelOne: {
    shortText: 'Ja, jag vill gärna få reklammeddelanden från Miele AB och Miele & Cie. KG ("Miele") som är anpassad till mina personliga intressen via e-post, textmeddelande, post och via Miele-appar (om de används)',
    text: `Ja, jag vill gärna få reklammeddelanden från Miele AB och Miele & Cie. KG ("Miele") som är anpassad till mina personliga intressen via e-post, textmeddelande, post och via Miele-appar (om de används) med information om produkter, erbjudanden och innovationer från Mieles produktsortiment och om Miele-evenemang samt kundundersökningar, begäran om produktbetyg och recensioner samt recept. För detta ändamål kan Miele använda mina kontaktuppgifter (titel, namn, e-postadress, mobiltelefonnummer och postadress) och utforma kommunikationen baserat på mina köp, tjänster, händelsehistorik, klick- och öppningsbeteende för nyhetsbrev samt kundvärde, vilket beskrivs i detalj i vår integritetspolicy. Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden (t.ex. genom att skicka ett informellt meddelande till info{'@'}miele.se, de kontaktuppgifter som anges i avtrycket eller genom att klicka på länken för avregistrering i e-postmeddelanden).`,
    link: {
      title: "Integritetspolicy",
      ref: "https://www.miele.se/c/integritetspolicy-14.htm"
    }
  },
  levelTwo: {
    text: "Utöver mitt grundläggande samtycke samtycker jag till att Miele även får behandla data från användningen av Miele-appen och mina besök på Mieles webbplatser (www.miele.se), inklusive användarbeteende på Mieles webbplatser efter klick på länkade nyhetsbrev, för att komplettera min användarprofil för personlig reklamkommunikation, förutsatt att mitt separata samtycke i appen eller på webbplatsen frigör databehandlingen. Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden. Ytterligare information finns i Mieles dataskyddspolicy.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Utöver mitt grundläggande samtycke samtycker jag till att Miele även får behandla data från mina anslutna Miele-produkter (data om produkternasanvändning och status) för att komplettera min användarprofil för personlig reklam. Mer information om behandlingen av produktdata hittar jag i sekretesspolicyn för Miele{'@'}Home-systemet. Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden. Ytterligare information finns i Mieles dataskyddspolicy.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jag godkänner användarvillkoren.",
    link: {
      title: "Se användarvillkoren*",
      ref: "https://www.miele.se/c/anvandarvillkor-304.htm"
    }
  }
}, Bp = {
  headline: "Miele Club",
  why: {
    title: "Medlemskap utan kostnad - Exklusiva erbjudanden för medlemmar.",
    reasons: [
      "Välkomstgåva 10 % rabatt",
      "Födelsedagsöverraskning",
      "Exklusiva erbjudanden",
      "Inbjudningar till event & upplevelser "
    ]
  },
  birthDateTitle: "Får vi skicka en födelsedagspresent till dig?",
  birthDateLabel: "Födelsedatum (frivilligt)",
  birthDateValidation: {
    requirementMsg: "Ange datumformat DD/MM/ÅÅÅÅ",
    errorMsg: "Ogiltigt datum"
  },
  joinClubLabel: "Ja, jag vill gå med i Miele Club.",
  termsAndCondition: {
    description: "Jag godkänner Miele Club {termsAndConditionLink} och har tagit del av {privacyLink} gällande Miele Club.",
    termsAndConditionLink: {
      title: "medlems- och användarvillkor",
      ref: "https://www.miele.se/c/allmanna-villkor-13.htm"
    },
    privacyLink: {
      title: "integritetspolicyn",
      ref: "https://www.miele.se/c/integritetspolicy-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Ja, jag vill få klubbkommunikation från Miele AB (”Miele”) som har skräddarsytts utifrån mina personliga intressen via e-post och post",
    description: "Ja, jag vill få klubbkommunikation från Miele AB (”Miele”) som har skräddarsytts utifrån mina personliga intressen via e-post och post med specialerbjudanden, information, inbjudan till evenemang samt kundundersökningar om våra produkter och tjänster. För detta ändamål kan Miele använda mina kontaktuppgifter (namn, e-postadress och postadress) och utforma kommunikation baserat på mitt köpbeteende, mina interaktioner med nyhetsbrev samt mitt kundvärde, vilket beskrivs mer i detalj i {privacyLink}. Jag kan när som helst återkalla mitt samtycke med framtida verkan (t. ex. genom att skicka ett informellt meddelande till info{'@'}miele.se, eller genom att använda kontaktuppgifterna under Miele AB eller genom att klicka på avregistreringslänken i e-postmeddelanden). Den avtalsenliga {termsAndConditionLink} förblir opåverkad tills medlemskapet avslutas. ",
    privacyLink: {
      title: "integritetspolicyn för vår kundklubb",
      href: "https://www.miele.se/c/integritetspolicy-14.htm"
    },
    termsAndConditionLink: {
      title: "kommunikationen från kundklubben",
      href: "https://www.miele.se/c/allmanna-villkor-13.htm"
    },
    supportEmail: "info{'@'}miele.se"
  },
  selectAllConsents: {
    description: "För att gå med i Miele-klubben måste du acceptera alla villkor *"
  }
}, Rp = "visa hela texten", Vp = "dölja hela texten", Fp = {
  auth: Cp,
  changeEmailScene: Pp,
  changePasswordScene: Tp,
  errors: Ap,
  forgotPassword: xp,
  login: Ip,
  modal: Dp,
  passwordStrength: Np,
  passwordHelper: Op,
  register: Up,
  "marketing-consent": {
    title: "Marknadsföringspreferenser",
    description: "Markera nedan för exklusiva erbjudanden, nyheter, evenemang och hur du får ut det mesta av din apparat.",
    submit: "Spara",
    newsletter: {
      text: "Jag godkänner att Miele AB (“Miele”) skickar information om produkter och nyheter från Mieles sortiment och om Miele-evenemang samt kundundersökningar, produktomdömen och betyg och recept till mig via e-post, Mieles appar och sms. För att göra detta får Miele behandla de kontaktuppgifter som jag har angett (titel, namn, e-postadress, mobiltelefonnummer och postnummer) och de Miele-produkter som jag har köpt hittills och kommer att köpa i framtiden samt de intressen som jag har angett.",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    personalisation: {
      text: "Jag samtycker till att Miele får behandla information om de tjänster jag har använt och teknikeruppdrag jag har utfört, samt event som jag har deltagit i, i syfte att förbättra personaliseringen.",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Utöver den utökade personaliseringen samtycker jag till att Miele även kan behandla data från användningen av Miele-appen och mina besök på Mieles webbplatser (www.miele.co.uk) för att komplettera min användarprofil, förutsatt att jag har gett separat samtycke ",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden.  ",
      link: {
        title: "dataskyddspolicy.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jag godkänner användarvillkoren.",
      link: {
        title: "Se användarvillkoren*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: $p,
  mieleClub: Bp,
  readMore: Rp,
  readLess: Vp
}, qp = {
  waitMessage: "Skoraj tam. "
}, Gp = {
  buttonLabel: "Shrani",
  buttonLabelClose: "Zapri",
  confirmEmailMessage: "Potrdite svoj e-poštni naslov",
  copy: "Če želite posodobiti svoj e-poštni naslov, dodajte novega spodaj:",
  errorMessageCopy: "Nekaj ​​je šlo narobe. Poskusite znova ",
  errorMessageHeadline: "Napaka",
  headline: "Podrobnosti profila",
  inputEmailConfirmPlaceholder: "Potrdite Svoj Elektronski Naslov",
  inputEmailPlaceholder: "E-poštni naslov",
  invalidEmailMessage: "E-poštni naslov ni veljaven!",
  rememberMeLabel: "Zapomni si me",
  successMessageCopy: "Vaš e-poštni naslov je bil uspešno posodobljen.",
  successMessageHeadline: "E-poštni naslov posodobljen"
}, Kp = {
  closeButtonLabel: "Zapri",
  confirmPasswordLabel: "Potrdi geslo",
  currentPasswordLabel: "Trenutno geslo",
  newPasswordLabel: "novo geslo",
  passwordMismatchError: "Geslo se ne ujema",
  passwordUpdateErrorTitle: "Napaka",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  samePasswordError: "To geslo je bilo že uporabljeno, prosimo, pošljite novo geslo",
  subtitle: "Za spremembo gesla izpolnite spodnja polja:",
  submitButtonLabel: "Oddaj",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno",
  title: "Sprememba gesla"
}, Hp = {
  invalidEmail: "Napačen e-poštni naslov",
  invalidPassword: "Napačno geslo",
  sap_206002: "Vaš račun čaka na preverjanje, vam trenutno ne moremo dovoliti nadaljevanja.  Prosim stopite v stik z nami za več informacij",
  sap_206006: "Videti je, da e-poštni naslov, ki ste ga poslali, čaka na preverjanje",
  sap_400003: "Ta e-poštni naslov že obstaja, uporabite drug e-poštni naslov.",
  sap_400028: "Poslani e-poštni naslov čaka na preverjanje",
  sap_400050: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_400097: "Videti je, da do naših storitev dostopate iz nevarnega/nepodprtega brskalnika. Prosim poizkusite ponovno z drugim brskalnikom",
  sap_401030: "To geslo je bilo že uporabljeno, prosimo, vnesite novo geslo",
  sap_403005: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403011: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite. ",
  sap_403012: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite.",
  sap_403013: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403035: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403041: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403042: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403043: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403047: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403100: "Zahteva za posodobitev gesla je bila nedavno zahtevana, prosimo počakajte, dokler zahteva ne bo obdelana",
  sap_403025: "Povezava za ponastavitev gesla je neveljavna, ponovno pošljite zahtevo za pozabljeno geslo, da prejmete novo povezavo za ponastavitev.",
  sapErrorTitle: "Napaka pri obdelavi zahteve",
  sessionExpired: "Seja je potekla",
  tooWeakPassword: "Geslo mora vsebovati vsaj {minLength} znakov in {minCharGroups} od naslednjega: velika črka, mala črka, številka, poseben simbol | Geslo mora vsebovati vsaj {minLength} znakov",
  unexpectedDescription: "Če se težava ponovi, se obrnite na nas prek kontaktnega obrazca in navedite podrobnosti.",
  unexpectedTitle: "Prišlo je do nepričakovane napake",
  unknownDescription: "Prišlo je do nepričakovane napake. ",
  unknownTitle: "Ojoj!"
}, Wp = {
  subtitle: "Nastavite novo geslo.",
  title: "Ste pozabili geslo?"
}, Jp = {
  headMetaDescription: "Stran za prijavo stranke",
  headTitle: "Prijavite se s svojim e-poštnim naslovom in geslom:",
  subtitle: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
  title: "Prijavite se v svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija e-poštnega naslova in gesla ni veljavna.",
    invalidEmailPasswordTitle: "Neveljavne poverilnice",
    missingConcentTitle: "Račun čaka na registracijo",
    noAccountDescription: "S tem e-poštnim naslovom ni povezan noben račun.",
    noAccountTitle: "Ni registriranega računa"
  },
  extraConsentScene: {
    continue: "Nadaljuj",
    privacyStatementCheckboxLabel: "Upošteval sem {0}.",
    privacyStatementName: "izjava o zasebnosti",
    privacyStatementTitle: "Naš pravilnik o zasebnosti se je spremenil",
    termsOfUseCheckboxLabel: "Strinjam se z {0}.",
    termsOfUseName: "pogoji uporabe",
    termsOfUseTitle: "Naši pogoji uporabe so se spremenili",
    title: "Dokončanje profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Nazaj na prijavo",
    submitButtonLabel: "Oddaj",
    successDescription: "Prosimo, preverite svojo e-pošto, kmalu boste prejeli podatke o vašem računu, da začnete s postopkom ponastavitve gesla.",
    successTitle: "Vaša zahteva je bila prejeta.",
    title: "Za ponastavitev gesla vnesite svoj e-poštni naslov:"
  },
  loginModalScene: {
    copy: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
    title: "Prijavite se v svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Pozabil sem geslo",
    invalidEmailMessage: "E-pošta ni veljavna!",
    loginButtonLabel: "Vpiši se",
    passwordInputLabel: "Geslo",
    rememberMeLabel: "Zapomni si me",
    title: "Prijavite se s svojim e-poštnim naslovom in geslom:"
  }
}, Zp = {
  accessibility: {
    close: "Zapri"
  }
}, Yp = {
  tooShort: "Prekratko",
  medium: "Srednje",
  strong: "Močno",
  tooWeak: "Prešibko",
  veryStrong: "Zelo močno",
  weak: "Šibko"
}, Xp = {
  showPasswordText: "Prikaži",
  hidePasswordText: "Skrij"
}, Qp = {
  registerButtonLabel: "registracija",
  registerTitle: "Nimate računa?",
  whyRegister: {
    list: [
      "Dostop do ekskluzivnih ugodnosti Miele Kluba",
      "Registrirajte naprave, sledite naročilom, dostopajte do priročnikov",
      "Prejemajte prilagojene ponudbe in promocije",
      "Oglejte si vsa vaša naročila, garancije, dogodke in storitve"
    ],
    title: "Zakaj se registrirati?"
  },
  closeButtonLabel: "Zapri",
  passwordMismatchError: "Gesli se ne ujemata",
  passwordUpdateErrorTitle: "Napaka pri posodobitvi gesla",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno"
}, eg = {
  title: "Tržnenjske preference",
  description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
  submit: "Shrani",
  levelOne: {
    shortText: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, ankete za kupce, prošnje za ocene in mnenja o izdelkih ter recepte.",
    text: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, ankete za kupce, prošnje za ocene in mnenja o izdelkih ter recepte. V ta namen lahko Miele uporabi moje kontaktne podatke (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštni naslov) in oblikuje sporočila na podlagi zgodovine mojih nakupov, udeležbe na dogodkih in uporabe servisnih storitev, mojega vedenja pri klikanju in odpiranju novic ter moje vrednosti stranke, kot je podrobneje opisano v naših informacijah o varstvu podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej (npr. tako, da pošljem neformalno sporočilo na naslov info{'@'}miele.si, na kontaktne podatke, navedene v pravnem obvestilu, ali s klikom na povezavo za odjavo v e-poštnih sporočilih).",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelTwo: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojega obiska spletnih strani Miele (www.miele.si), vključno z vedenjem na spletnih straneh Miele, do katerih pridem s klikanjem v novicah Miele, za dopolnitev mojega uporabniškega profila za prilagojeno oglaševalsko komunikacijo, če moja ločena privolitev v aplikaciji ali na spletni strani dovoli obdelavo podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne podrobnosti so navedene v Politiki zasebnosti.",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelThree: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje podatke o mojih aparatih Miele, povezanih v omrežje (podatki o uporabi in stanju aparatov), da dopolni moj uporabniški profil za prilagojeno oglaševanje. Dodatne informacije o obdelavi podatkov o aparatih najdete v pravilniku o zasebnosti za sistem Miele{'@'}home. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne informacije so na voljo v varstvo podatkov.",
    link: {
      title: "Politika zasebnosti za sistem Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, strinjam se s pogoji uporabe.",
    link: {
      title: "Oglejte si pogoje uporabe*",
      ref: "https://www.miele.si/c/pogoji-uporabe-304.htm"
    }
  }
}, tg = {
  headline: "Miele klub",
  birthDateTitle: "Vam lahko pošljemo darilo za rojstni dan?",
  birthDateLabel: "Vaš rojstni datum (neobvezno)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rojstnodnevno presenečenje",
      "Ekskluzivne ponudbe in akcije",
      "Darilo dobrodošlice",
      "VIP ponudbe in",
      "izkušnje",
      "Privlačni prihranki",
      "Klubske novice"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Prosimo, da vnesete ta datumski format: DD/MM/LLLL",
    errorMsg: "Napačen datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Strinjam se s {termsAndConditionLink} Miele kluba in potrjujem {privacyLink} informacije o Miele klubu.",
    termsAndConditionLink: {
      title: "Pogoji",
      ref: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želim prejemati promocijsko komunikacijo kluba Miele, prilagojeno mojim osebnim interesom, po e-pošti in pošti",
    description: "Da, želim postati član Miele kluba in prejemati sporočila Miele kluba (darilo dobrodošlice, rojstnodnevno presenečenje, sprememba statusa nadgradnje, novice Miele kluba) po e-pošti.",
    privacyLink: {
      title: "Varstvo podatkov kluba Miele",
      href: "https://www.miele.si/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikacija kluba",
      href: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.si"
  },
  selectAllConsents: {
    description: "Če želite postati član Miele kluba, morate sprejeti vse pogoje *"
  }
}, ig = "pokaži celotno izjavo", ag = "skrij celotno izjavo", ng = {
  auth: qp,
  changeEmailScene: Gp,
  changePasswordScene: Kp,
  errors: Hp,
  forgotPassword: Wp,
  login: Jp,
  modal: Zp,
  passwordStrength: Yp,
  passwordHelper: Xp,
  register: Qp,
  "marketing-consent": {
    title: "Tržnenjske preference",
    description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
    submit: "Shrani",
    newsletter: {
      text: 'Strinjam se, da mi lahko Miele trgovina in servis d.o.o. ("Miele") pošilja informacije o izdelkih in novostih iz nabora izdelkov Miele in o dogodkih Miele ter ankete strank in recepte po e-pošti, aplikacijah Miele in SMS-ih ter da lahko Miele obdeluje kontaktne podatke, ki sem jih posredoval (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštno številko) in izdelke Miele, ki sem jih kupil do sedaj in jih bom kupil v prihodnosti, ter interese, ki sem jih navedel v ta namen . Nadalje se strinjam, da lahko Miele obdela potrdila o prejemu in branju, prejete prek glasila, in informacije o povezavah, na katere sem kliknil, ter o mojem povezanem vedenju uporabnika na povezani spletni strani za namene personalizacije. Enako velja za potisna sporočila v aplikaciji, v kolikor se uporabljajo aplikacije Miele. ',
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    personalisation: {
      text: "Strinjam se, da lahko Miele obdeluje podatke o storitvah, ki sem jih uporabil, in tehničnih nalogah, ki sem jih opravil, ter dogodkih, ki sem se jih udeležil, za namen izboljšane personalizacije.",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Poleg razširjene personalizacije se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojih obiskov spletnih strani Miele (www.miele.si) za dopolnitev mojega uporabniškega profila, pod pogojem, da sem posebej privolil v to. ",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoje soglasje lahko kadar koli prekličem brez navedbe razlogov z učinkom za naprej.  ",
      link: {
        title: "politiko varstva podatkov.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, strinjam se s pogoji uporabe.",
      link: {
        title: "Oglejte si pogoje uporabe*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: eg,
  mieleClub: tg,
  readMore: ig,
  readLess: ag
}, sg = {
  waitMessage: "Majdnem kész. "
}, og = {
  buttonLabel: "Mentés",
  buttonLabelClose: "Bezárás",
  confirmEmailMessage: "Erősítse meg e-mail címét",
  copy: "E-mail címének frissítéséhez adja hozzá az újat alább:",
  errorMessageCopy: "Hiba történt. Próbálja meg újra.",
  errorMessageHeadline: "Hiba",
  headline: "Profil részletei",
  inputEmailConfirmPlaceholder: "Erősítse meg az e-mail címét",
  inputEmailPlaceholder: "Email cím",
  invalidEmailMessage: "Az e-mail cím nem érvényes!",
  rememberMeLabel: "Emlékezz rám",
  successMessageCopy: "E-mail címe sikeresen frissítve.",
  successMessageHeadline: "E-mail cím frissítve"
}, rg = {
  closeButtonLabel: "Bezárás",
  confirmPasswordLabel: "Jelszó megerősítése",
  currentPasswordLabel: "Jelenlegi jelszó",
  newPasswordLabel: "Új jelszó",
  passwordMismatchError: "Jelszó nem egyezik",
  passwordUpdateErrorTitle: "Hiba",
  passwordUpdateSuccessTitle: "Jelszó frissítve",
  samePasswordError: "Ezt a jelszót korábban már használták, kérjük, adjon meg új jelszót",
  subtitle: "Jelszava megváltoztatásához töltse ki az alábbi mezőket:",
  submitButtonLabel: "Küldés",
  successfulChangeLabel: "Jelszava sikeresen frissítve",
  title: "Jelszó változtatás"
}, lg = {
  invalidEmail: "Helytelen e-mail",
  invalidPassword: "Rossz jelszó",
  sap_206002: "Fiókja ellenőrzésre vár, de sajnos  jelenleg nem tudjuk folytatni. További részletekért vegye fel velünk a kapcsolatot.",
  sap_206006: "Úgy tűnik, hogy a beküldött e-mail cím ellenőrzésre vár",
  sap_400003: "Ez az e-mail cím már létezik, kérjük, használjon másik e-mail címet.",
  sap_400028: "A beküldött e-mail cím ellenőrzésre vár",
  sap_400050: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_400097: "Úgy tűnik, nem biztonságos/nem támogatott böngészőből éri el szolgáltatásainkat. Kérjük, próbálja meg újra egy másik böngészővel",
  sap_401030: "Ezt a jelszót korábban már használták, kérjük, adjon meg új jelszót",
  sap_403005: "Ehhez az e-mail címhez nincs társítva fiók, kérjük, ellenőrizze e-mailjét, és próbálja újra",
  sap_403011: "A munkamenet ideje lejárt. Kérjük, töltse be újra a böngészőt, és jelentkezzen be újra.",
  sap_403012: "A munkamenet ideje lejárt. Kérjük, töltse be újra a böngészőt, és jelentkezzen be újra. ",
  sap_403013: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_403035: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_403041: "Ehhez az e-mail címhez nincs társítva fiók, kérjük, ellenőrizze e-mailjét, és próbálja újra",
  sap_403042: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403043: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403047: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403100: "A közelmúltban jelszófrissítési kérelmet nyújtottak be, kérjük, szíves türelmét kérjük a kérelem feldolgozásáig",
  sap_403025: "A jelszó visszaállítása link érvénytelen, kérjük, küldje el újra az elfelejtett jelszó kérelmét, hogy megkapja az új visszaállítási hivatkozást.",
  sapErrorTitle: "Hiba a kérelem feldolgozása során",
  sessionExpired: "A munkamenet ideje lejárt",
  tooWeakPassword: "A jelszónak legalább {minLength} karakterből és az alábbiak közül {minCharGroups} karakterből kell állnia: nagybetű, kisbetű, szám, speciális karakter | A jelszónak legalább {minLength} karakterből",
  unexpectedDescription: "Ha a probléma továbbra is fennáll, kérjük, vegye fel velünk a kapcsolatot a kapcsolatfelvételi űrlapon keresztül a részletekkel.",
  unexpectedTitle: "Váratlan hiba történt",
  unknownDescription: "Váratlan hiba történt. Kérjük, próbálja meg újra. ",
  unknownTitle: "Hoppá!"
}, cg = {
  subtitle: "Állítsa be az új jelszavát.",
  title: "Elfelejtette a jelszavát?"
}, dg = {
  headMetaDescription: "Ügyfél bejelentkező oldala",
  headTitle: "Jelentkezzen be e-mail címével és jelszavával:",
  subtitle: "Jelentkezzen be, vagy hozzon létre egy fiókot a Miele összes funkciójának eléréséhez.",
  title: "Jelentkezzen be a fiókjába",
  error: {
    invalidEmailPasswordDescription: "Az e-mail cím és a jelszó kombinációja nem érvényes.",
    invalidEmailPasswordTitle: "Érvénytelen hitelesítő adatok",
    missingConcentTitle: "Fiók regisztráció függőben",
    noAccountDescription: "Ehhez az e-mail címhez nincs fiók társítva.",
    noAccountTitle: "Nincs regisztrált fiók"
  },
  extraConsentScene: {
    continue: "Folytatás",
    privacyStatementCheckboxLabel: "Tudomásul vettem a következőt: {0}.",
    privacyStatementName: "Adatvédelmi nyilatkozat",
    privacyStatementTitle: "Adatvédelmi szabályzatunk megváltozott",
    termsOfUseCheckboxLabel: "Elfogadom a következőt: {0}.",
    termsOfUseName: "Felhasználási feltételek",
    termsOfUseTitle: "Felhasználási feltételeink megváltoztak",
    title: "Profil kitöltése"
  },
  forgotPasswordScene: {
    backButtonLabel: "Vissza a bejelentkezéshez",
    submitButtonLabel: "Beküldés",
    successDescription: "Kérjük, ellenőrizze e-mailjeit, hamarosan megkapja a fiókjához tartozó információkat a jelszó-visszaállítási folyamat megkezdéséhez.",
    successTitle: "Kérését megkaptuk.",
    title: "Kérjük, adja meg e-mail címét a jelszó visszaállításához:"
  },
  loginModalScene: {
    copy: "Jelentkezzen be, vagy hozzon létre egy fiókot a Miele összes funkciójának eléréséhez.",
    title: "Jelentkezzen be a fiókjába"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Elfelejtettem a jelszavam",
    invalidEmailMessage: "Az e-mail cím nem érvényes!",
    loginButtonLabel: "Belépés",
    passwordInputLabel: "Jelszó",
    rememberMeLabel: "Emlékezz rám",
    title: "Jelentkezzen be e-mail címével és jelszavával:"
  }
}, ug = {
  accessibility: {
    close: "Bezárás"
  }
}, mg = {
  tooShort: "Túl rövid",
  medium: "Közepes",
  strong: "Erős",
  tooWeak: "Túl gyenge",
  veryStrong: "Nagyon erős",
  weak: "Gyenge"
}, pg = {
  showPasswordText: "Megjelenít",
  hidePasswordText: "Elrejt"
}, gg = {
  registerButtonLabel: "Regisztráció",
  registerTitle: "Nincs fiókja?",
  whyRegister: {
    list: [
      "Hozzáférés a Miele Club exkluzív előnyeihez",
      "Készülékek regisztrálása, rendelések nyomon követése, használati útmutatók elérése",
      "Kapjon személyre szabott ajánlatokat és promóciókat",
      "Tekintse meg az összes megrendelését, garanciáját, eseményét és szolgáltatását"
    ],
    title: "Miért regisztráljon?"
  },
  closeButtonLabel: "Bezárás",
  passwordMismatchError: "A jelszavak nem egyeznek",
  passwordUpdateErrorTitle: "Jelszó frissítési hiba",
  passwordUpdateSuccessTitle: "Jelszó frissítve",
  successfulChangeLabel: "Jelszava sikeresen frissítve"
}, hg = {
  title: "Marketingbeállítások",
  description: "Jelölje be alább az exkluzív ajánlatokat, híreket, eseményeket és azt, hogyan hozhatja ki a legtöbbet készülékéből.",
  submit: "Mentés",
  levelOne: {
    shortText: 'Igen, szeretném, ha a  Miele Kft. és a Miele & Cie. KG ("Miele") e-mailben, SMS-ben, postai úton és a Miele alkalmazásokon keresztül (ha használom) marketing célú kereskedelmi kommunikációt küldjön a részemre',
    text: `Igen, szeretném, ha a  Miele Kft. és a Miele & Cie. KG ("Miele") e-mailben, SMS-ben, postai úton és a Miele alkalmazásokon keresztül (ha használom) marketing célú kereskedelmi kommunikációt küldjön a részemre. Ennek érdekében hozzájárulok, hogy a Miele a termékeiről, ajánlatairól és újdonságairól, rendezvényeiről, receptekről tájékoztatást küldjön, valamint megkeressen vásárlói elégedettség felmérésekkel, termékértékelési kérésekkel kapcsolatban. Hozzájárulok, hogy a Miele ebből a célból az általam megadott   elérhetőségeimet (megszólítás, név, e-mail cím, mobiltelefonszám és postacím) kezelje és a kommunikációt a vásárlási és szolgáltatási előzményeim, eseménytörténetem, hírlevél kattintási és megnyitási szokásaim, valamint az ügyfélértékem alapján alakítsa, ahogy azt részletesen ismertetjük az adatkezelési tájékoztatóban.Hozzájárulásomat a jövőre vonatkozóan bármikor indokolás nélkül visszavonhatom a (info{'@'}miele.hu címre küldött üzenettel, az adatkezelési tájékoztatóban megadott elérhetőségeken vagy a kapott kommunikációban található leiratkozási linkre kattintva).`,
    link: {
      title: "Adatvédelem",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  levelTwo: {
    text: "Alapszintű hozzájárulásomon túlmenően hozzájárulok ahhoz, hogy a Miele alkalmazás használata során keletkező  és a Miele weboldalon  (www.miele.hu) tett látogatásaimból származó adatokat (beleértve a kereskedelmi kommunikációban kapott linkre kattintva elérhető Miele weboldalon való felhasználói szokásaimat)a felhasználói profilom kiegészítés során személyre szabott marketing kommunikáció céljából a Miele kezelje, feltéve, hogy külön hozzájárulásom az alkalmazásban vagy a Miele weboldalon lehetővé teszi az adatkezelést. Hozzájárulásomat a jövőre vonatkozóan bármikor indokolás nélkül visszavonhatom. További részletek az adatkezelési tájékoztatóban.",
    link: {
      title: "Adatvédelem",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  levelThree: {
    text: "Alapszintű hozzájárulásomon túlmenően hozzájárulok ahhoz, hogy a Miele kezelje a hálózatba kapcsolt Miele készülékeim adatait (a készülékek használatára és állapotára vonatkozó adatok), hogy kiegészítse felhasználói profilomat a személyre szabott marketing kommunikáció céljából. A készülékadatok kezeléséről  további információkat a Miele{'@'}Home rendszer adatvédelmi szabályzatában találok.",
    link: {
      title: "Miele{'@'}Home rendszer",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Igen, elfogadom a Felhasználási feltételeket.",
    link: {
      title: "Felhasználási feltételeket",
      ref: "https://www.miele.hu/c/aszf-13.htm"
    }
  }
}, vg = {
  headline: "Miele Club",
  birthDateTitle: "Küldhetünk születésnapi ajándékot?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Tagság",
    reasons: [
      "Születésnapi meglepetés"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Használja a köv. formátumot:  HH/NN/ÉÉÉÉ",
    errorMsg: "Érvénytelen dátum"
  },
  joinClubLabel: "Igen, szeretnék csatlakozni a Miele Clubhoz.",
  termsAndCondition: {
    description: "A Miele Club tagságával ön elfogadja a Miele Club feltételeit.",
    termsAndConditionLink: {
      title: "Általános Szerződési Feltételek",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    privacyLink: {
      title: "Adatvédelem",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Igen, szeretnék személyes érdeklődési körömre szabott Miele Club promóciós közleményeket kapni e-mailben és postai úton",
    description: "Igen, szeretnék Miele Club tag lenni, és szeretnék e-mailben kapni  Miele Club kommunikációt (üdvözlő ajándék, születésnapi meglepetés, Miele Club hírek).",
    privacyLink: {
      title: "Miele Club adatvédelem",
      href: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    termsAndConditionLink: {
      title: "Klubkommunikáció",
      href: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    supportEmail: "info{'@'}miele.hu"
  },
  selectAllConsents: {
    description: "A Miele Klubhoz való csatlakozáshoz el kell fogadnia az összes feltételt *"
  }
}, fg = "teljes nyilatkozat megjelenítése", kg = "teljes nyilatkozat elrejtése", bg = {
  auth: sg,
  changeEmailScene: og,
  changePasswordScene: rg,
  errors: lg,
  forgotPassword: cg,
  login: dg,
  modal: ug,
  passwordStrength: mg,
  passwordHelper: pg,
  register: gg,
  "marketing-consent": {
    title: "Marketingbeállítások",
    description: "Jelölje be alább az exkluzív ajánlatokat, híreket, eseményeket és azt, hogyan hozhatja ki a legtöbbet készülékéből.",
    submit: "Mentés",
    newsletter: {
      text: 'Hozzájárulok ahhoz, hogy a Miele Co Ltd. ("Miele") információkat küldjön nekem a Miele termékeiről és innovációiról, valamint a Miele rendezvényeiről,  vásárlói felmérésekről és receptekről e-mailben, a Miele alkalmazásokban és SMS-ben, valamint hogy a Miele kezelheti az általam megadott elérhetőségeket (cím, név, e-mail cím, mobiltelefonszám és irányítószám), és az eddig vásárolt és a jövőben vásárolni kívánt Miele termékeket, valamint az e célból megjelölt érdeklődési köröket. Hozzájárulok továbbá ahhoz, hogy a Miele személyre szabás céljából feldolgozza a hírlevélen keresztül kapott átvételi és olvasási visszaigazolásokat, valamint az általam kattintott linkekre vonatkozó információkat és a kapcsolódó felhasználói magatartásomat a hivatkozott weboldalon. Ugyanez vonatkozik az alkalmazáson belüli push üzenetekre is a Miele alkalmazások használata esetén.',
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    personalisation: {
      text: "Hozzájárulok ahhoz, hogy a Miele a fokozott személyre szabás érdekében feldolgozzon információkat az általam igénybe vett szolgáltatásokról és az általam kért technikusi megbízásokról, valamint azokról az eseményekről, amelyeken részt vettem.",
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "A kiterjesztett személyre szabás mellett hozzájárulok ahhoz, hogy a Miele a Miele alkalmazás használatából és a Miele weboldalain (www.miele.hu) tett látogatásaimból származó adatokat is kezeljen felhasználói profilom kiegészítése céljából, feltéve, hogy ehhez külön hozzájárultam. ",
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    highlightedText: {
      text: "Hozzájárulásomat a jövőre vonatkozó indoklás nélkül bármikor visszavonhatom. Ha többet szeretne megtudni arról, hogy a Miele hogyan kezeli az ön adatait, kérjük, olvassa el a Miele ",
      link: {
        title: "Adatvédelmi szabályzatát.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Igen, elfogadom a Felhasználási feltételeket.",
      link: {
        title: "Lásd a Felhasználási feltételeket*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: hg,
  mieleClub: vg,
  readMore: fg,
  readLess: kg
}, wg = {
  waitMessage: "Nearly there. Hang tight ..."
}, yg = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Mg = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, zg = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, jg = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, _g = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Eg = {
  accessibility: {
    close: "Close"
  }
}, Sg = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, Lg = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, Cg = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, Pg = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps',
    text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  levelTwo: {
    text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  levelThree: {
    text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  highlightedText: {
    text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
    link: {
      title: "data protection policy.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "#"
    }
  }
}, Tg = {
  headline: "Miele Club",
  birthDateTitle: "Would you like to receive a birthday surprise?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Free membership - Exclusive offers for members.",
    reasons: [
      "£ 10 Welcome voucher",
      "Birthday surprise",
      "Special sale offers",
      "Invites to exclusive events & experiences"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Please enter this date format: DD/MM/YYYY",
    errorMsg: "Incorrect date"
  },
  joinClubLabel: "Yes, I would like to join the Miele Club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}miele.co.uk, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, Ag = "show full statement", xg = "hide full statement", Ig = {
  auth: wg,
  changeEmailScene: yg,
  changePasswordScene: Mg,
  errors: zg,
  forgotPassword: jg,
  login: _g,
  modal: Eg,
  passwordStrength: Sg,
  passwordHelper: Lg,
  register: Cg,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Pg,
  mieleClub: Tg,
  readMore: Ag,
  readLess: xg
}, Dg = {
  waitMessage: "Nearly there. Hang tight ..."
}, Ng = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Og = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, Ug = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, $g = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, Bg = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Rg = {
  accessibility: {
    close: "Close"
  }
}, Vg = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, Fg = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, qg = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, Gg = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'Yes, I would like to receive promotional communications from Miele Ireland Ltd and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post and via the Miele apps (if used)',
    text: `Yes, I would like to receive promotional communications from Miele Ireland Ltd and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post and via the Miele apps (if used) with information on products, offers and innovations from the Miele product range and on Miele events as well as customer surveys, product rating and review requests and recipes. For this purpose, Miele may use my contact information (title, name, email address, mobile phone number and postal address) and design the communication based on my purchase, service, event history, newsletter click and open behavior as well as customer value, as described in detail in our privacy policy. I can revoke my consent at any time without giving reasons with effect for the future (e.g. by sending an informal message to contact{'@'}miele-support.ie, the contact details given in the imprint or by clicking on the unsubscribe link in emails).`,
    link: {
      title: "Data protection policy",
      ref: "https://www.miele.ie/c/data-protection-14.htm"
    }
  },
  levelTwo: {
    text: "In addition to my basic consent, I agree that Miele may also process data from the use of the Miele app and my visits to Miele websites (www.miele.ie), including user behavior on the Miele websites after linked newsletter clicks, to supplement my user profile for personalized advertising communications, provided that my separate consent in the app or on the website releases the data processing. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele’s data protection policy.",
    link: {
      title: "Data protection policy",
      ref: "https://www.miele.ie/c/data-protection-14.htm"
    }
  },
  levelThree: {
    text: "In addition to my basic consent, I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele’s data protection policy.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "https://www.miele.ie/c/terms-of-use-304.htm"
    }
  }
}, Kg = {
  headline: "Miele Club",
  birthDateTitle: "Can we send you a birthday gift?",
  birthDateLabel: "Birthday (optional)",
  why: {
    title: "Membership",
    reasons: [
      "Birthday surprise",
      "Exclusive offers and campaigns",
      "Welcome gift",
      "VIP offers and experiences",
      "Attractive savings",
      "Club news"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Use format like MM/DD/YYYY",
    errorMsg: "Invalid date"
  },
  joinClubLabel: "Yes, I want to join the Miele club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.ie/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.ie/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}miele.ie, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.miele.ie/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.miele.ie/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.ie"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, Hg = "show full statement", Wg = "hide full statement", Jg = {
  auth: Dg,
  changeEmailScene: Ng,
  changePasswordScene: Og,
  errors: Ug,
  forgotPassword: $g,
  login: Bg,
  modal: Rg,
  passwordStrength: Vg,
  passwordHelper: Fg,
  register: qg,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Gg,
  mieleClub: Kg,
  readMore: Hg,
  readLess: Wg
}, Zg = {
  waitMessage: "Η αναμονή σχεδόν τελείωσε. "
}, Yg = {
  buttonLabel: "Αποθήκευση",
  buttonLabelClose: "Κλείσιμο",
  confirmEmailMessage: "Επιβεβαιώστε τη διεύθυνση e-mail σας",
  copy: "Για να ενημερώσετε τη διεύθυνση email σας, προσθέστε τη νέα διεύθυνση παρακάτω:",
  errorMessageCopy: "Κάτι πήγε στραβά. Προσπαθήστε ξανά ",
  errorMessageHeadline: "Σφάλμα",
  headline: "Στοιχεία προφίλ",
  inputEmailConfirmPlaceholder: "Επιβεβαιώστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας",
  inputEmailPlaceholder: "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
  invalidEmailMessage: "Το e-mail δεν ισχύει!",
  rememberMeLabel: "Θυμήσου με",
  successMessageCopy: "Η διεύθυνση email σας ενημερώθηκε με επιτυχία.",
  successMessageHeadline: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου ενημερώθηκε"
}, Xg = {
  closeButtonLabel: "Κλείσιμο",
  confirmPasswordLabel: "Επιβεβαίωση Κωδικού",
  currentPasswordLabel: "Τρέχων κωδικός πρόσβασης",
  newPasswordLabel: "Νέος Κωδικός",
  passwordMismatchError: "Ο κωδικός δεν ταιριάζει",
  passwordUpdateErrorTitle: "Λάθος",
  passwordUpdateSuccessTitle: "Ο κωδικός ενημερώθηκε",
  samePasswordError: "Αυτός ο κωδικός πρόσβασης χρησιμοποιήθηκε στο παρελθόν, υποβάλετε έναν νέο κωδικό πρόσβασης",
  subtitle: "Για να αλλάξετε τον κωδικό πρόσβασής σας, συμπληρώστε τα παρακάτω πεδία:",
  submitButtonLabel: "Υποβολή",
  successfulChangeLabel: "Ο κωδικός πρόσβασής σας ενημερώθηκε με επιτυχία",
  title: "Αλλαγή κωδικού"
}, Qg = {
  invalidEmail: "Λάθος email",
  invalidPassword: "Λάθος κωδικός",
  sap_206002: "Ο λογαριασμός σας δεν έχει επαληθευτεί, δυστυχώς δεν μπορούμε να σας επιτρέψουμε να συνεχίσετε αυτήν τη στιγμή. ",
  sap_206006: "Φαίνεται ότι η διεύθυνση ηλεκτρονικού ταχυδρομείου που υποβάλατε δεν έχει επαληθευτεί",
  sap_400003: "Αυτό το email υπάρχει ήδη, χρησιμοποιήστε διαφορετική διεύθυνση email.",
  sap_400028: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου που υποβλήθηκε δεν έχει επαληθευτεί",
  sap_400050: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_400097: "Φαίνεται ότι προσπαθέιτε να χρησιμοποιήσετε τις υπηρεσίες μας από ένα μη ασφαλές/μη υποστηριζόμενο πρόγραμμα περιήγησης. ",
  sap_401030: "Αυτός ο κωδικός πρόσβασης χρησιμοποιήθηκε στο παρελθόν, υποβάλετε έναν νέο κωδικό πρόσβασης",
  sap_403005: "Δεν έχουμε λογαριασμό που να σχετίζεται με αυτήν τη διεύθυνση email, ελέγξτε το email σας και δοκιμάστε ξανά",
  sap_403011: "Η συνεδρία έληξε. Παρακαλούμε επαναφορτώστε το πρόγραμμα περιήγησης και συνδεθείτε ξανά. ",
  sap_403012: "Η συνεδρία έληξε. Παρακαλούμε επαναφορτώστε το πρόγραμμα περιήγησης και συνδεθείτε ξανά.",
  sap_403013: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_403035: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_403041: "Δεν έχουμε λογαριασμό που να σχετίζεται με αυτήν τη διεύθυνση email, ελέγξτε το email σας και δοκιμάστε ξανά",
  sap_403042: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403043: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403047: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403100: "Πρόσφατα ζητήθηκε αίτημα ενημέρωσης κωδικού πρόσβασης, παρακαλούμε περιμένετε μέχρι να διεκπεραιωθεί το αίτημα",
  sap_403025: "Μη έγκυρος σύνδεσμος επαναφοράς κωδικού πρόσβασης. Στείλτε ξανά αίτημα για τον ξεχασμένο κωδικό πρόσβασης για να λάβετε νέο σύνδεσμο επαναφοράς.",
  sapErrorTitle: "Σφάλμα κατά την επεξεργασία του αιτήματος",
  sessionExpired: "Η συνεδρία έληξε",
  tooWeakPassword: "Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον {minLength} χαρακτήρες και {minCharGroups} από τα ακόλουθα: κεφαλαίο γράμμα, πεζό γράμμα, αριθμό, ειδικό σύμβολο | Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον {minLength} χαρακτήρες",
  unexpectedDescription: "Εάν το πρόβλημα επιμένει, επικοινωνήστε μαζί μας μέσω της φόρμας επικοινωνίας.",
  unexpectedTitle: "Παρουσιάστηκε σφάλμα",
  unknownDescription: "Παρουσιάστηκε μη αναμενόμενο σφάλμα. Παρακαλούμε προσπαθήστε ξανά. ",
  unknownTitle: "Ωχ!"
}, eh = {
  subtitle: "Ορίστε τον νέο σας κωδικό πρόσβασης.",
  title: "Ξεχάσατε τον κωδικό σας;"
}, th = {
  headMetaDescription: "Σύνδεση ",
  headTitle: "Συνδεθείτε με το email και τον κωδικό πρόσβασής σας:",
  subtitle: "Συνδεθείτε ή δημιουργήστε έναν λογαριασμό για να αποκτήσετε όλες τις δυνατότητες της Miele.",
  title: "Συνδεθείτε στο λογαριασμό σας",
  error: {
    invalidEmailPasswordDescription: "Ο συνδυασμός διεύθυνσης email και κωδικού πρόσβασης δεν είναι έγκυρος.",
    invalidEmailPasswordTitle: "Μη έγκυρα στοιχέια λογαριασμού",
    missingConcentTitle: "Εκκρεμεί η δημιουργία λογαριασμού",
    noAccountDescription: "Δεν υπάρχει λογαριασμός που να σχετίζεται με αυτήν τη διεύθυνση email.",
    noAccountTitle: "Δεν έχει καταχωρηθεί λογαριασμός"
  },
  extraConsentScene: {
    continue: "Συνέχεια",
    privacyStatementCheckboxLabel: "Έχω λάβει υπόψη το {0}.",
    privacyStatementName: "Δήλωση προστασίας προσωπικών δεδομένων",
    privacyStatementTitle: "Η Πολιτική Απορρήτου μας έχει αλλάξει",
    termsOfUseCheckboxLabel: "Συμφωνώ με το {0}.",
    termsOfUseName: "όροι χρήσης",
    termsOfUseTitle: "Οι Όροι Χρήσης μας έχουν αλλάξει",
    title: "Ολοκλήρωση προφίλ"
  },
  forgotPasswordScene: {
    backButtonLabel: "Επιστροφή στην σελίδα εισόδου",
    submitButtonLabel: "Υποβολή",
    successDescription: "Ελέγξτε το e-mail σας, σύντομα θα λάβετε τις πληροφορίες στον λογαριασμό σας για να ξεκινήσετε τη διαδικασία επαναφοράς κωδικού πρόσβασης.",
    successTitle: "Το αίτημά σας έχει ληφθεί.",
    title: "Εισαγάγετε τη διεύθυνση email σας για να επαναφέρετε τον κωδικό πρόσβασής σας:"
  },
  loginModalScene: {
    copy: "Συνδεθείτε ή δημιουργήστε έναν λογαριασμό για να αποκτήσετε όλες τις δυνατότητες της Miele.",
    title: "Συνδεθείτε στο λογαριασμό σας"
  },
  loginScene: {
    emailInputLabel: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    forgotPwdButtonLabel: "Ξεχασα τον κωδικο μου",
    invalidEmailMessage: "Το e-mail δεν ισχύει!",
    loginButtonLabel: "Σύνδεση",
    passwordInputLabel: "Κωδικός πρόσβασης",
    rememberMeLabel: "Θυμήσου με",
    title: "Συνδεθείτε με το email και τον κωδικό πρόσβασής σας:"
  }
}, ih = {
  accessibility: {
    close: "Κλείσιμο"
  }
}, ah = {
  tooShort: "Πολύ σύντομο",
  medium: "Μέτριο",
  strong: "Ισχυρός",
  tooWeak: "Πολύ αδύναμος",
  veryStrong: "Πολύ δυνατός",
  weak: "Αδύναμος"
}, nh = {
  showPasswordText: "Προβολή",
  hidePasswordText: "Απόκρυψη"
}, sh = {
  registerButtonLabel: "ΕΓΓΡΑΦΗ",
  registerTitle: "Δεν έχετε λογαριασμό;",
  whyRegister: {
    list: [
      "Αποκτήστε πρόσβαση στα αποκλειστικά προνόμια του Miele Club",
      "Εγγραφή συσκευών, παρακολούθηση παραγγελιών, πρόσβαση σε οδηγίες χρήσης",
      "Λάβετε εξατομικευμένες προσφορές και προωθήσεις",
      "Δείτε όλες τις παραγγελίες, τις εγγυήσεις, τις εκδηλώσεις και τις υπηρεσίες σας"
    ],
    title: "Γιατί να εγγραφείτε;"
  },
  closeButtonLabel: "Κλείσιμο",
  passwordMismatchError: "Οι κωδικοί δεν ταιριάζουν",
  passwordUpdateErrorTitle: "Σφάλμα ενημέρωσης κωδικού πρόσβασης",
  passwordUpdateSuccessTitle: "Ο κωδικός ενημερώθηκε",
  successfulChangeLabel: "Ο κωδικός πρόσβασής σας ενημερώθηκε με επιτυχία"
}, oh = {
  title: "Προτιμήσεις διαφημίσεων",
  description: "Επιλέξτε παρακάτω για αποκλειστικές προσφορές, νέα, εκδηλώσεις και πώς να αξιοποιήσετε στο έπακρο τη συσκευή σας.",
  submit: "Αποθηκεύσετε",
  levelOne: {
    shortText: 'Ναι, θα ήθελα να λαμβάνω διαφημιστική επικοινωνία προσαρμοσμένη στα προσωπικά μου ενδιαφέροντα από την Miele Hellas Ε.Π.Ε και την Miele & Cie. KG ("Miele") μέσω e-mail, SMS, ταχυδρομείου και μέσω των εφαρμογών Miele (αν χρησιμοποιούνται) με πληροφορίες για προϊόντα, προσφορές, καινοτομίες και για εκδηλώσεις της Miele, καθώς και για έρευνες πελατών, αιτήσεις αξιολόγησης και κριτικής προϊόντων και συνταγές.',
    text: `Ναι, θα ήθελα να λαμβάνω διαφημιστική επικοινωνία προσαρμοσμένη στα προσωπικά μου ενδιαφέροντα από την Miele Hellas Ε.Π.Ε και την Miele & Cie. KG ("Miele") μέσω e-mail, SMS, ταχυδρομείου και μέσω των εφαρμογών Miele (αν χρησιμοποιούνται) με πληροφορίες για προϊόντα, προσφορές, καινοτομίες και για εκδηλώσεις της Miele, καθώς και για έρευνες πελατών, αιτήσεις αξιολόγησης και κριτικής προϊόντων και συνταγές. Για το σκοπό αυτό, η Miele μπορεί να χρησιμοποιήσει τα στοιχεία επικοινωνίας μου (τίτλος, όνομα, διεύθυνση ηλεκτρονικού ταχυδρομείου, αριθμός κινητού τηλεφώνου και ταχυδρομική διεύθυνση) και να σχεδιάσει την επικοινωνία με βάση το ιστορικό αγορών, εκδηλώσεων και υπηρεσιών, τη συμπεριφορά μου ως προς το κλικ και το άνοιγμα του newsletter και την αξία ως πελάτη, όπως περιγράφεται λεπτομερέστερα στις πληροφορίες μας για την προστασία δεδομένων. Μπορώ να ανακαλέσω τη συγκατάθεσή μου ανά πάσα στιγμή στο μέλλον (π.χ. στέλνοντας ένα ανεπίσημο μήνυμα στο info{'@'}miele.gr, στα στοιχεία επικοινωνίας που αναφέρονται στη νομική σημείωση ή κάνοντας κλικ στον σύνδεσμο διαγραφής στα μηνύματα ηλεκτρονικού ταχυδρομείου).`,
    link: {
      title: "Πολιτική προστασίας δεδομένων",
      ref: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    }
  },
  levelTwo: {
    text: "Εκτός από τη βασική μου συγκατάθεση, συμφωνώ ότι η Miele μπορεί επίσης να επεξεργάζεται δεδομένα από τη χρήση της εφαρμογής Miele και τις επισκέψεις μου στις ιστοσελίδες της Miele (http://www.miele.gr ), συμπεριλαμβανομένης της συμπεριφοράς του χρήστη που συνδέεται με τα κλικ στο newsletter στις ιστοσελίδες της Miele που συνδέονται εκεί, για να συμπληρώσει το προφίλ χρήστη μου για εξατομικευμένη διαφημιστική επικοινωνία, υπό την προϋπόθεση ότι η ξεχωριστή συγκατάθεσή μου στην εφαρμογή ή στην ιστοσελίδα αποδεσμεύει την επεξεργασία δεδομένων. Μπορώ να ανακαλέσω τη συναίνεση μου ανά πάσα στιγμή χωρίς αιτιολόγηση για το μέλλον. Περισσότερες λεπτομέρειες στην πολιτική απορρήτου.",
    link: {
      title: "Πολιτική προστασίας δεδομένων",
      ref: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    }
  },
  levelThree: {
    text: "Εκτός από τη βασική μου συγκατάθεση, συμφωνώ ότι η Miele μπορεί να επεξεργάζεται δεδομένα από τις συνδεδεμένες συσκευές Miele (δεδομένα σχετικά με τη χρήση και την κατάσταση της συσκευής) για να συμπληρώσει το προφίλ χρήστη μου για εξατομικευμένη διαφήμιση. Μπορώ να βρω περισσότερες πληροφορίες σχετικά με την επεξεργασία των δεδομένων των συσκευών στην πολιτική απορρήτου για το σύστημα Miele{'@'}Home. Μπορώ να ανακαλέσω τη συγκατάθεσή μου ανά πάσα στιγμή για το μέλλον. Περισσότερες λεπτομέρειες στην πολιτική απορρήτου.",
    link: {
      title: "Πολιτική απορρήτου για το σύστημα Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4/DataProtection/Privacy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ναι, συμφωνώ με τους όρους χρήσης.",
    link: {
      title: "Δείτε τους Όρους Χρήσης*",
      ref: "https://www.miele.gr/c/oroi-xrhshs-13.htm"
    }
  }
}, rh = {
  auth: Zg,
  changeEmailScene: Yg,
  changePasswordScene: Xg,
  errors: Qg,
  forgotPassword: eh,
  login: th,
  modal: ih,
  passwordStrength: ah,
  passwordHelper: nh,
  register: sh,
  "marketing-consent": {
    title: "Προτιμήσεις διαφημίσεων",
    description: "Επιλέξτε παρακάτω για αποκλειστικές προσφορές, νέα, εκδηλώσεις και πώς να αξιοποιήσετε στο έπακρο τη συσκευή σας.",
    submit: "Αποθηκεύσετε",
    newsletter: {
      text: 'Συμφωνώ ότι η Miele Co Ltd. ("Miele") μπορεί να μου στέλνει πληροφορίες για προϊόντα και καινοτομίες από τη γκάμα προϊόντων Miele και για εκδηλώσεις της Miele, καθώς και για έρευνες πελατών και συνταγές μέσω ηλεκτρονικού ταχυδρομείου, των εφαρμογών Miele και SMS και ότι η Miele μπορεί να επεξεργάζεται τα στοιχεία επικοινωνίας που έχω παράσχει (τίτλος, όνομα, διεύθυνση ηλεκτρονικού ταχυδρομείου, αριθμός κινητού τηλεφώνου και ταχυδρομικός κώδικας) και τα προϊόντα Miele που έχω αγοράσει μέχρι σήμερα και θα αγοράσω στο μέλλον, καθώς και τα ενδιαφέροντα που έχω δηλώσει για το σκοπό αυτό. Συμφωνώ περαιτέρω ότι η Miele μπορεί επίσης να επεξεργάζεται τις επιβεβαιώσεις παραλαβής και ανάγνωσης που λαμβάνει μέσω του ενημερωτικού δελτίου και τις πληροφορίες σχετικά με τους συνδέσμους στους οποίους έχω κάνει κλικ, καθώς και τη σχετική συμπεριφορά μου ως χρήστης στον συνδεδεμένο ιστότοπο με σκοπό την εξατομίκευση. Το ίδιο ισχύει και για τα push μηνύματα εντός της εφαρμογής, εφόσον χρησιμοποιούνται οι εφαρμογές της Miele.',
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    personalisation: {
      text: "Συμφωνώ ότι η Miele μπορεί να επεξεργάζεται πληροφορίες σχετικά με τις υπηρεσίες που έχω χρησιμοποιήσει και τις αναθέσεις τεχνικών που έχω πραγματοποιήσει, καθώς και εκδηλώσεις στις οποίες έχω παρακολουθήσει, με σκοπό τη βελτιωμένη εξατομίκευση.",
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Εκτός από την εκτεταμένη εξατομίκευση, συμφωνώ ότι η Miele μπορεί επίσης να επεξεργάζεται δεδομένα από τη χρήση της εφαρμογής Miele και τις επισκέψεις μου στους ιστότοπους της Miele (www.miele.gr) για τη συμπλήρωση του προφίλ χρήστη μου, εφόσον έχω δώσει ξεχωριστά τη συγκατάθεσή μου για την επεξεργασία αυτών των δεδομένων. ",
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    highlightedText: {
      text: "Μπορώ να ανακαλέσω τη συγκατάθεσή μου ανά πάσα στιγμή χωρίς να αναφέρω λόγους με ισχύ για το μέλλον.  ",
      link: {
        title: "πολιτική προστασίας δεδομένων.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ναι, συμφωνώ με τους όρους χρήσης.",
      link: {
        title: "Δείτε τους Όρους Χρήσης*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: oh
}, lh = {
  waitMessage: "Už ste skoro tam. "
}, ch = {
  buttonLabel: "Uložiť",
  buttonLabelClose: "Zavrieť",
  confirmEmailMessage: "Potvrďte svoju e-mailovú adresu",
  copy: "Ak chcete aktualizovať svoju e-mailovú adresu, pridajte novú nižšie:",
  errorMessageCopy: "Niečo sa pokazilo. ",
  errorMessageHeadline: "Chyba",
  headline: "Podrobnosti profilu",
  inputEmailConfirmPlaceholder: "Potvrďte svoju e-mailovú adresu",
  inputEmailPlaceholder: "Emailová adresa",
  invalidEmailMessage: "E-mail je neplatný!",
  rememberMeLabel: "Zapamätovať",
  successMessageCopy: "Vaša e-mailová adresa bola úspešne aktualizovaná.",
  successMessageHeadline: "E-mailová adresa bola aktualizovaná"
}, dh = {
  closeButtonLabel: "Zavrieť",
  confirmPasswordLabel: "Potvrďte heslo",
  currentPasswordLabel: "Aktuálne heslo",
  newPasswordLabel: "Nové heslo",
  passwordMismatchError: "Heslo sa nezhoduje",
  passwordUpdateErrorTitle: "Chyba",
  passwordUpdateSuccessTitle: "Heslo bolo aktualizované",
  samePasswordError: "Toto heslo sa už používalo, zadajte nové heslo",
  subtitle: "Ak chcete zmeniť svoje heslo, vyplňte nižšie uvedené polia: ",
  submitButtonLabel: "Potvrdiť",
  successfulChangeLabel: "Vaše heslo bolo úspešne aktualizované",
  title: "Zmena hesla"
}, uh = {
  invalidEmail: "Nespravny email",
  invalidPassword: "Zlé heslo",
  sap_206002: "Váš účet čaká na overenie. Kontaktujte nás pre bližšie informácie. ",
  sap_206006: "Zdá sa, že e-mailová adresa, ktorú ste odoslali, čaká na overenie",
  sap_400003: "Tento e-mail už existuje, použite inú e-mailovú adresu.",
  sap_400028: "Odoslaná e-mailová adresa čaká na overenie",
  sap_400050: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_400097: "Zdá sa, že k našim službám pristupujete z nezabezpečeného/nepodporovaného prehliadača. ",
  sap_401030: "Toto heslo sa už používalo, zadajte nové heslo",
  sap_403005: "K tejto e-mailovej adrese nemáme priradený účet, skontrolujte svoj e-mail a skúste to znova",
  sap_403011: "Platnosť relácie vypršala. Znova načítajte prehliadač a znova sa prihláste.",
  sap_403012: "Platnosť relácie vypršala. Znova načítajte prehliadač a znova sa prihláste. ",
  sap_403013: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_403035: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_403041: "K tejto e-mailovej adrese nemáme priradený účet, skontrolujte svoj e-mail a skúste to znova",
  sap_403042: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403043: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403047: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403100: "Žiadosť o aktualizáciu hesla bola nedávno vyžiadaná, prosíme o strpenie, kým nebude žiadosť spracovaná",
  sap_403025: "Odkaz na obnovenie hesla je neplatný, pošlite žiadosť o zabudnuté heslo znova, aby ste dostali nový odkaz na obnovenie.",
  sapErrorTitle: "Chyba pri spracovaní požiadavky",
  sessionExpired: "Platnosť relácie vypršala",
  tooWeakPassword: "Heslo musí obsahovať aspoň {minLength} znakov a {minCharGroups} z nasledujúcich znakov: veľké písmeno, malé písmeno, číslo, špeciálny symbol | Heslo musí obsahovať aspoň {minLength} znakov",
  unexpectedDescription: "Ak problém pretrváva, kontaktujte nás prostredníctvom kontaktného formulára s podrobnosťami.",
  unexpectedTitle: "Vyskytla sa neočakávaná chyba",
  unknownDescription: "Vyskytla sa neočakávaná chyba. Skúste to prosím neskôr. ",
  unknownTitle: "Niečo sa nepodarilo."
}, mh = {
  subtitle: "Nastavte si nové heslo.",
  title: "Zabudli ste heslo?"
}, ph = {
  headMetaDescription: "Prihlasovacia stránka zákazníka",
  headTitle: "Prihláste sa svojím emailom a heslom:",
  subtitle: "Prihláste sa alebo si vytvorte účet a získajte všetky výhody Miele.",
  title: "Prihláste sa do svojho účtu",
  error: {
    invalidEmailPasswordDescription: "Kombinácia e-mailovej adresy a hesla nie je platná.",
    invalidEmailPasswordTitle: "Neplatné prihlasovacie údaje",
    missingConcentTitle: "Účet čaká na registráciu",
    noAccountDescription: "K tejto e-mailovej adrese nie je priradený žiadny účet.",
    noAccountTitle: "Nie je zaregistrovaný žiadny účet"
  },
  extraConsentScene: {
    continue: "Pokračovať",
    privacyStatementCheckboxLabel: "Beriem na vedomie {0}.",
    privacyStatementName: "Vyhlásenie o ochrane súkromia",
    privacyStatementTitle: "Naše zásady ochrany osobných údajov sa zmenili",
    termsOfUseCheckboxLabel: "Súhlasím s {0}.",
    termsOfUseName: "Podmienky používania",
    termsOfUseTitle: "Naše podmienky používania sa zmenili",
    title: "Finalizácia profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Späť na prihlásenie",
    submitButtonLabel: "Potvrdiť",
    successDescription: "Skontrolujte svoj e-mail, čoskoro dostanete informácie k procesu obnovenia hesla.",
    successTitle: "Vaša žiadosť bola prijatá.",
    title: "Ak chcete obnoviť heslo, zadajte svoju e-mailovú adresu:"
  },
  loginModalScene: {
    copy: "Prihláste sa alebo si vytvorte účet a získajte všetky funkcie Miele.",
    title: "Prihláste sa do svojho účtu"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Zabudol som heslo",
    invalidEmailMessage: "E-mail je neplatný!",
    loginButtonLabel: "Prihlásiť sa",
    passwordInputLabel: "Heslo",
    rememberMeLabel: "Zapamätovať",
    title: "Prihláste sa svojím emailom a heslom:"
  }
}, gh = {
  accessibility: {
    close: "Zavrieť"
  }
}, hh = {
  tooShort: "Príliš krátke",
  medium: "Stredné",
  strong: "Silné",
  tooWeak: "Príliš slabé",
  veryStrong: "Veľmi silné",
  weak: "Silné"
}, vh = {
  showPasswordText: "Zobraziť",
  hidePasswordText: "Skryť"
}, fh = {
  registerButtonLabel: "Registrovať",
  registerTitle: "Nemáte účet?",
  whyRegister: {
    list: [
      "Registrácia spotrebičov, sledovanie objednávok, prístup k manuálom",
      "Dostávajte informácie o aktuálnych ponukách a akciách",
      "Pozrite si všetky svoje objednávky, záruky, udalosti a služby"
    ],
    title: "Prečo sa registrovať?"
  },
  closeButtonLabel: "Zavrieť",
  passwordMismatchError: "heslá sa nezhodujú",
  passwordUpdateErrorTitle: "Chyba aktualizácie hesla",
  passwordUpdateSuccessTitle: "Heslo bolo aktualizované",
  successfulChangeLabel: "Vaše heslo bolo úspešne aktualizované"
}, kh = {
  title: "Marketingové preferencie",
  description: "Zaškrtnutím nižšie získate exkluzívne ponuky, novinky, udalosti a spôsob, ako zo svojho spotrebiča vyťažiť maximum.",
  submit: "Uložiť",
  levelOne: {
    text: `Áno, chcem dostávať od spoločností Miele s.r.o. a Miele & Cie. KG ("Miele") reklamné oznámenia prispôsobené mojim osobným záujmom prostredníctvom e-mailu, SMS, pošty a aplikácií Miele (ak ich používam) s informáciami o výrobkoch, ponukách a inováciách zo sortimentu Miele a o podujatiach Miele, ako aj o zákazníckych prieskumoch, požiadavkách na hodnotenie a recenzie výrobkov a o receptoch. Na tento účel môže spoločnosť Miele použiť moje kontaktné údaje (titul, meno, e-mailovú adresu, číslo mobilného telefónu a poštovú adresu) a navrhnúť komunikáciu na základe histórie mojich nákupov, udalostí a služieb, môjho správania pri klikaní a otváraní newsletteru a mojich zákazníckych hodnotení, ako je podrobnejšie popísané v našich informáciách o ochrane údajov. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať (napr. zaslaním neformálnej správy na e-mail info{'@'}miele.sk, kontaktnými údajmi uvedenými v právnom upozornení alebo kliknutím na odkaz na odhlásenie v e-mailoch).`,
    link: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/ochrana-osobnych-udajov-14.htm"
    }
  },
  levelTwo: {
    text: "Okrem môjho základného súhlasu súhlasím s tým, že spoločnosť Miele môže spracúvať aj údaje z používania aplikácie Miele a z mojich návštev webových stránok Miele (www.miele.sk) vrátane správania používateľa súvisiaceho s kliknutiami na newsletter na prepojených webových stránkach Miele na doplnenie môjho používateľského profilu na účely personalizovanej reklamnej komunikácie, a to za predpokladu, že môj samostatný súhlas v aplikácii alebo na webovej stránke uvoľní spracovanie údajov. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať. Ďalšie podrobnosti nájdete na odkaze Ochrana osobných údajov.",
    link: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/ochrana-osobnych-udajov-14.htm"
    }
  },
  levelThree: {
    text: "Okrem môjho základného súhlasu súhlasím s tým, že spoločnosť Miele môže spracúvať údaje z mojich sieťových spotrebičov Miele (údaje o používaní a stave spotrebičov) na doplnenie môjho používateľského profilu na účely personalizovanej reklamy. Ďalšie informácie o spracovaní údajov spotrebičov nájdem v zásadách ochrany osobných údajov pre systém Miele{'@'}Home. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať. Ďalšie informácie nájdete na odkaze Ochrana osobných údajov.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Áno, súhlasím s podmienkami používania.",
    link: {
      title: "Pozrite si podmienky používania",
      ref: "https://www.miele.sk/c/podmienky-pouzivania-304.htm"
    }
  }
}, bh = {
  headline: "",
  why: {
    title: "",
    reasons: ""
  },
  birthDateTitle: "",
  birthDateValidation: {
    requirementMsg: "",
    errorMsg: ""
  },
  joinClubLabel: "",
  termsAndCondition: {
    description: "",
    termsAndConditionLink: {
      title: "Podmienky používania",
      ref: "https://www.miele.sk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    description: "",
    shortDescription: "Áno, chcem dostávať propagačnú komunikáciu Miele Club, prispôsobenú mojim osobným záujmom, prostredníctvom e-mailu a pošty",
    privacyLink: {
      title: "Ochrana osobných údajov Miele Club",
      href: "https://www.miele.sk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikácia Club",
      href: "https://www.miele.sk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.sk"
  },
  selectAllConsents: {
    description: "Aby ste sa stali členom Miele Klubu, musíte prijať všetky podmienky *"
  },
  birthDateLabel: "Váš dátum narodenia (nepovinné)"
}, wh = "zobraziť celé vyhlásenie", yh = "skryť celé vyhlásenie", Mh = {
  auth: lh,
  changeEmailScene: ch,
  changePasswordScene: dh,
  errors: uh,
  forgotPassword: mh,
  login: ph,
  modal: gh,
  passwordStrength: hh,
  passwordHelper: vh,
  register: fh,
  "marketing-consent": {
    title: "Marketingové preferencie",
    description: "Zaškrtnutím nižšie získate exkluzívne ponuky, novinky, udalosti a spôsob, ako zo svojho spotrebiča vyťažiť maximum.",
    submit: "Uložiť",
    newsletter: {
      text: 'Súhlasím s tým, že Miele s.r.o ("Miele") mi môže posielať informácie o produktoch a inováciách z produktového radu Miele, podujatiach Miele, ako aj zákaznícke prieskumy a recepty prostredníctvom e-mailu, aplikácií Miele a SMS a že Miele môže spracovať kontaktné údaje, ktoré som uviedol (titul, meno, e-mailová adresa, číslo mobilného telefónu a PSČ) a produkty Miele, ktoré som si doteraz zakúpil a kúpim v budúcnosti, ako aj záujmy, ktoré som na tento účel uviedol. Ďalej súhlasím s tým, že Miele môže za účelom personalizácie spracovávať aj potvrdenia o prijatí a prečítaní potvrdení doručených prostredníctvom newsletteru a informácie o odkazoch, na ktoré som klikol, ako aj o mojom správaní používateľov na prepojenej webovej stránke. To isté platí pre push správy v aplikácii, pokiaľ sa používajú v aplikácii Miele.',
      link: {
        title: "Viď. zásady ochrany údajov",
        ref: ""
      }
    },
    personalisation: {
      text: "Súhlasím s tým, že Miele môže spracovávať informácie o službách, ktoré som využil, a o úlohách technikov, ktoré som vykonal, ako aj o podujatiach, ktorých som sa zúčastnil, za účelom vylepšenej personalizácie.",
      link: {
        title: "Viď. zásady ochrany údajov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Okrem rozšírenej personalizácie súhlasím s tým, že Miele môže na doplnenie môjho používateľského profilu spracúvať aj údaje z používania aplikácie Miele a mojich návštev na webových stránkach Miele (www.miele.co.uk), ak som s tým osobitne súhlasil. ",
      link: {
        title: "Viď. Zásady ochrany údajov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoj súhlas môžem kedykoľvek odvolať bez uvedenia dôvodov s účinnosťou do budúcnosti.  ",
      link: {
        title: "Zásady ochrany údajov",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Áno, súhlasím s podmienkami používania.",
      link: {
        title: "Viď. Podmienky používania*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: kh,
  mieleClub: bh,
  readMore: wh,
  readLess: yh
}, zh = {
  waitMessage: "Už jste skoro tam. "
}, jh = {
  buttonLabel: "Uložit",
  buttonLabelClose: "Zavřít",
  confirmEmailMessage: "Potvrďte svou e-mailovou adresu",
  copy: "Chcete-li aktualizovat svou e-mailovou adresu, přidejte novou níže:",
  errorMessageCopy: "Něco se pokazilo. ",
  errorMessageHeadline: "Chyba",
  headline: "Podrobnosti profilu",
  inputEmailConfirmPlaceholder: "Potvrďte svou e-mailovou adresu",
  inputEmailPlaceholder: "E-mailová adresa",
  invalidEmailMessage: "E-mail není platný!",
  rememberMeLabel: "Zapamatovat",
  successMessageCopy: "Vaše e-mailová adresa byla úspěšně aktualizována.",
  successMessageHeadline: "E-mailová adresa byla aktualizována"
}, _h = {
  closeButtonLabel: "Zavřít",
  confirmPasswordLabel: "Potvrďte heslo",
  currentPasswordLabel: "Aktuální heslo",
  newPasswordLabel: "Nové heslo",
  passwordMismatchError: "Heslo se neshoduje",
  passwordUpdateErrorTitle: "Chyba",
  passwordUpdateSuccessTitle: "Heslo aktualizováno",
  samePasswordError: "Toto heslo bylo použito již dříve, zadejte prosím nové heslo",
  subtitle: "Chcete-li změnit heslo, vyplňte níže uvedená pole:",
  submitButtonLabel: "Potvrdit",
  successfulChangeLabel: "Vaše heslo bylo úspěšně aktualizováno",
  title: "Změna hesla"
}, Eh = {
  invalidEmail: "Nesprávný e-mail",
  invalidPassword: "Špatné heslo",
  sap_206002: "Váš účet čeká na ověření. Kontaktujte nás pro bližší informace. ",
  sap_206006: "Zdá se, že vámi odeslaná e-mailová adresa čeká na ověření",
  sap_400003: "Tento e-mail již existuje, použijte prosím jinou e-mailovou adresu.",
  sap_400028: "Odeslaná e-mailová adresa čeká na ověření",
  sap_400050: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_400097: "Zdá se, že k našim službám přistupujete z nezabezpečeného/nepodporovaného prohlížeče. ",
  sap_401030: "Toto heslo bylo použito již dříve, zadejte prosím nové heslo",
  sap_403005: "K této e-mailové adrese nemáme přidružený účet, zkontrolujte svůj e-mail a zkuste to znovu",
  sap_403011: "Relace vypršela. Znovu načtěte prohlížeč a opět se přihlaste. ",
  sap_403012: "Relace vypršela. Znovu načtěte prohlížeč a opět se přihlaste.",
  sap_403013: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_403035: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_403041: "K této e-mailové adrese nemáme přidružený účet, zkontrolujte svůj e-mail a zkuste to znovu",
  sap_403042: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403043: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403047: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403100: "Žádost o aktualizaci hesla byla nedávno vyžádána, prosíme o strpení, dokud nebude žádost zpracována",
  sap_403025: "Odkaz pro resetování hesla je neplatný, zašlete prosím žádost o zapomenuté heslo znovu, abyste obdrželi nový odkaz pro resetování.",
  sapErrorTitle: "Chyba při zpracování požadavku",
  sessionExpired: "Relace vypršela",
  tooWeakPassword: "Heslo musí obsahovat alespoň {minLength} znaků a {minCharGroups} z následujících: velké písmeno, malé písmeno, číslo, speciální symbol | Heslo musí obsahovat alespoň {minLength} znaků",
  unexpectedDescription: "Pokud problém přetrvává, sdělte nám prosím podrobnosti prostřednictvím kontaktního formuláře.",
  unexpectedTitle: "Došlo k neočekávané chybě",
  unknownDescription: "Došlo k neočekávané chybě. ",
  unknownTitle: "Něco je špatně."
}, Sh = {
  subtitle: "Nastavte si nové heslo.",
  title: "Zapomněli jste heslo?"
}, Lh = {
  headMetaDescription: "Přihlašovací stránka zákazníka",
  headTitle: "Přihlaste se pomocí svého e-mailu a hesla:",
  subtitle: "Přihlaste se nebo si vytvořte účet a získejte všechny výhody Miele.",
  title: "Přihlaste se ke svému účtu",
  error: {
    invalidEmailPasswordDescription: "Kombinace e-mailové adresy a hesla není platná.",
    invalidEmailPasswordTitle: "Neplatné přihlašovací údaje",
    missingConcentTitle: "Účet čeká na registraci",
    noAccountDescription: "K této e-mailové adrese není přidružen žádný účet.",
    noAccountTitle: "Není registrován žádný účet"
  },
  extraConsentScene: {
    continue: "Pokračovat",
    privacyStatementCheckboxLabel: "Beru na vědomí {0}.",
    privacyStatementName: "Prohlášení o ochraně soukromí",
    privacyStatementTitle: "Naše zásady ochrany osobních údajů se změnily",
    termsOfUseCheckboxLabel: "Souhlasím s {0}.",
    termsOfUseName: "Podmínky používání",
    termsOfUseTitle: "Naše podmínky používání se změnily",
    title: "Finalizace profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zpět k přihlášení",
    submitButtonLabel: "Potvrdit",
    successDescription: "Zkontrolujte prosím svůj e-mail, brzy obdržíte informace na svůj účet, abyste mohli začít s procesem resetování hesla.",
    successTitle: "Vaše žádost byla přijata.",
    title: "Pro resetování hesla zadejte svou e-mailovou adresu:"
  },
  loginModalScene: {
    copy: "Přihlaste se nebo si vytvořte účet a získejte všechny funkce Miele.",
    title: "Přihlaste se ke svému účtu"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Zapomněl jsem heslo",
    invalidEmailMessage: "E-mail není platný!",
    loginButtonLabel: "Přihlásit se",
    passwordInputLabel: "Heslo",
    rememberMeLabel: "Zapamatovat",
    title: "Přihlaste se pomocí svého e-mailu a hesla:"
  }
}, Ch = {
  accessibility: {
    close: "Zavřít"
  }
}, Ph = {
  tooShort: "Příliš krátké",
  medium: "Střední",
  strong: "Silné",
  tooWeak: "Příliš slabé",
  veryStrong: "Velmi silné",
  weak: "Slabé"
}, Th = {
  showPasswordText: "Zobrazit",
  hidePasswordText: "Skrýt"
}, Ah = {
  registerButtonLabel: "Registrovat",
  registerTitle: "Nemáte účet?",
  whyRegister: {
    list: [
      "Získejte přístup k exkluzivním výhodám klubu Miele",
      "Registrace spotřebičů, sledování objednávek, přístup k návodům",
      "Získejte individuální nabídky a akce",
      "Podívejte se na všechny své objednávky, záruky, události a služby"
    ],
    title: "Proč se registrovat?"
  },
  closeButtonLabel: "Zavřít",
  passwordMismatchError: "Hesla se neshodují",
  passwordUpdateErrorTitle: "Chyba aktualizace hesla",
  passwordUpdateSuccessTitle: "Heslo aktualizováno",
  successfulChangeLabel: "Vaše heslo bylo úspěšně aktualizováno"
}, xh = {
  title: "Marketingové preference",
  description: "Zaškrtnutím níže získáte exkluzivní nabídky, novinky, události a způsob, jak ze svého spotřebiče vytěžit maximum.",
  submit: "Uložit",
  levelOne: {
    shortText: 'Ano, chci dostávat marketingová sdělení od společností Miele, spol. s r.o.a Miele & Cie. KG ("Miele") přizpůsobená mým osobním zájmům prostřednictvím e-mailu, textových zpráv, pošty a aplikací Miele (pokud je používám)',
    text: `Ano, chci dostávat marketingová sdělení od společností Miele, spol. s r.o.a Miele & Cie. KG ("Miele") přizpůsobená mým osobním zájmům prostřednictvím e-mailu, textových zpráv, pošty a aplikací Miele (pokud je používám) s informacemi o výrobcích, nabídkách a novinkách ze sortimentu Miele a o akcích Miele, jakož i o průzkumech mezi zákazníky, žádostech o hodnocení a recenze výrobků a receptech. K tomuto účelu může Miele použít mé kontaktní údaje (titul, jméno, e-mailovou adresu, číslo mobilního telefonu a poštovní adresu) a navrhnout komunikaci na základě mých nákupů, služeb, historie událostí, chování při kliknutí na newsletter a jeho otevření, jakož i hodnoty zákazníka, jak je podrobně popsáno v našich zásadách ochrany osobních údajů. Svůj souhlas mohu kdykoli odvolat bez udání důvodu s účinností do budoucna (např. zasláním neformální zprávy na adresu info{'@'}miele.cz, kontaktními údaji uvedenými v tiráži nebo kliknutím na odhlašovací odkaz v e-mailech)`,
    link: {
      title: "Ochrana osobních údajů",
      ref: "https://www.miele.cz/c/ochrana-osobnich-udaju-14.htm"
    }
  },
  levelTwo: {
    text: "Kromě mého základního souhlasu souhlasím s tím, že společnost Miele může zpracovávat také údaje z používání aplikace Miele a z mých návštěv webových stránek Miele (www.miele.cz ), včetně chování uživatele na webových stránkách Miele po kliknutí na propojený newsletter, za účelem doplnění mého uživatelského profilu pro personalizovaná reklamní sdělení, pokud můj samostatný souhlas v aplikaci nebo na webové stránce povoluje zpracování údajů. Svůj souhlas mohu kdykoli odvolat bez udání důvodů s účinností do budoucna. Další podrobnosti najdete v zásadách ochrany osobních údajů společnosti Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Kromě mého základního souhlasu souhlasím s tím, že společnost Miele může zpracovávat také údaje z mých připojených spotřebičů Miele (údaje o používání a stavu spotřebičů) za účelem doplnění mého uživatelského profilu pro personalizovanou reklamu. Další informace o zpracování údajů o přístrojích naleznu v zásadách ochrany osobních údajů o systému Miele{'@'}Home. Svůj souhlas mohu kdykoli odvolat bez udání důvodů s účinností do budoucna. Další podrobnosti najdete v zásadách ochrany osobních údajů společnosti Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Svůj souhlas mohu kdykoli bez udání důvodů odvolat s účinkem do budoucna.  ",
    link: {
      title: "Zásady ochrany údajů",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ano, souhlasím s podmínkami použití.",
    link: {
      title: "Viz Podmínky použití*",
      ref: ""
    }
  }
}, Ih = {
  headline: "Miele Club",
  birthDateTitle: "Chtěli byste dostat narozeninové překvapení?",
  birthDateLabel: "Vaše datum narození (volitelné)",
  why: {
    title: "Bezplatné členství – Exkluzivní nabídky pro členy.",
    reasons: [
      "Uvítací voucher",
      "Narozeninové překvapení",
      "Speciální nabídky",
      "Pozvánky na exkluzivní akce a zážitky"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Zadejte prosím tento formát data: DD/MM/RRRR",
    errorMsg: "Nesprávné datum"
  },
  joinClubLabel: "Ano, rád bych se stal členem Miele Club.",
  termsAndCondition: {
    description: "Souhlasím s podmínkami klubu Miele {termsAndConditionLink} a beru na vědomí {privacyLink} informace týkající se klubu Miele.",
    termsAndConditionLink: {
      title: "Podmínky užívání",
      ref: "https://www.miele.cz/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Ochrana dat",
      ref: "https://www.miele.cz/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Ano, rád(a) bych dostával(a) propagační komunikaci klubu Miele, přizpůsobenou mým osobním zájmům, e-mailem a poštou",
    description: "Ano, rád(a) bych dostával(a) propagační komunikaci klubu Miele, přizpůsobenou mým osobním zájmům, e-mailem a poštou zahrnující speciální nabídky, informace, pozvánky na akce a zákaznické průzkumy o produktech a službách Miele. Za tímto účelem může Miele použít mé kontaktní údaje (tituly, jméno, e-mailovou a poštovní adresu) a upravit komunikaci na základě mého nákupního a newsletterového chování i mé zákaznícké hodnoty, jak je podrobněji popsáno v našich {privacyLink}. Svůj souhlas mohu kdykoli odvolat s účinností do budoucna (například zasláním e-mailu na info{'@'}miele.cz, kontaktováním prostřednictvím kontaktních údajů uvedených v právním oznámení nebo kliknutím na odkaz pro odhlášení v e-mailech). Smluvní komunikace klubu Miele {termsAndConditionLink} tím nejsou ovlivněny, pokud neukončím své členství.",
    privacyLink: {
      title: "Ochrana dat klubu Miele",
      href: "https://www.miele.cz/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikace klubu",
      href: "https://www.miele.cz/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.cz"
  },
  selectAllConsents: {
    description: "Pro vstup do Miele Clubu musíte souhlasit se všemi podmínkami *"
  }
}, Dh = "vis hele erklæringen", Nh = "vis mindre", Oh = {
  auth: zh,
  changeEmailScene: jh,
  changePasswordScene: _h,
  errors: Eh,
  forgotPassword: Sh,
  login: Lh,
  modal: Ch,
  passwordStrength: Ph,
  passwordHelper: Th,
  register: Ah,
  "marketing-consent": {
    title: "Marketingové preference",
    description: "Zaškrtnutím níže získáte exkluzivní nabídky, novinky, události a způsob, jak ze svého spotřebiče vytěžit maximum.",
    submit: "Uložit",
    newsletter: {
      text: 'Souhlasím s tím, že mi Miele, spol. s r.o. ("Miele") může zasílat informace o produktech, novinkách a akcích Miele, jakož i zákaznické průzkumy a recepty prostřednictvím e-mailu, aplikace Miele a SMS a že Miele může zpracovávat kontaktní údaje, které jsem uvedl (titul, jméno, e-mailová adresa, číslo mobilního telefonu a PSČ) a produkty Miele, které jsem dosud zakoupil a zakoupím v budoucnu, jakož i zájmy, které jsem pro tento účel uvedl. Dále souhlasím s tím, že Miele může za účelem personalizace zpracovávat také potvrzení o přijetí a přečtení přijatá prostřednictvím newsletteru a informace o odkazech, na které jsem klikl, a také o mém souvisejícím uživatelském chování na odkazovaném webu. Totéž platí pro push notifikace v aplikaci Miele.',
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    personalisation: {
      text: "Souhlasím s tím, že Miele může zpracovávat informace o službách, které jsem využil, a úkolech techniků, které jsem provedl, a také o akcích, kterých jsem se zúčastnil, za účelem lepší personalizace.",
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Kromě rozšířené personalizace souhlasím s tím, že Miele může také zpracovávat údaje z používání aplikace Miele a mých návštěv na webových stránkách Miele (www.miele.cz) za účelem doplnění mého uživatelského profilu, pokud jsem k tomu dal samostatný souhlas. ",
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svůj souhlas mohu kdykoli bez udání důvodů odvolat s účinkem do budoucna.  ",
      link: {
        title: "Zásady ochrany údajů",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ano, souhlasím s podmínkami použití.",
      link: {
        title: "Viz Podmínky použití*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: xh,
  mieleClub: Ih,
  readMore: Dh,
  readLess: Nh
}, Uh = {
  waitMessage: "Aproape acolo. "
}, $h = {
  buttonLabel: "Salvați",
  buttonLabelClose: "Închide",
  confirmEmailMessage: "Confirmați-vă adresa de e-mail",
  copy: "Pentru a vă actualiza adresa de e-mail, adăugați-o pe cea nouă mai jos:",
  errorMessageCopy: "Ceva nu a mers bine. ",
  errorMessageHeadline: "Eroare",
  headline: "Detalii profil",
  inputEmailConfirmPlaceholder: "Confirmați adresa dumneavoastră de email",
  inputEmailPlaceholder: "Adresa de e-mail",
  invalidEmailMessage: "E-mail nu este valabil!",
  rememberMeLabel: "Ține-mă minte",
  successMessageCopy: "Adresa dvs. de e-mail a fost actualizată cu succes.",
  successMessageHeadline: "Adresă de e-mail actualizată"
}, Bh = {
  closeButtonLabel: "Închide",
  confirmPasswordLabel: "Confirmă parola",
  currentPasswordLabel: "Parola actuală",
  newPasswordLabel: "Parolă nouă",
  passwordMismatchError: "Parola nu se potriveste",
  passwordUpdateErrorTitle: "Eroare",
  passwordUpdateSuccessTitle: "Parolă actualizată",
  samePasswordError: "Această parolă a fost folosită anterior, vă rugăm să trimiteți o nouă parolă",
  subtitle: "Pentru a vă schimba parola, vă rugăm să completați câmpurile de mai jos:",
  submitButtonLabel: "Trimite",
  successfulChangeLabel: "Parola dvs. a fost actualizată cu succes",
  title: "Schimbarea parolei"
}, Rh = {
  invalidEmail: "email incorect",
  invalidPassword: "Parola greşită",
  sap_206002: "Contul dvs. este în așteptarea verificării, nu vă putem lăsa să continuați în acest moment. ",
  sap_206006: "Se pare că adresa de e-mail pe care ați trimis-o este în așteptarea verificării",
  sap_400003: "Acest e-mail există deja, vă rugăm să utilizați o altă adresă de e-mail.",
  sap_400028: "Adresa de e-mail trimisă este în așteptarea verificării",
  sap_400050: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_400097: "Se pare că accesați serviciile noastre dintr-un browser nesigur/neacceptat. Vă rugăm să încercaţi din nou pe un alt browser. ",
  sap_401030: "Această parolă a fost folosită anterior, vă rugăm să trimiteți o nouă parolă",
  sap_403005: "Nu avem un cont asociat cu această adresă de e-mail, vă rugăm să vă verificați e-mailul și să încercați din nou",
  sap_403011: "Sesiunea a expirat. Vă rugăm să reîncărcați browserul și să vă conectați din nou. ",
  sap_403012: "Sesiunea a expirat. Vă rugăm să reîncărcați browserul și să vă conectați din nou.",
  sap_403013: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_403035: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_403041: "Nu avem un cont asociat cu această adresă de e-mail, vă rugăm să vă verificați e-mailul și să încercați din nou",
  sap_403042: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403043: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403047: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403100: "Recent a fost solicitată actualizarea parolei, vă rugăm să asteptaţi până când cererea este procesată",
  sap_403025: "Linkul de resetare a parolei este invalid, vă rugăm să trimiteți din nou cererea de resetare a parolei pentru a primi un nou link de resetare.",
  sapErrorTitle: "Eroare la procesarea cererii",
  sessionExpired: "Sesiunea a expirat",
  tooWeakPassword: "Parola trebuie să conțină cel puțin {minLength} caractere și {minCharGroups} dintre următoarele: literă mare, literă mică, număr, simbol special | Parola trebuie să conțină cel puțin {minLength} caractere",
  unexpectedDescription: "Dacă problema persistă, vă rugăm să ne contactați prin formularul de contact cu detalii.",
  unexpectedTitle: "A apărut o eroare neașteptată",
  unknownDescription: "A apărut o eroare neașteptată. Vă rugăm să încercaţi din nou. ",
  unknownTitle: "Uh Oh!"
}, Vh = {
  subtitle: "Setează-ți noua parolă.",
  title: "Ați uitat parola?"
}, Fh = {
  headMetaDescription: "Pagina de conectare a clientului",
  headTitle: "Conectați-vă cu adresa dvs. de e-mail și parola:",
  subtitle: "Conectați-vă sau creaţi un cont pentru a beneficia de toate funcțiile Miele.",
  title: "conectați-vă la contul dvs.",
  error: {
    invalidEmailPasswordDescription: "Combinația dintre adresa de e-mail și parola nu este validă.",
    invalidEmailPasswordTitle: "Acreditări nevalide",
    missingConcentTitle: "Cont în așteptarea înregistrării",
    noAccountDescription: "Nu există niciun cont asociat acestei adrese de e-mail.",
    noAccountTitle: "Niciun cont înregistrat"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Am luat notă de {0}.",
    privacyStatementName: "Declarație de confidențialitate",
    privacyStatementTitle: "Politica noastră de confidențialitate s-a schimbat",
    termsOfUseCheckboxLabel: "Sunt de acord cu {0}.",
    termsOfUseName: "termeni de utilizare",
    termsOfUseTitle: "Termenii noștri de utilizare s-au modificat",
    title: "Finalizarea profilului"
  },
  forgotPasswordScene: {
    backButtonLabel: "Înapoi la autentificare",
    submitButtonLabel: "Trimite",
    successDescription: "Vă rugăm să vă verificați e-mailul, veți primi în curând informațiile despre contul dvs. pentru a începe procesul de resetare a parolei.",
    successTitle: "Cererea dvs. a fost primită.",
    title: "Vă rugăm să introduceți adresa de e-mail pentru a vă reseta parola:"
  },
  loginModalScene: {
    copy: "Conectați-vă sau creaţi un cont pentru a beneficia de toate funcțiile Miele.",
    title: "conectați-vă la contul dvs."
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mi-am uitat parola",
    invalidEmailMessage: "E-mail nu este valabil!",
    loginButtonLabel: "Log in",
    passwordInputLabel: "Parola",
    rememberMeLabel: "Ține-mă minte",
    title: "Conectați-vă cu adresa dvs. de e-mail și parola:"
  }
}, qh = {
  accessibility: {
    close: "Închide"
  }
}, Gh = {
  tooShort: "Prea scurtă",
  medium: "Mediu",
  strong: "Puternic",
  tooWeak: "Prea slab",
  veryStrong: "Foarte puternic",
  weak: "Slab"
}, Kh = {
  showPasswordText: "Arată",
  hidePasswordText: "Ascunde"
}, Hh = {
  registerButtonLabel: "Înregistrează-te",
  registerTitle: "Nu aveţi un cont?",
  whyRegister: {
    list: [
      "Acces la beneficiile exclusive Miele Club",
      "Înregistrați aparatele, urmăriți comenzile, accesați manuale",
      "Primiți oferte și promoții personalizate",
      "Vedeți toate comenzile, garanțiile, evenimentele și serviciile dvs"
    ],
    title: "De ce să te înregistrezi?"
  },
  closeButtonLabel: "Închide",
  passwordMismatchError: "parola nu se potriveste",
  passwordUpdateErrorTitle: "Eroare de actualizare a parolei",
  passwordUpdateSuccessTitle: "Parolă actualizată",
  successfulChangeLabel: "Parola dvs. a fost actualizată cu succes"
}, Wh = {
  title: "Preferințe de marketing",
  description: "Bifați mai jos pentru oferte exclusive, noutăţi, evenimente și cum să profitați la maximum de aparatul dvs.",
  submit: "Salvați",
  levelOne: {
    shortText: 'Da, aș dori să primesc comunicări promoționale de la Miele Appliances S.R.L. și Miele & Cie. KG ("Miele") adaptate intereselor mele personale prin e-mail, mesaj text, poștă și prin aplicațiile Miele (dacă sunt utilizate)',
    text: `Da, aș dori să primesc comunicări promoționale de la Miele Appliances S.R.L. și Miele & Cie. KG ("Miele") adaptate intereselor mele personale prin e-mail, mesaj text, poștă și prin aplicațiile Miele (dacă sunt utilizate) cu informații despre produse, oferte și inovații din gama de produse Miele și despre evenimentele Miele, precum și cu sondaje de opinie pentru clienți, solicitări de evaluare și recenzii ale produselor, și rețete. În acest scop, Miele poate utiliza informațiile mele de contact (titlu, nume, adresă de e-mail, număr de telefon mobil și adresă poștală) și poate concepe comunicarea în funcție de achiziția mea, servicii, istoricul evenimentelor, comportamentul de click și deschidere a newsletter-ului, precum și de valoarea clientului, așa cum este descris în detaliu în politica noastră de confidențialitate. Îmi pot revoca consimțământul în orice moment, fără a oferi motive, cu efect pentru viitor (de exemplu, prin trimiterea unui mesaj informal la news{'@'}miele.ro, la datele de contact indicate în amprentă sau făcând click pe link-ul de dezabonare din e-mailuri).`,
    link: {
      title: "Protecția datelor",
      ref: "https://www.miele.ro/c/protectia-datelor-14.htm"
    }
  },
  levelTwo: {
    text: "În plus față de consimțământul meu de bază, sunt de acord că Miele poate, de asemenea, să prelucreze date din utilizarea aplicației Miele și din vizitele mele pe site-urile Miele (www.miele.ro), inclusiv comportamentul utilizatorului pe site-urile Miele după clickurile pe newsletter-ul legat, pentru a completa profilul meu de utilizator pentru comunicări publicitare personalizate, cu condiția ca consimțământul meu separat în aplicație sau pe site să autorizeze prelucrarea datelor. Îmi pot revoca consimțământul în orice moment, fără a oferi motive, cu efect pentru viitor. Mai multe detalii în politica de protecție a datelor a Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: " În plus față de consimțământul meu de bază, sunt de acord că Miele poate, de asemenea, să prelucreze date de la aparatele mele Miele conectate (date privind utilizarea și starea aparatului) pentru a completa profilul meu de utilizator pentru publicitate personalizată. Pot găsi mai multe informații despre prelucrarea datelor aparatelor în politica de confidențialitate privind sistemul Miele{'@'}Home. Îmi pot revoca consimțământul în orice moment, fără a da motive, cu efect pentru viitor. Mai multe detalii în politica de protecție a datelor a Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Îmi pot revoca consimțământul în orice moment, fără a oferi motive cu efect pentru viitor. Pentru mai multe informații despre modul în care Miele gestionează datele dvs., consultați  ",
    link: {
      title: "politica de protectie a datelor.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, sunt de acord cu termenii de utilizare.",
    link: {
      title: "Consultați Termenii de utilizare*",
      ref: ""
    }
  }
}, Jh = {
  headline: "Miele Club",
  why: {
    title: "Membru",
    reasons: "Surpriză cu ocazia zilei de naștereOferte și campanii exclusive"
  },
  birthDateTitle: "Vă putem trimite un cadou de ziua de naștere?",
  birthDateValidation: {
    requirementMsg: "Utilizați un format precum LL/ZZ/AAAA",
    errorMsg: "Dată invalidă"
  },
  joinClubLabel: "Da, vreau să mă alătur clubului Miele.",
  termsAndCondition: {
    description: "Devenind membru al Clubului Miele, sunteți de acord cu termenii și condițiile Clubului Miele.",
    termsAndConditionLink: {
      title: "Termenii și condițiile",
      ref: "https://www.miele.ro/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Protecția datelor cu caracter personal",
      ref: "https://www.miele.ro/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    description: "Da, vreau să devin membru al Clubului Miele și să primesc comunicări din Clubul Miele (cadou de bun venit, surpriză de ziua de naștere, reformulare a statutului de membru, știri despre Clubul Miele) prin e-mail.",
    shortDescription: "Da, aș dori să primesc comunicări promoționale de la Clubul Miele, adaptate intereselor mele personale, prin e-mail și poștă",
    privacyLink: {
      title: "Protecția datelor Clubului Miele",
      href: "https://www.miele.ro/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicare Club",
      href: "https://www.miele.ro/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.ro"
  },
  selectAllConsents: {
    description: "Pentru a deveni membru al Clubului Miele, trebuie să acceptați toți termenii și condițiile *"
  },
  birthDateLabel: "Data ta de naștere (opțional)"
}, Zh = "arată declarația completă", Yh = "ascunde declarația completă", Xh = {
  auth: Uh,
  changeEmailScene: $h,
  changePasswordScene: Bh,
  errors: Rh,
  forgotPassword: Vh,
  login: Fh,
  modal: qh,
  passwordStrength: Gh,
  passwordHelper: Kh,
  register: Hh,
  "marketing-consent": {
    title: "Preferințe de marketing",
    description: "Bifați mai jos pentru oferte exclusive, noutăţi, evenimente și cum să profitați la maximum de aparatul dvs.",
    submit: "Salvați",
    newsletter: {
      text: 'Sunt de acord ca Miele Co Ltd. ("Miele") să îmi trimită informaţii despre produse şi despre inovaţiile din gama de produse Miele, despre evenimente, despre sondaje şi reţete pe adresa de e-mail, aplicaţiile Miele şi prin SMS, şi că Miele poate procesa datele de contact pe care le-am furnizat (titlu, nume, adresa de e-mail, număr de telefon mobil și cod poștal) și produsele Miele pe care le-am achiziționat până în prezent și pe care le voi achiziționa în viitor, precum și interesele pe care le-am indicat în acest scop. De asemenea, sunt de acord că Miele poate procesa primirea și confirmările primite prin newsletter și informații despre linkurile pe care am făcut click, precum și despre comportamentul meu de utilizator al site-ul web în scopul personalizării serviciilor.  Același lucru este valabil și pentru mesajele push din aplicație, în măsura în care sunt utilizate aplicațiile Miele.',
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    personalisation: {
      text: "Sunt de acord ca Miele să prelucreze informații despre serviciile pe care le-am folosit și despre asistenţa tehnicienilor de care am beneficiat, precum și despre evenimentele la care am participat, în scopul îmbunătăţirii serviciilor",
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Pe lângă personalizarea extinsă, sunt de acord că Miele poate prelucra și date din utilizarea aplicației Miele și vizitele mele pe site-ul web Miele (www.miele.ro) pentru a-mi suplimenta profilul de utilizator, cu condiția să fiu de acord separat. ",
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    highlightedText: {
      text: "Îmi pot revoca consimțământul în orice moment, fără a oferi motive cu efect pentru viitor. Pentru mai multe informații despre modul în care Miele gestionează datele dvs., consultați  ",
      link: {
        title: "politica de protectie a datelor.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, sunt de acord cu termenii de utilizare.",
      link: {
        title: "Consultați Termenii de utilizare.",
        ref: "https://www.miele.ro/c/termeni-si-conditii-generale-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: Wh,
  mieleClub: Jh,
  readMore: Zh,
  readLess: Yh
}, Qh = {
  waitMessage: "Još samo malo... "
}, ev = {
  buttonLabel: "Pohraniti",
  buttonLabelClose: "Zatvoriti",
  confirmEmailMessage: "Potvrdite svoju e-mail adresu",
  copy: "Da biste ažurirali svoju adresu e-pošte, molimo dodajte novu u nastavku:",
  errorMessageCopy: "Nešto je pošlo po zlu. Molimo pokušajte ponovno. ",
  errorMessageHeadline: "Greška",
  headline: "Pojedinosti o profilu",
  inputEmailConfirmPlaceholder: "Potvrdite svoju adresu e-pošte",
  inputEmailPlaceholder: "Adresa e-pošte",
  invalidEmailMessage: "E-pošta nije valjana!",
  rememberMeLabel: "Zapamti me",
  successMessageCopy: "Vaša adresa e-pošte je uspješno ažurirana.",
  successMessageHeadline: "Adresa e-pošte ažurirana"
}, tv = {
  closeButtonLabel: "Zatvoriti",
  confirmPasswordLabel: "Potvrditi zaporku",
  currentPasswordLabel: "Trenutna zaporka",
  newPasswordLabel: "Nova zaporka",
  passwordMismatchError: "Zaporka se ne podudara",
  passwordUpdateErrorTitle: "Greška",
  passwordUpdateSuccessTitle: "Zaporka ažurirana",
  samePasswordError: "Ova zaporka je već korištena ranije, molimo pošaljite novu zaporku",
  subtitle: "Za promjenu zaporke molimo ispunite polja niže:",
  submitButtonLabel: "Podnijeti",
  successfulChangeLabel: "Vaša zaporka je uspješno ažurirana",
  title: "Promjena zaporke"
}, iv = {
  invalidEmail: "Netočna e-pošta",
  invalidPassword: "Pogrešna zaporka",
  sap_206002: "Vaš račun čeka potvrdu, na žalost trenutno ne možete nastaviti. ",
  sap_206006: "Čini se da adresa e-pošte koju ste poslali čeka potvrdu",
  sap_400003: "Ova adresa e-pošte već postoji, molimo upotrijebite drugu adresu e-pošte.",
  sap_400028: "Poslana adresa e-pošte čeka potvrdu",
  sap_400050: "Nažalost, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_400097: "Čini se da našim uslugama pristupate iz nesigurnog/nepodržanog preglednika. ",
  sap_401030: "Ova zaporka je već korištena ranije, molimo pošaljite novu zaporku",
  sap_403005: "Nemamo račun povezan s ovom adresom e-pošte, provjerite svoju e-poštu i pokušajte ponovno",
  sap_403011: "Vrijeme isteklo. Molimo ponovno učitajte preglednik i ponovno se prijavite.",
  sap_403012: "Vrijeme isteklo. Molimo ponovno učitajte preglednik i ponovno se prijavite.",
  sap_403013: "Ispričavamo se, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_403035: "Ispričavamo se, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_403041: "Nemamo račun povezan s ovom adresom e-pošte, molimo provjerite svoju e-poštu i pokušajte ponovno",
  sap_403042: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403043: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403047: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403100: "Nedavno je zatražen zahtjev za ažuriranje zaporke, molimo za strpljenje dok se zahtjev ne obradi",
  sap_403025: "Veza za poništavanje lozinke nije važeća, pošaljite ponovno zahtjev za zaboravljenu lozinku kako biste primili novu vezu za poništavanje.",
  sapErrorTitle: "Greška u obradi zahtjeva",
  sessionExpired: "Vrijeme isteklo",
  tooWeakPassword: "Zaporka mora sadržavati najmanje {minLength} znakova i {minCharGroups} od sljedećeg: veliko slovo, malo slovo, broj, poseban simbol | Zaporka mora sadržavati najmanje {minLength} znakova",
  unexpectedDescription: "Ako problem potraje, kontaktirajte nas putem obrasca za kontakt s detaljima.",
  unexpectedTitle: "Došlo je do neočekivane greške",
  unknownDescription: "Došlo je do neočekivane greške. ",
  unknownTitle: "Uh oh!"
}, av = {
  subtitle: "Postavite novu zaporku.",
  title: "Zaboravili ste zaporku?"
}, nv = {
  headMetaDescription: "Stranica za prijavu korisnika",
  headTitle: "Prijavite se svojom e-poštom i zaporkom:",
  subtitle: "Prijavite se ili izradite račun kako biste dobili sve Miele značajke.",
  title: "Prijavite se na svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija adrese e-pošte i zaporke nije važeća.",
    invalidEmailPasswordTitle: "Nevažeće vjerodajnice",
    missingConcentTitle: "Račun na čekanju za registraciju",
    noAccountDescription: "Ne postoji račun povezan s ovom adresom e-pošte.",
    noAccountTitle: "Nema registriranog računa"
  },
  extraConsentScene: {
    continue: "Nastaviti",
    privacyStatementCheckboxLabel: "Primljeno na znanje {0}.",
    privacyStatementName: "Izjava o privatnosti",
    privacyStatementTitle: "Naša Pravila o privatnosti su promijenjena",
    termsOfUseCheckboxLabel: "Slažem se s {0}.",
    termsOfUseName: "Uvjeti korištenja",
    termsOfUseTitle: "Naši Uvjeti korištenja su promijenjeni",
    title: "Završetak profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Natrag na prijavu",
    submitButtonLabel: "Podnijeti",
    successDescription: "Provjerite svoju e-poštu, uskoro ćete dobiti informacije o svom računu kako biste započeli s postupkom ponovnog postavljanja zaporke.",
    successTitle: "Vaš zahtjev je zaprimljen.",
    title: "Molimo unesite svoju adresu e-pošte za poništavanje zaporke:"
  },
  loginModalScene: {
    copy: "Prijavite se ili izradite račun kako biste dobili sve Miele značajke.",
    title: "Prijavite se na svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Zaboravila/o sam lozinku",
    invalidEmailMessage: "E-pošta nije valjana!",
    loginButtonLabel: "Prijava",
    passwordInputLabel: "Zaporka",
    rememberMeLabel: "Zapamti me",
    title: "Prijavite se sa svojom e-poštom i zaporkom:"
  }
}, sv = {
  accessibility: {
    close: "Zatvoriti"
  }
}, ov = {
  tooShort: "Prekratka",
  medium: "Srednja",
  strong: "Jaka",
  tooWeak: "Preslaba",
  veryStrong: "Vrlo jaka",
  weak: "Slaba"
}, rv = {
  showPasswordText: "Prikazati",
  hidePasswordText: "Sakriti"
}, lv = {
  registerButtonLabel: "Registracija",
  registerTitle: "Nemate račun?",
  whyRegister: {
    list: [
      "Pristup ekskluzivnim pogodnostima Miele Cluba",
      "Registrirajte uređaje, pratite narudžbe, pristupite priručnicima",
      "Primajte prilagođene ponude i promocije",
      "Pogledajte sve svoje narudžbe, jamstva, događaje i usluge"
    ],
    title: "Zašto se registrirati?"
  },
  closeButtonLabel: "Zatvoriti",
  passwordMismatchError: "Zaporke se ne podudaraju",
  passwordUpdateErrorTitle: "Pogreška ažuriranja zaporke",
  passwordUpdateSuccessTitle: "Zaporka ažurirana",
  successfulChangeLabel: "Vaša zaporka je uspješno ažurirana"
}, cv = {
  title: "Marketinške postavke",
  description: "Označite niže za ekskluzivne ponude, novosti, događaje i kako najbolje iskoristiti svoj uređaj.",
  submit: "Pohraniti",
  levelOne: {
    text: "Da, želim primati promotivne poruke od tvrtke Miele trgovina i servis d.o.o. i od Miele&Cie. KG (“Miele”), prilagođene mojim osobnim interesima e-poštom, SMS-om, poštom i putem Miele aplikacija (ako ih koristim). Poruke sadrže informacije o proizvodima, ponudama i inovacijama iz asortimana tvrtke Miele te događanjima kao i ankete kupaca, zahtjeve za ocjenama i recenzije proizvoda i recepata. U tu svrhu Miele može koristiti moje podatke za kontakt (naziv, ime, adresu e-pošte, broj mobilnog telefona i poštansku adresu) i oblikovati komunikaciju na temelju povijesti mojih prijašnjih kupnji, sudjelovanja u  događajima i uporabe servisnih usluga, mog ponašanja pri otvaranju novosti i moje vrijednosti kao kupca, kao što je detaljnije opisano u Miele informacijama o zaštiti podataka. Svoju privolu mogu opozvati u bilo kojem trenutku u budućnosti (npr. slanjem neformalne poruke na info{'@'}miele.hr, koristeći podatke za kontakt navedene u pravnoj obavijesti ili pritiskom na poveznicu za odjavu u e-porukama). Informacije o zaštiti podataka.",
    link: {
      title: "Zaštita podataka.",
      ref: "https://www.miele.hr/c/zastita-podataka-14.htm"
    }
  },
  levelTwo: {
    text: "Uz moj osnovni pristanak, slažem se da Miele također može koristiti podatke iz korištenja Miele aplikacije i mojih posjeta Miele internetskim stranicama (www.miele.hr), uključujući ponašanje korisnika na temelju otvaranja poveznica sadržanih u newsletterima na Miele internetske stranice, za dopunu mog korisničkog profila za personaliziranu oglašivačku komunikaciju, pod uvjetom da moja posebna suglasnost u aplikaciji ili na internetskoj stranici omogućuje obradu podataka. Svoj pristanak možete opozvati bilo kada u budućnosti. Više detalja u politici o zaštiti podataka.",
    link: {
      title: "Zaštita podataka.",
      ref: "https://www.miele.hr/c/zastita-podataka-14.htm"
    }
  },
  levelThree: {
    text: "Uz moj osnovni pristanak, slažem se da Miele može obrađivati podatke s mojih povezanih Miele uređaja (podatke o korištenju i statusu uređaja) za dopunu mog korisničkog profila za personalizirano oglašavanje. Dodatne informacije o obradi podataka uređaja mogu se pronaći u izjavi o zaštiti podataka o sustavu Miele{'@'}Home. Svoj pristanak možete opozvati bilo kada s budućim učinkom. Više detalja u politici o zaštiti podataka.",
    link: {
      title: "Zaštita podataka Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, slažem se s uvjetima korištenja.",
    link: {
      title: "Pogledajte uvjete korištenja*",
      ref: "https://www.miele.hr/c/uvjeti-koristenja-304.htm"
    }
  }
}, dv = {
  headline: "Miele klub",
  birthDateTitle: "Možemo li vam poslati rođendanski poklon?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rođendansko iznenađenje"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Koristite format poput MM/DD/GGGG",
    errorMsg: "Nevažeći datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Pristajem na Miele Club {termsAndConditionLink} i potvrđujem {privacyLink} informacije u vezi s Miele Clubom.",
    termsAndConditionLink: {
      title: "Odredbe i uvjeti",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želio bih primati promotivnu komunikaciju Miele Cluba, prilagođenu mojim osobnim interesima, putem e-pošte i poštom",
    description: "Da, želio bih primati promotivnu komunikaciju Miele Cluba, prilagođenu mojim osobnim interesima, putem e-pošte i poštom uključujući posebne ponude, informacije, pozivnice na događaje i ankete kupaca o Miele proizvodima i uslugama. U tu svrhu Miele može koristiti moje podatke za kontakt (titula, ime, e-mail i poštanska adresa) i prilagoditi komunikaciju na temelju mog ponašanja pri kupnji i slanju biltena, kao i moje vrijednosti za kupca, kao što je detaljnije opisano u našem {privacyLink}. Svoj pristanak mogu opozvati s učinkom za budućnost u bilo kojem trenutku (na primjer, slanjem e-pošte na info{'@'}miele.co.uk, stupanjem u kontakt putem podataka za kontakt navedenih u pravnoj obavijesti ili klikom na odjavu link u e-porukama). Ovo ne utječe na ugovornu komunikaciju Miele Cluba {termsAndConditionLink} osim ako ne raskinem svoje članstvo.",
    privacyLink: {
      title: "Privatnost podataka Miele Cluba",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Klubska komunikacija",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "Da biste se pridružili Miele klubu, morate prihvatiti sve uvjete i odredbe *"
  }
}, uv = "pokazati punu izjavu", mv = "sakrij punu izjavu", pv = {
  auth: Qh,
  changeEmailScene: ev,
  changePasswordScene: tv,
  errors: iv,
  forgotPassword: av,
  login: nv,
  modal: sv,
  passwordStrength: ov,
  passwordHelper: rv,
  register: lv,
  "marketing-consent": {
    title: "Marketinške postavke",
    description: "Označite niže za ekskluzivne ponude, novosti, događaje i kako najbolje iskoristiti svoj uređaj.",
    submit: "Pohraniti",
    newsletter: {
      text: 'Slažem se da mi Miele Co Ltd. ("Miele") može slati informacije o proizvodima i inovacijama iz asortimana Miele proizvoda i o Miele događajima, kao i ankete kupaca i recepte putem e-pošte, Miele aplikacija i SMS-a te da Miele može obraditi podatke za kontakt koje sam dala/o (titula, ime, adresa e-pošte, broj mobilnog telefona i poštanski broj) i Miele proizvode koje sam do sada kupila/o i koje ću kupiti u budućnosti, kao i interese koje sam navela/o u tu svrhu. Nadalje, slažem se da Miele također može obrađivati potvrde o primitku i čitanju primljene putem newsletter-a i informacije o poveznicama na koje sam kliknula/o, kao i moje povezano korisničko ponašanje na povezanoj internetskoj stranici u svrhu personalizacije. Isto vrijedi i za push poruke unutar aplikacije, ukoliko se koriste Miele aplikacije.',
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    personalisation: {
      text: "Slažem se da Miele može obrađivati ​​informacije o uslugama koje sam koristila/o i tehničkim zadacima koje sam izvršila/o, kao i o događajima kojima sam prisustvovala/o, u svrhu poboljšane personalizacije.",
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Pored proširene personalizacije, suglasna/an sam da Miele također može obrađivati ​​podatke iz korištenja Miele aplikacije i mojih posjeta Miele internetskim stranicama (www.miele.hr) kako bi dopunio moj korisnički profil, pod uvjetom da sam zasebno pristao na obradu navedenih podataka",
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoj pristanak mogu opozvati u bilo kojem trenutku bez navođenja razloga s učinkom za budućnost.  ",
      link: {
        title: "politika zaštite podataka.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, slažem se s uvjetima korištenja.",
      link: {
        title: "Pogledajte uvjete korištenja*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: cv,
  mieleClub: dv,
  readMore: uv,
  readLess: mv
}, gv = {
  waitMessage: "Już prawie! Poczekaj jeszcze chwilę... "
}, hv = {
  buttonLabel: "Zapisz",
  buttonLabelClose: "Zamknij",
  confirmEmailMessage: "Potwierdź swój adres e-mail",
  copy: "Aby zaktualizować swój adres e-mail, dodaj nowy poniżej:",
  errorMessageCopy: "Coś poszło nie tak. ",
  errorMessageHeadline: "Błąd",
  headline: "szczegóły profilu",
  inputEmailConfirmPlaceholder: "Potwierdź adres e-mail",
  inputEmailPlaceholder: "Adres e-mail",
  invalidEmailMessage: "Adres e-mail jest nieprawidłowy!",
  rememberMeLabel: "Zapamiętaj mnie",
  successMessageCopy: "Twój adres e-mail został pomyślnie zaktualizowany.",
  successMessageHeadline: "Adres e-mail zaktualizowany"
}, vv = {
  closeButtonLabel: "Zamknij",
  confirmPasswordLabel: "Potwierdź hasło",
  currentPasswordLabel: "Aktualne hasło",
  newPasswordLabel: "nowe hasło",
  passwordMismatchError: "Hasło nie pasuje",
  passwordUpdateErrorTitle: "Błąd",
  passwordUpdateSuccessTitle: "Hasło zostało zaktualizowane",
  samePasswordError: "To hasło było już używane. Prosimy o podanie nowego hasła",
  subtitle: "Aby zmienić hasło prosimy o wypełnienie poniższych pól:",
  submitButtonLabel: "Wyślij",
  successfulChangeLabel: "Twoje hasło zostało pomyślnie zaktualizowane",
  title: "Zmiana hasła"
}, fv = {
  invalidEmail: "nieprawidłowy email",
  invalidPassword: "Złe hasło",
  sap_206002: "Twoje konto oczekuje na weryfikację. W tej chwili nie możemy pozwolić Ci kontynuować. ",
  sap_206006: "Wygląda na to, że przesłany adres e-mail oczekuje na weryfikację",
  sap_400003: "Ten adres e-mail już istnieje. Użyj innego adresu e-mail.",
  sap_400028: "Podany adres e-mail oczekuje na weryfikację",
  sap_400050: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_400097: "Wygląda na to, że uzyskujesz dostęp do naszych usług za pomocą niezabezpieczonej/nieobsługiwanej przeglądarki. ",
  sap_401030: "To hasło było już używane. Prosimy o podanie nowego hasła",
  sap_403005: "Nie mamy konta powiązanego z tym adresem e-mail. Sprawdź pocztę i spróbuj ponownie",
  sap_403011: "Sesja wygasła. Odśwież przeglądarkę i zaloguj się ponownie. ",
  sap_403012: "Sesja wygasła. Odśwież przeglądarkę i zaloguj się ponownie. ",
  sap_403013: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_403035: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_403041: "Nie mamy konta powiązanego z tym adresem e-mail. Sprawdź pocztę i spróbuj ponownie",
  sap_403042: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403043: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403047: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403100: "Niedawno złożono prośbę o aktualizację hasła. Prosimy o pozostanie z nami do czasu przetworzenia wniosku",
  sap_403025: "Link do resetowania hasła jest nieprawidłowy. Prosimy o ponowne wysłanie prośby o zapomniane hasło, aby otrzymać nowy link do resetowania hasła.",
  sapErrorTitle: "Błąd przetwarzania żądania",
  sessionExpired: "Sesja wygasła",
  tooWeakPassword: "Hasło musi zawierać co najmniej {minLength} znaków i {minCharGroups} z następujących elementów: duża litera, mała litera, cyfra, symbol specjalny | Hasło musi zawierać co najmniej {minLength} znaków",
  unexpectedDescription: "Jeśli problem będzie się powtarzał, skontaktuj się z nami za pośrednictwem formularza kontaktowego.",
  unexpectedTitle: "Wystąpił nieoczekiwany błąd",
  unknownDescription: "Wystąpił nieoczekiwany błąd. ",
  unknownTitle: "O o!"
}, kv = {
  subtitle: "Ustaw nowe hasło.",
  title: "Nie pamiętasz hasła?"
}, bv = {
  headMetaDescription: "Strona logowania dla klientów",
  headTitle: "Zaloguj się podając swój adres e-mail i hasło:",
  subtitle: "Zaloguj się lub utwórz konto, aby uzyskać dostęp do wszystkich funkcji Miele.",
  title: "Zaloguj się na swoje konto",
  error: {
    invalidEmailPasswordDescription: "Kombinacja adresu e-mail i hasła jest nieprawidłowa.",
    invalidEmailPasswordTitle: "Nieprawidłowe dane uwierzytelniające",
    missingConcentTitle: "Konto oczekuje na rejestrację",
    noAccountDescription: "Z tym adresem e-mail nie jest powiązane żadne konto.",
    noAccountTitle: "Brak zarejestrowanego konta"
  },
  extraConsentScene: {
    continue: "Kontynuować",
    privacyStatementCheckboxLabel: "Potwierdzam zapoznanie się z {0}.",
    privacyStatementName: "oświadczenie o ochronie prywatności",
    privacyStatementTitle: "Nasza Polityka Prywatności uległa zmianie",
    termsOfUseCheckboxLabel: "Zgadzam się z {0}.",
    termsOfUseName: "Warunki korzystania",
    termsOfUseTitle: "Nasze Warunki korzystania uległy zmianie",
    title: "Uzupełnianie profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Powrót do strony logowania",
    submitButtonLabel: "Wyślij",
    successDescription: "Sprawdź swoją skrzynkę e-mail, wkrótce otrzymasz informację o swoim koncie, aby rozpocząć proces resetowania hasła.",
    successTitle: "Twoje zgłoszenie zostało odebrane.",
    title: "Wpisz swój adres e-mail, aby zresetować hasło:"
  },
  loginModalScene: {
    copy: "Zaloguj się lub utwórz konto, aby uzyskać dostęp do wszystkich funkcji Miele.",
    title: "Zaloguj się na swoje konto"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Nie pamiętam hasła",
    invalidEmailMessage: "Adres e-mail jest nieprawidłowy!",
    loginButtonLabel: "Zaloguj sie",
    passwordInputLabel: "Hasło",
    rememberMeLabel: "Zapamiętaj mnie",
    title: "Zaloguj się podając swój adres e-mail i hasło:"
  }
}, wv = {
  accessibility: {
    close: "Zamknij"
  }
}, yv = {
  tooShort: "Za krótkie",
  medium: "Średnie",
  strong: "Mocne",
  tooWeak: "Zbyt słabe",
  veryStrong: "Bardzo silne",
  weak: "Słabe"
}, Mv = {
  showPasswordText: "Pokaż",
  hidePasswordText: "Ukryj"
}, zv = {
  registerButtonLabel: "rejestracja",
  registerTitle: "Nie masz konta?",
  whyRegister: {
    list: [
      "Dostęp do ekskluzywnych korzyści Klubu Miele",
      "Zarejestruj urządzenia, śledź zamówienia, uzyskaj dostęp do instrukcji",
      "Otrzymuj spersonalizowane oferty i promocje",
      "Zobacz wszystkie swoje zamówienia, gwarancje, wydarzenia i usługi"
    ],
    title: "Dlaczego warto się zarejestrować?"
  },
  closeButtonLabel: "Zamknij",
  passwordMismatchError: "Hasła się nie zgadzają",
  passwordUpdateErrorTitle: "Wystąpił błąd podczas aktualizacji hasła",
  passwordUpdateSuccessTitle: "Hasło zaktualizowane",
  successfulChangeLabel: "Twoje hasło zostało pomyślnie zaktualizowane"
}, jv = {
  title: "Preferencje marketingowe",
  description: 'Nasza obietnica jakości "Zawsze lepiej" dotyczy również konta klienta Miele. Polegaj na odpowiedzialnej obsłudze swoich danych osobowych i uzyskaj dostęp do wszystkich informacji o swoich transakcjach w dowolnym momencie. Do zalogowania wystarczy adres e-mail i hasło. Interesują Cię najnowsze produkty Miele, chciałbyś wziąć udział w ekskluzywnych wydarzeniach Miele lub uwielbiasz gotować? Newsletter Miele dostarcza przydatnej wiedzy ze świata Miele. Aby jeszcze lepiej dopasować treść do Twoich potrzeb, stosujemy personalizację. Chcesz lepiej poznać świat Miele? Z naszymi zaawansowanymi możliwościami personalizacji to możliwe.',
  submit: "Zapisz",
  levelOne: {
    shortText: 'Tak, chcę otrzymywać wiadomości promocyjne od Miele Sp z o.o. i Miele & Cie. KG  ("Miele") dostosowane do moich osobistych zainteresowań pocztą elektroniczną, SMS-em, pocztą tradycyjną i za pośrednictwem aplikacji Miele (jeśli jest używana)',
    text: `Tak, chcę otrzymywać wiadomości promocyjne od Miele Sp z o.o. i Miele & Cie. KG  ("Miele") dostosowane do moich osobistych zainteresowań pocztą elektroniczną, SMS-em, pocztą tradycyjną i za pośrednictwem aplikacji Miele (jeśli jest używana) informacje o produktach, ofertach i innowacjach z asortymentu Miele oraz o wydarzeniach Miele, a także ankiety klientów, prośby o ocenę i recenzje produktów oraz przepisy kulinarne. W tym celu Miele może wykorzystywać moje dane kontaktowe (tytuł, imię i nazwisko, adres e-mail, numer telefonu komórkowego i adres pocztowy) i opracowywać komunikację na podstawie moich zakupów, usług, historii wydarzeń, kliknięć i otwarć newslettera, a także wartości dla klienta, jak opisano szczegółowo w naszej polityce prywatności. Mogę odwołać swoją zgodę w dowolnym momencie bez podawania przyczyn ze skutkiem na przyszłość (np. wysyłając nieformalną wiadomość na adres info{'@'}miele.pl, dane kontaktowe podane w stopce redakcyjnej lub klikając łącze rezygnacji z subskrypcji w wiadomościach e-mai).`,
    link: {
      title: "Polityka prywatności",
      ref: "https://www.miele.pl/c/polityka-prywatnosci-12.htm"
    }
  },
  levelTwo: {
    text: "Oprócz mojej podstawowej zgody, wyrażam zgodę na przetwarzanie przez Miele danych pochodzących z korzystania z aplikacji Miele i moich wizyt na stronach internetowych Miele (www.miele.pl), w tym zachowania użytkownika na stronach internetowych Miele po kliknięciu w linki z newslettera, w celu uzupełnienia mojego profilu użytkownika na potrzeby spersonalizowanej komunikacji reklamowej, pod warunkiem, że moja oddzielna zgoda w aplikacji lub na stronie internetowej zezwala na przetwarzanie danych. Mogę odwołać swoją zgodę w dowolnym momencie bez podania przyczyny ze skutkiem na przyszłość. Dalsze szczegóły w polityce ochrony danych Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Oprócz mojej podstawowej zgody, wyrażam zgodę na przetwarzanie przez Miele danych z moich podłączonych urządzeń Miele (dane dotyczące użytkowania i statusu urządzenia) w celu uzupełnienia mojego profilu użytkownika na potrzeby spersonalizowanej reklamy. Więcej informacji na temat przetwarzania danych urządzeń można znaleźć w polityce prywatności systemu Miele{'@'}Home. Mogę odwołać swoją zgodę w dowolnym momencie bez podania przyczyny ze skutkiem na przyszłość. Dalsze szczegóły w polityce ochrony danych Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "W każdej chwili mogę odwołać wyrażoną zgodę bez podania przyczyny ze skutkiem na przyszłość.  ",
    link: {
      title: "polityka ochrony danych.",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  },
  termsOfUse: {
    text: "Tak, zgadzam się z warunkami użytkowania.",
    link: {
      title: "Zobacz Warunki korzystania*",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  }
}, _v = {
  headline: "Miele Club",
  why: {
    title: "Bezpłatne członkostwo - Ekskluzywne oferty dla klubowiczów.",
    reasons: [
      "Prezent powitalny po zarejestrowaniu urządzeń",
      "Urodzinowa niespodzianka",
      "Dostęp do specjalnych ofert",
      "Wyjątkowe eventy"
    ]
  },
  birthDateTitle: "Chcesz otrzymać urodzinową niespodziankę?",
  birthDateLabel: "Twoja data urodzenia (opcjonalnie)",
  birthDateValidation: {
    requirementMsg: "Wprowadź datę w tym formacie: DD/MM/RRRR",
    errorMsg: "nieprawidłowa data"
  },
  joinClubLabel: "Tak, chcę dołączyć do Miele Club.",
  termsAndCondition: {
    description: "Wyrażam zgodę na {termsAndConditionLink} Miele Club i akceptuję {privacyLink} informacje dotyczące Miele Club.",
    termsAndConditionLink: {
      title: "Ogólne-warunki-handlowe",
      ref: "https://www.miele.pl/c/ogolne-warunki-handlowe-13.htm"
    },
    privacyLink: {
      title: "Oświadczenie o ochronie danych",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  },
  newsletter: {
    description: "Tak, chcę otrzymywać od spółki Miele Sp. z o.o. („Miele“) za pośrednictwem poczty elektronicznej i tradycyjnej komunikację promocyjną Miele Club, dostosowaną do moich osobistych zainteresowań, w tym oferty specjalne, informacje, zaproszenia na wydarzenia i ankiety dotyczące produktów i usług Miele. W tym celu Miele może wykorzystywać moje dane kontaktowe (tytuł, imię i nazwisko, adres e-mail i adres pocztowy) i dostosowywać komunikację na podstawie moich zakupów i zachowań związanych z newsletterem, a także mojej wartości dla klienta, jak opisano bardziej szczegółowo w naszym {privacyLink}. W każdej chwili mogę odwołać swoją zgodę ze skutkiem na przyszłość (na przykład wysyłając wiadomość e-mail na adres info{'@'}miele.pl, kontaktując się za pośrednictwem danych kontaktowych podanych w nocie prawnej lub klikając link rezygnacji z subskrypcji w wiadomościach e-mail). Nie ma to wpływu na umowną komunikację Miele Club {termsAndConditionLink}, chyba że wypowiem członkostwo.",
    shortDescription: "Tak, chcę otrzymywać od spółki Miele Sp. z o.o. („Miele“) za pośrednictwem poczty elektronicznej i tradycyjnej komunikację promocyjną Miele Club, dostosowaną do moich osobistych zainteresowań",
    privacyLink: {
      title: "ochronie danych w ramach klubu",
      href: "https://www.miele.pl/c/ochrona-danych-14.htm"
    },
    termsAndConditionLink: {
      title: "(Miele Club Ogólne-warunki-handlowe)",
      href: "https://www.miele.pl/c/ogolne-warunki-handlowe-13.htm"
    },
    supportEmail: "info{'@'}miele.pl"
  },
  selectAllConsents: {
    description: "Aby dołączyć do Klubu Miele, musisz zaakceptować wszystkie warunki *"
  }
}, Ev = "pokaż pełne oświadczenie", Sv = "Pokaż mniej", Lv = {
  auth: gv,
  changeEmailScene: hv,
  changePasswordScene: vv,
  errors: fv,
  forgotPassword: kv,
  login: bv,
  modal: wv,
  passwordStrength: yv,
  passwordHelper: Mv,
  register: zv,
  "marketing-consent": {
    title: "Preferencje marketingowe",
    description: "Zaznacz, aby poznać ekskluzywne oferty, aktualności, wydarzenia i dowiedzieć się, jak w pełni wykorzystać możliwości swojego urządzenia.",
    submit: "Zapisz",
    newsletter: {
      text: 'Wyrażam zgodę na przesyłanie mi przez Miele Sp. z o.o. ("Miele") informacji o produktach i nowościach związanych z asortymentem Miele oraz o wydarzeniach Miele, a także ankiet dla klientów, zaproszeń do oceny i recenzji zakupionych produktów, przepisów za pośrednictwem poczty elektronicznej, aplikacji Miele i wiadomości SMS oraz na przetwarzanie przez Miele podanych przeze mnie danych kontaktowych (forma grzecznościowa, imię i nazwisko, adres e-mail, numer telefonu komórkowego i kod pocztowy) oraz produktów Miele, zakupionych do tej pory i w przyszłości, a także wskazanych przeze mnie zainteresowań. Ponadto wyrażam zgodę na przetwarzanie przez Miele potwierdzeń odbioru i odczytu otrzymanych za pośrednictwem newslettera oraz informacji o klikniętych przeze mnie łączach i powiązanych z tym zachowaniach na powiązanych stronach internetowych w celach personalizacyjnych. To samo dotyczy powiadomień push w aplikacjach, o ile używane są aplikacje Miele.',
      link: {
        title: "Pozostałe informacje",
        ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
      }
    },
    personalisation: {
      text: "Wyrażam zgodę na przetwarzanie przez Miele informacji o usługach, z których korzystałem, wykonanych przeze mnie zadaniach technicznych, a także wydarzeniach, w których brałem udział, w celu większej personalizacji.",
      link: {
        title: "Zobacz politykę ochrony danych",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Oprócz rozszerzonej personalizacji zgadzam się, na przetwarzanie przez Miele danych pochodzących z korzystania z aplikacji Miele i moich wizyt na stronach internetowych Miele (www.miele.pl) w celu uzupełnienia mojego profilu użytkownika, pod warunkiem, że osobno wyraziłem zgodę na przetwarzanie tych danych. ",
      link: {
        title: "Zobacz politykę ochrony danych",
        ref: ""
      }
    },
    highlightedText: {
      text: "W każdej chwili mogę odwołać wyrażoną zgodę bez podania przyczyny ze skutkiem na przyszłość.  ",
      link: {
        title: "polityka ochrony danych.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Tak, zgadzam się z warunkami użytkowania.",
      link: {
        title: "Zobacz Warunki korzystania",
        ref: "https://www.miele.pl/c/warunki-korzystania-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: jv,
  mieleClub: _v,
  readMore: Ev,
  readLess: Sv
}, Cv = {
  waitMessage: "Skoraj tam. "
}, Pv = {
  buttonLabel: "Shrani",
  buttonLabelClose: "Zapri",
  confirmEmailMessage: "Potrdite svoj e-poštni naslov",
  copy: "Če želite posodobiti svoj e-poštni naslov, dodajte novega spodaj:",
  errorMessageCopy: "Nekaj ​​je šlo narobe. Poskusite znova ",
  errorMessageHeadline: "Napaka",
  headline: "Podrobnosti profila",
  inputEmailConfirmPlaceholder: "Potrdite Svoj Elektronski Naslov",
  inputEmailPlaceholder: "E-poštni naslov",
  invalidEmailMessage: "E-poštni naslov ni veljaven!",
  rememberMeLabel: "Zapomni si me",
  successMessageCopy: "Vaš e-poštni naslov je bil uspešno posodobljen.",
  successMessageHeadline: "E-poštni naslov posodobljen"
}, Tv = {
  closeButtonLabel: "Zapri",
  confirmPasswordLabel: "Potrdi geslo",
  currentPasswordLabel: "Trenutno geslo",
  newPasswordLabel: "novo geslo",
  passwordMismatchError: "Geslo se ne ujema",
  passwordUpdateErrorTitle: "Napaka",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  samePasswordError: "To geslo je bilo že uporabljeno, prosimo, pošljite novo geslo",
  subtitle: "Za spremembo gesla izpolnite spodnja polja:",
  submitButtonLabel: "Oddaj",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno",
  title: "Sprememba gesla"
}, Av = {
  invalidEmail: "Napačen e-poštni naslov",
  invalidPassword: "Napačno geslo",
  sap_206002: "Vaš račun čaka na preverjanje, vam trenutno ne moremo dovoliti nadaljevanja.  Prosim stopite v stik z nami za več informacij",
  sap_206006: "Videti je, da e-poštni naslov, ki ste ga poslali, čaka na preverjanje",
  sap_400003: "Ta e-poštni naslov že obstaja, uporabite drug e-poštni naslov.",
  sap_400028: "Poslani e-poštni naslov čaka na preverjanje",
  sap_400050: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_400097: "Videti je, da do naših storitev dostopate iz nevarnega/nepodprtega brskalnika. Prosim poizkusite ponovno z drugim brskalnikom",
  sap_401030: "To geslo je bilo že uporabljeno, prosimo, vnesite novo geslo",
  sap_403005: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403011: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite. ",
  sap_403012: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite.",
  sap_403013: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403035: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403041: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403042: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403043: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403047: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403100: "Zahteva za posodobitev gesla je bila nedavno zahtevana, prosimo počakajte, dokler zahteva ne bo obdelana",
  sap_403025: "Povezava za ponastavitev gesla je neveljavna, ponovno pošljite zahtevo za pozabljeno geslo, da prejmete novo povezavo za ponastavitev.",
  sapErrorTitle: "Napaka pri obdelavi zahteve",
  sessionExpired: "Seja je potekla",
  tooWeakPassword: "Geslo mora vsebovati vsaj {minLength} znakov in {minCharGroups} od naslednjega: velika črka, mala črka, številka, poseben simbol | Geslo mora vsebovati vsaj {minLength} znakov",
  unexpectedDescription: "Če se težava ponovi, se obrnite na nas prek kontaktnega obrazca in navedite podrobnosti.",
  unexpectedTitle: "Prišlo je do nepričakovane napake",
  unknownDescription: "Prišlo je do nepričakovane napake. ",
  unknownTitle: "Ojoj!"
}, xv = {
  subtitle: "Nastavite novo geslo.",
  title: "Ste pozabili geslo?"
}, Iv = {
  headMetaDescription: "Stran za prijavo stranke",
  headTitle: "Prijavite se s svojim e-poštnim naslovom in geslom:",
  subtitle: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
  title: "Prijavite se v svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija e-poštnega naslova in gesla ni veljavna.",
    invalidEmailPasswordTitle: "Neveljavne poverilnice",
    missingConcentTitle: "Račun čaka na registracijo",
    noAccountDescription: "S tem e-poštnim naslovom ni povezan noben račun.",
    noAccountTitle: "Ni registriranega računa"
  },
  extraConsentScene: {
    continue: "Nadaljuj",
    privacyStatementCheckboxLabel: "Upošteval sem {0}.",
    privacyStatementName: "izjava o zasebnosti",
    privacyStatementTitle: "Naš pravilnik o zasebnosti se je spremenil",
    termsOfUseCheckboxLabel: "Strinjam se z {0}.",
    termsOfUseName: "pogoji uporabe",
    termsOfUseTitle: "Naši pogoji uporabe so se spremenili",
    title: "Dokončanje profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Nazaj na prijavo",
    submitButtonLabel: "Oddaj",
    successDescription: "Prosimo, preverite svojo e-pošto, kmalu boste prejeli podatke o vašem računu, da začnete s postopkom ponastavitve gesla.",
    successTitle: "Vaša zahteva je bila prejeta.",
    title: "Za ponastavitev gesla vnesite svoj e-poštni naslov:"
  },
  loginModalScene: {
    copy: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
    title: "Prijavite se v svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Pozabil sem geslo",
    invalidEmailMessage: "E-pošta ni veljavna!",
    loginButtonLabel: "Vpiši se",
    passwordInputLabel: "Geslo",
    rememberMeLabel: "Zapomni si me",
    title: "Prijavite se s svojim e-poštnim naslovom in geslom:"
  }
}, Dv = {
  accessibility: {
    close: "Zapri"
  }
}, Nv = {
  tooShort: "Prekratko",
  medium: "Srednje",
  strong: "Močno",
  tooWeak: "Prešibko",
  veryStrong: "Zelo močno",
  weak: "Šibko"
}, Ov = {
  showPasswordText: "Prikaži",
  hidePasswordText: "Skrij"
}, Uv = {
  registerButtonLabel: "registracija",
  registerTitle: "Nimate računa?",
  whyRegister: {
    list: [
      "Dostop do ekskluzivnih ugodnosti Miele Kluba",
      "Registrirajte naprave, sledite naročilom, dostopajte do priročnikov",
      "Prejemajte prilagojene ponudbe in promocije",
      "Oglejte si vsa vaša naročila, garancije, dogodke in storitve"
    ],
    title: "Zakaj se registrirati?"
  },
  closeButtonLabel: "Zapri",
  passwordMismatchError: "Gesli se ne ujemata",
  passwordUpdateErrorTitle: "Napaka pri posodobitvi gesla",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno"
}, $v = {
  title: "Tržnenjske preference",
  description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
  submit: "Shrani",
  levelOne: {
    shortText: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, ankete za kupce, prošnje za ocene in mnenja o izdelkih ter recepte.",
    text: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, ankete za kupce, prošnje za ocene in mnenja o izdelkih ter recepte. V ta namen lahko Miele uporabi moje kontaktne podatke (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštni naslov) in oblikuje sporočila na podlagi zgodovine mojih nakupov, udeležbe na dogodkih in uporabe servisnih storitev, mojega vedenja pri klikanju in odpiranju novic ter moje vrednosti stranke, kot je podrobneje opisano v naših informacijah o varstvu podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej (npr. tako, da pošljem neformalno sporočilo na naslov info{'@'}miele.si, na kontaktne podatke, navedene v pravnem obvestilu, ali s klikom na povezavo za odjavo v e-poštnih sporočilih).",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelTwo: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojega obiska spletnih strani Miele (www.miele.si), vključno z vedenjem na spletnih straneh Miele, do katerih pridem s klikanjem v novicah Miele, za dopolnitev mojega uporabniškega profila za prilagojeno oglaševalsko komunikacijo, če moja ločena privolitev v aplikaciji ali na spletni strani dovoli obdelavo podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne podrobnosti so navedene v Politiki zasebnosti.",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelThree: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje podatke o mojih aparatih Miele, povezanih v omrežje (podatki o uporabi in stanju aparatov), da dopolni moj uporabniški profil za prilagojeno oglaševanje. Dodatne informacije o obdelavi podatkov o aparatih najdete v pravilniku o zasebnosti za sistem Miele{'@'}home. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne informacije so na voljo v varstvo podatkov.",
    link: {
      title: "Politika zasebnosti za sistem Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, strinjam se s pogoji uporabe.",
    link: {
      title: "Oglejte si pogoje uporabe*",
      ref: "https://www.miele.si/c/pogoji-uporabe-304.htm"
    }
  }
}, Bv = {
  headline: "Miele klub",
  birthDateTitle: "Vam lahko pošljemo darilo za rojstni dan?",
  birthDateLabel: "Vaš rojstni datum (neobvezno)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rojstnodnevno presenečenje",
      "Ekskluzivne ponudbe in akcije",
      "Darilo dobrodošlice",
      "VIP ponudbe in",
      "izkušnje",
      "Privlačni prihranki",
      "Klubske novice"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Prosimo, da vnesete ta datumski format: DD/MM/LLLL",
    errorMsg: "Napačen datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Strinjam se s {termsAndConditionLink} Miele kluba in potrjujem {privacyLink} informacije o Miele klubu.",
    termsAndConditionLink: {
      title: "Pogoji",
      ref: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želim prejemati promocijsko komunikacijo kluba Miele, prilagojeno mojim osebnim interesom, po e-pošti in pošti",
    description: "Da, želim postati član Miele kluba in prejemati sporočila Miele kluba (darilo dobrodošlice, rojstnodnevno presenečenje, sprememba statusa nadgradnje, novice Miele kluba) po e-pošti.",
    privacyLink: {
      title: "Varstvo podatkov kluba Miele",
      href: "https://www.miele.si/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikacija kluba",
      href: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.si"
  },
  selectAllConsents: {
    description: "Če želite postati član Miele kluba, morate sprejeti vse pogoje *"
  }
}, Rv = "pokaži celotno izjavo", Vv = "skrij celotno izjavo", Fv = {
  auth: Cv,
  changeEmailScene: Pv,
  changePasswordScene: Tv,
  errors: Av,
  forgotPassword: xv,
  login: Iv,
  modal: Dv,
  passwordStrength: Nv,
  passwordHelper: Ov,
  register: Uv,
  "marketing-consent": {
    title: "Tržnenjske preference",
    description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
    submit: "Shrani",
    newsletter: {
      text: 'Strinjam se, da mi lahko Miele trgovina in servis d.o.o. ("Miele") pošilja informacije o izdelkih in novostih iz nabora izdelkov Miele in o dogodkih Miele ter ankete strank in recepte po e-pošti, aplikacijah Miele in SMS-ih ter da lahko Miele obdeluje kontaktne podatke, ki sem jih posredoval (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštno številko) in izdelke Miele, ki sem jih kupil do sedaj in jih bom kupil v prihodnosti, ter interese, ki sem jih navedel v ta namen . Nadalje se strinjam, da lahko Miele obdela potrdila o prejemu in branju, prejete prek glasila, in informacije o povezavah, na katere sem kliknil, ter o mojem povezanem vedenju uporabnika na povezani spletni strani za namene personalizacije. Enako velja za potisna sporočila v aplikaciji, v kolikor se uporabljajo aplikacije Miele. ',
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    personalisation: {
      text: "Strinjam se, da lahko Miele obdeluje podatke o storitvah, ki sem jih uporabil, in tehničnih nalogah, ki sem jih opravil, ter dogodkih, ki sem se jih udeležil, za namen izboljšane personalizacije.",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Poleg razširjene personalizacije se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojih obiskov spletnih strani Miele (www.miele.si) za dopolnitev mojega uporabniškega profila, pod pogojem, da sem posebej privolil v to. ",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoje soglasje lahko kadar koli prekličem brez navedbe razlogov z učinkom za naprej.  ",
      link: {
        title: "politiko varstva podatkov.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, strinjam se s pogoji uporabe.",
      link: {
        title: "Oglejte si pogoje uporabe*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: $v,
  mieleClub: Bv,
  readMore: Rv,
  readLess: Vv
}, ri = H();
function ue() {
  ri.value || (ri.value = Pi({
    locale: "en-US",
    messages: {
      "da-DK": pl,
      "de-AT": Ll,
      "de-CH": Fl,
      "de-DE": nc,
      "de-LU": bc,
      "en-GB": Ic,
      "en-US": Jc,
      "es-ES": dd,
      "fi-FI": Bd,
      "fr-FR": tu,
      "fr-BE": vu,
      "fr-CH": Tu,
      "fr-LU": Ku,
      "it-IT": rm,
      "it-CH": Mm,
      "nl-NL": Om,
      "nl-BE": Xm,
      "no-NO": pp,
      "pt-PT": Lp,
      "sv-SE": Fp,
      "sl-SI": ng,
      "hu-HU": bg,
      "ga-IE": Ig,
      "en-IE": Jg,
      "el-GR": rh,
      "sk-SK": Mh,
      "cs-CZ": Oh,
      "ro-RO": Xh,
      "pl-PL": Lv,
      "hr-HR": pv,
      "si-SL": Fv,
      "es-MX": _d
    }
  }));
  const { t: e, tm: t, rt: i, te: a } = ri.value;
  return { ct: e, ctm: t, crt: i, cte: a, i18n: ri.value };
}
class ye extends Error {
  constructor(i, a, n, s, o = !1) {
    const l = ue().ct, u = i || l("errors.unknownTitle");
    super(u);
    st(this, "cause");
    st(this, "details");
    st(this, "data");
    st(this, "code");
    st(this, "isDismissible");
    Error.captureStackTrace && Error.captureStackTrace(this, ye), this.name = "GenericError", this.cause = n, this.details = a || l("errors.unknownDescription"), this.data = s, this.isDismissible = o, this.code = void 0;
  }
}
class Ot extends ye {
  constructor(t, i, a) {
    super(t, i, a), this.name = "AccountsApiError";
  }
}
const qv = (e = "Error on account login.") => {
  const t = new Error(e);
  return t.name = "AccountLoginError", t;
};
class us extends ye {
  constructor(t, i, a) {
    const s = ue().ct;
    super(t || s("errors.sessionExpired"), i, a), this.name = "HybrisSessionExpiredError";
  }
}
class ba extends ye {
  constructor(t, i, a) {
    const s = ue().ct;
    super(
      t || s("login.error.invalidEmailPasswordTitle"),
      i || s("login.error.invalidEmailPasswordDescription"),
      a
    ), this.name = "InvalidEmailPasswordError";
  }
}
class wa extends ye {
  constructor(t, i, a) {
    super(t, i, a), this.name = "InvalidLoginError";
  }
}
class ya extends ye {
  constructor(t, i, a) {
    super(t, i, a), this.name = "InvalidSessionError";
  }
}
class Ti extends ye {
  constructor(t, i, a, n) {
    const o = ue().ct;
    super(t || o("login.error.missingConcentTitle"), i, a, n), this.name = "MissingConsentError";
  }
}
class Gv extends ye {
  constructor(t, i, a) {
    const s = ue().ct;
    super(t || s("login.error.noAccountTitle"), i || s("login.error.noAccountDescription"), a), this.name = "NoAccountError";
  }
}
const Kv = [
  206002,
  206006,
  400003,
  400028,
  400050,
  400097,
  401030,
  403005,
  403011,
  403012,
  403013,
  403035,
  403041,
  403042,
  403043,
  403047,
  403100,
  403025
], Ut = (e) => e && Kv.includes(e);
class $t extends ye {
  constructor(t) {
    const a = ue().ct, n = t ? a(`errors.sap_${t}`) : void 0;
    super(a("errors.sapErrorTitle"), n), this.name = "SapError", this.code = t;
  }
}
class Ma extends ye {
  constructor(t, i, a) {
    super(t || "Invalid session grant", i, a), this.name = "SessionInvalidGrantError";
  }
}
class Ce extends ye {
  constructor(t, i, a) {
    const s = ue().ct;
    super(t || s("errors.unexpectedTitle"), i || s("errors.unexpectedDescription"), a), this.name = "UnexpectedError";
  }
}
class ms extends ye {
  constructor(t, i, a) {
    const s = ue().ct;
    super(t || s("errors.unknownTitle"), i || s("errors.unknownDescription"), a), this.name = "UnknownError";
  }
}
const Fw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountLoginError: qv,
  AccountsApiError: Ot,
  GenericError: ye,
  HybrisSessionExpiredError: us,
  InvalidEmailPasswordError: ba,
  InvalidLoginError: wa,
  InvalidSessionError: ya,
  MissingConsentError: Ti,
  NoAccountError: Gv,
  SapError: $t,
  SessionInvalidGrantError: Ma,
  UnexpectedError: Ce,
  UnknownError: ms,
  isSapErrorHandled: Ut
}, Symbol.toStringTag, { value: "Module" })), ps = "MIELE_LOGIN_TOGGLE", gs = "MIELE_CHANGE_PASSWORD_TOGGLE", hs = "MIELE_FORGOT_PASSWORD_TOGGLE", vs = "MIELE_CHANGE_EMAIL_TOGGLE", fs = "MIELE_CONSENT_TOGGLE", ks = "MIELE_NEWSLETTER_CONSENT_TOGGLE", bs = "MIELE_CLUB_CONSENT_TOGGLE", Hv = "MIELE_NINJA_LOGOUT", qw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CHANGE_EMAIL_TOGGLE: vs,
  CHANGE_PASSWORD_TOGGLE: gs,
  CONSENT_TOGGLE: fs,
  FORGOT_PASSWORD_TOGGLE: hs,
  LOGIN_TOGGLE: ps,
  MIELE_CLUB_CONSENT_TOGGLE: bs,
  NEWSLETTER_CONSENT_TOGGLE: ks,
  NINJA_LOGOUT: Hv
}, Symbol.toStringTag, { value: "Module" })), Wv = [
  { countryCode: "be", languages: ["nl", "fr"] },
  { countryCode: "ch", languages: ["de", "fr", "it"] },
  { countryCode: "ca", languages: ["en", "fr"] },
  { countryCode: "lu", languages: ["fr", "de"] }
], Ai = {
  global: "miele.com",
  dk: "miele.dk",
  uk: "miele.co.uk",
  us: "mieleusa.com",
  nl: "miele.nl",
  be: "miele.be",
  lu: "miele.lu",
  fi: "miele.fi",
  no: "miele.no",
  se: "miele.se",
  pl: "miele.pl",
  ch: "miele.ch",
  gr: "miele.gr",
  fr: "miele.fr",
  es: "miele.es",
  pt: "miele.pt",
  ie: "miele.ie",
  za: "miele.co.za",
  at: "miele.at",
  de: "miele.de",
  au: "miele.com.au",
  nz: "miele.co.nz",
  jp: "miele.co.jp",
  ae: "miele.ae",
  hk: "miele.hk",
  cn: "miele.cn",
  hr: "miele.hr",
  sl: "miele.sl",
  cz: "miele.cz",
  sk: "miele.sk",
  my: "miele.my",
  sg: "miele.sg",
  kr: "miele.co.kr",
  lt: "miele.lt",
  lv: "miele.lv",
  ee: "miele.ee",
  it: "miele.it",
  ca: "miele.ca",
  bg: "miele.bg",
  hu: "miele.hu",
  mx: "miele.com.mx",
  cl: "miele.cl",
  ro: "miele.ro",
  ru: "miele.ru",
  ua: "miele.ua",
  kz: "miele.kz",
  rs: "miele.rs",
  tr: "miele.tr",
  in: "miele.in",
  th: "miele.co.th",
  br: "mielebrasil.com.br",
  si: "miele.si"
}, Jv = (e) => {
  const t = e == null ? void 0 : e.split("/")[3], i = za(e), a = xi(i);
  return a != null && a.languages.includes(t) ? t : (a == null ? void 0 : a.languages[0]) || void 0;
}, Gw = (e) => {
  const t = za(e), i = xi(t);
  return (i == null ? void 0 : i.languages[0]) || void 0;
}, za = (e) => {
  try {
    const t = new URL(e).host, i = Object.entries(Ai).find(([a, n]) => t.includes(n));
    return i == null ? void 0 : i[0];
  } catch (t) {
    if (t.message.includes("Invalid URL:"))
      return;
    throw t;
  }
}, xi = (e) => Wv.find((t) => t.countryCode === (e == null ? void 0 : e.toLowerCase())), Zv = (e, t) => {
  const i = xi(e);
  return !!(i != null && i.languages.includes(t == null ? void 0 : t.toLowerCase()));
}, ja = (e) => {
  const t = za(e);
  return !!xi(t);
}, bt = (e, t) => {
  let i = e.startsWith("/") ? e : `/${e}`;
  const a = (t == null ? void 0 : t.domain) || window.location.href;
  return ja(a) && (i = `/${(t == null ? void 0 : t.language) || Jv(a) || ""}${i}`), i;
}, Yv = () => {
  var e;
  return (e = /\/([a-z]{2})\//.exec(window.location.pathname)) == null ? void 0 : e[1];
}, Kw = (e) => {
  const t = e.startsWith("/") ? e : `/${e}`, i = Yv();
  return i ? `/${i}${t}` : t;
}, Xv = (e = 61) => Array.from({ length: e }, () => window.Math.random().toString(36)[2]).join(""), Hw = (e, t, i) => {
  var s, o;
  const a = (s = e.value) == null ? void 0 : s["general.country"].toUpperCase();
  if (Zv(a, i)) {
    const r = (o = e.value) == null ? void 0 : o["general.language"];
    console.debug(`Switching language: ${r}-${a} > ${i}-${a}`), t(`${i}-${a}`);
  } else
    console.debug(`"${i}" is not a valid language for this domain (${a}). Ignoring locale change request.`);
}, Qv = (e) => {
  const t = e == null ? void 0 : e["general.language"], i = e == null ? void 0 : e["general.country"];
  return `${t}-${i}`;
}, ef = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, tf = (e) => ef.test(e);
var Je = /* @__PURE__ */ ((e) => (e[e.TooShort = -1] = "TooShort", e[e.TooWeak = 0] = "TooWeak", e[e.Weak = 1] = "Weak", e[e.Medium = 2] = "Medium", e[e.Strong = 3] = "Strong", e[e.VeryStrong = 4] = "VeryStrong", e))(Je || {});
const af = 12, nf = 14, Ww = (e) => tf(e) ? e.length >= nf ? 4 : e.length >= af ? 3 : 1 : 0, sf = /[A-Z]/, of = /[a-z]/, rf = /[0-9]/, lf = /[^\w\s]/, cf = (e) => {
  let t = 0;
  return sf.test(e) && t++, of.test(e) && t++, rf.test(e) && t++, lf.test(e) && t++, t;
}, ws = (e, t = 8, i = 0) => {
  if (e.length < t)
    return -1;
  const a = cf(e);
  return i > 0 && a < i ? 0 : a <= 1 ? 1 : a === 2 ? 2 : a === 3 ? 3 : a >= 4 ? 4 : 0;
}, df = (e) => e.reduce((t, i) => {
  const [a, ...n] = i.split(".");
  return t[a] || (t[a] = []), t[a].push(n.join(".")), t;
}, {}), uf = /(@.*@|(\.@)|(@\.)|^\.|\.$|\.\.|\s)/i, mf = /\S+@\S+\.\w{2,}/i, Tt = (e) => uf.test(e) ? !1 : mf.test(e), pf = (e) => {
  const t = [];
  for (const i in e) {
    const a = encodeURIComponent(i), n = e[i], s = typeof n == "object" ? JSON.stringify(Object.assign({}, n)) : n, o = encodeURIComponent(s);
    t.push(a + "=" + o);
  }
  return t.join("&");
}, cn = (...e) => e.map((t, i) => i === 0 ? t.trim().replace(/[\/]*$/g, "") : t.trim().replace(/(^[\/]*|[\/]*$)/g, "")).filter((t) => t.length).join("/");
async function gf(e) {
  const t = new TextEncoder().encode(e);
  let i;
  globalThis.window ? (console.debug("sha256b64: hashing with browser ..."), i = await window.crypto.subtle.digest("SHA-256", t)) : (console.debug("sha256b64: hashing with node ..."), i = (await import("./__vite-browser-external-2447137e.js")).createHash("sha256").update(t).digest());
  const a = new Uint8Array(i);
  return btoa(String.fromCharCode(...a)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function hf(e) {
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let i = "";
  for (let a = 0; a < e; a++)
    i += t.charAt(Math.floor(Math.random() * t.length));
  return i;
}
const dn = (e) => {
  try {
    return new URL(e).hostname;
  } catch {
    return null;
  }
}, vf = (e) => {
  try {
    return new URL(e).pathname;
  } catch {
    return null;
  }
}, Bi = (e) => typeof e == "string" ? e === "true" : !!e, Ri = "miele_auth_redirect", un = 36e5, ff = "miele_force_auth_proxy", mn = "miele_code_verifier", Vi = H(void 0), Xe = () => ({
  globalsState: Vi,
  loadSessionGlobals: () => {
    const i = sessionStorage.getItem("miele_globals");
    Vi.value = i ? JSON.parse(i) : void 0;
  },
  setGlobals: (i) => {
    Vi.value = i;
  }
});
function ra(e) {
  const t = e.startsWith("http://") || e.startsWith("https://") ? e : `https://${e}`, i = new URL(t).hostname, a = i.split("."), n = Object.values(Ai).map((s) => {
    const o = s.split(".");
    return o.length > 2 ? o.slice(-2).join(".") : "";
  }).filter(Boolean);
  for (const s of n)
    if (i.endsWith(`.${s}`))
      return `${a[a.length - 3]}.${s}`;
  return a.slice(-2).join(".");
}
const kf = (e) => {
  const t = decodeURIComponent(e);
  return /<script[^>]*>[^<]*<\/script[^>]*>|javascript:|data:text\/html/i.test(t);
};
function Fi(e) {
  if (kf(e))
    return !1;
  const t = ra(window.location.hostname), i = new URL(e, window.location.origin), a = ra(i.hostname);
  return a === t ? !0 : Object.values(Ai).some((s) => s === a);
}
function bf(e) {
  return `/${e.split("/").slice(2).join("/")}`;
}
function pn(e) {
  return ja(e.toString()) ? bf(e.pathname) : e.pathname;
}
function qi(e, t) {
  const i = decodeURIComponent(e), a = decodeURIComponent(t), n = pn(new URL(i, window.location.origin));
  return pn(new URL(a, window.location.origin)) === n;
}
const gn = ["login.microsoftonline.com"], wf = ["/e/newpassword", "/login/newpassword"];
function ys() {
  const { globalsState: e } = Xe();
  e.value && e.value["module.auth.baseUrl"] && gn.push(dn(e.value["module.auth.baseUrl"]));
  const t = (o) => {
    sessionStorage.setItem(Ri, o);
  }, i = () => {
    sessionStorage.removeItem(Ri);
  }, a = () => {
    const o = sessionStorage.getItem(Ri);
    return o && Fi(o) && !qi(o, window.location.toString()) ? o : null;
  };
  return { saveRedirectTarget: () => {
    const o = window.location.toString(), l = new URLSearchParams(window.location.search).get("target_url");
    if (l && Fi(l) && !qi(l, o)) {
      t(decodeURIComponent(l));
      return;
    }
    const u = document.referrer, c = dn(u), m = vf(u);
    if (c && u !== window.location.href) {
      if (gn.includes(c) || wf.includes(m))
        return;
      if (Fi(u) && !qi(l, o)) {
        t(u);
        return;
      }
    }
    i();
  }, redirectToTarget: () => {
    var m;
    const { globalsState: o } = Xe(), r = a(), l = ja(window.location.href) ? (m = o.value) == null ? void 0 : m["general.language"] : "", u = `${window.location.origin}/${l}`, c = r || u;
    i(), window.location.assign(c);
  }, storeRedirect: t, retrieveRedirect: a, clearRedirect: i };
}
const Jw = "miele-session", yf = "miele_host", li = "miele_sessionData", Ms = "miele_regToken", Mf = "miele_authCode", Zw = "miele_jwt", zf = "miele_DANGER_ZONE";
/*! js-cookie v3.0.5 | MIT */
function ci(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t];
    for (var a in i)
      e[a] = i[a];
  }
  return e;
}
var jf = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function la(e, t) {
  function i(n, s, o) {
    if (!(typeof document > "u")) {
      o = ci({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var r = "";
      for (var l in o)
        o[l] && (r += "; " + l, o[l] !== !0 && (r += "=" + o[l].split(";")[0]));
      return document.cookie = n + "=" + e.write(s, n) + r;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], o = {}, r = 0; r < s.length; r++) {
        var l = s[r].split("="), u = l.slice(1).join("=");
        try {
          var c = decodeURIComponent(l[0]);
          if (o[c] = e.read(u, c), n === c)
            break;
        } catch {
        }
      }
      return n ? o[n] : o;
    }
  }
  return Object.create(
    {
      set: i,
      get: a,
      remove: function(n, s) {
        i(
          n,
          "",
          ci({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return la(this.converter, ci({}, this.attributes, n));
      },
      withConverter: function(n) {
        return la(ci({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Gi = la(jf, { path: "/" });
const _f = () => {
  if (globalThis.window) {
    const e = Object.values(Ai), t = ra(window.location.hostname), i = e.find((a) => t === a);
    return i || (console.warn(
      `Could not determine domain from page hostname=${window == null ? void 0 : window.location.hostname}. Defaulting to window.location.hostname`
    ), window.location.hostname);
  }
  return null;
}, zt = (e, t) => {
  const i = _f(), a = i === "localhost" ? i : `.${i}`, n = "strict", s = !0, o = { opts: t };
  return { set: (c, m) => {
    m && (o.opts = m);
    const d = typeof c == "string" ? c : JSON.stringify(c);
    return Gi.set(e, d, { domain: a, sameSite: n, secure: s, ...o.opts });
  }, get: () => {
    const c = Gi.get(e);
    try {
      return JSON.parse(c);
    } catch (m) {
      return m instanceof SyntaxError || console.error(m), c;
    }
  }, remove: () => Gi.remove(e, { domain: a, sameSite: n, secure: s, ...o.opts }) };
}, zs = () => {
  const e = zt(Ms);
  return { set: (a, n) => {
    var s, o, r, l;
    (a != null && a.regToken || (s = a.sessionInfo) != null && s.cookieValue) && (e.set((a == null ? void 0 : a.regToken) || ((o = a.sessionInfo) == null ? void 0 : o.cookieValue), {
      expires: n ? new Date(Date.now() + un) : void 0,
      maxAge: n ? `${un}` : void 0
    }), (r = a.sessionInfo) != null && r.cookieName && zt((l = a.sessionInfo) == null ? void 0 : l.cookieName).set(a.sessionInfo.cookieValue));
  }, get: () => e != null && e.get() ? e.get() : (console.warn("No session token cookie found"), null), remove: e.remove };
}, js = () => {
  const e = zs(), t = {
    remember: !1
  }, i = (o, r) => {
    t.remember = r || !1, e.set(o, r), localStorage.setItem(li, JSON.stringify(o));
  }, a = () => {
    const o = localStorage.getItem(li) || sessionStorage.getItem(li);
    if (o) {
      const r = JSON.parse(o);
      return s() || e.set(r, t.remember), r;
    }
    return null;
  }, n = () => {
    localStorage.removeItem(li);
  }, s = () => e == null ? void 0 : e.get();
  return { set: i, get: a, remove: n, getCdcToken: s };
}, Ef = (e, t) => {
  const i = e[t];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((a, n) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(n.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, we = async (e, t, i) => {
  if (e) {
    console.debug("Returning mocked json:", t);
    const { default: a } = await Ef(/* @__PURE__ */ Object.assign({ "../mocks/accounts.getAccountInfo.ts": () => import("./accounts.getAccountInfo-daa5f0a7.js"), "../mocks/accounts.getPasswordPolicies.ts": () => import("./accounts.getPasswordPolicies-cbffd8da.js"), "../mocks/accounts.login.missing-consent.ts": () => import("./accounts.login.missing-consent-1ceeb468.js"), "../mocks/accounts.login.ts": () => import("./accounts.login-8b7bdf12.js"), "../mocks/accounts.logout.ts": () => import("./accounts.logout-ca9acf65.js"), "../mocks/accounts.resetPassword.ts": () => import("./accounts.resetPassword-26e2c546.js"), "../mocks/accounts.resetPasswordWithResetToken.ts": () => import("./accounts.resetPasswordWithResetToken-69c282b9.js"), "../mocks/accounts.setAccountInfo.ts": () => import("./accounts.setAccountInfo-a81e02f2.js"), "../mocks/cdc.verifySession.ts": () => import("./cdc.verifySession-9d1a6552.js"), "../mocks/experience.email.ts": () => import("./experience.email-c5fbeec2.js"), "../mocks/experience.userInfo.ts": () => import("./experience.userInfo-2dbb35b3.js"), "../mocks/globals-mock.ts": () => import("./globals-mock-2bed6c6d.js"), "../mocks/hybris.csrf.ts": () => import("./hybris.csrf-9768cfa3.js"), "../mocks/hybris.login.ts": () => import("./hybris.login-22c48e84.js"), "../mocks/hybris.logout.ts": () => import("./hybris.logout-fa8d5e51.js"), "../mocks/hybris.session.ts": () => import("./hybris.session-1897913c.js"), "../mocks/session-data-mocks.ts": () => import("./session-data-mocks-b34ec4c1.js") }), `../mocks/${t}.ts`);
    return { json: a, resp: { ok: !0 } };
  }
  return i();
}, hn = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
}, Fe = {
  login: "/accounts.login",
  resetPassword: "/accounts.resetPassword",
  logout: "/accounts.logout",
  getPasswordPolicies: "/accounts.getPolicies",
  isEmailAvailable: "/accounts.isAvailableLoginID",
  registrationToken: "/accounts.initRegistration",
  register: "/accounts.register",
  finalizeRegistration: "/accounts.finalizeRegistration",
  getConsents: "/accounts.getConsentsStatements",
  setConsents: "/accounts.setConsentsStatements",
  setAccountInfoLegacy: "/accounts.setAccountInfo",
  // XAPI migrated
  getAccountInfo: "cdc/accounts.getAccountInfo",
  setAccountInfo: "cdc/accounts.setAccountInfo",
  verifySession: "cdc/accounts.session.verify"
}, Ki = {
  create: "session/token",
  status: "session",
  logout: "session/logout"
}, Hi = {
  getUserInfo(e) {
    return `occ/miele-${e}/user`;
  },
  getMieleClubUrl(e) {
    return `occ/miele-${e}/miele-club`;
  },
  getEmailUrl(e) {
    return `occ/miele-${e}/email`;
  }
}, Zt = {
  csrf: "/e/csrf",
  authenticationStatus: "/e/authentication/status",
  gigyaRaasLogin: "/e/gigyaraas/login",
  logout: "/e/logout",
  completeRegistration: "/e/account/complete-registration"
}, Sf = {
  oidc: "/oidc/op/v1.0"
}, Yw = "https://stg.cdn.api.miele.com/api-connector", Ii = {
  login: "/login",
  auth: "/login/auth"
}, Xw = {
  authVerifier: "umf-verifier"
};
var Lf = /* @__PURE__ */ ((e) => (e.USER = "user", e))(Lf || {});
const vn = Object.freeze({
  ignoreUnknown: !1,
  respectType: !1,
  respectFunctionNames: !1,
  respectFunctionProperties: !1,
  unorderedObjects: !0,
  unorderedArrays: !1,
  unorderedSets: !1,
  excludeKeys: void 0,
  excludeValues: void 0,
  replacer: void 0
});
function Cf(e, t) {
  t ? t = { ...vn, ...t } : t = vn;
  const i = _s(t);
  return i.dispatch(e), i.toString();
}
const Pf = Object.freeze([
  "prototype",
  "__proto__",
  "constructor"
]);
function _s(e) {
  let t = "", i = /* @__PURE__ */ new Map();
  const a = (n) => {
    t += n;
  };
  return {
    toString() {
      return t;
    },
    getContext() {
      return i;
    },
    dispatch(n) {
      return e.replacer && (n = e.replacer(n)), this[n === null ? "null" : typeof n](n);
    },
    object(n) {
      if (n && typeof n.toJSON == "function")
        return this.object(n.toJSON());
      const s = Object.prototype.toString.call(n);
      let o = "";
      const r = s.length;
      r < 10 ? o = "unknown:[" + s + "]" : o = s.slice(8, r - 1), o = o.toLowerCase();
      let l = null;
      if ((l = i.get(n)) === void 0)
        i.set(n, i.size);
      else
        return this.dispatch("[CIRCULAR:" + l + "]");
      if (typeof Buffer < "u" && Buffer.isBuffer && Buffer.isBuffer(n))
        return a("buffer:"), a(n.toString("utf8"));
      if (o !== "object" && o !== "function" && o !== "asyncfunction")
        this[o] ? this[o](n) : e.ignoreUnknown || this.unkown(n, o);
      else {
        let u = Object.keys(n);
        e.unorderedObjects && (u = u.sort());
        let c = [];
        e.respectType !== !1 && !fn(n) && (c = Pf), e.excludeKeys && (u = u.filter((d) => !e.excludeKeys(d)), c = c.filter((d) => !e.excludeKeys(d))), a("object:" + (u.length + c.length) + ":");
        const m = (d) => {
          this.dispatch(d), a(":"), e.excludeValues || this.dispatch(n[d]), a(",");
        };
        for (const d of u)
          m(d);
        for (const d of c)
          m(d);
      }
    },
    array(n, s) {
      if (s = s === void 0 ? e.unorderedArrays !== !1 : s, a("array:" + n.length + ":"), !s || n.length <= 1) {
        for (const l of n)
          this.dispatch(l);
        return;
      }
      const o = /* @__PURE__ */ new Map(), r = n.map((l) => {
        const u = _s(e);
        u.dispatch(l);
        for (const [c, m] of u.getContext())
          o.set(c, m);
        return u.toString();
      });
      return i = o, r.sort(), this.array(r, !1);
    },
    date(n) {
      return a("date:" + n.toJSON());
    },
    symbol(n) {
      return a("symbol:" + n.toString());
    },
    unkown(n, s) {
      if (a(s), !!n && (a(":"), n && typeof n.entries == "function"))
        return this.array(
          Array.from(n.entries()),
          !0
          /* ordered */
        );
    },
    error(n) {
      return a("error:" + n.toString());
    },
    boolean(n) {
      return a("bool:" + n);
    },
    string(n) {
      a("string:" + n.length + ":"), a(n);
    },
    function(n) {
      a("fn:"), fn(n) ? this.dispatch("[native]") : this.dispatch(n.toString()), e.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(n.name)), e.respectFunctionProperties && this.object(n);
    },
    number(n) {
      return a("number:" + n);
    },
    xml(n) {
      return a("xml:" + n.toString());
    },
    null() {
      return a("Null");
    },
    undefined() {
      return a("Undefined");
    },
    regexp(n) {
      return a("regex:" + n.toString());
    },
    uint8array(n) {
      return a("uint8array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    uint8clampedarray(n) {
      return a("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(n));
    },
    int8array(n) {
      return a("int8array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    uint16array(n) {
      return a("uint16array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    int16array(n) {
      return a("int16array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    uint32array(n) {
      return a("uint32array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    int32array(n) {
      return a("int32array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    float32array(n) {
      return a("float32array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    float64array(n) {
      return a("float64array:"), this.dispatch(Array.prototype.slice.call(n));
    },
    arraybuffer(n) {
      return a("arraybuffer:"), this.dispatch(new Uint8Array(n));
    },
    url(n) {
      return a("url:" + n.toString());
    },
    map(n) {
      a("map:");
      const s = [...n];
      return this.array(s, e.unorderedSets !== !1);
    },
    set(n) {
      a("set:");
      const s = [...n];
      return this.array(s, e.unorderedSets !== !1);
    },
    file(n) {
      return a("file:"), this.dispatch([n.name, n.size, n.type, n.lastModfied]);
    },
    blob() {
      if (e.ignoreUnknown)
        return a("[blob]");
      throw new Error(
        `Hashing Blob objects is currently not supported
Use "options.replacer" or "options.ignoreUnknown"
`
      );
    },
    domwindow() {
      return a("domwindow");
    },
    bigint(n) {
      return a("bigint:" + n.toString());
    },
    /* Node.js standard native objects */
    process() {
      return a("process");
    },
    timer() {
      return a("timer");
    },
    pipe() {
      return a("pipe");
    },
    tcp() {
      return a("tcp");
    },
    udp() {
      return a("udp");
    },
    tty() {
      return a("tty");
    },
    statwatcher() {
      return a("statwatcher");
    },
    securecontext() {
      return a("securecontext");
    },
    connection() {
      return a("connection");
    },
    zlib() {
      return a("zlib");
    },
    context() {
      return a("context");
    },
    nodescript() {
      return a("nodescript");
    },
    httpparser() {
      return a("httpparser");
    },
    dataview() {
      return a("dataview");
    },
    signal() {
      return a("signal");
    },
    fsevent() {
      return a("fsevent");
    },
    tlswrap() {
      return a("tlswrap");
    }
  };
}
const Es = "[native code] }", Tf = Es.length;
function fn(e) {
  return typeof e != "function" ? !1 : Function.prototype.toString.call(e).slice(-Tf) === Es;
}
class ct {
  constructor(t, i) {
    t = this.words = t || [], this.sigBytes = i === void 0 ? t.length * 4 : i;
  }
  toString(t) {
    return (t || Af).stringify(this);
  }
  concat(t) {
    if (this.clamp(), this.sigBytes % 4)
      for (let i = 0; i < t.sigBytes; i++) {
        const a = t.words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
        this.words[this.sigBytes + i >>> 2] |= a << 24 - (this.sigBytes + i) % 4 * 8;
      }
    else
      for (let i = 0; i < t.sigBytes; i += 4)
        this.words[this.sigBytes + i >>> 2] = t.words[i >>> 2];
    return this.sigBytes += t.sigBytes, this;
  }
  clamp() {
    this.words[this.sigBytes >>> 2] &= 4294967295 << 32 - this.sigBytes % 4 * 8, this.words.length = Math.ceil(this.sigBytes / 4);
  }
  clone() {
    return new ct([...this.words]);
  }
}
const Af = {
  stringify(e) {
    const t = [];
    for (let i = 0; i < e.sigBytes; i++) {
      const a = e.words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
      t.push((a >>> 4).toString(16), (a & 15).toString(16));
    }
    return t.join("");
  }
}, xf = {
  stringify(e) {
    const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = [];
    for (let a = 0; a < e.sigBytes; a += 3) {
      const n = e.words[a >>> 2] >>> 24 - a % 4 * 8 & 255, s = e.words[a + 1 >>> 2] >>> 24 - (a + 1) % 4 * 8 & 255, o = e.words[a + 2 >>> 2] >>> 24 - (a + 2) % 4 * 8 & 255, r = n << 16 | s << 8 | o;
      for (let l = 0; l < 4 && a * 8 + l * 6 < e.sigBytes * 8; l++)
        i.push(t.charAt(r >>> 6 * (3 - l) & 63));
    }
    return i.join("");
  }
}, If = {
  parse(e) {
    const t = e.length, i = [];
    for (let a = 0; a < t; a++)
      i[a >>> 2] |= (e.charCodeAt(a) & 255) << 24 - a % 4 * 8;
    return new ct(i, t);
  }
}, Df = {
  parse(e) {
    return If.parse(unescape(encodeURIComponent(e)));
  }
};
class Nf {
  constructor() {
    this._data = new ct(), this._nDataBytes = 0, this._minBufferSize = 0, this.blockSize = 512 / 32;
  }
  reset() {
    this._data = new ct(), this._nDataBytes = 0;
  }
  _append(t) {
    typeof t == "string" && (t = Df.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _doProcessBlock(t, i) {
  }
  _process(t) {
    let i, a = this._data.sigBytes / (this.blockSize * 4);
    t ? a = Math.ceil(a) : a = Math.max((a | 0) - this._minBufferSize, 0);
    const n = a * this.blockSize, s = Math.min(n * 4, this._data.sigBytes);
    if (n) {
      for (let o = 0; o < n; o += this.blockSize)
        this._doProcessBlock(this._data.words, o);
      i = this._data.words.splice(0, n), this._data.sigBytes -= s;
    }
    return new ct(i, s);
  }
}
class Of extends Nf {
  update(t) {
    return this._append(t), this._process(), this;
  }
  finalize(t) {
    t && this._append(t);
  }
}
const kn = [
  1779033703,
  -1150833019,
  1013904242,
  -1521486534,
  1359893119,
  -1694144372,
  528734635,
  1541459225
], Uf = [
  1116352408,
  1899447441,
  -1245643825,
  -373957723,
  961987163,
  1508970993,
  -1841331548,
  -1424204075,
  -670586216,
  310598401,
  607225278,
  1426881987,
  1925078388,
  -2132889090,
  -1680079193,
  -1046744716,
  -459576895,
  -272742522,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  -1740746414,
  -1473132947,
  -1341970488,
  -1084653625,
  -958395405,
  -710438585,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  -2117940946,
  -1838011259,
  -1564481375,
  -1474664885,
  -1035236496,
  -949202525,
  -778901479,
  -694614492,
  -200395387,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  -2067236844,
  -1933114872,
  -1866530822,
  -1538233109,
  -1090935817,
  -965641998
], ft = [];
class $f extends Of {
  constructor() {
    super(...arguments), this._hash = new ct([...kn]);
  }
  reset() {
    super.reset(), this._hash = new ct([...kn]);
  }
  _doProcessBlock(t, i) {
    const a = this._hash.words;
    let n = a[0], s = a[1], o = a[2], r = a[3], l = a[4], u = a[5], c = a[6], m = a[7];
    for (let d = 0; d < 64; d++) {
      if (d < 16)
        ft[d] = t[i + d] | 0;
      else {
        const f = ft[d - 15], b = (f << 25 | f >>> 7) ^ (f << 14 | f >>> 18) ^ f >>> 3, P = ft[d - 2], k = (P << 15 | P >>> 17) ^ (P << 13 | P >>> 19) ^ P >>> 10;
        ft[d] = b + ft[d - 7] + k + ft[d - 16];
      }
      const v = l & u ^ ~l & c, w = n & s ^ n & o ^ s & o, S = (n << 30 | n >>> 2) ^ (n << 19 | n >>> 13) ^ (n << 10 | n >>> 22), j = (l << 26 | l >>> 6) ^ (l << 21 | l >>> 11) ^ (l << 7 | l >>> 25), E = m + j + v + Uf[d] + ft[d], A = S + w;
      m = c, c = u, u = l, l = r + E | 0, r = o, o = s, s = n, n = E + A | 0;
    }
    a[0] = a[0] + n | 0, a[1] = a[1] + s | 0, a[2] = a[2] + o | 0, a[3] = a[3] + r | 0, a[4] = a[4] + l | 0, a[5] = a[5] + u | 0, a[6] = a[6] + c | 0, a[7] = a[7] + m | 0;
  }
  finalize(t) {
    super.finalize(t);
    const i = this._nDataBytes * 8, a = this._data.sigBytes * 8;
    return this._data.words[a >>> 5] |= 128 << 24 - a % 32, this._data.words[(a + 64 >>> 9 << 4) + 14] = Math.floor(
      i / 4294967296
    ), this._data.words[(a + 64 >>> 9 << 4) + 15] = i, this._data.sigBytes = this._data.words.length * 4, this._process(), this._hash;
  }
}
function Bf(e) {
  return new $f().finalize(e).toString(xf);
}
function Rf(e, t = {}) {
  const i = typeof e == "string" ? e : Cf(e, t);
  return Bf(i).slice(0, 10);
}
function ti(e) {
  const { host: t, path: i, defaultOptions: a, defaultHeaders: n } = e, o = (() => {
    const d = cn(t, i);
    return d.startsWith("http") ? d : `/${d}`;
  })(), r = (d, v = {}) => {
    const w = new URLSearchParams({
      ...v
    }).toString(), S = cn(o, d);
    return w ? `${S}?${w}` : S;
  }, l = (d = {}) => {
    const { headers: v, ...w } = d;
    return {
      headers: {
        ...n,
        ...v
      },
      ...a,
      ...w
    };
  };
  return {
    baseUrl: o,
    buildRequestUrl: r,
    buildRequestOptions: l,
    fetchPostJson: (d, v, w, S) => fetch(r(d, v), {
      ...l({ ...S, method: hn.POST, body: JSON.stringify(w) })
    }),
    fetchPost: (d, v, w, S) => fetch(r(d, v), {
      ...l({ ...S, method: hn.POST, body: pf(w) })
    }),
    fetchGet: (d, v, w) => fetch(r(d, v), {
      ...l({ ...w, key: Rf([d, v]) })
    })
  };
}
const Bt = () => {
  var E, A, f, b, P;
  const e = Rt(), { globalsState: t } = Xe(), i = ((E = t.value) == null ? void 0 : E["module.cdc.baseUrl"]) || "", a = ((A = t.value) == null ? void 0 : A["module.cdc.ApiKey"]) || "", n = ((f = t.value) == null ? void 0 : f["module.cdc.clientId"]) || "", o = `https://${(P = (b = t.value) == null ? void 0 : b["general.domain"]) == null ? void 0 : P.replace(/\/$/, "")}${Ii.auth}`, r = ti({
    host: i,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  });
  return {
    login: (k, M) => {
      var _;
      return we(
        (_ = e.value) == null ? void 0 : _.isMocked,
        "accounts.login",
        () => r.fetchPost(Fe.login, void 0, {
          ApiKey: a,
          loginID: k,
          password: M,
          include: "missing-required-fields,preferences",
          includeUserInfo: !0,
          httpStatusCodes: !0
        }).then(async (C) => {
          const $ = await C.json();
          return { resp: C, json: $ };
        })
      );
    },
    logout: ({ sessionData: k }) => {
      var M;
      return we(
        (M = e.value) == null ? void 0 : M.isMocked,
        "accounts.logout",
        () => r.fetchPost(Fe.logout, void 0, {
          ApiKey: a,
          UID: k.UID,
          httpStatusCodes: !0
        }).then(async (_) => {
          const C = await _.json();
          return { resp: _, json: C };
        })
      );
    },
    emailValidation: (k) => r.fetchPost(Fe.isEmailAvailable, void 0, {
      ApiKey: a,
      loginID: k
    }).then(async (M) => {
      const _ = await M.json();
      return { ...M, json: _ };
    }),
    getPasswordPolicies: (k) => {
      var M;
      return we(
        (M = e.value) == null ? void 0 : M.isMocked,
        "accounts.getPasswordPolicies",
        () => r.fetchPost(Fe.getPasswordPolicies, void 0, {
          ApiKey: a,
          sections: k.join(","),
          filter: "full",
          httpStatusCodes: !0
        }).then(async (_) => {
          const C = await _.json();
          return { resp: _, json: C };
        })
      );
    },
    resetPassword: (k) => {
      var M;
      return we(
        (M = e.value) == null ? void 0 : M.isMocked,
        "accounts.resetPassword",
        () => r.fetchPost(Fe.resetPassword, void 0, {
          ApiKey: a,
          email: k,
          loginID: k,
          httpStatusCodes: !0
        }).then(async (_) => {
          try {
            const C = await _.json();
            return { resp: _, json: C };
          } catch {
            return { resp: _, json: {} };
          }
        })
      );
    },
    resetPasswordWithResetToken: ({ passwordResetToken: k, newPassword: M }) => {
      var _;
      return we(
        (_ = e.value) == null ? void 0 : _.isMocked,
        "accounts.resetPasswordWithResetToken",
        () => r.fetchPost(Fe.resetPassword, void 0, {
          ApiKey: a,
          passwordResetToken: k,
          newPassword: M,
          httpStatusCodes: !0
        }).then(async (C) => {
          try {
            const $ = await C.json();
            return { resp: C, json: $ };
          } catch {
            return { resp: C, json: {} };
          }
        })
      );
    },
    setAccountInfo: (k) => {
      var _;
      const M = _a();
      return we(
        (_ = e.value) == null ? void 0 : _.isMocked,
        "accounts.setAccountInfo",
        () => r.fetchPost(Fe.setAccountInfoLegacy, void 0, {
          ApiKey: a,
          login_token: M.get(),
          httpStatusCodes: !0,
          ...k
        }).then(async (C) => {
          try {
            const $ = await C.json();
            return { resp: C, json: $ };
          } catch {
            return { resp: C, json: {} };
          }
        })
      );
    },
    authorize: async (k) => {
      var F;
      console.debug("CDC authorize ...");
      const M = hf(60), _ = await gf(M);
      sessionStorage.setItem(mn, M);
      const C = {
        response_type: "code",
        // 'code', 'token', 'id_token'
        client_id: n,
        redirect_uri: (k == null ? void 0 : k.redirectUri) || o,
        scope: "openid customer_data bpdata shop",
        state: Xv(),
        code_challenge: _,
        code_challenge_method: "S256"
        // e.g., 'S256', 'plain'
        // nonce: 'NONCE_VALUE', // Should be generated dynamically
        // prompt: 'PROMPT_VALUE', // e.g., 'none', 'login', 'consent'
        // response_mode: 'RESPONSE_MODE', // e.g., 'query', 'fragment', 'form_post'
      }, $ = bn(C, a, i, "/authorize");
      (F = e.value) != null && F.isMocked ? (console.debug("MOCK", "Skipping authorize URL:", $), console.debug("MOCK", "Navigating to:", (location.pathname + "/auth?code=123456abc").replace("//", "/")), location.href = (location.pathname + "/auth?code=123456abc").replace("//", "/")) : location.href = $;
    },
    getToken: ({ authorizationCode: k, redirectUri: M = o }) => {
      var _;
      return we(
        (_ = e.value) == null ? void 0 : _.isMocked,
        "accounts.login",
        () => r.fetchPost(bn({}, a, "", "/token"), void 0, {
          code: k,
          grant_type: "authorization_code",
          redirect_uri: M,
          client_id: n,
          code_verifier: sessionStorage.getItem(mn)
        }).then(async (C) => {
          try {
            const $ = await C.json();
            return { resp: C, json: $ };
          } catch {
            return { resp: C, json: {} };
          }
        })
      );
    }
  };
};
function bn(e, t, i, a) {
  const n = `${i}${Sf.oidc}/${t}${a}`, s = Object.keys(e).map((o) => `${encodeURIComponent(o)}=${encodeURIComponent(e[o])}`).join("&");
  return `${n}?${s}`;
}
const Vf = () => async (e, t) => {
  var n;
  console.warn("useAccountLogin is DEPRECATED and will be removed. You should use: useCdcService");
  const i = Bt(), { json: a } = await i.login(e, t);
  if (a.statusCode !== 200)
    switch (a.statusCode) {
      case 206:
        let s = null;
        return (n = a.missingRequiredFields) != null && n.length && (s = new Ti(void 0, void 0, void 0, a)), { json: a, error: s };
      case 403:
        throw new ba();
      default:
        throw new wa(a.errorMessage, a.errorDetails);
    }
  return { json: a, error: null };
}, Ss = () => zt(Mf), _a = () => zt(Ms), Qw = (e, t) => {
  var a;
  const i = zt(yf);
  return i.get() || i.set(e.host || e[":authority"] || ((a = t.value) == null ? void 0 : a["general.domain"])), i;
}, Ff = () => {
  var c, m, d, v, w;
  const e = Rt(), { globalsState: t } = Xe(), i = ((c = t.value) == null ? void 0 : c["module.auth.baseUrl"]) || "", a = (d = (m = t.value) == null ? void 0 : m["general.domain"]) == null ? void 0 : d.replace(/\/$/, ""), n = ((w = (v = i == null ? void 0 : i.split("/")) == null ? void 0 : v.slice(-1)) == null ? void 0 : w.pop()) || "", s = `https://${a}${Ii.auth}`, o = ti({
    host: i,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json"
    }
  });
  return { getToken: ({
    authorizationCode: S,
    org: j = n,
    grantType: E = "authorization_code",
    redirectUri: A = s
  }) => o.fetchPost("/token", void 0, {
    org: j,
    code: S,
    grant_type: E,
    redirect_uri: A
  }).then(async (f) => {
    const b = await f.json();
    return { resp: f, data: b };
  }), authorize: (S) => {
    var b;
    if ((b = e.value) != null && b.isMocked) {
      location.href = "/login/auth?code=mockingreallywell";
      return;
    }
    const {
      clientId: j = "XXX",
      responseType: E = "code",
      scope: A = "openid+email+profile+bpdata+zuora+mcs+shop+stock",
      redirectUri: f = s
      // redirectUri = 'https://oauth2-demo-qs.map.miele-iot.com/demo/oauth2/gb2', // whitelisted address for testing
    } = S || {};
    location.href = `${i}/authorize?client_id=${j}&response_type=${E}&scope=${A}&redirect_uri=${f}`;
  }, logout: ({ authorizationCode: S, org: j = n }) => {
    var E;
    return we(
      (E = e.value) == null ? void 0 : E.isMocked,
      "accounts.logout",
      () => o.fetchPost("/logout", void 0, void 0, {
        headers: {
          org: j,
          Authorization: `Bearer ${S}`
        }
      }).then(async (A) => {
        const f = await A.json();
        return { resp: A, json: f };
      })
    );
  } };
}, At = () => {
  var u;
  const { globalsState: e } = Xe(), t = Rt(), i = ti({
    host: ((u = e.value) == null ? void 0 : u["general.experienceApi"]) || "",
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  });
  return {
    createSession: async (c) => {
      const m = await i.fetchPostJson(
        Ki.create,
        void 0,
        {
          regToken: c.refresh_token,
          mieleJWT: c.access_token
        },
        {
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        }
      );
      try {
        const d = await m.json();
        return { resp: m, json: d };
      } catch {
        return { resp: m, json: {} };
      }
    },
    validateSession: async () => {
      const c = await i.fetchGet(Ki.status, void 0, {
        credentials: "include"
      });
      try {
        const m = await c.json();
        return { resp: c, json: m };
      } catch {
        return { resp: c, json: {} };
      }
    },
    logoutSession: async () => {
      const c = await i.fetchGet(Ki.logout, void 0, {
        credentials: "include"
      });
      try {
        const m = await c.json();
        return { resp: c, json: m };
      } catch {
        return { resp: c, json: {} };
      }
    },
    getUserInfo: async () => {
      var c;
      return we((c = t.value) == null ? void 0 : c.isMocked, "experience.userInfo", async () => {
        var d;
        const m = await i.fetchGet(
          Hi.getUserInfo(e.value["general.country"]),
          {
            fields: "FULL",
            lang: `${e.value["general.language"]}_${e.value["general.country"].toUpperCase()}`
          },
          {
            headers: {
              ApiKey: ((d = e.value) == null ? void 0 : d["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const v = await m.json();
          return { resp: m, json: v };
        } catch {
          return { resp: m };
        }
      });
    },
    setMieleClub: async (c) => {
      var m;
      return we((m = t.value) == null ? void 0 : m.isMocked, "experience.mieleClub", async () => {
        var v;
        const d = await i.fetchPost(
          Hi.getMieleClubUrl(e.value["general.country"]),
          { isMieleClubMember: c },
          {},
          {
            headers: {
              ApiKey: ((v = e.value) == null ? void 0 : v["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const w = await d.json();
          return { resp: d, json: w };
        } catch {
          return { resp: d };
        }
      });
    },
    setEmail: async (c) => {
      var m;
      return we((m = t.value) == null ? void 0 : m.isMocked, "experience.email", async () => {
        var v;
        const d = await i.fetchPostJson(
          Hi.getEmailUrl(e.value["general.country"]),
          {},
          { newEmail: c },
          {
            headers: {
              "Content-Type": "application/json",
              ApiKey: ((v = e.value) == null ? void 0 : v["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const w = await d.json();
          return { resp: d, json: w };
        } catch {
          return { resp: d };
        }
      });
    }
  };
}, ii = () => ({
  createSession: async (a) => {
    const { resp: n } = await At().createSession(a);
    if (!n.ok)
      throw new Ce("Unable to create session");
  },
  isSessionValid: async () => {
    var o;
    const { resp: a, json: n } = await At().validateSession();
    if (!a.ok)
      throw new Ce("Unable to validate session");
    const s = n;
    return ((o = s == null ? void 0 : s.auth) == null ? void 0 : o.authenticated) || !1;
  },
  logoutSession: async () => {
    const { resp: a } = await At().logoutSession();
    if (!a.ok)
      throw new Ce("Unable to logout of session");
  }
}), qf = () => {
  const { isSessionValid: e } = ii(), t = Ff(), i = H({
    access_token: null,
    token_type: null,
    expires_in: null,
    refresh_token: null
  }), a = () => {
    t.authorize();
  }, n = _a();
  return { authorize: a, getJwtToken: async ({ authorizationCode: o }) => {
    if (!await e() || !i.value.access_token) {
      const l = await t.getToken({ authorizationCode: o }), { resp: u, data: c } = l;
      if (!u.ok) {
        const m = c;
        throw (m == null ? void 0 : m.error) === "invalid_grant" ? (console.warn("New session is required.", m == null ? void 0 : m.error_description), new Ma(m == null ? void 0 : m.error_description)) : Error(`Unhandled error getJwtToken: ${JSON.stringify(m)}`);
      }
      n.set(c.refresh_token), i.value = c;
    }
    return i.value;
  } };
}, Gf = () => !!zt(zf).get(), Wi = H(void 0), Rt = () => (Wi.value || (Wi.value = {
  isMocked: !1,
  isDangerZone: Gf()
}), Wi), Kf = (e) => {
  var u;
  const t = Rt(), { globalsState: i } = Xe(), a = e || ((u = i.value) == null ? void 0 : u["general.domain"]), n = ti({
    host: `https://${a}`,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json"
    }
  }), s = async () => {
    var c;
    return we(
      (c = t.value) == null ? void 0 : c.isMocked,
      "hybris.csrf",
      () => n.fetchGet(bt(Zt.csrf)).then(async (m) => {
        const d = await m.json();
        return { resp: m, json: d };
      })
    );
  };
  return { login: async ({
    newUser: c,
    UIDSignature: m,
    signatureTimestamp: d,
    UID: v,
    profile: w,
    data: S,
    ...j
  }) => {
    var f;
    const E = {
      gigyaData: {
        eventName: "login",
        remember: !1,
        isGlobal: !0,
        fullEventName: Fe.login,
        loginMode: "standard",
        provider: "",
        source: "showScreenSet",
        // TODO: check if this is necessary
        newUser: c ?? j.isNewUser ?? !1,
        UIDSignature: m,
        signatureTimestamp: d,
        UID: v,
        profile: w,
        data: S
      }
    }, A = { headers: {} };
    try {
      const { json: b } = await s();
      A.headers.csrftoken = b.CSRFToken;
    } catch (b) {
      throw console.error(b), new ye("Unable to get csrf token.", void 0, b);
    }
    return we(
      (f = t.value) == null ? void 0 : f.isMocked,
      "hybris.login",
      () => n.fetchPost(bt(Zt.gigyaRaasLogin), void 0, E, A).then(async (b) => {
        const P = await b.json();
        return { resp: b, json: P };
      })
    );
  }, logout: () => {
    var c;
    return we(
      (c = t.value) == null ? void 0 : c.isMocked,
      "hybris.logout",
      () => n.fetchGet(bt(Zt.logout)).then(async (m) => ({ resp: m, json: {} }))
    );
  }, sessionStatus: (c) => {
    var m;
    return we(
      (m = t.value) == null ? void 0 : m.isMocked,
      "hybris.session",
      () => n.fetchGet(
        bt(Zt.authenticationStatus),
        void 0,
        c ? { headers: { cookie: c } } : void 0
      ).then(async (d) => ({ resp: d, json: {} }))
    );
  } };
}, Ea = (e) => {
  const t = Kf(e);
  return { login: async (s) => {
    const { resp: o, json: r } = await t.login(s);
    if (!o.ok)
      throw console.error("ERROR", "hybris login failed with status", o.status), Error("WebLoginError");
    return r;
  }, logout: async () => {
    const { resp: s } = await t.logout();
    if (!s.ok)
      throw console.error("ERROR", "hybris logout failed with status", s.status), Error("WebLoginError");
  }, sessionStatus: async (s) => {
    const { resp: o } = await t.sessionStatus(s);
    if (!o.ok)
      switch (o.status) {
        case 401:
          const r = new us(o.statusText);
          throw r.code = 401, r;
        default:
          throw new ye(o.statusText);
      }
    if (new URL(o.url).pathname !== bt(Zt.authenticationStatus)) {
      const r = new ye("Unable to check session status.");
      throw r.code = 403, r;
    }
    return o.status;
  } };
}, Hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useWebService: Ea
}, Symbol.toStringTag, { value: "Module" })), Wf = (e) => e.startsWith("glt_") || e.startsWith("gig_");
function Jf() {
  document.cookie.split(";").map((t) => t.split("=")[0].trim()).filter(Wf).forEach((t) => zt(t).remove());
}
const Sa = () => {
  const { setIsLoggedIn: e, isLoggedIn: t } = La(), i = () => {
    const n = js();
    console.debug("Removing session data from storage"), n.remove();
  };
  return { logout: async () => {
    const n = zs(), s = Ss();
    console.debug("Initiating logout process");
    const { logoutSession: o } = ii(), r = Ea();
    console.debug("Logging out from AuthProxy & remove JWT cookie via experience api"), await o(), console.debug("Logging out from Hybris"), await r.logout(), console.debug("Removing CDC session cookie"), n.remove(), console.debug("Removing auth code cookie"), s.remove(), i(), console.debug("Removing Gigya cookies"), Jf(), e(!1);
  }, isLoggedIn: t, clearSessionCache: i };
}, wn = H(!1), La = () => {
  const e = (i) => {
    console.debug(`User is logged ${i ? "in" : "out"}`), wn.value = i;
  };
  return {
    isLoggedIn: () => wn.value,
    setIsLoggedIn: e,
    checkSession: async (i = !1) => {
      const a = (await Promise.resolve().then(() => Hf)).useWebService();
      try {
        return await a.sessionStatus(), e(!0), !0;
      } catch (n) {
        if (n.code === 401) {
          const { logout: s, clearSessionCache: o } = Sa();
          i ? await s() : (o(), e(!1));
        } else
          throw n;
        return !1;
      }
    }
  };
}, Dt = "miele.marketingconsent.personalized.tracking.isConsentGranted", Ls = "miele.marketingconsent.personalized.general.isConsentGranted", Zf = "miele.marketingconsent.personalized.iot.isConsentGranted", Cs = "terms.miele.statement.isConsentGranted", Ps = "miele.general.newsletter.email.isSubscribed", $e = {
  login: "umf-login-form",
  register: "umf-register-form",
  registerDetails: "umf-register-details-form",
  changeEmail: "umf-change-email-form",
  changePassword: "umf-change-password-form",
  changeMarketingPreference: "umf-marketing-preference-form",
  newPassword: "umf-new-password-form",
  forgotPassword: "umf-forgot-password-form"
}, di = {
  login: "login_event",
  register: "register_event",
  registerDetailsComplete: "full_registration_complete",
  formSubmit: "MieleBasic_FormSubmit",
  addressLookupClick: "search_address_click",
  addressLookupError: "lookup_address_error",
  selectAddressFromDropdown: "system_provided_address_click"
};
function Be() {
  function e({ userInfo: o, loginSession: r }) {
    var u, c;
    const l = {
      event: di.login,
      uid: r.UID,
      consent_status: Xf(r),
      user: {
        account_type: ((u = o.customerType) == null ? void 0 : u.toLowerCase()) ?? "n/a",
        clubmember: o.clubMember ? "yes" : "no",
        loginStatus: "logged in",
        miele_club_level: (c = o.mieleClubUserGroup) == null ? void 0 : c.toLowerCase()
      }
    };
    return s().push(l);
  }
  function t(o, r) {
    const l = r.map((c, m) => c ? `level ${m + 1}` : null).filter((c) => !!c).join(","), u = {
      event: di.register,
      uid: o,
      consent_status: r.includes(!0),
      user: {
        clubmember: "no",
        loginStatus: "logged in",
        marketing_consent_levels: l || "no"
      }
    };
    s().push(u);
  }
  function i(o, r) {
    var c;
    const l = Qf(o), u = {
      event: di.registerDetailsComplete,
      uid: o.UID,
      consent_status: ek(o),
      user: {
        account_type: (c = r.customerType) == null ? void 0 : c.toLowerCase(),
        clubmember: r.registerMieleClub ? "yes" : "no",
        loginStatus: "logged in",
        marketing_consent_levels: l,
        miele_club_level: r.registerMieleClub ? "member" : "none"
      }
    };
    return s().push(u);
  }
  const a = (o, r) => {
    const l = {
      event: di.formSubmit,
      form: {
        identifier: o,
        form_submission_status: [void 0, null].includes(r) ? "ok" : `error:${r}`
      }
    };
    return s().push(l);
  }, n = (o, r) => {
    if (window === void 0)
      return;
    const l = {
      event: o
    };
    return r && (l.error_message = r), s().push(l);
  };
  function s() {
    return window != null && window.dataLayer || (window.dataLayer = []), window == null ? void 0 : window.dataLayer;
  }
  return {
    getDataLayer: s,
    pushLoginEvent: e,
    pushRegisterEvent: t,
    pushRegisterDetailsEvent: i,
    pushFormSubmitEvent: a,
    pushAddressEvent: n
  };
}
function Yf(e) {
  var t, i, a, n, s, o;
  return [
    (s = (n = (a = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : a.personalized) == null ? void 0 : n.tracking) == null ? void 0 : s.isConsentGranted,
    (o = e == null ? void 0 : e.preferences[Ts(Dt)]) == null ? void 0 : o.isConsentGranted,
    e == null ? void 0 : e.preferences[Dt]
  ];
}
function Xf(e) {
  var t, i, a, n, s, o;
  return (
    // TODO: check with CDC if this ⬇ can be standardized
    ((s = (n = (a = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : a.personalized) == null ? void 0 : n.tracking) == null ? void 0 : s.isConsentGranted) ?? ((o = e == null ? void 0 : e.preferences[Ts(Dt)]) == null ? void 0 : o.isConsentGranted) ?? (e == null ? void 0 : e.preferences[Dt]) ?? !1
  );
}
function Qf(e) {
  var t, i, a, n, s, o, r, l, u, c, m, d, v, w, S;
  return [
    (s = (n = (a = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : a.personalized) == null ? void 0 : n.general) == null ? void 0 : s.isConsentGranted,
    (c = (u = (l = (r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o.miele) == null ? void 0 : r.marketingconsent) == null ? void 0 : l.personalized) == null ? void 0 : u.tracking) == null ? void 0 : c.isConsentGranted,
    (S = (w = (v = (d = (m = e == null ? void 0 : e.preferences) == null ? void 0 : m.miele) == null ? void 0 : d.marketingconsent) == null ? void 0 : v.personalized) == null ? void 0 : w.iot) == null ? void 0 : S.isConsentGranted
  ].map((j, E) => j ? `level ${E + 1}` : null).filter((j) => !!j).join(",");
}
function ek(e) {
  var t, i, a, n, s, o, r, l, u, c, m, d, v, w, S;
  return ((s = (n = (a = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : a.personalized) == null ? void 0 : n.general) == null ? void 0 : s.isConsentGranted) || ((c = (u = (l = (r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o.miele) == null ? void 0 : r.marketingconsent) == null ? void 0 : l.personalized) == null ? void 0 : u.tracking) == null ? void 0 : c.isConsentGranted) || ((S = (w = (v = (d = (m = e == null ? void 0 : e.preferences) == null ? void 0 : m.miele) == null ? void 0 : d.marketingconsent) == null ? void 0 : v.personalized) == null ? void 0 : w.iot) == null ? void 0 : S.isConsentGranted) || !1;
}
const Ts = (e) => e.includes(".") ? e.substring(0, e.lastIndexOf(".")) : e, tk = () => {
  const e = Bt(), { isSessionValid: t } = ii(), i = _a(), a = H({
    access_token: null,
    token_type: null,
    expires_in: null,
    refresh_token: null
  });
  return { login: async (r, l) => {
    var c;
    const { json: u } = await e.login(r, l);
    if (u.statusCode !== 200)
      switch (u.statusCode) {
        case 206:
          let m = null;
          return (c = u.missingRequiredFields) != null && c.length && (m = new Ti(void 0, void 0, void 0, u)), { json: u, error: m };
        case 403:
          throw new ba();
        default:
          throw new wa(u.errorMessage, u.errorDetails);
      }
    return { json: u, error: null };
  }, authorize: () => e.authorize(), getJwtToken: async ({ authorizationCode: r }) => {
    if (!await t() || !a.value.access_token) {
      const u = await e.getToken({ authorizationCode: r }), { resp: c, json: m } = u;
      if (!c.ok) {
        const d = m;
        throw (d == null ? void 0 : d.error) === "invalid_grant" ? (console.warn("New session is required.", d == null ? void 0 : d.error_description), new Ma(d == null ? void 0 : d.error_description)) : Error(`Unhandled error getJwtToken: ${JSON.stringify(d)}`);
      }
      i.set(m.refresh_token), a.value = m;
    }
    return a.value;
  } };
}, As = () => {
  const { setIsLoggedIn: e, isLoggedIn: t } = La(), i = Vf(), { redirectToTarget: a, storeRedirect: n } = ys(), s = At(), o = H(null);
  return { login: async ({ email: l, password: u, code: c, redirectUrl: m, isRemember: d }) => {
    const v = !!sessionStorage.getItem(ff), w = Xe().globalsState.value["module.auth.authProxyDeprecated"], S = (
      // useConfig().value?.isDangerZone && // TODO: remove this check when feature is ready
      !v && // AuthProxy forced when "miele_force_auth_proxy" exist in session storage
      w
    ), { authorize: j, getJwtToken: E } = S ? tk() : qf(), A = Ea(), f = Ss(), b = js(), { createSession: P } = ii(), { logout: k } = Sa();
    if (o.value = null, m && n(m), l && u)
      try {
        await k();
        const { json: M, error: _ } = await i(l, u);
        if (await A.login(M), b.set(M, d), _)
          throw _;
      } catch (M) {
        throw console.warn("An error ocurred when trying to login with CDC."), o.value = M, M;
      }
    else
      c && f.set(c);
    if (!f.get())
      await j();
    else {
      const M = b.get();
      if (M) {
        try {
          const _ = await E({ authorizationCode: f.get() });
          await P(_);
        } catch (_) {
          if (_ instanceof Error)
            switch (_.name) {
              case "SessionInvalidGrantError":
                await j();
                return;
              default:
                o.value = new ms();
                return;
            }
          else
            throw _;
        } finally {
          f.remove();
        }
        if (e(!0), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: _, pushLoginEvent: C } = Be();
          try {
            const $ = await s.getUserInfo();
            $.json && (ik(), _($e.login), C({ userInfo: $.json, loginSession: M }));
          } catch ($) {
            console.error("Error fetching user info: ", $);
          }
        }
        a();
      } else
        e(!1), location.href = bt(Ii.login);
    }
  }, error: o, isLoggedIn: t };
};
function ik() {
  const e = new URL(globalThis.window.location.href);
  e.search = "", globalThis.window.history.pushState({}, document.title, e);
}
const xs = (e) => {
  if (e.statusCode !== 200 || e.errorCode !== 0) {
    if (Ut(e.errorCode))
      throw new $t(e.errorCode);
    switch (e.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new Ce();
      default:
        throw e.errorMessage ? new Ot(e.errorMessage, e.errorDetails) : new Ce();
    }
  }
  return e;
}, ak = () => async (e) => {
  const { json: t } = await Bt().resetPassword(e);
  return xs(t);
}, ey = () => async ({ passwordResetToken: e, newPassword: t }) => {
  const { json: i } = await Bt().resetPasswordWithResetToken({ passwordResetToken: e, newPassword: t });
  return xs(i);
}, nk = () => {
  const e = ak();
  return { forgotPassword: async (i) => await e(i) };
}, Di = () => async () => {
  const { resp: e, json: t } = await Ca().verifySession();
  if (!e.ok)
    throw e.status === 401 || !t.active ? new ya("Session is not valid") : new Ce(t.message);
  return t;
}, sk = () => ({ submitChangePassword: async (t, i) => {
  const a = ai();
  return await Di()(), await a({ password: t, newPassword: i });
} }), ok = () => async (e) => {
  const t = Bt();
  await Di()();
  const { json: a } = await t.getPasswordPolicies(e);
  if (a.statusCode !== 200 || a.errorCode !== 0) {
    if (Ut(a.errorCode))
      throw new $t(a.errorCode);
    switch (a.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new Ce();
      default:
        throw a.errorMessage ? new Ot(a.errorMessage, a.errorDetails) : new Ce();
    }
  }
  return a;
}, yn = {
  completeRegistrationUrl: "/registration/details",
  dashboardUrl: "/e/account/dashboard",
  loginUrl: "/login",
  registerUrl: "/registration",
  forgotPasswordUrl: "/login/forgotpassword",
  newPasswordUrl: "/login/newpassword"
}, ty = () => ({ checkSessionAndRedirectOnInvalid: async (t) => {
  var o;
  if ((o = Rt().value) != null && o.isMocked)
    return;
  const a = t ? yn.loginUrl + "?target_url=" + t : yn.loginUrl, { isSessionValid: n } = ii();
  await n() || (location.href = a);
} }), Is = () => async (e) => {
  await Di()();
  const { json: i } = await Ca().getAccountInfo({ include: e });
  if (i.statusCode !== 200 || i.errorCode !== 0) {
    if (Ut(i.errorCode))
      throw new $t(i.errorCode);
    switch (i.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new Ce();
      default:
        throw i.errorMessage ? new Ot(i.errorMessage, i.errorDetails) : new Ce();
    }
  }
  return i;
}, Ca = () => {
  var o, r;
  const e = Rt(), { globalsState: t } = Xe(), i = ti({
    host: ((o = t.value) == null ? void 0 : o["general.experienceApi"]) || "",
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      apiKey: ((r = t.value) == null ? void 0 : r["module.eComApi.ApiKey"]) || ""
    }
  });
  return {
    getAccountInfo: ({ include: l }) => {
      var u;
      return we(
        (u = e.value) == null ? void 0 : u.isMocked,
        "accounts.getAccountInfo",
        () => i.fetchPost(
          Fe.getAccountInfo,
          void 0,
          {
            include: l == null ? void 0 : l.join(","),
            httpStatusCodes: !1
          },
          {
            credentials: "include"
          }
        ).then(async (c) => {
          const m = await c.json();
          return { resp: c, json: m };
        })
      );
    },
    setAccountInfo: (l) => {
      var u;
      return we(
        (u = e.value) == null ? void 0 : u.isMocked,
        "accounts.setAccountInfo",
        () => i.fetchPost(
          Fe.setAccountInfo,
          void 0,
          {
            httpStatusCodes: !1,
            ...l
          },
          {
            credentials: "include"
          }
        ).then(async (c) => {
          try {
            const m = await c.json();
            return { resp: c, json: m };
          } catch {
            return { resp: c, json: {} };
          }
        })
      );
    },
    verifySession: () => {
      var l;
      return we(
        (l = e.value) == null ? void 0 : l.isMocked,
        "cdc.verifySession",
        () => i.fetchPost(
          Fe.verifySession,
          void 0,
          {
            httpStatusCodes: !1
          },
          {
            credentials: "include"
          }
        ).then(async (u) => {
          const c = await u.json();
          return { resp: u, json: c };
        })
      );
    }
  };
}, ai = () => async (e) => {
  await Di()();
  const { json: i } = await Ca().setAccountInfo(e);
  if (i.statusCode !== 200 || i.errorCode !== 0) {
    if (Ut(i.errorCode))
      throw new $t(i.errorCode);
    switch (i.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new Ce();
      default:
        throw i.errorMessage ? new Ot(i.errorMessage, i.errorDetails) : new Ce();
    }
  }
  return i;
}, rk = { class: "umf-change-email" }, lk = { class: "dcf-h2 umf-change-email__headline" }, ck = { class: "dcf-copy umf-change-email__copy" }, dk = { class: "umf-change-email__form-wrapper" }, uk = /* @__PURE__ */ pe({
  __name: "umf-change-email-scene",
  setup(e) {
    const { ct: t } = ue(), i = H({
      changeEmailSuccessful: !1,
      email: null,
      emailConfirmation: null,
      isFormReady: !0,
      error: null
    }), a = ai(), { setEmail: n } = At(), s = W(() => Tt(i.value.email)), o = W(() => i.value.email === i.value.emailConfirmation), r = W(() => i.value.email !== null && !s.value ? t("changeEmailScene.invalidEmailMessage") : null), l = W(() => i.value.emailConfirmation !== null && !o.value ? t("changeEmailScene.confirmEmailMessage") : null), u = W(() => i.value.changeEmailSuccessful && !i.value.email && !i.value.emailConfirmation), c = W(() => !s.value || !o.value || !i.value.isFormReady), m = async () => {
      i.value.isFormReady = !1, i.value.changeEmailSuccessful = !1;
      try {
        const v = i.value.email;
        if (await a({ profile: { email: v } }), await n(v), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: w } = Be();
          w($e.changeEmail);
        }
        i.value.changeEmailSuccessful = !0, window.location.reload();
      } catch (v) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: w } = Be();
          w($e.changeEmail, v.name);
        }
        i.value.changeEmailSuccessful = !1, i.value.error = v, i.value.isFormReady = !0;
      }
    }, d = async () => {
      await m(), i.value.email = null, i.value.emailConfirmation = null;
    };
    return (v, w) => (G(), Z("div", rk, [
      D("h2", lk, R(p(t)("changeEmailScene.headline")), 1),
      D("p", ck, R(p(t)("changeEmailScene.copy")), 1),
      D("form", {
        onSubmit: Qe(d, ["prevent"])
      }, [
        D("div", dk, [
          U(p(rt), {
            modelValue: i.value.email,
            "onUpdate:modelValue": w[0] || (w[0] = (S) => i.value.email = S),
            modelModifiers: { trim: !0 },
            label: p(t)("changeEmailScene.inputEmailPlaceholder"),
            "is-validated": p(Tt)(i.value.email),
            "is-required": "",
            autocomplete: "email",
            disabled: !i.value.isFormReady,
            "error-message": r.value
          }, null, 8, ["modelValue", "label", "is-validated", "disabled", "error-message"]),
          U(p(rt), {
            modelValue: i.value.emailConfirmation,
            "onUpdate:modelValue": w[1] || (w[1] = (S) => i.value.emailConfirmation = S),
            modelModifiers: { trim: !0 },
            label: p(t)("changeEmailScene.inputEmailConfirmPlaceholder"),
            "is-required": "",
            disabled: !i.value.isFormReady,
            "error-message": l.value
          }, null, 8, ["modelValue", "label", "disabled", "error-message"]),
          u.value ? (G(), Ve(p(ji), {
            key: 0,
            headline: p(t)("changeEmailScene.successMessageHeadline"),
            description: p(t)("changeEmailScene.successMessageCopy"),
            variant: "SUCCESS",
            "has-close-button": !1
          }, null, 8, ["headline", "description"])) : ke("", !0),
          U(p(mt), {
            error: i.value.error
          }, null, 8, ["error"]),
          U(p(Ue), {
            type: "submit",
            variant: "primary",
            "full-width": "",
            disabled: c.value
          }, {
            default: ne(() => [
              Pe(R(p(t)("changeEmailScene.buttonLabel")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]));
  }
});
const Ie = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [a, n] of t)
    i[a] = n;
  return i;
}, mk = /* @__PURE__ */ Ie(uk, [["__scopeId", "data-v-20a36d7a"]]), pk = { class: "umf-change-password" }, gk = { class: "dcf-h2 umf-change-password_form-title" }, hk = { class: "dcf-h5 umf-change-password_form-subtitle" }, vk = { class: "form-wrap" }, fk = {
  key: 1,
  class: "success-display"
}, kk = /* @__PURE__ */ pe({
  __name: "umf-change-password-scene",
  emits: ["onClose"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), { submitChangePassword: a } = sk(), n = H(), s = H({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      isChangeSuccessful: !1,
      errorMsg: "",
      minCharGroups: 3,
      minLength: 8,
      error: null
    }), o = W(() => !s.value.currentPassword || !s.value.newPassword || !s.value.confirmPassword || !r.value || !u.value || m.value || !c.value), r = W(() => {
      const E = s.value.confirmPassword === "";
      return s.value.newPassword === s.value.confirmPassword || E;
    }), l = W(() => ws(s.value.newPassword, s.value.minLength, s.value.minCharGroups)), u = W(() => l.value > Je.TooWeak), c = W(() => s.value.currentPassword !== "" && s.value.newPassword !== "" ? s.value.currentPassword !== s.value.newPassword : !0), m = W(() => {
      var E;
      return (E = n == null ? void 0 : n.value) == null ? void 0 : E.isLoading;
    }), d = t, v = async (E) => {
      try {
        if (await a(s.value.currentPassword, s.value.newPassword), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: f } = Be();
          f($e.changePassword);
        }
        s.value.isChangeSuccessful = !0;
        const { logout: A } = Sa();
        await A(), window.location.replace("/");
      } catch (A) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: f } = Be();
          f($e.changePassword, A.name);
        }
        E(), s.value.isChangeSuccessful = !1, s.value.error = A;
      }
    }, w = () => {
      n.value.isLoading = !0, v(n.value.resolveLoading);
    }, S = () => {
      d("onClose");
    }, j = async () => {
      try {
        const A = await ok()(["passwordComplexity"]);
        s.value.minCharGroups = A.passwordComplexity.minCharGroups, s.value.minLength = A.passwordComplexity.minLength;
      } catch (E) {
        s.value.error = E;
      }
    };
    return dt(() => {
      j();
    }), (E, A) => (G(), Z("div", pk, [
      D("h2", gk, R(p(i)("changePasswordScene.title")), 1),
      s.value.isChangeSuccessful ? (G(), Z("div", fk, [
        U(p(ji), {
          "on-click": () => null,
          variant: "SUCCESS",
          headline: p(i)("changePasswordScene.passwordUpdateSuccessTitle"),
          description: p(i)("changePasswordScene.successfulChangeLabel")
        }, null, 8, ["headline", "description"]),
        U(p(Ue), {
          variant: "primary",
          "full-width": "",
          onClick: S
        }, {
          default: ne(() => [
            Pe(R(p(i)("changePasswordScene.closeButtonLabel")), 1)
          ]),
          _: 1
        })
      ])) : (G(), Z(_t, { key: 0 }, [
        D("h5", hk, R(p(i)("changePasswordScene.subtitle")), 1),
        D("form", {
          onSubmit: Qe(w, ["prevent"])
        }, [
          D("div", vk, [
            U(p(rt), {
              modelValue: s.value.currentPassword,
              "onUpdate:modelValue": A[0] || (A[0] = (f) => s.value.currentPassword = f),
              autocomplete: "current-password",
              label: p(i)("changePasswordScene.currentPasswordLabel"),
              "is-required": "",
              type: "password",
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "show-password-text", "hide-password-text"]),
            U(p(rt), {
              modelValue: s.value.newPassword,
              "onUpdate:modelValue": A[1] || (A[1] = (f) => s.value.newPassword = f),
              autocomplete: "new-password",
              label: p(i)("changePasswordScene.newPasswordLabel"),
              "is-required": "",
              type: "password",
              "error-message": c.value ? null : p(i)("changePasswordScene.samePasswordError"),
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "error-message", "show-password-text", "hide-password-text"]),
            Ws(U(p(Ib), {
              password: s.value.newPassword,
              "min-length": s.value.minLength,
              "min-char-groups": s.value.minCharGroups
            }, null, 8, ["password", "min-length", "min-char-groups"]), [
              [Js, s.value.newPassword]
            ]),
            U(p(rt), {
              modelValue: s.value.confirmPassword,
              "onUpdate:modelValue": A[2] || (A[2] = (f) => s.value.confirmPassword = f),
              autocomplete: "confirm-password",
              label: p(i)("changePasswordScene.confirmPasswordLabel"),
              "is-required": "",
              type: "password",
              "error-message": r.value ? null : p(i)("changePasswordScene.passwordMismatchError"),
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "error-message", "show-password-text", "hide-password-text"]),
            U(p(mt), {
              error: s.value.error
            }, null, 8, ["error"]),
            U(p(Ue), {
              ref_key: "submitChangeButtonRef",
              ref: n,
              variant: "primary",
              "full-width": "",
              disabled: o.value,
              "with-loading-state": "",
              type: "submit"
            }, {
              default: ne(() => [
                Pe(R(p(i)("changePasswordScene.submitButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)
      ], 64))
    ]));
  }
});
const bk = /* @__PURE__ */ Ie(kk, [["__scopeId", "data-v-32e7e62c"]]);
var Me = /* @__PURE__ */ ((e) => (e.dark = "dcf-ctx-dark", e.light = "dcf-ctx-light", e))(Me || {}), le = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e))(le || {});
const wk = () => async (e) => {
  const { json: t } = await Bt().setAccountInfo(e);
  if (t.statusCode !== 200 || t.errorCode !== 0) {
    if (Ut(t.errorCode))
      throw new $t(t.errorCode);
    switch (t.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new Ce();
      default:
        throw t.errorMessage ? new Ot(t.errorMessage, t.errorDetails) : new Ce();
    }
  }
  return t;
}, yk = ["for", "innerHTML"], Mn = /* @__PURE__ */ pe({
  __name: "umf-consent-scene-consent",
  props: {
    label: null,
    for: null,
    linkLabel: null,
    url: null
  },
  setup(e) {
    var n;
    const { ct: t } = ue(), i = e, a = (n = i.linkLabel) != null && n.length ? `<a href="${i.url}">${t(i.linkLabel)}</a>` : void 0;
    return (s, o) => (G(), Z("label", {
      tag: "label",
      for: i.for,
      innerHTML: p(t)(i.label, [p(a)])
    }, null, 8, yk));
  }
}), Mk = { class: "dcf-h4 login-form-title" }, zk = { key: 0 }, jk = {
  key: 0,
  class: "umf-consent-scene__checkbox-group"
}, _k = { class: "dcf-h5" }, Ek = { class: "umf-consent-scene__checkbox dcf-body-copy" }, Sk = {
  key: 1,
  class: "umf-consent-scene__checkbox-group"
}, Lk = { class: "dcf-h5" }, Ck = { class: "umf-consent-scene__checkbox dcf-body-copy" }, Pk = { class: "umf-consent-scene__cta" }, Tk = /* @__PURE__ */ pe({
  __name: "umf-consent-scene",
  props: {
    context: { default: le.light },
    missingConsentFields: { default: void 0 },
    credentials: { default: void 0 }
  },
  setup(e) {
    const { ct: t } = ue(), i = e, a = wk(), { login: n } = As(), s = H(!1), o = H(!1), r = H(!1), l = H(!1), u = H(null), c = H(), m = W(
      () => (r.value || s.value) && (l.value || o.value)
    ), d = (S) => {
      s.value = !!S.checked;
    }, v = (S) => {
      o.value = !!S.checked;
    }, w = async () => {
      try {
        await a({
          preferences: {
            "privacy.miele.statement.isConsentGranted": "true",
            "terms.miele.statement.isConsentGranted": "true"
          }
        }), await n(i.credentials || {});
      } catch (S) {
        u.value = S;
      }
    };
    return dt(async () => {
      var S, j;
      c.value = df(
        i.missingConsentFields
      ), r.value = !((S = c.value.preferences) != null && S.includes(
        "privacy.miele.statement.isConsentGranted"
      )), l.value = !((j = c.value.preferences) != null && j.includes(
        "terms.miele.statement.isConsentGranted"
      ));
    }), (S, j) => (G(), Z("div", {
      class: et([
        "umf-consent-scene",
        {
          [p(Me).dark]: i.context === p(le).dark,
          [p(Me).light]: i.context === p(le).light
        }
      ])
    }, [
      D("h2", Mk, R(p(t)("login.extraConsentScene.title")), 1),
      D("form", {
        onSubmit: Qe(w, ["prevent"])
      }, [
        c.value ? (G(), Z("div", zk, [
          r.value ? ke("", !0) : (G(), Z("div", jk, [
            D("h5", _k, R(p(t)("login.extraConsentScene.privacyStatementTitle")), 1),
            D("div", Ek, [
              U(p(Oe), {
                id: "privacy",
                label: "",
                context: i.context,
                checked: s.value,
                "onUpdate:CheckboxValue": d
              }, null, 8, ["context", "checked"]),
              U(Mn, {
                label: "login.extraConsentScene.privacyStatementCheckboxLabel",
                "link-label": "login.extraConsentScene.privacyStatementName",
                url: "/c/datenschutz-14.htm",
                for: "privacy"
              })
            ])
          ])),
          l.value ? ke("", !0) : (G(), Z("div", Sk, [
            D("h5", Lk, R(p(t)("login.extraConsentScene.termsOfUseTitle")), 1),
            D("div", Ck, [
              U(p(Oe), {
                id: "terms",
                label: "",
                context: i.context,
                checked: o.value,
                "onUpdate:CheckboxValue": v
              }, null, 8, ["context", "checked"]),
              U(Mn, {
                label: "login.extraConsentScene.termsOfUseCheckboxLabel",
                "link-label": "login.extraConsentScene.termsOfUseName",
                url: "/c/nutzungsbedingungen-304.htm",
                for: "terms"
              })
            ])
          ]))
        ])) : ke("", !0),
        U(p(mt), { error: u.value }, null, 8, ["error"]),
        D("div", Pk, [
          U(p(Ue), {
            variant: "primary",
            "full-width": "",
            disabled: !m.value
          }, {
            default: ne(() => [
              Pe(R(p(t)("login.extraConsentScene.continue")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ], 2));
  }
});
const Ak = /* @__PURE__ */ Ie(Tk, [["__scopeId", "data-v-424e7a96"]]);
const xk = {}, Ik = { class: "umf-divider-container" };
function Dk(e, t) {
  return G(), Z("div", Ik, t[0] || (t[0] = [
    D("div", { class: "umf-divider-line" }, null, -1)
  ]));
}
const iy = /* @__PURE__ */ Ie(xk, [["render", Dk], ["__scopeId", "data-v-beece808"]]), Nk = {
  key: 0,
  class: "umf-error-handler"
}, mt = /* @__PURE__ */ pe({
  __name: "umf-error-handler",
  props: {
    error: { default: null }
  },
  setup(e) {
    const t = e, i = H({
      visibleError: null,
      isErrorDismissed: !0
    });
    gi(t, () => {
      t.error !== null && (t.error instanceof ya ? location.href = bt(Ii.login) : (console.error("Error Handler <", t.error), i.value = {
        visibleError: t.error,
        isErrorDismissed: !1
      }));
    });
    const a = () => {
      i.value.isErrorDismissed = !0;
    };
    return (n, s) => i.value.visibleError && !i.value.isErrorDismissed ? (G(), Z("div", Nk, [
      U(p(ji), {
        headline: i.value.visibleError.message,
        description: i.value.visibleError.details,
        variant: "ERROR",
        "has-close-button": i.value.visibleError.isDismissible,
        onOnClose: a
      }, null, 8, ["headline", "description", "has-close-button"])
    ])) : ke("", !0);
  }
});
var ve = /* @__PURE__ */ ((e) => (e[e.ChangeEmail = 0] = "ChangeEmail", e[e.ChangePassword = 1] = "ChangePassword", e[e.ForgotPassword = 2] = "ForgotPassword", e[e.Login = 3] = "Login", e[e.Consent = 4] = "Consent", e[e.NewsletterConsent = 5] = "NewsletterConsent", e[e.MieleClubConsent = 6] = "MieleClubConsent", e))(ve || {});
const Ok = { class: "dcf-h4 forgotPassword-form-title" }, Uk = { class: "form-wrap" }, $k = { class: "buttons-wrap" }, Bk = {
  key: 1,
  class: "dcf-h5-child"
}, Rk = /* @__PURE__ */ pe({
  __name: "umf-forgot-password-scene",
  props: {
    context: { default: le.light }
  },
  emits: ["onClose", "onChangeModal"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), a = e, n = t, { forgotPassword: s } = nk(), o = H({
      email: null,
      isErrorDismissed: !1,
      resetSuccessful: !1,
      error: null
    }), r = W(() => Tt(o.value.email)), l = W(
      () => o.value.email !== null && !r.value ? i("errors.invalidEmail") : null
    ), u = async () => {
      await c();
    }, c = async () => {
      if (!l.value && o.value.email) {
        o.value.error = null;
        try {
          const d = await s(o.value.email);
          o.value.resetSuccessful = (d == null ? void 0 : d.statusCode) === 200;
        } catch (d) {
          o.value.error = d;
        }
      }
    }, m = () => {
      n("onChangeModal", ve.Login);
    };
    return (d, v) => (G(), Z("div", {
      class: et([
        "forgotPassword-scene-content",
        {
          [p(Me).dark]: a.context === p(le).dark,
          [p(Me).light]: a.context === p(le).light
        }
      ])
    }, [
      D("h2", Ok, R(o.value.resetSuccessful ? p(i)("login.forgotPasswordScene.successTitle") : p(i)("login.forgotPasswordScene.title")), 1),
      o.value.resetSuccessful ? ke("", !0) : (G(), Z("form", {
        key: 0,
        onSubmit: Qe(u, ["prevent"])
      }, [
        D("div", Uk, [
          U(p(rt), {
            modelValue: o.value.email,
            "onUpdate:modelValue": v[0] || (v[0] = (w) => o.value.email = w),
            modelModifiers: { trim: !0 },
            label: p(i)("login.loginScene.emailInputLabel"),
            "is-validated": r.value,
            "is-required": "",
            autocomplete: "email",
            "error-message": l.value
          }, null, 8, ["modelValue", "label", "is-validated", "error-message"]),
          D("div", $k, [
            U(p(Ue), {
              type: "submit",
              variant: "primary",
              "full-width": "",
              disabled: !o.value.email
            }, {
              default: ne(() => [
                Pe(R(p(i)("login.forgotPasswordScene.submitButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            U(p(mt), {
              error: o.value.error
            }, null, 8, ["error"])
          ])
        ])
      ], 32)),
      o.value.resetSuccessful ? (G(), Z("p", Bk, R(p(i)("login.forgotPasswordScene.successDescription")), 1)) : ke("", !0),
      U(p(Ue), {
        class: "go-back-btn",
        variant: "tertiary",
        icon: "chevron-right",
        onClick: m
      }, {
        default: ne(() => [
          Pe(R(p(i)("login.forgotPasswordScene.backButtonLabel")), 1)
        ]),
        _: 1
      })
    ], 2));
  }
});
const Vk = /* @__PURE__ */ Ie(Rk, [["__scopeId", "data-v-96f69cdc"]]), Fk = { class: "umf-login-scene__form-wrapper" }, qk = { class: "buttons-wrap" }, Gk = /* @__PURE__ */ pe({
  __name: "umf-login-scene",
  props: {
    context: { default: le.light },
    redirectUrl: { default: "" },
    onForgotPasswordClick: { type: Function, default: () => {
    } },
    onExtraConsentRequired: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const { ct: t } = ue(), { login: i } = As(), a = e, n = H({
      email: null,
      emailFormatError: null,
      isFormReady: !0,
      isRememberChecked: !1,
      password: "",
      error: null
    }), s = W(() => Tt(n.value.email)), o = async () => {
      l(), await r();
    }, r = async () => {
      const u = n.value.emailFormatError, c = n.value.email && n.value.password;
      if (!(u || !c)) {
        n.value.error = null;
        try {
          await i({
            email: n.value.email,
            password: n.value.password,
            redirectUrl: a.redirectUrl,
            isRemember: n.value.isRememberChecked
          });
        } catch (m) {
          if (m instanceof Ti) {
            if (a.onExtraConsentRequired) {
              const { email: d, password: v } = n.value, { missingRequiredFields: w } = m.data;
              a.onExtraConsentRequired(w, { email: d, password: v });
            }
          } else
            n.value.error = m;
          if (globalThis != null && globalThis.window) {
            const { pushFormSubmitEvent: d } = Be();
            d($e.login, m.name);
          }
        }
      }
    }, l = () => {
      n.value.emailFormatError = Tt(n.value.email) ? null : t("errors.invalidEmail");
    };
    return (u, c) => (G(), Z("div", {
      class: et([
        "umf-login-scene",
        {
          [p(Me).dark]: a.context === p(le).dark,
          [p(Me).light]: a.context === p(le).light
        }
      ])
    }, [
      D("form", {
        onSubmit: Qe(o, ["prevent"])
      }, [
        D("div", Fk, [
          U(p(rt), {
            modelValue: n.value.email,
            "onUpdate:modelValue": c[0] || (c[0] = (m) => n.value.email = m),
            modelModifiers: { trim: !0 },
            label: p(t)("login.loginScene.emailInputLabel"),
            "is-validated": p(Tt)(n.value.email),
            "is-required": "",
            autocomplete: "email",
            disabled: !n.value.isFormReady,
            "error-message": n.value.email != null && !s.value ? p(t)("login.loginScene.invalidEmailMessage") : null
          }, null, 8, ["modelValue", "label", "is-validated", "disabled", "error-message"]),
          U(p(rt), {
            modelValue: n.value.password,
            "onUpdate:modelValue": c[1] || (c[1] = (m) => n.value.password = m),
            label: p(t)("login.loginScene.passwordInputLabel"),
            "is-required": "",
            type: "password",
            autocomplete: "current-password",
            disabled: !n.value.isFormReady,
            "show-password-text": p(t)("passwordHelper.showPasswordText"),
            "hide-password-text": p(t)("passwordHelper.hidePasswordText")
          }, null, 8, ["modelValue", "label", "disabled", "show-password-text", "hide-password-text"]),
          D("div", qk, [
            U(p(Ue), {
              variant: "primary",
              "full-width": "",
              disabled: !n.value.isFormReady || !n.value.email || !n.value.password
            }, {
              default: ne(() => [
                Pe(R(p(t)("login.loginScene.loginButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            U(p(mt), {
              error: n.value.error
            }, null, 8, ["error"]),
            U(p(Ue), {
              class: "forgot-pwd-btn",
              variant: "tertiary",
              disabled: !n.value.isFormReady,
              icon: "chevron-right",
              onClick: e.onForgotPasswordClick
            }, {
              default: ne(() => [
                Pe(R(p(t)("login.loginScene.forgotPwdButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ], 32)
    ], 2));
  }
});
const Ds = /* @__PURE__ */ Ie(Gk, [["__scopeId", "data-v-4d44666f"]]), Kk = { class: "dcf-h4 umf-login__headline" }, Hk = /* @__PURE__ */ pe({
  __name: "umf-login",
  props: {
    context: { default: le.light },
    onForgotPasswordClick: { type: Function, default: () => {
    } },
    onExtraConsentRequired: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const { ct: t } = ue(), i = e;
    return (a, n) => (G(), Z("div", {
      class: et([
        "umf-login",
        {
          [p(Me).dark]: i.context === p(le).dark,
          [p(Me).light]: i.context === p(le).light
        }
      ])
    }, [
      D("h2", Kk, R(p(t)("login.loginScene.title")), 1),
      U(Ds, {
        "on-forgot-password-click": e.onForgotPasswordClick,
        "on-extra-consent-required": e.onExtraConsentRequired
      }, null, 8, ["on-forgot-password-click", "on-extra-consent-required"])
    ], 2));
  }
});
const ay = /* @__PURE__ */ Ie(Hk, [["__scopeId", "data-v-8322c143"]]), Wk = { class: "umf-login-modal__wrapper" }, Jk = { class: "dcf-h2 umf-login-modal__headline" }, Zk = { class: "dcf-copy umf-login-modal__copy" }, Yk = /* @__PURE__ */ pe({
  __name: "umf-login-modal-scene",
  emits: ["onClose", "onChangeModal"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), a = H({
      redirectUrl: ""
    }), n = t, s = () => {
      n("onChangeModal", ve.ForgotPassword);
    }, o = (r, l) => {
      n("onChangeModal", ve.Consent, {
        consentState: {
          accountMissingConsentFields: r,
          credentials: l
        }
      });
    };
    return (r, l) => (G(), Z("div", Wk, [
      D("h2", Jk, R(p(i)("login.loginModalScene.title")), 1),
      D("p", Zk, R(p(i)("login.loginModalScene.copy")), 1),
      U(p(Ds), {
        "redirect-url": a.value.redirectUrl,
        "on-forgot-password-click": s,
        "on-extra-consent-required": o
      }, null, 8, ["redirect-url"])
    ]));
  }
});
const Xk = /* @__PURE__ */ Ie(Yk, [["__scopeId", "data-v-246ac9f3"]]);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Ns = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], bi = /* @__PURE__ */ Ns.join(","), Os = typeof Element > "u", jt = Os ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, wi = !Os && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, yi = function e(t, i) {
  var a;
  i === void 0 && (i = !0);
  var n = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "inert"), s = n === "" || n === "true", o = s || i && t && e(t.parentNode);
  return o;
}, Qk = function(t) {
  var i, a = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "contenteditable");
  return a === "" || a === "true";
}, Us = function(t, i, a) {
  if (yi(t))
    return [];
  var n = Array.prototype.slice.apply(t.querySelectorAll(bi));
  return i && jt.call(t, bi) && n.unshift(t), n = n.filter(a), n;
}, $s = function e(t, i, a) {
  for (var n = [], s = Array.from(t); s.length; ) {
    var o = s.shift();
    if (!yi(o, !1))
      if (o.tagName === "SLOT") {
        var r = o.assignedElements(), l = r.length ? r : o.children, u = e(l, !0, a);
        a.flatten ? n.push.apply(n, u) : n.push({
          scopeParent: o,
          candidates: u
        });
      } else {
        var c = jt.call(o, bi);
        c && a.filter(o) && (i || !t.includes(o)) && n.push(o);
        var m = o.shadowRoot || // check for an undisclosed shadow
        typeof a.getShadowRoot == "function" && a.getShadowRoot(o), d = !yi(m, !1) && (!a.shadowRootFilter || a.shadowRootFilter(o));
        if (m && d) {
          var v = e(m === !0 ? o.children : m.children, !0, a);
          a.flatten ? n.push.apply(n, v) : n.push({
            scopeParent: o,
            candidates: v
          });
        } else
          s.unshift.apply(s, o.children);
      }
  }
  return n;
}, Bs = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, kt = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Qk(t)) && !Bs(t) ? 0 : t.tabIndex;
}, eb = function(t, i) {
  var a = kt(t);
  return a < 0 && i && !Bs(t) ? 0 : a;
}, tb = function(t, i) {
  return t.tabIndex === i.tabIndex ? t.documentOrder - i.documentOrder : t.tabIndex - i.tabIndex;
}, Rs = function(t) {
  return t.tagName === "INPUT";
}, ib = function(t) {
  return Rs(t) && t.type === "hidden";
}, ab = function(t) {
  var i = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(a) {
    return a.tagName === "SUMMARY";
  });
  return i;
}, nb = function(t, i) {
  for (var a = 0; a < t.length; a++)
    if (t[a].checked && t[a].form === i)
      return t[a];
}, sb = function(t) {
  if (!t.name)
    return !0;
  var i = t.form || wi(t), a = function(r) {
    return i.querySelectorAll('input[type="radio"][name="' + r + '"]');
  }, n;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    n = a(window.CSS.escape(t.name));
  else
    try {
      n = a(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var s = nb(n, t.form);
  return !s || s === t;
}, ob = function(t) {
  return Rs(t) && t.type === "radio";
}, rb = function(t) {
  return ob(t) && !sb(t);
}, lb = function(t) {
  var i, a = t && wi(t), n = (i = a) === null || i === void 0 ? void 0 : i.host, s = !1;
  if (a && a !== t) {
    var o, r, l;
    for (s = !!((o = n) !== null && o !== void 0 && (r = o.ownerDocument) !== null && r !== void 0 && r.contains(n) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !s && n; ) {
      var u, c, m;
      a = wi(n), n = (u = a) === null || u === void 0 ? void 0 : u.host, s = !!((c = n) !== null && c !== void 0 && (m = c.ownerDocument) !== null && m !== void 0 && m.contains(n));
    }
  }
  return s;
}, zn = function(t) {
  var i = t.getBoundingClientRect(), a = i.width, n = i.height;
  return a === 0 && n === 0;
}, cb = function(t, i) {
  var a = i.displayCheck, n = i.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = jt.call(t, "details>summary:first-of-type"), o = s ? t.parentElement : t;
  if (jt.call(o, "details:not([open]) *"))
    return !0;
  if (!a || a === "full" || a === "legacy-full") {
    if (typeof n == "function") {
      for (var r = t; t; ) {
        var l = t.parentElement, u = wi(t);
        if (l && !l.shadowRoot && n(l) === !0)
          return zn(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = r;
    }
    if (lb(t))
      return !t.getClientRects().length;
    if (a !== "legacy-full")
      return !0;
  } else if (a === "non-zero-area")
    return zn(t);
  return !1;
}, db = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var i = t.parentElement; i; ) {
      if (i.tagName === "FIELDSET" && i.disabled) {
        for (var a = 0; a < i.children.length; a++) {
          var n = i.children.item(a);
          if (n.tagName === "LEGEND")
            return jt.call(i, "fieldset[disabled] *") ? !0 : !n.contains(t);
        }
        return !0;
      }
      i = i.parentElement;
    }
  return !1;
}, Mi = function(t, i) {
  return !(i.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  yi(i) || ib(i) || cb(i, t) || // For a details element with a summary, the summary element gets the focus
  ab(i) || db(i));
}, ca = function(t, i) {
  return !(rb(i) || kt(i) < 0 || !Mi(t, i));
}, ub = function(t) {
  var i = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(i) || i >= 0);
}, mb = function e(t) {
  var i = [], a = [];
  return t.forEach(function(n, s) {
    var o = !!n.scopeParent, r = o ? n.scopeParent : n, l = eb(r, o), u = o ? e(n.candidates) : r;
    l === 0 ? o ? i.push.apply(i, u) : i.push(r) : a.push({
      documentOrder: s,
      tabIndex: l,
      item: n,
      isScope: o,
      content: u
    });
  }), a.sort(tb).reduce(function(n, s) {
    return s.isScope ? n.push.apply(n, s.content) : n.push(s.content), n;
  }, []).concat(i);
}, pb = function(t, i) {
  i = i || {};
  var a;
  return i.getShadowRoot ? a = $s([t], i.includeContainer, {
    filter: ca.bind(null, i),
    flatten: !1,
    getShadowRoot: i.getShadowRoot,
    shadowRootFilter: ub
  }) : a = Us(t, i.includeContainer, ca.bind(null, i)), mb(a);
}, gb = function(t, i) {
  i = i || {};
  var a;
  return i.getShadowRoot ? a = $s([t], i.includeContainer, {
    filter: Mi.bind(null, i),
    flatten: !0,
    getShadowRoot: i.getShadowRoot
  }) : a = Us(t, i.includeContainer, Mi.bind(null, i)), a;
}, Lt = function(t, i) {
  if (i = i || {}, !t)
    throw new Error("No node provided");
  return jt.call(t, bi) === !1 ? !1 : ca(i, t);
}, hb = /* @__PURE__ */ Ns.concat("iframe").join(","), Ji = function(t, i) {
  if (i = i || {}, !t)
    throw new Error("No node provided");
  return jt.call(t, hb) === !1 ? !1 : Mi(i, t);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function jn(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function _n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jn(Object(i), !0).forEach(function(a) {
      vb(e, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : jn(Object(i)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return e;
}
function vb(e, t, i) {
  return t = kb(t), t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function fb(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(e, t || "default");
    if (typeof a != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function kb(e) {
  var t = fb(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var En = {
  activateTrap: function(t, i) {
    if (t.length > 0) {
      var a = t[t.length - 1];
      a !== i && a.pause();
    }
    var n = t.indexOf(i);
    n === -1 || t.splice(n, 1), t.push(i);
  },
  deactivateTrap: function(t, i) {
    var a = t.indexOf(i);
    a !== -1 && t.splice(a, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, bb = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, wb = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Yt = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, yb = function(t) {
  return Yt(t) && !t.shiftKey;
}, Mb = function(t) {
  return Yt(t) && t.shiftKey;
}, Sn = function(t) {
  return setTimeout(t, 0);
}, Ln = function(t, i) {
  var a = -1;
  return t.every(function(n, s) {
    return i(n) ? (a = s, !1) : !0;
  }), a;
}, Jt = function(t) {
  for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++)
    a[n - 1] = arguments[n];
  return typeof t == "function" ? t.apply(void 0, a) : t;
}, ui = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, zb = [], jb = function(t, i) {
  var a = (i == null ? void 0 : i.document) || document, n = (i == null ? void 0 : i.trapStack) || zb, s = _n({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: yb,
    isKeyBackward: Mb
  }, i), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, r, l = function(y, L, O) {
    return y && y[L] !== void 0 ? y[L] : s[O || L];
  }, u = function(y, L) {
    var O = typeof (L == null ? void 0 : L.composedPath) == "function" ? L.composedPath() : void 0;
    return o.containerGroups.findIndex(function(K) {
      var q = K.container, Y = K.tabbableNodes;
      return q.contains(y) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (O == null ? void 0 : O.includes(q)) || Y.find(function(ie) {
        return ie === y;
      });
    });
  }, c = function(y) {
    var L = s[y];
    if (typeof L == "function") {
      for (var O = arguments.length, K = new Array(O > 1 ? O - 1 : 0), q = 1; q < O; q++)
        K[q - 1] = arguments[q];
      L = L.apply(void 0, K);
    }
    if (L === !0 && (L = void 0), !L) {
      if (L === void 0 || L === !1)
        return L;
      throw new Error("`".concat(y, "` was specified but was not a node, or did not return a node"));
    }
    var Y = L;
    if (typeof L == "string" && (Y = a.querySelector(L), !Y))
      throw new Error("`".concat(y, "` as selector refers to no known node"));
    return Y;
  }, m = function() {
    var y = c("initialFocus");
    if (y === !1)
      return !1;
    if (y === void 0 || !Ji(y, s.tabbableOptions))
      if (u(a.activeElement) >= 0)
        y = a.activeElement;
      else {
        var L = o.tabbableGroups[0], O = L && L.firstTabbableNode;
        y = O || c("fallbackFocus");
      }
    if (!y)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return y;
  }, d = function() {
    if (o.containerGroups = o.containers.map(function(y) {
      var L = pb(y, s.tabbableOptions), O = gb(y, s.tabbableOptions), K = L.length > 0 ? L[0] : void 0, q = L.length > 0 ? L[L.length - 1] : void 0, Y = O.find(function(oe) {
        return Lt(oe);
      }), ie = O.slice().reverse().find(function(oe) {
        return Lt(oe);
      }), ce = !!L.find(function(oe) {
        return kt(oe) > 0;
      });
      return {
        container: y,
        tabbableNodes: L,
        focusableNodes: O,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ce,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: K,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: Y,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ie,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ze) {
          var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Ee = L.indexOf(ze);
          return Ee < 0 ? ge ? O.slice(O.indexOf(ze) + 1).find(function(De) {
            return Lt(De);
          }) : O.slice(0, O.indexOf(ze)).reverse().find(function(De) {
            return Lt(De);
          }) : L[Ee + (ge ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(y) {
      return y.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(y) {
      return y.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function F(y) {
    var L = y.activeElement;
    if (L)
      return L.shadowRoot && L.shadowRoot.activeElement !== null ? F(L.shadowRoot) : L;
  }, w = function F(y) {
    if (y !== !1 && y !== v(document)) {
      if (!y || !y.focus) {
        F(m());
        return;
      }
      y.focus({
        preventScroll: !!s.preventScroll
      }), o.mostRecentlyFocusedNode = y, bb(y) && y.select();
    }
  }, S = function(y) {
    var L = c("setReturnFocus", y);
    return L || (L === !1 ? !1 : y);
  }, j = function(y) {
    var L = y.target, O = y.event, K = y.isBackward, q = K === void 0 ? !1 : K;
    L = L || ui(O), d();
    var Y = null;
    if (o.tabbableGroups.length > 0) {
      var ie = u(L, O), ce = ie >= 0 ? o.containerGroups[ie] : void 0;
      if (ie < 0)
        q ? Y = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : Y = o.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var oe = Ln(o.tabbableGroups, function(Ge) {
          var Ke = Ge.firstTabbableNode;
          return L === Ke;
        });
        if (oe < 0 && (ce.container === L || Ji(L, s.tabbableOptions) && !Lt(L, s.tabbableOptions) && !ce.nextTabbableNode(L, !1)) && (oe = ie), oe >= 0) {
          var ze = oe === 0 ? o.tabbableGroups.length - 1 : oe - 1, ge = o.tabbableGroups[ze];
          Y = kt(L) >= 0 ? ge.lastTabbableNode : ge.lastDomTabbableNode;
        } else
          Yt(O) || (Y = ce.nextTabbableNode(L, !1));
      } else {
        var Ee = Ln(o.tabbableGroups, function(Ge) {
          var Ke = Ge.lastTabbableNode;
          return L === Ke;
        });
        if (Ee < 0 && (ce.container === L || Ji(L, s.tabbableOptions) && !Lt(L, s.tabbableOptions) && !ce.nextTabbableNode(L)) && (Ee = ie), Ee >= 0) {
          var De = Ee === o.tabbableGroups.length - 1 ? 0 : Ee + 1, at = o.tabbableGroups[De];
          Y = kt(L) >= 0 ? at.firstTabbableNode : at.firstDomTabbableNode;
        } else
          Yt(O) || (Y = ce.nextTabbableNode(L));
      }
    } else
      Y = c("fallbackFocus");
    return Y;
  }, E = function(y) {
    var L = ui(y);
    if (!(u(L, y) >= 0)) {
      if (Jt(s.clickOutsideDeactivates, y)) {
        r.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: s.returnFocusOnDeactivate
        });
        return;
      }
      Jt(s.allowOutsideClick, y) || y.preventDefault();
    }
  }, A = function(y) {
    var L = ui(y), O = u(L, y) >= 0;
    if (O || L instanceof Document)
      O && (o.mostRecentlyFocusedNode = L);
    else {
      y.stopImmediatePropagation();
      var K, q = !0;
      if (o.mostRecentlyFocusedNode)
        if (kt(o.mostRecentlyFocusedNode) > 0) {
          var Y = u(o.mostRecentlyFocusedNode), ie = o.containerGroups[Y].tabbableNodes;
          if (ie.length > 0) {
            var ce = ie.findIndex(function(oe) {
              return oe === o.mostRecentlyFocusedNode;
            });
            ce >= 0 && (s.isKeyForward(o.recentNavEvent) ? ce + 1 < ie.length && (K = ie[ce + 1], q = !1) : ce - 1 >= 0 && (K = ie[ce - 1], q = !1));
          }
        } else
          o.containerGroups.some(function(oe) {
            return oe.tabbableNodes.some(function(ze) {
              return kt(ze) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (K = j({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(o.recentNavEvent)
      })), w(K || o.mostRecentlyFocusedNode || m());
    }
    o.recentNavEvent = void 0;
  }, f = function(y) {
    var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = y;
    var O = j({
      event: y,
      isBackward: L
    });
    O && (Yt(y) && y.preventDefault(), w(O));
  }, b = function(y) {
    if (wb(y) && Jt(s.escapeDeactivates, y) !== !1) {
      y.preventDefault(), r.deactivate();
      return;
    }
    (s.isKeyForward(y) || s.isKeyBackward(y)) && f(y, s.isKeyBackward(y));
  }, P = function(y) {
    var L = ui(y);
    u(L, y) >= 0 || Jt(s.clickOutsideDeactivates, y) || Jt(s.allowOutsideClick, y) || (y.preventDefault(), y.stopImmediatePropagation());
  }, k = function() {
    if (o.active)
      return En.activateTrap(n, r), o.delayInitialFocusTimer = s.delayInitialFocus ? Sn(function() {
        w(m());
      }) : w(m()), a.addEventListener("focusin", A, !0), a.addEventListener("mousedown", E, {
        capture: !0,
        passive: !1
      }), a.addEventListener("touchstart", E, {
        capture: !0,
        passive: !1
      }), a.addEventListener("click", P, {
        capture: !0,
        passive: !1
      }), a.addEventListener("keydown", b, {
        capture: !0,
        passive: !1
      }), r;
  }, M = function() {
    if (o.active)
      return a.removeEventListener("focusin", A, !0), a.removeEventListener("mousedown", E, !0), a.removeEventListener("touchstart", E, !0), a.removeEventListener("click", P, !0), a.removeEventListener("keydown", b, !0), r;
  }, _ = function(y) {
    var L = y.some(function(O) {
      var K = Array.from(O.removedNodes);
      return K.some(function(q) {
        return q === o.mostRecentlyFocusedNode;
      });
    });
    L && w(m());
  }, C = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(_) : void 0, $ = function() {
    C && (C.disconnect(), o.active && !o.paused && o.containers.map(function(y) {
      C.observe(y, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return r = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(y) {
      if (o.active)
        return this;
      var L = l(y, "onActivate"), O = l(y, "onPostActivate"), K = l(y, "checkCanFocusTrap");
      K || d(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = a.activeElement, L == null || L();
      var q = function() {
        K && d(), k(), $(), O == null || O();
      };
      return K ? (K(o.containers.concat()).then(q, q), this) : (q(), this);
    },
    deactivate: function(y) {
      if (!o.active)
        return this;
      var L = _n({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, y);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, M(), o.active = !1, o.paused = !1, $(), En.deactivateTrap(n, r);
      var O = l(L, "onDeactivate"), K = l(L, "onPostDeactivate"), q = l(L, "checkCanReturnFocus"), Y = l(L, "returnFocus", "returnFocusOnDeactivate");
      O == null || O();
      var ie = function() {
        Sn(function() {
          Y && w(S(o.nodeFocusedBeforeActivation)), K == null || K();
        });
      };
      return Y && q ? (q(S(o.nodeFocusedBeforeActivation)).then(ie, ie), this) : (ie(), this);
    },
    pause: function(y) {
      if (o.paused || !o.active)
        return this;
      var L = l(y, "onPause"), O = l(y, "onPostPause");
      return o.paused = !0, L == null || L(), M(), $(), O == null || O(), this;
    },
    unpause: function(y) {
      if (!o.paused || !o.active)
        return this;
      var L = l(y, "onUnpause"), O = l(y, "onPostUnpause");
      return o.paused = !1, L == null || L(), d(), k(), $(), O == null || O(), this;
    },
    updateContainerElements: function(y) {
      var L = [].concat(y).filter(Boolean);
      return o.containers = L.map(function(O) {
        return typeof O == "string" ? a.querySelector(O) : O;
      }), o.active && d(), $(), this;
    }
  }, r.updateContainerElements(t), r;
};
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const _b = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, Eb = pe({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, _b),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: i }) {
    let a;
    const n = H(null), s = W(() => {
      const r = n.value;
      return r && (r instanceof HTMLElement ? r : r.$el);
    });
    function o() {
      return a || (a = jb(s.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          i("update:active", !0), i("activate");
        },
        onDeactivate: () => {
          i("update:active", !1), i("deactivate");
        },
        onPostActivate: () => i("postActivate"),
        onPostDeactivate: () => i("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return dt(() => {
      gi(() => e.active, (r) => {
        r && s.value ? o().activate() : a && (a.deactivate(), (!s.value || s.value.nodeType === Node.COMMENT_NODE) && (a = null));
      }, { immediate: !0, flush: "post" });
    }), Tn(() => {
      a && a.deactivate(), a = null;
    }), {
      activate() {
        o().activate();
      },
      deactivate() {
        a && a.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const r = t.default().filter((u) => u.type !== Zs);
        return !r || !r.length || r.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), r) : Ys(r[0], { ref: n });
      }
    };
  }
}), Sb = { class: "umf-modal-overlay" }, Lb = /* @__PURE__ */ pe({
  __name: "umf-modal-overlay",
  props: {
    isOpen: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  emits: ["close-modal"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), a = e, n = t, s = {
      close: i("modal.accessibility.close")
    }, o = H({
      isFocusTrapActive: !1
    }), r = () => {
      o.value.isFocusTrapActive = !1, n("close-modal");
    };
    return (l, u) => (G(), Z("div", Sb, [
      U(p(Eb), {
        active: o.value.isFocusTrapActive
      }, {
        default: ne(() => [
          U(p(Xs), {
            name: "umf-modal",
            size: a.size,
            position: "center",
            "mobile-alignment": "full",
            "is-open": a.isOpen,
            "accessibility-labels": s,
            onClosed: u[0] || (u[0] = (c) => r()),
            onOpened: u[1] || (u[1] = (c) => o.value.isFocusTrapActive = !0)
          }, {
            default: ne(() => [
              mi(l.$slots, "default")
            ]),
            _: 3
          }, 8, ["size", "is-open"])
        ]),
        _: 3
      }, 8, ["active"])
    ]));
  }
});
const zi = class zi {
  constructor() {
    st(this, "subscribers");
    this.subscribers = {};
  }
  dispatch(t, i) {
    const a = this.subscribers[t];
    a !== void 0 && Object.keys(a).forEach((n) => a[n](i));
  }
  register(t, i) {
    const a = this.getNextId();
    return this.subscribers[t] || (this.subscribers[t] = {}), this.subscribers[t][a] = i, {
      unregister: () => {
        delete this.subscribers[t][a], Object.keys(this.subscribers[t]).length === 0 && delete this.subscribers[t];
      }
    };
  }
  getNextId() {
    return zi.nextId++;
  }
};
st(zi, "nextId", 0);
let da = zi;
const ny = /* @__PURE__ */ pe({
  __name: "umf-modals-controller",
  props: {
    globals: null,
    featureToggleConfigs: null
  },
  setup(e) {
    ue();
    const t = e, i = H({
      isOpen: !1,
      contents: null
    }), a = H({
      accountMissingConsentFields: void 0,
      credentials: void 0
    }), n = ys(), { setGlobals: s } = Xe();
    s(t.globals);
    const o = W(
      () => {
        var j, E, A;
        return !!((A = (E = (j = t.featureToggleConfigs) == null ? void 0 : j.marketingconsent) == null ? void 0 : E.enableMultiLevelConsent) != null && A.enabled);
      }
    ), r = W(
      () => {
        var j, E, A;
        return !!((A = (E = (j = t.featureToggleConfigs) == null ? void 0 : j.marketingconsent) == null ? void 0 : E.hasSingleConsent) != null && A.enabled);
      }
    ), l = W(() => Bi(t.globals["module.cdc.SyncMieleClub"])), u = W(
      () => {
        var j, E;
        return Bi((E = (j = t.featureToggleConfigs) == null ? void 0 : j.mieleClub) == null ? void 0 : E.requireToSelectAllConsents);
      }
    ), c = W(
      () => {
        var j, E;
        return Bi((E = (j = t.featureToggleConfigs) == null ? void 0 : j.mieleClub) == null ? void 0 : E.toSyncSubscriptionOnCdc);
      }
    ), m = W(
      () => [ve.NewsletterConsent, ve.MieleClubConsent].includes(i.value.contents) ? "lg" : "sm"
    ), d = (j) => {
      i.value = {
        isOpen: !0,
        contents: j
      };
    }, v = () => {
      i.value = {
        isOpen: !1,
        contents: null
      };
    }, w = (j, E) => {
      S(E), i.value.contents = j;
    }, S = (j) => {
      j != null && j.consentState && (a.value = j.consentState);
    };
    return dt(async () => {
      window.EventBus = window.EventBus || new da(), window.EventBus.register(vs, () => d(ve.ChangeEmail)), window.EventBus.register(gs, () => d(ve.ChangePassword)), window.EventBus.register(hs, () => d(ve.ForgotPassword)), window.EventBus.register(ps, (E) => {
        E ? n.storeRedirect(E.targetUrl) : n.saveRedirectTarget(), d(ve.Login);
      }), window.EventBus.register(fs, (E) => {
        S({ consentState: E }), d(ve.Consent);
      }), window.EventBus.register(ks, () => d(ve.NewsletterConsent)), window.EventBus.register(bs, () => d(ve.MieleClubConsent));
      const { checkSession: j } = La();
      j();
    }), (j, E) => (G(), Ve(p(Lb), {
      size: m.value,
      class: "umf-controller-modal",
      "is-open": i.value.isOpen,
      onCloseModal: v
    }, {
      default: ne(() => [
        i.value.contents === p(ve).Consent ? (G(), Ve(p(Ak), {
          key: 0,
          "missing-consent-fields": a.value.accountMissingConsentFields,
          credentials: a.value.credentials
        }, null, 8, ["missing-consent-fields", "credentials"])) : ke("", !0),
        i.value.contents === p(ve).ChangeEmail ? (G(), Ve(p(mk), {
          key: 1,
          onOnClose: v
        })) : ke("", !0),
        i.value.contents === p(ve).ChangePassword ? (G(), Ve(p(bk), {
          key: 2,
          onOnClose: v
        })) : ke("", !0),
        i.value.contents === p(ve).ForgotPassword ? (G(), Ve(p(Vk), {
          key: 3,
          onOnChangeModal: w,
          onOnClose: v
        })) : ke("", !0),
        i.value.contents === p(ve).Login ? (G(), Ve(p(Xk), {
          key: 4,
          onOnChangeModal: w,
          onOnClose: v
        })) : ke("", !0),
        i.value.contents === p(ve).NewsletterConsent && o.value ? (G(), Ve(p(dw), {
          key: 5,
          "only-has-single-consent": r.value,
          onOnClose: v
        }, null, 8, ["only-has-single-consent"])) : i.value.contents === p(ve).NewsletterConsent ? (G(), Ve(p(Zb), {
          key: 6,
          onOnClose: v
        })) : ke("", !0),
        i.value.contents === p(ve).MieleClubConsent ? (G(), Ve(p(Nw), {
          key: 7,
          "show-newsletter": l.value,
          "all-consents-required": u.value,
          "to-sync-miele-club-subscription-on-cdc": c.value,
          onOnChangeModal: w,
          onOnClose: v
        }, null, 8, ["show-newsletter", "all-consents-required", "to-sync-miele-club-subscription-on-cdc"])) : ke("", !0)
      ]),
      _: 1
    }, 8, ["size", "is-open"]));
  }
}), Cb = { class: "umf-password-strength" }, Pb = {
  class: "umf-password-strength__msg",
  "aria-live": "polite"
}, Tb = { class: "umf-password-strength__meter" }, Ab = {
  key: 0,
  class: "umf-password-strength__error"
}, xb = /* @__PURE__ */ pe({
  __name: "umf-password-strength",
  props: {
    password: { default: "" },
    minCharGroups: { default: 3 },
    minLength: { default: 8 },
    hideMessage: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { ct: t } = ue(), i = e, a = W(() => i.minCharGroups <= 0 ? 2 : 1), n = W(() => ws(i.password, i.minLength, i.minCharGroups)), s = (o) => {
      switch (o) {
        case Je.TooShort:
          return t("passwordStrength.tooShort");
        case Je.TooWeak:
          return t("passwordStrength.tooWeak");
        case Je.Weak:
          return t("passwordStrength.weak");
        case Je.Medium:
          return t("passwordStrength.medium");
        case Je.Strong:
          return t("passwordStrength.strong");
        case Je.VeryStrong:
          return t("passwordStrength.veryStrong");
      }
    };
    return (o, r) => (G(), Z("div", Cb, [
      D("span", Pb, R(s(n.value)), 1),
      D("span", Tb, [
        D("span", {
          class: et(`umf-password-strength__meter-strength_${n.value}`)
        }, null, 2)
      ]),
      !e.hideMessage && n.value <= p(Je).TooWeak ? (G(), Z("span", Ab, R(p(t)("errors.tooWeakPassword", { minLength: i.minLength, minCharGroups: i.minCharGroups }, a.value)), 1)) : ke("", !0)
    ]));
  }
});
const Ib = /* @__PURE__ */ Ie(xb, [["__scopeId", "data-v-53fdf548"]]), Db = { class: "dcf-h2 marketing-consent-scene-content__title" }, Nb = { class: "marketing-consent-scene-content__description" }, Ob = { class: "marketing-consent-scene-content__scroll-content" }, Ub = { class: "marketing-consent-scene-content__input-field" }, $b = ["href"], Bb = { class: "marketing-consent-scene-content__input-field" }, Rb = ["href"], Vb = { class: "marketing-consent-scene-content__input-field" }, Fb = ["href"], qb = { class: "marketing-consent-scene-content__highlighted" }, Gb = ["href"], Kb = { class: "marketing-consent-scene-content__input-field" }, Hb = ["href"], Wb = { class: "marketing-consent-scene-content__button-area" }, Jb = /* @__PURE__ */ pe({
  __name: "umf-marketing-consent-scene",
  props: {
    context: { default: le.light }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), a = t, n = H({
      isNewsletterAccepted: !1,
      isPrivacyAccepted: !1,
      isExtendedPrivacyAccepted: !1,
      isAgreementAccepted: !1,
      error: null
    }), s = () => {
      a("on-close");
    };
    dt(async () => {
      var d, v, w, S, j, E, A, f, b, P, k, M, _, C, $, F, y, L, O;
      try {
        const q = await Is()(["subscriptions", "preferences"]);
        n.value.isNewsletterAccepted = ((j = (S = (w = (v = (d = q.subscriptions) == null ? void 0 : d.miele) == null ? void 0 : v.general) == null ? void 0 : w.newsletter) == null ? void 0 : S.email) == null ? void 0 : j.isSubscribed) || !1, n.value.isPrivacyAccepted = ((P = (b = (f = (A = (E = q.preferences) == null ? void 0 : E.miele) == null ? void 0 : A.marketingconsent) == null ? void 0 : f.personalized) == null ? void 0 : b.general) == null ? void 0 : P.isConsentGranted) || !1, n.value.isExtendedPrivacyAccepted = (($ = (C = (_ = (M = (k = q.preferences) == null ? void 0 : k.miele) == null ? void 0 : M.marketingconsent) == null ? void 0 : _.personalized) == null ? void 0 : C.tracking) == null ? void 0 : $.isConsentGranted) || !1, n.value.isAgreementAccepted = ((O = (L = (y = (F = q.preferences) == null ? void 0 : F.terms) == null ? void 0 : y.miele) == null ? void 0 : L.statement) == null ? void 0 : O.isConsentGranted) || !1;
      } catch (K) {
        n.value.error = K;
      }
    });
    const o = e, r = (d) => n.value.isNewsletterAccepted = d.checked, l = (d) => n.value.isPrivacyAccepted = d.checked, u = (d) => n.value.isExtendedPrivacyAccepted = d.checked, c = (d) => {
      n.value.isAgreementAccepted = d.checked;
    }, m = async () => {
      try {
        const d = ai(), v = {
          preferences: {
            [Dt]: n.value.isExtendedPrivacyAccepted,
            [Ls]: n.value.isPrivacyAccepted,
            [Cs]: n.value.isAgreementAccepted
          },
          subscriptions: {
            [Ps]: n.value.isNewsletterAccepted
          }
        };
        if (await d(v), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: w } = Be();
          w($e.changeMarketingPreference);
        }
        s();
      } catch (d) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: v } = Be();
          v($e.changeMarketingPreference, d.name);
        }
        n.value.error = d;
      }
    };
    return (d, v) => (G(), Z("div", {
      class: et([
        "marketing-consent-scene-content",
        {
          [p(Me).dark]: o.context === p(le).dark,
          [p(Me).light]: o.context === p(le).light
        }
      ])
    }, [
      D("h2", Db, R(p(i)("marketing-consent.title")), 1),
      D("p", Nb, R(p(i)("marketing-consent.description")), 1),
      D("form", null, [
        D("div", Ob, [
          D("div", Ub, [
            U(p(Oe), {
              label: p(i)("marketing-consent.newsletter.text"),
              checked: n.value.isNewsletterAccepted,
              "onUpdate:CheckboxValue": r
            }, null, 8, ["label", "checked"]),
            D("a", {
              href: p(i)("marketing-consent.newsletter.link.ref"),
              class: "dcf-link"
            }, R(p(i)("marketing-consent.newsletter.link.title")), 9, $b)
          ]),
          D("div", Bb, [
            U(p(Oe), {
              label: p(i)("marketing-consent.personalisation.text"),
              checked: n.value.isPrivacyAccepted,
              "onUpdate:CheckboxValue": l
            }, null, 8, ["label", "checked"]),
            D("a", {
              href: p(i)("marketing-consent.personalisation.link.ref"),
              class: "dcf-link"
            }, R(p(i)("marketing-consent.personalisation.link.title")), 9, Rb)
          ]),
          D("div", Vb, [
            U(p(Oe), {
              label: p(i)("marketing-consent.extendedPersonalisation.text"),
              checked: n.value.isExtendedPrivacyAccepted,
              "onUpdate:CheckboxValue": u
            }, null, 8, ["label", "checked"]),
            D("a", {
              href: p(i)("marketing-consent.extendedPersonalisation.link.ref"),
              class: "dcf-link"
            }, R(p(i)("marketing-consent.extendedPersonalisation.link.title")), 9, Fb)
          ]),
          D("p", qb, [
            Pe(R(p(i)("marketing-consent.highlightedText.text")) + " ", 1),
            D("a", {
              href: p(i)("marketing-consent.highlightedText.link.ref"),
              class: "dcf-link"
            }, R(p(i)("marketing-consent.highlightedText.link.title")), 9, Gb)
          ])
        ]),
        D("div", Kb, [
          U(p(Oe), {
            label: p(i)("marketing-consent.termsOfUse.text"),
            checked: n.value.isAgreementAccepted,
            "onUpdate:CheckboxValue": c
          }, null, 8, ["label", "checked"]),
          D("a", {
            href: p(i)("marketing-consent.termsOfUse.link.ref"),
            class: "dcf-link"
          }, R(p(i)("marketing-consent.termsOfUse.link.title")), 9, Hb)
        ]),
        D("div", Wb, [
          U(p(Ue), {
            type: "submit",
            class: "marketing-consent-scene-content__submit",
            variant: "primary",
            disabled: !n.value.isAgreementAccepted,
            "full-width": "",
            onClick: Qe(m, ["prevent"])
          }, {
            default: ne(() => [
              Pe(R(p(i)("marketing-consent.submit")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        U(p(mt), {
          error: n.value.error
        }, null, 8, ["error"])
      ])
    ], 2));
  }
});
const Zb = /* @__PURE__ */ Ie(Jb, [["__scopeId", "data-v-ce675638"]]), Zi = (...e) => e.some((t) => !t.includes(!1));
function Cn() {
  let e = !1, t = !1, i = !1, a = !1;
  const n = () => ({
    consentLevelOne: e,
    consentLevelTwo: t,
    consentLevelThree: i,
    isAgreementAccepted: a
  }), s = (c) => {
    var S, j, E, A, f, b, P, k, M, _, C, $, F, y, L, O, K, q, Y, ie, ce, oe, ze, ge;
    const m = ((f = (A = (E = (j = (S = c == null ? void 0 : c.subscriptions) == null ? void 0 : S.miele) == null ? void 0 : j.general) == null ? void 0 : E.newsletter) == null ? void 0 : A.email) == null ? void 0 : f.isSubscribed) || !1, d = ((_ = (M = (k = (P = (b = c == null ? void 0 : c.preferences) == null ? void 0 : b.miele) == null ? void 0 : P.marketingconsent) == null ? void 0 : k.personalized) == null ? void 0 : M.general) == null ? void 0 : _.isConsentGranted) || !1, v = ((L = (y = (F = ($ = (C = c == null ? void 0 : c.preferences) == null ? void 0 : C.miele) == null ? void 0 : $.marketingconsent) == null ? void 0 : F.personalized) == null ? void 0 : y.tracking) == null ? void 0 : L.isConsentGranted) || !1, w = ((ie = (Y = (q = (K = (O = c == null ? void 0 : c.preferences) == null ? void 0 : O.miele) == null ? void 0 : K.marketingconsent) == null ? void 0 : q.personalized) == null ? void 0 : Y.iot) == null ? void 0 : ie.isConsentGranted) || !1;
    a = ((ge = (ze = (oe = (ce = c == null ? void 0 : c.preferences) == null ? void 0 : ce.terms) == null ? void 0 : oe.miele) == null ? void 0 : ze.statement) == null ? void 0 : ge.isConsentGranted) || !1, e = Zi(
      [m, d, v],
      [m, d],
      [m, v],
      [m]
    ), t = e && Zi(
      [v],
      [m, d, v],
      [m, v]
    ), i = e && Zi([w]);
  }, o = (c) => ({
    preferences: {
      // consent personalized general
      [Ls]: c.consentLevelOne,
      // consent personalized tracking
      [Dt]: c.hasSingleConsent ? c.consentLevelOne : c.consentLevelTwo,
      // consent iot
      [Zf]: c.consentLevelThree,
      // terms & services
      [Cs]: c.isAgreementAccepted
    },
    subscriptions: {
      // consent newsletter
      [Ps]: c.consentLevelOne
    }
  }), r = async () => {
    const m = await Is()(["subscriptions", "preferences"]);
    return s(m), n();
  }, l = (c) => ai()(o(c));
  return {
    fetchUserConsent: r,
    postUserConsent: async (c) => l(c).then(() => {
      if (globalThis != null && globalThis.window) {
        const { pushFormSubmitEvent: m } = Be();
        m($e.changeMarketingPreference);
      }
    }).catch((m) => {
      if (globalThis != null && globalThis.window) {
        const { pushFormSubmitEvent: d } = Be();
        d($e.changeMarketingPreference, m.name);
      }
      throw m;
    }),
    setMultiLevelConsent: s,
    getMultiLevelConsent: n
  };
}
const Yb = { class: "dcf-h2 marketing-consent-scene-content__title" }, Xb = { class: "marketing-consent-scene-content__description" }, Qb = { class: "marketing-consent-scene-content__scroll-content" }, ew = { class: "marketing-consent-scene-content__input-field" }, tw = ["href"], iw = {
  key: 0,
  class: "marketing-consent-scene-content__input-field"
}, aw = ["href"], nw = {
  key: 0,
  class: "marketing-consent-scene-content__input-field"
}, sw = ["href"], ow = { class: "marketing-consent-scene-content__input-field" }, rw = ["href"], lw = { class: "marketing-consent-scene-content__button-area" }, cw = /* @__PURE__ */ pe({
  __name: "umf-marketing-consent-multi-level-scene",
  props: {
    context: { default: le.light },
    onlyHasSingleConsent: { type: Boolean, default: !1 }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i } = ue(), a = t, n = H({
      consentLevelOne: !1,
      consentLevelTwo: !1,
      consentLevelThree: !1,
      isAgreementAccepted: !1,
      error: null,
      isSubmitting: !1,
      isLoading: !1
    }), s = e, o = (v) => {
      n.value.consentLevelOne = v.checked, n.value.consentLevelOne || (n.value.consentLevelTwo = !1, n.value.consentLevelThree = !1);
    }, r = (v) => n.value.consentLevelTwo = v.checked, l = (v) => n.value.consentLevelThree = v.checked, u = (v) => {
      n.value.isAgreementAccepted = v.checked;
    }, c = async () => {
      try {
        n.value.isLoading = !0;
        const { fetchUserConsent: v } = Cn(), { consentLevelOne: w, consentLevelTwo: S, consentLevelThree: j, isAgreementAccepted: E } = await v();
        n.value.consentLevelOne = w, n.value.consentLevelTwo = !s.onlyHasSingleConsent && S, n.value.consentLevelThree = !s.onlyHasSingleConsent && j, n.value.isAgreementAccepted = E;
      } catch (v) {
        n.value.error = v;
      } finally {
        n.value.isLoading = !1;
      }
    }, m = async () => {
      try {
        n.value.isSubmitting = !0;
        const { postUserConsent: v } = Cn();
        await v({
          consentLevelOne: n.value.consentLevelOne,
          consentLevelTwo: n.value.consentLevelTwo,
          consentLevelThree: n.value.consentLevelThree,
          isAgreementAccepted: n.value.isAgreementAccepted,
          hasSingleConsent: s.onlyHasSingleConsent
        }), d();
      } catch (v) {
        n.value.error = v;
      } finally {
        n.value.isSubmitting = !1;
      }
    }, d = () => a("on-close");
    return dt(() => {
      c();
    }), (v, w) => (G(), Z("div", {
      class: et([
        "marketing-consent-scene-content",
        {
          [p(Me).dark]: s.context === p(le).dark,
          [p(Me).light]: s.context === p(le).light
        }
      ])
    }, [
      D("h2", Yb, R(p(i)("multiLevelMarketingConsent.title")), 1),
      D("p", Xb, R(p(i)("multiLevelMarketingConsent.description")), 1),
      D("form", null, [
        D("div", Qb, [
          D("div", ew, [
            U(p(Oe), {
              label: p(i)("multiLevelMarketingConsent.levelOne.text"),
              checked: n.value.consentLevelOne,
              "onUpdate:CheckboxValue": o
            }, null, 8, ["label", "checked"]),
            D("a", {
              href: p(i)("multiLevelMarketingConsent.levelOne.link.ref"),
              class: "dcf-link"
            }, R(p(i)("multiLevelMarketingConsent.levelOne.link.title")), 9, tw)
          ]),
          U(Ta, null, {
            default: ne(() => [
              !s.onlyHasSingleConsent && n.value.consentLevelOne ? (G(), Z("div", iw, [
                U(p(Oe), {
                  label: p(i)("multiLevelMarketingConsent.levelTwo.text"),
                  checked: n.value.consentLevelTwo,
                  "onUpdate:CheckboxValue": r
                }, null, 8, ["label", "checked"]),
                D("a", {
                  href: p(i)("multiLevelMarketingConsent.levelTwo.link.ref"),
                  class: "dcf-link"
                }, R(p(i)("multiLevelMarketingConsent.levelTwo.link.title")), 9, aw)
              ])) : ke("", !0)
            ]),
            _: 1
          }),
          U(Ta, null, {
            default: ne(() => [
              !s.onlyHasSingleConsent && n.value.consentLevelOne ? (G(), Z("div", nw, [
                U(p(Oe), {
                  label: p(i)("multiLevelMarketingConsent.levelThree.text"),
                  checked: n.value.consentLevelThree,
                  "onUpdate:CheckboxValue": l
                }, null, 8, ["label", "checked"]),
                D("a", {
                  href: p(i)("multiLevelMarketingConsent.levelThree.link.ref"),
                  class: "dcf-link"
                }, R(p(i)("multiLevelMarketingConsent.levelThree.link.title")), 9, sw)
              ])) : ke("", !0)
            ]),
            _: 1
          })
        ]),
        D("div", ow, [
          U(p(Oe), {
            label: p(i)("multiLevelMarketingConsent.termsOfUse.text"),
            checked: n.value.isAgreementAccepted,
            "onUpdate:CheckboxValue": u
          }, null, 8, ["label", "checked"]),
          D("a", {
            href: p(i)("multiLevelMarketingConsent.termsOfUse.link.ref"),
            class: "dcf-link"
          }, R(p(i)("multiLevelMarketingConsent.termsOfUse.link.title")), 9, rw)
        ]),
        D("div", lw, [
          U(p(Ue), {
            type: "submit",
            class: "marketing-consent-scene-content__submit",
            variant: "primary",
            disabled: n.value.isLoading || n.value.isSubmitting || !n.value.isAgreementAccepted,
            icon: n.value.isSubmitting || n.value.isLoading ? "heartbeat-loader" : "",
            "full-width": "",
            onClick: Qe(m, ["prevent"])
          }, {
            default: ne(() => [
              Pe(R(p(i)("multiLevelMarketingConsent.submit")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "icon"])
        ]),
        U(p(mt), {
          error: n.value.error
        }, null, 8, ["error"])
      ])
    ], 2));
  }
});
const dw = /* @__PURE__ */ Ie(cw, [["__scopeId", "data-v-144a3da2"]]), uw = (e) => {
  const t = Date.now(), i = (a, n) => {
    var s, o, r, l;
    (o = (s = window.gigya) == null ? void 0 : s.accounts) != null && o.showScreenSet ? a((l = (r = window.gigya) == null ? void 0 : r.accounts) == null ? void 0 : l.showScreenSet) : e && Date.now() - t >= e ? n(new Error("timeout")) : setTimeout(i.bind(void 0, a, n), 30);
  };
  return new Promise(i);
}, mw = async (e) => {
  var t, i;
  try {
    await uw(2e3), (i = (t = window.gigya) == null ? void 0 : t.accounts) != null && i.showScreenSet ? window.gigya.accounts.showScreenSet({
      screenSet: "Default-RegistrationLogin",
      startScreen: "gigya-register-screen-simple",
      onError: (a) => {
        e({ error: a });
      },
      onAfterSubmit: (a) => {
        e({ response: a });
      }
    }) : console.warn('Unable to display screenset. Make sure "window.gigya" library is loaded.');
  } catch (a) {
    console.warn("Something went wrong loading gigya library.", a);
  }
}, pw = { class: "dcf-h4 umf-register-scene__headline" }, gw = { class: "umf-register-scene__buttonWrapper" }, hw = { class: "dcf-h5 umf-register-scene__list-headline" }, vw = { class: "umf-register-scene__list" }, sy = /* @__PURE__ */ pe({
  __name: "umf-register-scene",
  props: {
    context: { default: le.light },
    onRegisterComplete: { type: Function, default: void 0 },
    onRegisterError: { type: Function, default: void 0 },
    configState: null,
    useHead: { type: Function }
  },
  setup(e) {
    var m;
    const t = e, { ct: i, ctm: a, crt: n } = ue(), s = ((m = t.configState) == null ? void 0 : m["module.cdc.ApiKey"]) || "", o = W(() => new URLSearchParams(window == null ? void 0 : window.location.search).get("register") !== null), r = () => {
      mw(({ error: d, response: v }) => {
        if (d && console.error(d), d && t.onRegisterError) {
          if (globalThis != null && globalThis.window) {
            const { pushFormSubmitEvent: w } = Be();
            w($e.register, d.eventName);
          }
          t.onRegisterError(d);
        } else if (t.onRegisterComplete) {
          if (globalThis != null && globalThis.window) {
            const { pushRegisterEvent: w, pushFormSubmitEvent: S } = Be();
            S($e.register), w(v.response.UID, Yf(v.response));
          }
          t.onRegisterComplete(v);
        }
      });
    }, l = Qv(t.configState).replace("-", "_");
    let u = l.substring(l.length - 2), c = l.substring(0, l.length - 2) + u.toUpperCase();
    return t.useHead({
      script: [
        {
          src: `https://cdns.gigya.com/js/gigya.js?apikey=${s}&lang=${c}`,
          defer: !0
        }
      ]
    }), dt(() => {
      o.value && r();
    }), (d, v) => (G(), Z("div", {
      class: et([
        "umf-register-scene",
        {
          [p(Me).dark]: t.context === p(le).dark,
          [p(Me).light]: t.context === p(le).light
        }
      ])
    }, [
      D("h2", pw, R(p(i)("register.registerTitle")), 1),
      D("div", gw, [
        U(p(Ue), {
          variant: "secondary",
          "full-width": "",
          onClick: r
        }, {
          default: ne(() => [
            Pe(R(p(i)("register.registerButtonLabel")), 1)
          ]),
          _: 1
        })
      ]),
      D("div", null, [
        D("h3", hw, R(p(i)("register.whyRegister.title")), 1),
        D("ul", vw, [
          (G(!0), Z(_t, null, xn(p(a)("register.whyRegister.list"), (w) => (G(), Z("li", {
            key: w,
            class: "umf-register-scene__list-item"
          }, [
            U(p(Qs), {
              name: "checkmark",
              class: "umf-register-scene__list-icon"
            }),
            D("p", null, R(p(n)(w)), 1)
          ]))), 128))
        ])
      ])
    ], 2));
  }
});
const fw = { class: "umf-read-more" }, kw = { key: 0 }, bw = /* @__PURE__ */ pe({
  __name: "umf-read-more",
  props: {
    readMoreText: null,
    readLessText: null
  },
  setup(e) {
    const { ct: t } = ue(), i = e.readMoreText || t("readMore"), a = e.readLessText || t("readLess"), n = H(!1), s = () => {
      n.value = !n.value;
    };
    return (o, r) => (G(), Z("div", fw, [
      o.$slots["short-content"] ? (G(), Z("div", kw, [
        n.value ? mi(o.$slots, "default", { key: 1 }, void 0, !0) : mi(o.$slots, "short-content", { key: 0 }, void 0, !0),
        r[0] || (r[0] = Pe("   ")),
        D("button", {
          class: "umf-read-more__button",
          type: "button",
          onClick: Qe(s, ["prevent"])
        }, R(n.value ? p(a) : p(i)), 1)
      ])) : mi(o.$slots, "default", { key: 1 }, void 0, !0)
    ]));
  }
});
const ww = /* @__PURE__ */ Ie(bw, [["__scopeId", "data-v-90907899"]]), yw = { class: "miele-club-consent-scene__form" }, Mw = { class: "miele-club-consent-scene__description" }, zw = { class: "miele-club-consent-scene__benefits" }, jw = { class: "miele-club-consent-scene__consent" }, _w = { class: "miele-club-consent-scene__membership" }, Ew = { class: "miele-club-consent-scene__terms-condition" }, Sw = ["href"], Lw = ["href"], Cw = { key: 0 }, Pw = { class: "miele-club-consent-scene__newsletter" }, Tw = ["href"], Aw = ["href"], xw = ["href"], Iw = "https://media.miele.com/images/2000021/200002108/20000210898.png?impolicy=gallery&imwidth=768", Dw = /* @__PURE__ */ pe({
  __name: "umf-miele-club-consent-scene",
  props: {
    context: { default: le.light },
    showNewsletter: { type: Boolean, default: !0 },
    allConsentsRequired: { type: Boolean, default: !1 },
    toSyncMieleClubSubscriptionOnCdc: { type: Boolean, default: !1 }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i, ctm: a, crt: n, cte: s, i18n: o } = ue(), r = t, l = e, u = H(), c = H(!1), m = H(!1), d = H(!0), v = H(!1), w = H(!1), S = W(() => m.value || c.value || !v.value), j = (k) => {
      v.value = k.checked, k.checked || (w.value = !1);
    }, E = (k) => w.value = k.checked, A = async () => {
      const k = ai(), M = {
        preferences: {
          "miele.loyalty.membership.isConsentGranted": v.value
        }
      };
      return l.toSyncMieleClubSubscriptionOnCdc && (M.subscriptions = {
        "miele.loyalty.newsletter.email.isSubscribed": v.value
      }), w.value && (M.preferences["miele.loyalty.personalized.general.isConsentGranted"] = w.value), k(M);
    }, f = () => l.allConsentsRequired && (v.value || w.value) ? v.value && w.value : v.value, b = async () => {
      u.value = null;
      try {
        if (d.value = f(), !d.value)
          return;
        c.value = !0, await Promise.all([At().setMieleClub(v.value), A()]), P(), window.location.reload();
      } catch (k) {
        u.value = k;
      } finally {
        c.value = !1;
      }
    }, P = () => r("on-close");
    return (k, M) => (G(), Z("div", {
      class: et([
        "miele-club-consent-scene",
        {
          [p(Me).dark]: l.context === p(le).dark,
          [p(Me).light]: l.context === p(le).light
        }
      ])
    }, [
      D("form", yw, [
        U(p(eo), null, {
          media: ne(() => [
            D("img", {
              src: Iw,
              alt: ""
            })
          ]),
          title: ne(() => [
            Pe(R(p(i)("mieleClub.headline")), 1)
          ]),
          content: ne(() => [
            D("div", Mw, R(p(i)("mieleClub.why.title")), 1),
            D("ul", zw, [
              (G(!0), Z(_t, null, xn(p(a)("mieleClub.why.reasons"), (_) => (G(), Z("li", {
                key: _,
                class: "miele-club-consent-scene__benefit"
              }, [
                D("div", null, R(p(n)(_)), 1)
              ]))), 128))
            ]),
            D("div", jw, [
              D("div", _w, [
                U(p(Oe), {
                  label: p(i)("mieleClub.joinClubLabel"),
                  checked: v.value,
                  "onUpdate:CheckboxValue": j
                }, null, 8, ["label", "checked"]),
                D("div", Ew, [
                  U(p(Pn), {
                    keypath: "mieleClub.termsAndCondition.description",
                    i18n: p(o)
                  }, Oi({ _: 2 }, [
                    p(s)("mieleClub.termsAndCondition.termsAndConditionLink.ref") ? {
                      name: "termsAndConditionLink",
                      fn: ne(() => [
                        D("a", {
                          class: "miele-club-consent-scene__link",
                          href: p(i)("mieleClub.termsAndCondition.termsAndConditionLink.ref"),
                          target: "_blank"
                        }, R(p(i)("mieleClub.termsAndCondition.termsAndConditionLink.title")), 9, Sw)
                      ]),
                      key: "0"
                    } : void 0,
                    p(s)("mieleClub.termsAndCondition.privacyLink.ref") ? {
                      name: "privacyLink",
                      fn: ne(() => [
                        D("a", {
                          class: "miele-club-consent-scene__link",
                          href: p(i)("mieleClub.termsAndCondition.privacyLink.ref"),
                          target: "_blank"
                        }, R(p(i)("mieleClub.termsAndCondition.privacyLink.title")), 9, Lw)
                      ]),
                      key: "1"
                    } : void 0
                  ]), 1032, ["i18n"])
                ])
              ]),
              e.showNewsletter ? (G(), Z("div", Cw, [
                D("label", Pw, [
                  U(p(Oe), {
                    label: "",
                    disabled: !v.value,
                    checked: w.value,
                    "onUpdate:CheckboxValue": E
                  }, null, 8, ["disabled", "checked"]),
                  U(p(ww), null, Oi({
                    default: ne(() => [
                      U(p(Pn), {
                        keypath: "mieleClub.newsletter.description",
                        i18n: p(o)
                      }, Oi({ _: 2 }, [
                        p(s)("mieleClub.newsletter.supportEmail") ? {
                          name: "supportEmail",
                          fn: ne(() => [
                            D("a", {
                              class: "miele-club-consent-scene__link",
                              href: "mailto:" + p(i)("mieleClub.newsletter.supportEmail"),
                              target: "_blank"
                            }, R(p(i)("mieleClub.newsletter.supportEmail")), 9, Tw)
                          ]),
                          key: "0"
                        } : void 0,
                        p(s)("mieleClub.newsletter.privacyLink.href") ? {
                          name: "privacyLink",
                          fn: ne(() => [
                            D("a", {
                              class: "miele-club-consent-scene__link",
                              href: p(i)("mieleClub.newsletter.privacyLink.href"),
                              target: "_blank"
                            }, R(p(i)("mieleClub.newsletter.privacyLink.title")), 9, Aw)
                          ]),
                          key: "1"
                        } : void 0,
                        p(s)("mieleClub.newsletter.termsAndConditionLink.href") ? {
                          name: "termsAndConditionLink",
                          fn: ne(() => [
                            D("a", {
                              class: "miele-club-consent-scene__link",
                              href: p(i)("mieleClub.newsletter.termsAndConditionLink.href"),
                              target: "_blank"
                            }, R(p(i)("mieleClub.newsletter.termsAndConditionLink.title")), 9, xw)
                          ]),
                          key: "2"
                        } : void 0
                      ]), 1032, ["i18n"])
                    ]),
                    _: 2
                  }, [
                    p(s)("mieleClub.newsletter.shortDescription") ? {
                      name: "short-content",
                      fn: ne(() => [
                        D("div", null, R(p(i)("mieleClub.newsletter.shortDescription")), 1)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1024)
                ])
              ])) : ke("", !0)
            ]),
            e.allConsentsRequired && !d.value ? (G(), Ve(p(ji), {
              key: 0,
              headline: p(i)("mieleClub.selectAllConsents.description"),
              variant: "WARNING",
              class: "miele-club-consent-scene__msg-notification"
            }, null, 8, ["headline"])) : ke("", !0),
            U(p(mt), {
              error: u.value,
              class: "miele-club-consent-scene__msg-error"
            }, null, 8, ["error"]),
            U(p(Ue), {
              type: "submit",
              variant: "primary",
              class: "miele-club-consent-scene__submit",
              disabled: S.value,
              icon: c.value || m.value ? "heartbeat-loader" : "",
              "full-width": "",
              onClick: Qe(b, ["prevent"])
            }, {
              default: ne(() => [
                Pe(R(p(i)("multiLevelMarketingConsent.submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "icon"])
          ]),
          _: 1
        })
      ])
    ], 2));
  }
});
const Nw = /* @__PURE__ */ Ie(Dw, [["__scopeId", "data-v-45f68809"]]);
function Ow({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, n) => [...a, ...n.type === _t ? n.children : [n]], []) : t.reduce((i, a) => {
    const n = e[a];
    return n && (i[a] = n()), i;
  }, {});
}
function Uw() {
  return _t;
}
const Pn = pe({
  props: {
    keypath: {
      type: String,
      required: !0
    },
    i18n: {
      type: Object
    }
  },
  setup(e, t) {
    const { slots: i, attrs: a } = t, n = e.i18n;
    return () => {
      const s = Object.keys(i).filter((c) => c !== "_"), o = Ow(t, s), r = Object.getOwnPropertySymbols(n).find(
        (c) => c.toString().includes("__translateVNode")
      ), l = n[r](e.keypath, o), u = Uw();
      return ua(u, a, l);
    };
  }
});
var $w = /* @__PURE__ */ ((e) => (e.APPLIANCE = "APPLIANCE", e.SERVICE = "SERVICE", e.MSC = "MSC", e))($w || {});
export {
  Yw as APIConnectorBaseURL,
  Lf as API_URLS,
  Mf as AUTH_CODE_COOKIE,
  qv as AccountLoginError,
  Fe as AccountPaths,
  Ot as AccountsApiError,
  qw as BusEvents,
  Sf as CdcPaths,
  Me as ContextCssClasses,
  le as ContextOptions,
  zf as DANGER_ZONE,
  di as EventNames,
  $e as FormSubmitIds,
  ye as GenericError,
  hn as HttpMethods,
  Zt as HybrisPaths,
  us as HybrisSessionExpiredError,
  ba as InvalidEmailPasswordError,
  wa as InvalidLoginError,
  ya as InvalidSessionError,
  Zw as JWT_COOKIE,
  Jw as MIELE_SESSION_COOKIE,
  Ti as MissingConsentError,
  Gv as NoAccountError,
  Hi as OccPaths,
  Je as PasswordStrength,
  $w as ProductTypeCode,
  Ms as REG_TOKEN_COOKIE,
  li as SESSION_DATA_COOKIE,
  yf as SESSION_HOST_COOKIE,
  $t as SapError,
  Ma as SessionInvalidGrantError,
  Ki as SessionPaths,
  mk as UmfChangeEmailScene,
  bk as UmfChangePasswordScene,
  Ak as UmfConsentScene,
  iy as UmfDivider,
  mt as UmfErrorHandler,
  Vk as UmfForgotPasswordScene,
  Pn as UmfI18nT,
  Xw as UmfKeys,
  ay as UmfLogin,
  Xk as UmfLoginModalScene,
  Ds as UmfLoginScene,
  dw as UmfMarketingConsentMultiLevelScene,
  Zb as UmfMarketingConsentScene,
  Nw as UmfMieleClubConsentScene,
  Lb as UmfModalOverlay,
  ny as UmfModalsController,
  Ib as UmfPasswordStrength,
  Ii as UmfPaths,
  ww as UmfReadMore,
  sy as UmfRegisterScene,
  Ce as UnexpectedError,
  ms as UnknownError,
  Fw as errors,
  At as experienceApi,
  xi as findMultiLangCountry,
  hf as generateRandomString,
  cf as getComplexityScore,
  Yf as getConsentFields,
  Qv as getCurrentLocalLanguage,
  za as getDomainCountryCode,
  Jv as getDomainLanguage,
  Gw as getFallbackLanguage,
  Yv as getLocaleFromCurrentUrl,
  Xv as getNonce,
  Ww as getPasswordStrength,
  ws as getPasswordStrengthForComplexity,
  Ts as getPathWithoutLeaf,
  df as groupPathsByPathRoot,
  bt as handleMultilingualPrefix,
  dn as hostFromUrl,
  Tt as isEmailValid,
  ja as isMultiLingualDomain,
  tf as isPasswordValid,
  Ut as isSapErrorHandled,
  Xf as isTrackingConsentEnabled,
  Zv as isValidCountryLanguage,
  cn as joinPath,
  pf as objectToUrlEncoded,
  vf as pathFromUrl,
  Kw as prefixUrlWithCurrentLocale,
  Hw as setNewLocale,
  gf as sha256b64,
  Bi as toBoolean,
  Vf as useAccountLogin,
  js as useAccountLoginSession,
  Ss as useAuthCode,
  qf as useAuthProxy,
  tk as useCdcService,
  sk as useChangePassword,
  ty as useCheckSessionAndRedirectOnInvalid,
  Rt as useConfig,
  nk as useForgotPassword,
  Is as useGetAccountInfo,
  ok as useGetPasswordPolicies,
  Xe as useGlobals,
  ii as useJwtSession,
  As as useLogin,
  Sa as useLogout,
  _a as useRegToken,
  ak as useResetPassword,
  ey as useResetPasswordWithResetToken,
  La as useSession,
  Qw as useSessionHostCookie,
  ai as useSetAccountInfo,
  ys as useSuccessRedirect,
  Be as useTracking,
  ue as useTranslations,
  Ea as useWebService
};
